function _typeof4(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof4 = function _typeof4(obj) { return typeof obj; }; } else { _typeof4 = function _typeof4(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof4(obj); }

module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 191);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports) {
  module.exports = require("react");
  /***/
},
/* 1 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    if (process.env.NODE_ENV !== 'production') {
      var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol["for"] && Symbol["for"]('react.element') || 0xeac7;

      var isValidElement = function isValidElement(object) {
        return _typeof4(object) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }; // By explicitly using `prop-types` you are opting into new development behavior.
      // http://fb.me/prop-types-in-prod


      var throwOnDirectAccess = true;
      module.exports = __webpack_require__(230)(isValidElement, throwOnDirectAccess);
    } else {
      // By explicitly using `prop-types` you are opting into new production behavior.
      // http://fb.me/prop-types-in-prod
      module.exports = __webpack_require__(233)();
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(8));
  /***/
},
/* 2 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(205),
    __esModule: true
  };
  /***/
},
/* 3 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  exports["default"] = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };
  /***/

},
/* 4 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  var _defineProperty = __webpack_require__(124);

  var _defineProperty2 = _interopRequireDefault(_defineProperty);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  exports["default"] = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2["default"])(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  /***/

},
/* 5 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  var _typeof2 = __webpack_require__(85);

  var _typeof3 = _interopRequireDefault(_typeof2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  exports["default"] = function (self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3["default"])(call)) === "object" || typeof call === "function") ? call : self;
  };
  /***/

},
/* 6 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  var _setPrototypeOf = __webpack_require__(223);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create = __webpack_require__(227);

  var _create2 = _interopRequireDefault(_create);

  var _typeof2 = __webpack_require__(85);

  var _typeof3 = _interopRequireDefault(_typeof2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  exports["default"] = function (subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3["default"])(superClass)));
    }

    subClass.prototype = (0, _create2["default"])(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2["default"] ? (0, _setPrototypeOf2["default"])(subClass, superClass) : subClass.__proto__ = superClass;
  };
  /***/

},
/* 7 */

/***/
function (module, exports) {
  var core = module.exports = {
    version: '2.5.7'
  };
  if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

  /***/
},
/* 8 */

/***/
function (module, exports) {
  // shim for using process in browser
  var process = module.exports = {}; // cached from whatever global is present so that test runners that stub it
  // don't break things.  But we need to wrap it in a try catch in case it is
  // wrapped in strict mode code which doesn't define any globals.  It's inside a
  // function because try/catches deoptimize in certain engines.

  var cachedSetTimeout;
  var cachedClearTimeout;

  function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
  }

  function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
  }

  (function () {
    try {
      if (typeof setTimeout === 'function') {
        cachedSetTimeout = setTimeout;
      } else {
        cachedSetTimeout = defaultSetTimout;
      }
    } catch (e) {
      cachedSetTimeout = defaultSetTimout;
    }

    try {
      if (typeof clearTimeout === 'function') {
        cachedClearTimeout = clearTimeout;
      } else {
        cachedClearTimeout = defaultClearTimeout;
      }
    } catch (e) {
      cachedClearTimeout = defaultClearTimeout;
    }
  })();

  function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
      //normal enviroments in sane situations
      return setTimeout(fun, 0);
    } // if setTimeout wasn't available but was latter defined


    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
      cachedSetTimeout = setTimeout;
      return setTimeout(fun, 0);
    }

    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedSetTimeout(fun, 0);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
        return cachedSetTimeout.call(null, fun, 0);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
        return cachedSetTimeout.call(this, fun, 0);
      }
    }
  }

  function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
      //normal enviroments in sane situations
      return clearTimeout(marker);
    } // if clearTimeout wasn't available but was latter defined


    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
      cachedClearTimeout = clearTimeout;
      return clearTimeout(marker);
    }

    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedClearTimeout(marker);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
        return cachedClearTimeout.call(null, marker);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
        // Some versions of I.E. have different rules for clearTimeout vs setTimeout
        return cachedClearTimeout.call(this, marker);
      }
    }
  }

  var queue = [];
  var draining = false;
  var currentQueue;
  var queueIndex = -1;

  function cleanUpNextTick() {
    if (!draining || !currentQueue) {
      return;
    }

    draining = false;

    if (currentQueue.length) {
      queue = currentQueue.concat(queue);
    } else {
      queueIndex = -1;
    }

    if (queue.length) {
      drainQueue();
    }
  }

  function drainQueue() {
    if (draining) {
      return;
    }

    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;

    while (len) {
      currentQueue = queue;
      queue = [];

      while (++queueIndex < len) {
        if (currentQueue) {
          currentQueue[queueIndex].run();
        }
      }

      queueIndex = -1;
      len = queue.length;
    }

    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
  }

  process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);

    if (arguments.length > 1) {
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }
    }

    queue.push(new Item(fun, args));

    if (queue.length === 1 && !draining) {
      runTimeout(drainQueue);
    }
  }; // v8 likes predictible objects


  function Item(fun, array) {
    this.fun = fun;
    this.array = array;
  }

  Item.prototype.run = function () {
    this.fun.apply(null, this.array);
  };

  process.title = 'browser';
  process.browser = true;
  process.env = {};
  process.argv = [];
  process.version = ''; // empty string to avoid regexp issues

  process.versions = {};

  function noop() {}

  process.on = noop;
  process.addListener = noop;
  process.once = noop;
  process.off = noop;
  process.removeListener = noop;
  process.removeAllListeners = noop;
  process.emit = noop;
  process.prependListener = noop;
  process.prependOnceListener = noop;

  process.listeners = function (name) {
    return [];
  };

  process.binding = function (name) {
    throw new Error('process.binding is not supported');
  };

  process.cwd = function () {
    return '/';
  };

  process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
  };

  process.umask = function () {
    return 0;
  };
  /***/

},
/* 9 */

/***/
function (module, exports) {
  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self // eslint-disable-next-line no-new-func
  : Function('return this')();
  if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

  /***/
},
/* 10 */

/***/
function (module, exports, __webpack_require__) {
  var store = __webpack_require__(82)('wks');

  var uid = __webpack_require__(55);

  var _Symbol = __webpack_require__(9).Symbol;

  var USE_SYMBOL = typeof _Symbol == 'function';

  var $exports = module.exports = function (name) {
    return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
  };

  $exports.store = store;
  /***/
},
/* 11 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(9);

  var core = __webpack_require__(7);

  var ctx = __webpack_require__(30);

  var hide = __webpack_require__(26);

  var has = __webpack_require__(27);

  var PROTOTYPE = 'prototype';

  var $export = function $export(type, name, source) {
    var IS_FORCED = type & $export.F;
    var IS_GLOBAL = type & $export.G;
    var IS_STATIC = type & $export.S;
    var IS_PROTO = type & $export.P;
    var IS_BIND = type & $export.B;
    var IS_WRAP = type & $export.W;
    var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
    var expProto = exports[PROTOTYPE];
    var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;

    for (key in source) {
      // contains in native
      own = !IS_FORCED && target && target[key] !== undefined;
      if (own && has(exports, key)) continue; // export native or passed

      out = own ? target[key] : source[key]; // prevent global pollution for namespaces

      exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] // bind timers to global for call from export context
      : IS_BIND && own ? ctx(out, global) // wrap global constructors for prevent change them in library
      : IS_WRAP && target[key] == out ? function (C) {
        var F = function F(a, b, c) {
          if (this instanceof C) {
            switch (arguments.length) {
              case 0:
                return new C();

              case 1:
                return new C(a);

              case 2:
                return new C(a, b);
            }

            return new C(a, b, c);
          }

          return C.apply(this, arguments);
        };

        F[PROTOTYPE] = C[PROTOTYPE];
        return F; // make static versions for prototype methods
      }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out; // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%

      if (IS_PROTO) {
        (exports.virtual || (exports.virtual = {}))[key] = out; // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%

        if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
      }
    }
  }; // type bitmap


  $export.F = 1; // forced

  $export.G = 2; // global

  $export.S = 4; // static

  $export.P = 8; // proto

  $export.B = 16; // bind

  $export.W = 32; // wrap

  $export.U = 64; // safe

  $export.R = 128; // real proto method for `library`

  module.exports = $export;
  /***/
},
/* 12 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();

  exports.parseStartTime = parseStartTime;
  exports.randomString = randomString;
  exports.getSDK = getSDK;
  exports.getConfig = getConfig;
  exports.omit = omit;

  var _loadScript = __webpack_require__(238);

  var _loadScript2 = _interopRequireDefault(_loadScript);

  var _deepmerge = __webpack_require__(239);

  var _deepmerge2 = _interopRequireDefault(_deepmerge);

  var _props = __webpack_require__(89);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
  var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
  var MATCH_NUMERIC = /^\d+$/; // Parse YouTube URL for a start time param, ie ?t=1h14m30s
  // and return the start time in seconds

  function parseStartTime(url) {
    var match = url.match(MATCH_START_QUERY);

    if (match) {
      var stamp = match[1];

      if (stamp.match(MATCH_START_STAMP)) {
        return parseStartStamp(stamp);
      }

      if (MATCH_NUMERIC.test(stamp)) {
        return parseInt(stamp, 10);
      }
    }

    return 0;
  }

  function parseStartStamp(stamp) {
    var seconds = 0;
    var array = MATCH_START_STAMP.exec(stamp);

    while (array !== null) {
      var _array = array,
          _array2 = _slicedToArray(_array, 3),
          count = _array2[1],
          period = _array2[2];

      if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
      if (period === 'm') seconds += parseInt(count, 10) * 60;
      if (period === 's') seconds += parseInt(count, 10);
      array = MATCH_START_STAMP.exec(stamp);
    }

    return seconds;
  } // http://stackoverflow.com/a/38622545


  function randomString() {
    return Math.random().toString(36).substr(2, 5);
  } // Util function to load an external SDK
  // or return the SDK if it is already loaded


  function getSDK(url, sdkGlobal) {
    var sdkReady = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var isLoaded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
      return true;
    };

    if (window[sdkGlobal] && isLoaded(window[sdkGlobal])) {
      return Promise.resolve(window[sdkGlobal]);
    }

    return new Promise(function (resolve, reject) {
      if (sdkReady) {
        var previousOnReady = window[sdkReady];

        window[sdkReady] = function () {
          if (previousOnReady) previousOnReady();
          resolve(window[sdkGlobal]);
        };
      }

      (0, _loadScript2['default'])(url, function (err) {
        if (err) reject(err);

        if (!sdkReady) {
          resolve(window[sdkGlobal]);
        }
      });
    });
  }

  function getConfig(props, defaultProps, showWarning) {
    var config = (0, _deepmerge2['default'])(defaultProps.config, props.config);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = _props.DEPRECATED_CONFIG_PROPS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var p = _step.value;

        if (props[p]) {
          var key = p.replace(/Config$/, '');
          config = (0, _deepmerge2['default'])(config, _defineProperty({}, key, props[p]));

          if (showWarning) {
            var link = 'https://github.com/CookPete/react-player#config-prop';
            var message = 'ReactPlayer: %c' + p + " %cis deprecated, please use the config prop instead \u2013 " + link;
            console.warn(message, 'font-weight: bold', '');
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator['return']) {
          _iterator['return']();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return config;
  }

  function omit(object) {
    var _ref;

    for (var _len = arguments.length, arrays = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      arrays[_key - 1] = arguments[_key];
    }

    var omitKeys = (_ref = []).concat.apply(_ref, arrays);

    var output = {};
    var keys = Object.keys(object);
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var key = _step2.value;

        if (omitKeys.indexOf(key) === -1) {
          output[key] = object[key];
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2['return']) {
          _iterator2['return']();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return output;
  }
  /***/

},
/* 13 */

/***/
function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
  /*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
  */

  /* global define */


  (function () {
    'use strict';

    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;

        var argType = _typeof4(arg);

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          classes.push(classNames.apply(null, arg));
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (typeof module !== 'undefined' && module.exports) {
      module.exports = classNames;
    } else if (true) {
      // register as 'classnames', consistent with npm package name
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
        return classNames;
      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
      window.classNames = classNames;
    }
  })();
  /***/

},
/* 14 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  var _defineProperty = __webpack_require__(124);

  var _defineProperty2 = _interopRequireDefault(_defineProperty);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  exports["default"] = function (obj, key, value) {
    if (key in obj) {
      (0, _defineProperty2["default"])(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  };
  /***/

},
/* 15 */

/***/
function (module, exports, __webpack_require__) {
  var anObject = __webpack_require__(16);

  var IE8_DOM_DEFINE = __webpack_require__(111);

  var toPrimitive = __webpack_require__(78);

  var dP = Object.defineProperty;
  exports.f = __webpack_require__(23) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPrimitive(P, true);
    anObject(Attributes);
    if (IE8_DOM_DEFINE) try {
      return dP(O, P, Attributes);
    } catch (e) {
      /* empty */
    }
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
  };
  /***/
},
/* 16 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(22);

  module.exports = function (it) {
    if (!isObject(it)) throw TypeError(it + ' is not an object!');
    return it;
  };
  /***/

},
/* 17 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react = __webpack_require__(0);

  var _props2 = __webpack_require__(89);

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SEEK_ON_PLAY_EXPIRY = 5000;

  var Base = function (_Component) {
    _inherits(Base, _Component);

    function Base() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Base);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Base.__proto__ || Object.getPrototypeOf(Base)).call.apply(_ref, [this].concat(args))), _this), _this.isReady = false, _this.startOnPlay = true, _this.seekOnPlay = null, _this.onPlay = function () {
        var _this$props = _this.props,
            volume = _this$props.volume,
            muted = _this$props.muted,
            onStart = _this$props.onStart,
            onPlay = _this$props.onPlay,
            playbackRate = _this$props.playbackRate;

        if (_this.startOnPlay) {
          if (_this.setPlaybackRate) {
            _this.setPlaybackRate(playbackRate);
          }

          _this.setVolume(muted ? 0 : volume);

          onStart();
          _this.startOnPlay = false;
        }

        onPlay();

        if (_this.seekOnPlay) {
          _this.seekTo(_this.seekOnPlay);

          _this.seekOnPlay = null;
        }

        _this.onDurationCheck();
      }, _this.onReady = function () {
        var _this$props2 = _this.props,
            onReady = _this$props2.onReady,
            playing = _this$props2.playing;
        _this.isReady = true;
        _this.loadingSDK = false;
        onReady();

        if (playing || _this.preloading) {
          _this.preloading = false;

          if (_this.loadOnReady) {
            _this.load(_this.loadOnReady);

            _this.loadOnReady = null;
          } else {
            _this.play();
          }
        }

        _this.onDurationCheck();
      }, _this.onDurationCheck = function () {
        clearTimeout(_this.durationCheckTimeout);

        var duration = _this.getDuration();

        if (duration) {
          _this.props.onDuration(duration);
        } else {
          _this.durationCheckTimeout = setTimeout(_this.onDurationCheck, 100);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Base, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var url = this.props.url;
        this.mounted = true;

        if (url) {
          this.load(url);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.stop();
        this.mounted = false;
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _props = this.props,
            url = _props.url,
            playing = _props.playing,
            volume = _props.volume,
            muted = _props.muted,
            playbackRate = _props.playbackRate; // Invoke player methods based on incoming props

        if (url !== nextProps.url && nextProps.url) {
          this.seekOnPlay = null;
          this.startOnPlay = true;
          this.load(nextProps.url);
        }

        if (url && !nextProps.url) {
          this.stop();
          clearTimeout(this.updateTimeout);
        }

        if (!playing && nextProps.playing) {
          this.play();
        }

        if (playing && !nextProps.playing) {
          this.pause();
        }

        if (volume !== nextProps.volume && !nextProps.muted) {
          this.setVolume(nextProps.volume);
        }

        if (muted !== nextProps.muted) {
          this.setVolume(nextProps.muted ? 0 : nextProps.volume);
        }

        if (playbackRate !== nextProps.playbackRate && this.setPlaybackRate) {
          this.setPlaybackRate(nextProps.playbackRate);
        }
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return this.props.url !== nextProps.url;
      }
    }, {
      key: 'callPlayer',
      value: function callPlayer(method) {
        var _player; // Util method for calling a method on this.player
        // but guard against errors and console.warn instead


        if (!this.isReady || !this.player || !this.player[method]) {
          var message = 'ReactPlayer: ' + this.constructor.displayName + ' player could not call %c' + method + "%c \u2013 ";

          if (!this.isReady) {
            message += 'The player was not ready';
          } else if (!this.player) {
            message += 'The player was not available';
          } else if (!this.player[method]) {
            message += 'The method was not available';
          }

          console.warn(message, 'font-weight: bold', '');
          return null;
        }

        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        return (_player = this.player)[method].apply(_player, args);
      }
    }, {
      key: 'seekTo',
      value: function seekTo(amount) {
        var _this2 = this; // When seeking before player is ready, store value and seek later


        if (!this.isReady && amount !== 0) {
          this.seekOnPlay = amount;
          setTimeout(function () {
            _this2.seekOnPlay = null;
          }, SEEK_ON_PLAY_EXPIRY);
        } // Return the seconds to seek to


        if (amount > 0 && amount < 1) {
          // Convert fraction to seconds based on duration
          return this.getDuration() * amount;
        }

        return amount;
      }
    }]);

    return Base;
  }(_react.Component);

  Base.propTypes = _props2.propTypes;
  Base.defaultProps = _props2.defaultProps;
  exports['default'] = Base;
  /***/
},
/* 18 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /* unused harmony export mapProps */

    /* unused harmony export withProps */

    /* unused harmony export withPropsOnChange */

    /* unused harmony export withHandlers */

    /* unused harmony export defaultProps */

    /* unused harmony export renameProp */

    /* unused harmony export renameProps */

    /* unused harmony export flattenProp */

    /* unused harmony export withState */

    /* unused harmony export withStateHandlers */

    /* unused harmony export withReducer */

    /* unused harmony export branch */

    /* unused harmony export renderComponent */

    /* unused harmony export renderNothing */

    /* unused harmony export shouldUpdate */

    /* unused harmony export pure */

    /* unused harmony export onlyUpdateForKeys */

    /* unused harmony export onlyUpdateForPropTypes */

    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "b", function () {
      return withContext;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "a", function () {
      return getContext;
    });
    /* unused harmony export lifecycle */

    /* unused harmony export toClass */

    /* unused harmony export setStatic */

    /* unused harmony export setPropTypes */

    /* unused harmony export setDisplayName */

    /* unused harmony export compose */

    /* unused harmony export getDisplayName */

    /* unused harmony export wrapDisplayName */

    /* unused harmony export isClassComponent */

    /* unused harmony export createSink */

    /* unused harmony export componentFromProp */

    /* unused harmony export nest */

    /* unused harmony export hoistStatics */

    /* unused harmony export componentFromStream */

    /* unused harmony export componentFromStreamWithConfig */

    /* unused harmony export mapPropsStream */

    /* unused harmony export mapPropsStreamWithConfig */

    /* unused harmony export createEventHandler */

    /* unused harmony export createEventHandlerWithConfig */

    /* unused harmony export setObservableConfig */

    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__ = __webpack_require__(249);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(136);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_3_change_emitter__ = __webpack_require__(250);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_3_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_change_emitter__);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_4_symbol_observable__ = __webpack_require__(251);
    /* unused harmony reexport shallowEqual */


    var setStatic = function setStatic(key, value) {
      return function (BaseComponent) {
        /* eslint-disable no-param-reassign */
        BaseComponent[key] = value;
        /* eslint-enable no-param-reassign */

        return BaseComponent;
      };
    };

    var setDisplayName = function setDisplayName(displayName) {
      return setStatic('displayName', displayName);
    };

    var getDisplayName = function getDisplayName(Component$$1) {
      if (typeof Component$$1 === 'string') {
        return Component$$1;
      }

      if (!Component$$1) {
        return undefined;
      }

      return Component$$1.displayName || Component$$1.name || 'Component';
    };

    var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
      return hocName + '(' + getDisplayName(BaseComponent) + ')';
    };

    var mapProps = function mapProps(propsMapper) {
      return function (BaseComponent) {
        var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

        var MapProps = function MapProps(props) {
          return factory(propsMapper(props));
        };

        if (process.env.NODE_ENV !== 'production') {
          return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
        }

        return MapProps;
      };
    };

    var classCallCheck = function classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    };

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    var inherits = function inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    };

    var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
      var target = {};

      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }

      return target;
    };

    var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
    };

    var withProps = function withProps(input) {
      var hoc = mapProps(function (props) {
        return _extends({}, props, typeof input === 'function' ? input(props) : input);
      });

      if (process.env.NODE_ENV !== 'production') {
        return function (BaseComponent) {
          return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
        };
      }

      return hoc;
    };

    var pick = function pick(obj, keys) {
      var result = {};

      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];

        if (obj.hasOwnProperty(key)) {
          result[key] = obj[key];
        }
      }

      return result;
    };

    var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
      return function (BaseComponent) {
        var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
        var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
          return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
        };

        var WithPropsOnChange = function (_Component) {
          inherits(WithPropsOnChange, _Component);

          function WithPropsOnChange() {
            var _temp, _this, _ret;

            classCallCheck(this, WithPropsOnChange);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
          }

          WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (shouldMap(this.props, nextProps)) {
              this.computedProps = propsMapper(nextProps);
            }
          };

          WithPropsOnChange.prototype.render = function render() {
            return factory(_extends({}, this.props, this.computedProps));
          };

          return WithPropsOnChange;
        }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

        if (process.env.NODE_ENV !== 'production') {
          return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
        }

        return WithPropsOnChange;
      };
    };

    var mapValues = function mapValues(obj, func) {
      var result = {};
      /* eslint-disable no-restricted-syntax */

      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          result[key] = func(obj[key], key);
        }
      }
      /* eslint-enable no-restricted-syntax */


      return result;
    };
    /* eslint-disable no-console */


    var withHandlers = function withHandlers(handlers) {
      return function (BaseComponent) {
        var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

        var WithHandlers = function (_Component) {
          inherits(WithHandlers, _Component);

          function WithHandlers() {
            var _temp, _this, _ret;

            classCallCheck(this, WithHandlers);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
          }

          WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
            this.cachedHandlers = {};
          };

          WithHandlers.prototype.render = function render() {
            return factory(_extends({}, this.props, this.handlers));
          };

          return WithHandlers;
        }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

        var _initialiseProps = function _initialiseProps() {
          var _this2 = this;

          this.cachedHandlers = {};
          this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
            return function () {
              var cachedHandler = _this2.cachedHandlers[handlerName];

              if (cachedHandler) {
                return cachedHandler.apply(undefined, arguments);
              }

              var handler = createHandler(_this2.props);
              _this2.cachedHandlers[handlerName] = handler;

              if (process.env.NODE_ENV !== 'production' && typeof handler !== 'function') {
                console.error( // eslint-disable-line no-console
                'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
              }

              return handler.apply(undefined, arguments);
            };
          });
        };

        if (process.env.NODE_ENV !== 'production') {
          return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
        }

        return WithHandlers;
      };
    };

    var defaultProps = function defaultProps(props) {
      return function (BaseComponent) {
        var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

        var DefaultProps = function DefaultProps(ownerProps) {
          return factory(ownerProps);
        };

        DefaultProps.defaultProps = props;

        if (process.env.NODE_ENV !== 'production') {
          return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
        }

        return DefaultProps;
      };
    };

    var omit = function omit(obj, keys) {
      var rest = objectWithoutProperties(obj, []);

      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];

        if (rest.hasOwnProperty(key)) {
          delete rest[key];
        }
      }

      return rest;
    };

    var renameProp = function renameProp(oldName, newName) {
      var hoc = mapProps(function (props) {
        var _babelHelpers$extends;

        return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
      });

      if (process.env.NODE_ENV !== 'production') {
        return function (BaseComponent) {
          return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
        };
      }

      return hoc;
    };

    var keys = Object.keys;

    var mapKeys = function mapKeys(obj, func) {
      return keys(obj).reduce(function (result, key) {
        var val = obj[key];
        /* eslint-disable no-param-reassign */

        result[func(val, key)] = val;
        /* eslint-enable no-param-reassign */

        return result;
      }, {});
    };

    var renameProps = function renameProps(nameMap) {
      var hoc = mapProps(function (props) {
        return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
          return nameMap[oldName];
        }));
      });

      if (process.env.NODE_ENV !== 'production') {
        return function (BaseComponent) {
          return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
        };
      }

      return hoc;
    };

    var flattenProp = function flattenProp(propName) {
      return function (BaseComponent) {
        var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

        var FlattenProp = function FlattenProp(props) {
          return factory(_extends({}, props, props[propName]));
        };

        if (process.env.NODE_ENV !== 'production') {
          return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
        }

        return FlattenProp;
      };
    };

    var withState = function withState(stateName, stateUpdaterName, initialState) {
      return function (BaseComponent) {
        var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

        var WithState = function (_Component) {
          inherits(WithState, _Component);

          function WithState() {
            var _temp, _this, _ret;

            classCallCheck(this, WithState);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
              stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
            }, _this.updateStateValue = function (updateFn, callback) {
              return _this.setState(function (_ref) {
                var stateValue = _ref.stateValue;
                return {
                  stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
                };
              }, callback);
            }, _temp), possibleConstructorReturn(_this, _ret);
          }

          WithState.prototype.render = function render() {
            var _babelHelpers$extends;

            return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
          };

          return WithState;
        }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

        if (process.env.NODE_ENV !== 'production') {
          return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
        }

        return WithState;
      };
    };

    var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
      return function (BaseComponent) {
        var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

        var WithStateHandlers = function (_Component) {
          inherits(WithStateHandlers, _Component);

          function WithStateHandlers() {
            var _temp, _this, _ret;

            classCallCheck(this, WithStateHandlers);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
          }

          WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            var propsChanged = nextProps !== this.props; // the idea is to skip render if stateUpdater handler return undefined
            // this allows to create no state update handlers with access to state and props

            var stateChanged = !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(nextState, this.state);
            return propsChanged || stateChanged;
          };

          WithStateHandlers.prototype.render = function render() {
            return factory(_extends({}, this.props, this.state, this.stateUpdaters));
          };

          return WithStateHandlers;
        }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

        var _initialiseProps = function _initialiseProps() {
          var _this2 = this;

          this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
          this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
            return function (mayBeEvent) {
              for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                args[_key2 - 1] = arguments[_key2];
              } // Having that functional form of setState can be called async
              // we need to persist SyntheticEvent


              if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
                mayBeEvent.persist();
              }

              _this2.setState(function (state, props) {
                return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
              });
            };
          });
        };

        if (process.env.NODE_ENV !== 'production') {
          return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
        }

        return WithStateHandlers;
      };
    };

    var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
      return function (BaseComponent) {
        var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

        var WithReducer = function (_Component) {
          inherits(WithReducer, _Component);

          function WithReducer() {
            var _temp, _this, _ret;

            classCallCheck(this, WithReducer);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
              stateValue: _this.initializeStateValue()
            }, _this.dispatch = function (action) {
              return _this.setState(function (_ref) {
                var stateValue = _ref.stateValue;
                return {
                  stateValue: reducer(stateValue, action)
                };
              });
            }, _temp), possibleConstructorReturn(_this, _ret);
          }

          WithReducer.prototype.initializeStateValue = function initializeStateValue() {
            if (initialState !== undefined) {
              return typeof initialState === 'function' ? initialState(this.props) : initialState;
            }

            return reducer(undefined, {
              type: '@@recompose/INIT'
            });
          };

          WithReducer.prototype.render = function render() {
            var _babelHelpers$extends;

            return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
          };

          return WithReducer;
        }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

        if (process.env.NODE_ENV !== 'production') {
          return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
        }

        return WithReducer;
      };
    };

    var identity = function identity(Component$$1) {
      return Component$$1;
    };

    var branch = function branch(test, left) {
      var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
      return function (BaseComponent) {
        var leftFactory = void 0;
        var rightFactory = void 0;

        var Branch = function Branch(props) {
          if (test(props)) {
            leftFactory = leftFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(left(BaseComponent));
            return leftFactory(props);
          }

          rightFactory = rightFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(right(BaseComponent));
          return rightFactory(props);
        };

        if (process.env.NODE_ENV !== 'production') {
          return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
        }

        return Branch;
      };
    };

    var renderComponent = function renderComponent(Component$$1) {
      return function (_) {
        var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(Component$$1);

        var RenderComponent = function RenderComponent(props) {
          return factory(props);
        };

        if (process.env.NODE_ENV !== 'production') {
          RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
        }

        return RenderComponent;
      };
    };

    var Nothing = function (_Component) {
      inherits(Nothing, _Component);

      function Nothing() {
        classCallCheck(this, Nothing);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Nothing.prototype.render = function render() {
        return null;
      };

      return Nothing;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var renderNothing = function renderNothing(_) {
      return Nothing;
    };

    var shouldUpdate = function shouldUpdate(test) {
      return function (BaseComponent) {
        var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

        var ShouldUpdate = function (_Component) {
          inherits(ShouldUpdate, _Component);

          function ShouldUpdate() {
            classCallCheck(this, ShouldUpdate);
            return possibleConstructorReturn(this, _Component.apply(this, arguments));
          }

          ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return test(this.props, nextProps);
          };

          ShouldUpdate.prototype.render = function render() {
            return factory(this.props);
          };

          return ShouldUpdate;
        }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

        if (process.env.NODE_ENV !== 'production') {
          return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
        }

        return ShouldUpdate;
      };
    };

    var pure = function pure(BaseComponent) {
      var hoc = shouldUpdate(function (props, nextProps) {
        return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(props, nextProps);
      });

      if (process.env.NODE_ENV !== 'production') {
        return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
      }

      return hoc(BaseComponent);
    };

    var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
      var hoc = shouldUpdate(function (props, nextProps) {
        return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(nextProps, propKeys), pick(props, propKeys));
      });

      if (process.env.NODE_ENV !== 'production') {
        return function (BaseComponent) {
          return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
        };
      }

      return hoc;
    };

    var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
      var propTypes = BaseComponent.propTypes;

      if (process.env.NODE_ENV !== 'production') {
        if (!propTypes) {
          /* eslint-disable */
          console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
          /* eslint-enable */
        }
      }

      var propKeys = Object.keys(propTypes || {});
      var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

      if (process.env.NODE_ENV !== 'production') {
        return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
      }

      return OnlyUpdateForPropTypes;
    };

    var withContext = function withContext(childContextTypes, getChildContext) {
      return function (BaseComponent) {
        var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

        var WithContext = function (_Component) {
          inherits(WithContext, _Component);

          function WithContext() {
            var _temp, _this, _ret;

            classCallCheck(this, WithContext);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
              return getChildContext(_this.props);
            }, _temp), possibleConstructorReturn(_this, _ret);
          }

          WithContext.prototype.render = function render() {
            return factory(this.props);
          };

          return WithContext;
        }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

        WithContext.childContextTypes = childContextTypes;

        if (process.env.NODE_ENV !== 'production') {
          return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
        }

        return WithContext;
      };
    };

    var getContext = function getContext(contextTypes) {
      return function (BaseComponent) {
        var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

        var GetContext = function GetContext(ownerProps, context) {
          return factory(_extends({}, ownerProps, context));
        };

        GetContext.contextTypes = contextTypes;

        if (process.env.NODE_ENV !== 'production') {
          return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
        }

        return GetContext;
      };
    };
    /* eslint-disable no-console */


    var lifecycle = function lifecycle(spec) {
      return function (BaseComponent) {
        var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

        if (process.env.NODE_ENV !== 'production' && spec.hasOwnProperty('render')) {
          console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
        }

        var Lifecycle = function (_Component) {
          inherits(Lifecycle, _Component);

          function Lifecycle() {
            classCallCheck(this, Lifecycle);
            return possibleConstructorReturn(this, _Component.apply(this, arguments));
          }

          Lifecycle.prototype.render = function render() {
            return factory(_extends({}, this.props, this.state));
          };

          return Lifecycle;
        }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

        Object.keys(spec).forEach(function (hook) {
          return Lifecycle.prototype[hook] = spec[hook];
        });

        if (process.env.NODE_ENV !== 'production') {
          return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
        }

        return Lifecycle;
      };
    };

    var isClassComponent = function isClassComponent(Component$$1) {
      return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
    };

    var toClass = function toClass(baseComponent) {
      if (isClassComponent(baseComponent)) {
        return baseComponent;
      }

      var ToClass = function (_Component) {
        inherits(ToClass, _Component);

        function ToClass() {
          classCallCheck(this, ToClass);
          return possibleConstructorReturn(this, _Component.apply(this, arguments));
        }

        ToClass.prototype.render = function render() {
          if (typeof baseComponent === 'string') {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
          }

          return baseComponent(this.props, this.context);
        };

        return ToClass;
      }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

      ToClass.displayName = getDisplayName(baseComponent);
      ToClass.propTypes = baseComponent.propTypes;
      ToClass.contextTypes = baseComponent.contextTypes;
      ToClass.defaultProps = baseComponent.defaultProps;
      return ToClass;
    };

    var setPropTypes = function setPropTypes(propTypes) {
      return setStatic('propTypes', propTypes);
    };

    function compose() {
      for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
        funcs[_key] = arguments[_key];
      }

      if (funcs.length === 0) {
        return function (arg) {
          return arg;
        };
      }

      if (funcs.length === 1) {
        return funcs[0];
      }

      return funcs.reduce(function (a, b) {
        return function () {
          return a(b.apply(undefined, arguments));
        };
      });
    }

    var createSink = function createSink(callback) {
      return function (_Component) {
        inherits(Sink, _Component);

        function Sink() {
          classCallCheck(this, Sink);
          return possibleConstructorReturn(this, _Component.apply(this, arguments));
        }

        Sink.prototype.componentWillMount = function componentWillMount() {
          callback(this.props);
        };

        Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
          callback(nextProps);
        };

        Sink.prototype.render = function render() {
          return null;
        };

        return Sink;
      }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
    };

    var componentFromProp = function componentFromProp(propName) {
      var Component$$1 = function Component$$1(props) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(props[propName], omit(props, [propName]));
      };

      Component$$1.displayName = 'componentFromProp(' + propName + ')';
      return Component$$1;
    };

    var nest = function nest() {
      for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
        Components[_key] = arguments[_key];
      }

      var factories = Components.map(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"]);

      var Nest = function Nest(_ref) {
        var props = objectWithoutProperties(_ref, []),
            children = _ref.children;
        return factories.reduceRight(function (child, factory) {
          return factory(props, child);
        }, children);
      };

      if (process.env.NODE_ENV !== 'production') {
        var displayNames = Components.map(getDisplayName);
        Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
      }

      return Nest;
    };

    var hoistStatics = function hoistStatics(higherOrderComponent) {
      return function (BaseComponent) {
        var NewComponent = higherOrderComponent(BaseComponent);

        __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(NewComponent, BaseComponent);

        return NewComponent;
      };
    };

    var _config = {
      fromESObservable: null,
      toESObservable: null
    };

    var configureObservable = function configureObservable(c) {
      _config = c;
    };

    var config = {
      fromESObservable: function fromESObservable(observable) {
        return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
      },
      toESObservable: function toESObservable(stream) {
        return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
      }
    };

    var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
      return function (propsToVdom) {
        return function (_Component) {
          inherits(ComponentFromStream, _Component);

          function ComponentFromStream() {
            var _config$fromESObserva;

            var _temp, _this, _ret;

            classCallCheck(this, ComponentFromStream);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
              vdom: null
            }, _this.propsEmitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
              subscribe: function subscribe(observer) {
                var unsubscribe = _this.propsEmitter.listen(function (props) {
                  if (props) {
                    observer.next(props);
                  } else {
                    observer.complete();
                  }
                });

                return {
                  unsubscribe: unsubscribe
                };
              }
            }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a"
            /* default */
            ]] = function () {
              return this;
            }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
          } // Stream of props
          // Stream of vdom


          ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
            var _this2 = this; // Subscribe to child prop changes so we know when to re-render


            this.subscription = this.vdom$.subscribe({
              next: function next(vdom) {
                _this2.setState({
                  vdom: vdom
                });
              }
            });
            this.propsEmitter.emit(this.props);
          };

          ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            // Receive new props from the owner
            this.propsEmitter.emit(nextProps);
          };

          ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            return nextState.vdom !== this.state.vdom;
          };

          ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
            // Call without arguments to complete stream
            this.propsEmitter.emit(); // Clean-up subscription before un-mounting

            this.subscription.unsubscribe();
          };

          ComponentFromStream.prototype.render = function render() {
            return this.state.vdom;
          };

          return ComponentFromStream;
        }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
      };
    };

    var componentFromStream = function componentFromStream(propsToVdom) {
      return componentFromStreamWithConfig(config)(propsToVdom);
    };

    var identity$1 = function identity(t) {
      return t;
    };

    var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
      var componentFromStream = componentFromStreamWithConfig({
        fromESObservable: identity$1,
        toESObservable: identity$1
      });
      return function (transform) {
        return function (BaseComponent) {
          var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
          var fromESObservable = config$$1.fromESObservable,
              toESObservable = config$$1.toESObservable;
          return componentFromStream(function (props$) {
            var _ref;

            return _ref = {
              subscribe: function subscribe(observer) {
                var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
                  next: function next(childProps) {
                    return observer.next(factory(childProps));
                  }
                });
                return {
                  unsubscribe: function unsubscribe() {
                    return subscription.unsubscribe();
                  }
                };
              }
            }, _ref[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a"
            /* default */
            ]] = function () {
              return this;
            }, _ref;
          });
        };
      };
    };

    var mapPropsStream = function mapPropsStream(transform) {
      var hoc = mapPropsStreamWithConfig(config)(transform);

      if (process.env.NODE_ENV !== 'production') {
        return function (BaseComponent) {
          return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
        };
      }

      return hoc;
    };

    var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
      return function () {
        var _config$fromESObserva;

        var emitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])();
        var stream = config$$1.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = emitter.listen(function (value) {
              return observer.next(value);
            });
            return {
              unsubscribe: unsubscribe
            };
          }
        }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a"
        /* default */
        ]] = function () {
          return this;
        }, _config$fromESObserva));
        return {
          handler: emitter.emit,
          stream: stream
        };
      };
    };

    var createEventHandler = createEventHandlerWithConfig(config); // Higher-order component helpers

    /* WEBPACK VAR INJECTION */
  }).call(__webpack_exports__, __webpack_require__(8));
  /***/
},
/* 19 */

/***/
function (module, exports, __webpack_require__) {
  var freeGlobal = __webpack_require__(139);
  /** Detect free variable `self`. */


  var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof4(self)) == 'object' && self && self.Object === Object && self;
  /** Used as a reference to the global object. */

  var root = freeGlobal || freeSelf || Function('return this')();
  module.exports = root;
  /***/
},
/* 20 */

/***/
function (module, exports, __webpack_require__) {
  var freeGlobal = __webpack_require__(178);
  /** Detect free variable `self`. */


  var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof4(self)) == 'object' && self && self.Object === Object && self;
  /** Used as a reference to the global object. */

  var root = freeGlobal || freeSelf || Function('return this')();
  module.exports = root;
  /***/
},
/* 21 */

/***/
function (module, exports) {
  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray = Array.isArray;
  module.exports = isArray;
  /***/
},
/* 22 */

/***/
function (module, exports) {
  module.exports = function (it) {
    return _typeof4(it) === 'object' ? it !== null : typeof it === 'function';
  };
  /***/

},
/* 23 */

/***/
function (module, exports, __webpack_require__) {
  // Thank's IE8 for his funny defineProperty
  module.exports = !__webpack_require__(31)(function () {
    return Object.defineProperty({}, 'a', {
      get: function get() {
        return 7;
      }
    }).a != 7;
  });
  /***/
},
/* 24 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  var _assign = __webpack_require__(122);

  var _assign2 = _interopRequireDefault(_assign);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  exports["default"] = _assign2["default"] || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  /***/

},
/* 25 */

/***/
function (module, exports) {
  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray = Array.isArray;
  module.exports = isArray;
  /***/
},
/* 26 */

/***/
function (module, exports, __webpack_require__) {
  var dP = __webpack_require__(15);

  var createDesc = __webpack_require__(37);

  module.exports = __webpack_require__(23) ? function (object, key, value) {
    return dP.f(object, key, createDesc(1, value));
  } : function (object, key, value) {
    object[key] = value;
    return object;
  };
  /***/
},
/* 27 */

/***/
function (module, exports) {
  var hasOwnProperty = {}.hasOwnProperty;

  module.exports = function (it, key) {
    return hasOwnProperty.call(it, key);
  };
  /***/

},
/* 28 */

/***/
function (module, exports, __webpack_require__) {
  var baseIsNative = __webpack_require__(283),
      getValue = __webpack_require__(286);
  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */


  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }

  module.exports = getNative;
  /***/
},
/* 29 */

/***/
function (module, exports, __webpack_require__) {
  var baseIsNative = __webpack_require__(424),
      getValue = __webpack_require__(429);
  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */


  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }

  module.exports = getNative;
  /***/
},
/* 30 */

/***/
function (module, exports, __webpack_require__) {
  // optional / simple context binding
  var aFunction = __webpack_require__(54);

  module.exports = function (fn, that, length) {
    aFunction(fn);
    if (that === undefined) return fn;

    switch (length) {
      case 1:
        return function (a) {
          return fn.call(that, a);
        };

      case 2:
        return function (a, b) {
          return fn.call(that, a, b);
        };

      case 3:
        return function (a, b, c) {
          return fn.call(that, a, b, c);
        };
    }

    return function ()
    /* ...args */
    {
      return fn.apply(that, arguments);
    };
  };
  /***/

},
/* 31 */

/***/
function (module, exports) {
  module.exports = function (exec) {
    try {
      return !!exec();
    } catch (e) {
      return true;
    }
  };
  /***/

},
/* 32 */

/***/
function (module, exports, __webpack_require__) {
  // to indexed object, toObject with fallback for non-array-like ES3 strings
  var IObject = __webpack_require__(114);

  var defined = __webpack_require__(76);

  module.exports = function (it) {
    return IObject(defined(it));
  };
  /***/

},
/* 33 */

/***/
function (module, exports) {
  var g; // This works in non-strict mode

  g = function () {
    return this;
  }();

  try {
    // This works if eval is allowed (see CSP)
    g = g || Function("return this")() || (1, eval)("this");
  } catch (e) {
    // This works if the window reference is available
    if ((typeof window === "undefined" ? "undefined" : _typeof4(window)) === "object") g = window;
  } // g can still be undefined, but nothing to do about it...
  // We return undefined, instead of nothing here, so it's
  // easier to handle this case. if(!global) { ...}


  module.exports = g;
  /***/
},
/* 34 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);

  var _class,
      _temp,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/UI/Icon/Icon.js';

  var Icon = (_temp = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Icon, _React$Component);

    function Icon() {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Icon);

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Icon.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Icon)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Icon, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            name = _props.name,
            className = _props.className;
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('svg', {
          className: 'cw-icon ' + (className || ''),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 19
          }
        }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('use', {
          xlinkHref: '#' + name,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 20
          }
        }));
      }
    }]);

    return Icon;
  }(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component), _class.propTypes = {
    /** Name of the icon definition. Check it in icons.js */
    name: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
    className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['', '-tiny', '-smaller', '-small', '-medium', '-big', '-huge'])
  }, _class.defaultProps = {
    name: '',
    className: ''
  }, _temp);
  Icon.displayName = 'Icon';
  /* harmony default export */

  __webpack_exports__["a"] = Icon;
  /***/
},
/* 35 */

/***/
function (module, exports) {
  module.exports = require("react-dom");
  /***/
},
/* 36 */

/***/
function (module, exports) {
  module.exports = true;
  /***/
},
/* 37 */

/***/
function (module, exports) {
  module.exports = function (bitmap, value) {
    return {
      enumerable: !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable: !(bitmap & 4),
      value: value
    };
  };
  /***/

},
/* 38 */

/***/
function (module, exports) {
  module.exports = {};
  /***/
},
/* 39 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.14 / 15.2.3.14 Object.keys(O)
  var $keys = __webpack_require__(113);

  var enumBugKeys = __webpack_require__(83);

  module.exports = Object.keys || function keys(O) {
    return $keys(O, enumBugKeys);
  };
  /***/

},
/* 40 */

/***/
function (module, exports) {
  var toString = {}.toString;

  module.exports = function (it) {
    return toString.call(it).slice(8, -1);
  };
  /***/

},
/* 41 */

/***/
function (module, exports, __webpack_require__) {
  // 7.1.13 ToObject(argument)
  var defined = __webpack_require__(76);

  module.exports = function (it) {
    return Object(defined(it));
  };
  /***/

},
/* 42 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(254),
    __esModule: true
  };
  /***/
},
/* 43 */

/***/
function (module, exports, __webpack_require__) {
  var _Symbol2 = __webpack_require__(58),
      getRawTag = __webpack_require__(265),
      objectToString = __webpack_require__(266);
  /** `Object#toString` result references. */


  var nullTag = '[object Null]',
      undefinedTag = '[object Undefined]';
  /** Built-in value references. */

  var symToStringTag = _Symbol2 ? _Symbol2.toStringTag : undefined;
  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */

  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }

    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }

  module.exports = baseGetTag;
  /***/
},
/* 44 */

/***/
function (module, exports) {
  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return value != null && _typeof4(value) == 'object';
  }

  module.exports = isObjectLike;
  /***/
},
/* 45 */

/***/
function (module, exports) {
  module.exports = function (module) {
    if (!module.webpackPolyfill) {
      module.deprecate = function () {};

      module.paths = []; // module.parent = undefined by default

      if (!module.children) module.children = [];
      Object.defineProperty(module, "loaded", {
        enumerable: true,
        get: function get() {
          return module.l;
        }
      });
      Object.defineProperty(module, "id", {
        enumerable: true,
        get: function get() {
          return module.i;
        }
      });
      module.webpackPolyfill = 1;
    }

    return module;
  };
  /***/

},
/* 46 */

/***/
function (module, exports, __webpack_require__) {
  !function (e, t) {
    true ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == _typeof4(exports) ? exports["react-form"] = t() : e["react-form"] = t();
  }(this, function () {
    return function (e) {
      function t(a) {
        if (r[a]) return r[a].exports;
        var n = r[a] = {
          i: a,
          l: !1,
          exports: {}
        };
        return e[a].call(n.exports, n, n.exports, t), n.l = !0, n.exports;
      }

      var r = {};
      return t.m = e, t.c = r, t.d = function (e, r, a) {
        t.o(e, r) || Object.defineProperty(e, r, {
          configurable: !1,
          enumerable: !0,
          get: a
        });
      }, t.n = function (e) {
        var r = e && e.__esModule ? function () {
          return e["default"];
        } : function () {
          return e;
        };
        return t.d(r, "a", r), r;
      }, t.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, t.p = "", t(t.s = 23);
    }([function (e, t) {
      e.exports = __webpack_require__(0);
    }, function (e, t) {
      e.exports = __webpack_require__(3);
    }, function (e, t) {
      e.exports = __webpack_require__(4);
    }, function (e, t) {
      e.exports = __webpack_require__(24);
    }, function (e, t) {
      e.exports = __webpack_require__(2);
    }, function (e, t) {
      e.exports = __webpack_require__(5);
    }, function (e, t) {
      e.exports = __webpack_require__(6);
    }, function (e, t) {
      e.exports = __webpack_require__(161);
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function n(e) {
        var t = function (t) {
          function r() {
            return (0, h["default"])(this, r), (0, y["default"])(this, (r.__proto__ || (0, f["default"])(r)).apply(this, arguments));
          }

          return (0, _["default"])(r, t), (0, g["default"])(r, [{
            key: "componentWillReceiveProps",
            value: function value(e, t) {
              t.formApi.submitted === this.context.formApi.submitted || this.props.nestedForm || this.context.formApi.setTouched(this.props.field, !0, !1), t.formApi.submits === this.context.formApi.submits || this.props.nestedForm || this.context.formApi.setTouched(this.props.field, !0, !1);
            }
          }, {
            key: "shouldComponentUpdate",
            value: function value(e, t, r) {
              var a = this.props.field,
                  n = this.context.formApi,
                  u = r.formApi,
                  i = (0, d["default"])({}, this.props, {
                children: null
              }),
                  s = (0, d["default"])({}, e, {
                children: null
              });
              return C["default"].get(u.values, a) !== C["default"].get(n.values, a) || C["default"].get(u.touched, a) !== C["default"].get(n.touched, a) || C["default"].get(u.errors, a) !== C["default"].get(n.errors, a) || C["default"].get(u.warnings, a) !== C["default"].get(n.warnings, a) || C["default"].get(u.successes, a) !== C["default"].get(n.successes, a) || C["default"].get(u.validating, a) !== C["default"].get(n.validating, a) || C["default"].get(u.validationFailed, a) !== C["default"].get(n.validationFailed, a) || !C["default"].isShallowEqual(s, i) || r.formApi.submits !== this.context.formApi.submits || !1;
            }
          }, {
            key: "render",
            value: function value() {
              var t = this.context.formApi,
                  r = this.props,
                  a = r.field,
                  n = (0, o["default"])(r, ["field"]),
                  u = {
                setValue: function setValue(e) {
                  t.setValue(a, e);
                },
                setTouched: function setTouched(e) {
                  t.setTouched(a, e);
                },
                setError: function setError(e) {
                  t.setError(a, e);
                },
                setWarning: function setWarning(e) {
                  t.setWarning(a, e);
                },
                setSuccess: function setSuccess(e) {
                  t.setSuccess(a, e);
                },
                getFieldName: function getFieldName() {
                  return a;
                },
                getValue: function getValue() {
                  return t.getValue(a);
                },
                getTouched: function getTouched() {
                  return t.getTouched(a);
                },
                getError: function getError() {
                  return t.getError(a);
                },
                getWarning: function getWarning() {
                  return t.getWarning(a);
                },
                getSuccess: function getSuccess() {
                  return t.getSuccess(a);
                },
                validatingField: function validatingField() {
                  return t.validatingField(a);
                },
                doneValidatingField: function doneValidatingField() {
                  return t.doneValidatingField(a);
                },
                reset: function reset() {
                  return t.reset(a);
                },
                registerAsyncValidation: t.registerAsyncValidation,
                submitted: t.submitted,
                submits: t.submits
              };
              return E["default"].createElement(e, (0, d["default"])({
                fieldApi: u
              }, n));
            }
          }]), r;
        }(A.Component);

        return t.contextTypes = {
          formApi: b["default"].object
        }, "object" === (void 0 === e ? "undefined" : (0, i["default"])(e)) ? E["default"].createElement(N["default"], e) : t;
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var u = r(17),
          i = a(u),
          s = r(7),
          o = a(s),
          l = r(3),
          d = a(l),
          c = r(4),
          f = a(c),
          p = r(1),
          h = a(p),
          v = r(2),
          g = a(v),
          m = r(5),
          y = a(m),
          S = r(6),
          _ = a(S),
          A = r(0),
          E = a(A),
          V = r(12),
          b = a(V),
          T = r(14),
          C = a(T),
          O = r(33),
          N = a(O);

      t["default"] = n;
    }, function (e, t) {
      e.exports = __webpack_require__(14);
    }, function (e, t) {
      e.exports = __webpack_require__(362);
    }, function (e, t, r) {
      "use strict";

      function a(e, t, r) {
        var a = null;
        return e && (a = "error"), !e && t && (a = "warning"), e || t || !r || (a = "success"), a;
      }

      function n(e, t, r) {
        var a = "";
        return e && (a = e), !e && t && (a = t), e || t || !r || (a = r), a;
      }

      function u(e) {
        var t = e.touchValidation,
            r = e.valueValidation,
            a = e.touched,
            n = e.value;
        return !(t && !a) && !(r && !n);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t["default"] = {
        getMessage: n,
        getMessageType: a,
        shouldShowValidation: u
      };
    }, function (e, t) {
      e.exports = __webpack_require__(1);
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var n = r(3),
          u = a(n),
          i = r(9),
          s = a(i),
          o = r(7),
          l = a(o),
          d = r(0),
          c = a(d),
          f = r(10),
          p = a(f),
          h = function h(e) {
        var t = e.message,
            r = e.type,
            a = (0, l["default"])(e, ["message", "type"]),
            n = (0, p["default"])("react-form-message", (0, s["default"])({}, "react-form-message-" + r, r));
        return c["default"].createElement("small", (0, u["default"])({}, a, {
          className: n
        }), t);
      };

      t["default"] = h;
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function n(e) {
        return Array.isArray(e);
      }

      function u(e) {
        return !Array.isArray(e) && "object" === (void 0 === e ? "undefined" : (0, h["default"])(e)) && null !== e;
      }

      function i(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
        if (n(e)) for (var r = 0; r < e.length; r++) {
          i(e[r], t);
        } else t.push(e);
        return t;
      }

      function s(e) {
        var t = [];
        return i(e).forEach(function (e) {
          "string" == typeof e ? t = t.concat(e.replace(/\[(\d*)\]/gm, ".__int__$1").replace("[", ".").replace("]", "").split(".").map(function (e) {
            return 0 === e.indexOf("__int__") ? parseInt(e.substring(7), 10) : e;
          })) : t.push(e);
        }), t;
      }

      function o() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = arguments[1],
            r = arguments[2],
            a = s(t),
            i = void 0;
        "number" != typeof a[0] || n(e) ? "string" != typeof a[0] || u(e) || (e = {}) : e = [];

        for (var o = e; void 0 !== (i = a.shift()) && a.length;) {
          "number" != typeof a[0] || n(o[i]) || (o[i] = []), "number" == typeof a[0] || u(o[i]) || (o[i] = {}), o = o[i];
        }

        return o[i] = r, e;
      }

      function l(e, t, r) {
        if (!t) return e;
        var a = s(t),
            n = a.reduce(function (e, t) {
          if (void 0 !== e && null !== e) return e[t];
        }, e);
        return void 0 !== n ? n : r;
      }

      function d(e, t) {
        if ((0, f["default"])(e).length !== (0, f["default"])(t).length) return !1;

        for (var r in e) {
          if (e[r] !== t[r]) return !1;
        }

        return !0;
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var c = r(16),
          f = a(c),
          p = r(17),
          h = a(p);
      t["default"] = {
        get: l,
        set: o,
        isObject: u,
        isArray: n,
        isShallowEqual: d
      };
    }, function (e, t) {
      e.exports = __webpack_require__(53);
    }, function (e, t) {
      e.exports = __webpack_require__(42);
    }, function (e, t) {
      e.exports = __webpack_require__(85);
    }, function (e, t) {
      e.exports = __webpack_require__(363);
    }, function (e, t) {
      e.exports = __webpack_require__(366);
    }, function (e, t) {
      e.exports = __webpack_require__(130);
    }, function (e, t) {
      e.exports = __webpack_require__(122);
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function n(e) {
        return {
          type: W,
          formState: e
        };
      }

      function u(e, t) {
        return {
          type: D,
          field: e,
          value: t
        };
      }

      function i(e) {
        return {
          type: U,
          values: e
        };
      }

      function s(e, t) {
        return {
          type: B,
          field: e,
          format: t
        };
      }

      function o(e, t) {
        return {
          type: j,
          field: e,
          error: t
        };
      }

      function l(e, t) {
        return {
          type: P,
          field: e,
          warning: t
        };
      }

      function d(e, t) {
        return {
          type: q,
          field: e,
          success: t
        };
      }

      function c(e, t) {
        return {
          type: G,
          field: e,
          error: t
        };
      }

      function f(e, t) {
        return {
          type: Y,
          field: e,
          warning: t
        };
      }

      function p(e, t) {
        return {
          type: J,
          field: e,
          success: t
        };
      }

      function h(e) {
        return {
          type: H,
          field: e
        };
      }

      function v(e) {
        return {
          type: $,
          field: e
        };
      }

      function g(e) {
        return {
          type: z,
          field: e
        };
      }

      function m(e, t) {
        return {
          type: K,
          field: e,
          touched: t
        };
      }

      function y(e) {
        return {
          type: Q,
          touched: e
        };
      }

      function S(e) {
        return {
          type: X,
          field: e
        };
      }

      function _() {
        return {
          type: Z
        };
      }

      function A() {
        return {
          type: ee
        };
      }

      function E() {
        return {
          type: te
        };
      }

      function V() {
        return {
          type: re
        };
      }

      function b() {
        return {
          type: ae
        };
      }

      function T() {
        return {
          type: ne
        };
      }

      function C() {
        return {
          type: ue
        };
      }

      function O(e) {
        return {
          type: ie,
          submitting: e
        };
      }

      function N(e) {
        return {
          type: se,
          field: e
        };
      }

      function M(e) {
        return {
          type: oe,
          field: e
        };
      }

      function x(e, t) {
        return {
          type: le,
          field: e,
          error: t
        };
      }

      function R(e) {
        return {
          type: de,
          field: e
        };
      }

      function I(e) {
        var t = this,
            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function () {
          return {};
        };
        return function () {
          var a = (0, w["default"])(L["default"].mark(function a(n, u) {
            var i, s;
            return L["default"].wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (i = Array.isArray(e) ? e[0] : e, !r[i] || u().errors[i]) {
                      t.next = 17;
                      break;
                    }

                    return n(N(e)), t.prev = 3, t.next = 6, r[i](u().values[i]);

                  case 6:
                    s = t.sent, s.hasOwnProperty("error") && n(c(e, s.error)), s.hasOwnProperty("warning") && n(f(e, s.warning)), s.hasOwnProperty("success") && n(p(e, s.success)), n(R(e)), t.next = 16;
                    break;

                  case 13:
                    t.prev = 13, t.t0 = t["catch"](3), n(x(e, t.t0));

                  case 16:
                    n(M(e));

                  case 17:
                  case "end":
                    return t.stop();
                }
              }
            }, a, t, [[3, 13]]);
          }));
          return function (e, t) {
            return a.apply(this, arguments);
          };
        }();
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.VALIDATION_SUCCESS = t.VALIDATION_FAILURE = t.DONE_VALIDATING_FIELD = t.VALIDATING_FIELD = t.SUBMITTING = t.SUBMITS = t.SUBMITTED = t.SUBMIT = t.VALIDATE = t.PRE_VALIDATE = t.CLEAR_ALL = t.RESET_ALL = t.RESET = t.SET_ALL_TOUCHED = t.SET_TOUCHED = t.REMOVE_ASYNC_SUCCESS = t.REMOVE_ASYNC_WARNING = t.REMOVE_ASYNC_ERROR = t.SET_ASYNC_SUCCESS = t.SET_ASYNC_WARNING = t.SET_ASYNC_ERROR = t.SET_SUCCESS = t.SET_WARNING = t.SET_ERROR = t.FORMAT = t.SET_ALL_VALUES = t.SET_VALUE = t.SET_FORM_STATE = void 0;
      var F = r(18),
          L = a(F),
          k = r(19),
          w = a(k);
      t.setFormState = n, t.setValue = u, t.setAllValues = i, t.format = s, t.setError = o, t.setWarning = l, t.setSuccess = d, t.setAsyncError = c, t.setAsyncWarning = f, t.setAsyncSuccess = p, t.removeAsyncError = h, t.removeAsyncWarning = v, t.removeAsyncSuccess = g, t.setTouched = m, t.setAllTouched = y, t.reset = S, t.resetAll = _, t.clearAll = A, t.preValidate = E, t.validate = V, t.submit = b, t.submitted = T, t.submits = C, t.submitting = O, t.validatingField = N, t.doneValidatingField = M, t.validationFailure = x, t.validationSuccess = R, t.asyncValidate = I;
      var W = t.SET_FORM_STATE = "SET_FORM_STATE",
          D = t.SET_VALUE = "SET_VALUE",
          U = t.SET_ALL_VALUES = "SET_ALL_VALUES",
          B = t.FORMAT = "FORMAT",
          j = t.SET_ERROR = "SET_ERROR",
          P = t.SET_WARNING = "SET_WARNING",
          q = t.SET_SUCCESS = "SET_SUCCESS",
          G = t.SET_ASYNC_ERROR = "SET_ASYNC_ERROR",
          Y = t.SET_ASYNC_WARNING = "SET_ASYNC_WARNING",
          J = t.SET_ASYNC_SUCCESS = "SET_ASYNC_SUCCESS",
          H = t.REMOVE_ASYNC_ERROR = "REMOVE_ASYNC_ERROR",
          $ = t.REMOVE_ASYNC_WARNING = "REMOVE_ASYNC_WARNING",
          z = t.REMOVE_ASYNC_SUCCESS = "REMOVE_ASYNC_SUCCESS",
          K = t.SET_TOUCHED = "SET_TOUCHED",
          Q = t.SET_ALL_TOUCHED = "SET_ALL_TOUCHED",
          X = t.RESET = "RESET",
          Z = t.RESET_ALL = "RESET_ALL",
          ee = t.CLEAR_ALL = "CLEAR_ALL",
          te = t.PRE_VALIDATE = "PRE_VALIDATE",
          re = t.VALIDATE = "VALIDATE",
          ae = t.SUBMIT = "SUBMIT",
          ne = t.SUBMITTED = "SUBMITTED",
          ue = t.SUBMITS = "SUBMITS",
          ie = t.SUBMITTING = "SUBMITTING",
          se = t.VALIDATING_FIELD = "VALIDATING_FIELD",
          oe = t.DONE_VALIDATING_FIELD = "DONE_VALIDATING_FIELD",
          le = t.VALIDATION_FAILURE = "VALIDATION_FAILURE",
          de = t.VALIDATION_SUCCESS = "VALIDATION_SUCCESS";
    }, function (e, t, r) {
      e.exports = r(24);
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.StyledRadioGroup = t.StyledCheckbox = t.StyledSelect = t.StyledTextArea = t.StyledRadio = t.StyledText = t.TextArea = t.Checkbox = t.Select = t.Radio = t.RadioGroup = t.FormField = t.NestedForm = t.Text = t.Form = void 0;

      var n = r(25),
          u = a(n),
          i = r(32),
          s = a(i),
          o = r(34),
          l = a(o),
          d = r(35),
          c = a(d),
          f = r(36),
          p = a(f),
          h = r(37),
          v = a(h),
          g = r(38),
          m = a(g),
          y = r(39),
          S = a(y),
          _ = r(8),
          A = a(_),
          E = r(40),
          V = a(E),
          b = r(41),
          T = a(b),
          C = r(42),
          O = a(C),
          N = r(43),
          M = a(N),
          x = r(44),
          R = a(x),
          I = r(45),
          F = a(I);

      r(46), r(47), t.Form = u["default"], t.Text = s["default"], t.NestedForm = S["default"], t.FormField = A["default"], t.RadioGroup = m["default"], t.Radio = l["default"], t.Select = p["default"], t.Checkbox = v["default"], t.TextArea = c["default"], t.StyledText = V["default"], t.StyledRadio = T["default"], t.StyledTextArea = O["default"], t.StyledSelect = M["default"], t.StyledCheckbox = R["default"], t.StyledRadioGroup = F["default"];
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var n = r(3),
          u = a(n),
          i = r(7),
          s = a(i),
          o = r(18),
          l = a(o),
          d = r(26),
          c = a(d),
          f = r(19),
          p = a(f),
          h = r(15),
          v = a(h),
          g = r(4),
          m = a(g),
          y = r(1),
          S = a(y),
          _ = r(2),
          A = a(_),
          E = r(5),
          V = a(E),
          b = r(6),
          T = a(b),
          C = r(20),
          O = a(C),
          N = r(21),
          M = a(N),
          x = r(16),
          R = a(x),
          I = r(17),
          F = a(I),
          L = r(0),
          k = a(L),
          w = r(12),
          W = a(w),
          D = r(27),
          U = a(D),
          B = r(28),
          j = r(29),
          P = (r(30), r(31)),
          q = a(P),
          G = r(22),
          Y = function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
        return t["default"] = e, t;
      }(G),
          J = r(14),
          H = a(J),
          $ = function e(t) {
        return Array.isArray(t) ? t.some(function (t) {
          return e(t);
        }) : null !== t && "object" === (void 0 === t ? "undefined" : (0, F["default"])(t)) ? (0, R["default"])(t).some(function (r) {
          return e(t[r]);
        }) : t;
      },
          z = function z(e) {
        return (0, M["default"])({}, e.errors, e.asyncErrors);
      },
          K = function K(e) {
        return (0, M["default"])({}, e.warnings, e.asyncWarnings);
      },
          Q = function Q(e) {
        return (0, M["default"])({}, e.successes, e.asyncSuccesses);
      },
          X = function X(e) {
        return (0, M["default"])(JSON.parse((0, O["default"])(e)), {
          errors: z(e),
          warnings: K(e),
          successes: Q(e)
        });
      },
          Z = function (e) {
        function t(e) {
          (0, S["default"])(this, t);
          var r = (0, V["default"])(this, (t.__proto__ || (0, m["default"])(t)).call(this, e));
          return r.getFormState = function () {
            return X(r.props.formState);
          }, r.setValue = function (e, t) {
            r.props.dispatch(Y.setValue(e, t)), r.props.dispatch(Y.removeAsyncError(e)), r.props.dispatch(Y.removeAsyncWarning(e)), r.props.dispatch(Y.removeAsyncSuccess(e)), r.props.validateOnSubmit || (r.props.dispatch(Y.preValidate()), r.props.dispatch(Y.validate()));
          }, r.setTouched = function (e) {
            var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                a = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
            r.props.dispatch(Y.setTouched(e, t)), a && !r.props.validateOnSubmit && (r.props.dispatch(Y.preValidate()), r.props.dispatch(Y.validate()), r.props.dispatch(Y.asyncValidate(e, r.props.asyncValidators)));
          }, r.setError = function (e, t) {
            r.props.dispatch(Y.setError(e, t));
          }, r.setWarning = function (e, t) {
            r.props.dispatch(Y.setWarning(e, t));
          }, r.setSuccess = function (e, t) {
            r.props.dispatch(Y.setSuccess(e, t));
          }, r.setFormState = function (e) {
            r.props.dispatch(Y.setFormState(e));
          }, r.getTouched = function (e) {
            return H["default"].get(r.props.formState.touched, e);
          }, r.getValue = function (e) {
            return H["default"].get(r.props.formState.values, e);
          }, r.getError = function (e) {
            return H["default"].get(r.errors, e);
          }, r.getWarning = function (e) {
            return H["default"].get(r.warnings, e);
          }, r.getSuccess = function (e) {
            return H["default"].get(r.successes, e);
          }, r.addValue = function (e, t) {
            r.props.dispatch(Y.setValue(e, [].concat((0, v["default"])(H["default"].get(r.props.formState.values, e) || []), [t]))), r.props.dispatch(Y.removeAsyncError(e)), r.props.dispatch(Y.removeAsyncWarning(e)), r.props.dispatch(Y.removeAsyncSuccess(e)), r.props.dontValidateOnMount || r.props.validateOnSubmit || (r.props.dispatch(Y.preValidate()), r.props.dispatch(Y.validate()));
          }, r.removeValue = function (e, t) {
            var a = H["default"].get(r.props.formState.values, e) || [];
            r.props.dispatch(Y.setValue(e, [].concat((0, v["default"])(a.slice(0, t)), (0, v["default"])(a.slice(t + 1)))));
            var n = H["default"].get(r.props.formState.touched, e) || [];
            r.props.dispatch(Y.setTouched(e, [].concat((0, v["default"])(n.slice(0, t)), (0, v["default"])(n.slice(t + 1))))), r.props.dispatch(Y.removeAsyncError(e)), r.props.dispatch(Y.removeAsyncWarning(e)), r.props.dispatch(Y.removeAsyncSuccess(e)), r.props.dontValidateOnMount || r.props.validateOnSubmit || (r.props.dispatch(Y.preValidate()), r.props.dispatch(Y.validate()));
          }, r.swapValues = function (e, t, a) {
            var n = Math.min(t, a),
                u = Math.max(t, a),
                i = H["default"].get(r.props.formState.values, e) || [];
            r.props.dispatch(Y.setValue(e, [].concat((0, v["default"])(i.slice(0, n)), [i[u]], (0, v["default"])(i.slice(n + 1, u)), [i[n]], (0, v["default"])(i.slice(u + 1)))));
          }, r.registerAsyncValidation = function (e) {
            r.asyncValidators.push(e);
          }, r.format = function (e, t) {
            r.props.dispatch(Y.format(e, t)), r.props.dispatch(Y.preValidate()), r.props.dispatch(Y.validate());
          }, r.reset = function (e) {
            r.props.dispatch(Y.reset(e));
          }, r.resetAll = function () {
            r.props.dispatch(Y.resetAll());
          }, r.clearAll = function () {
            r.props.dispatch(Y.clearAll());
          }, r.validatingField = function (e) {
            r.props.dispatch(Y.validatingField(e));
          }, r.doneValidatingField = function (e) {
            r.props.dispatch(Y.doneValidatingField(e));
          }, r.submitForm = function (e) {
            if (r.props.dispatch(Y.submitting(!0)), r.props.dispatch(Y.preValidate()), r.props.dispatch(Y.validate()), r.props.dispatch(Y.submits()), e && e.preventDefault && !r.props.dontPreventDefault && e.preventDefault(e), r.props.dontPreventDefault) {
              $(r.errors) && e && e.preventDefault && e.preventDefault(e);
            }

            r.finishSubmission(e);
          }, r.asyncValidators = [], r.finishSubmission = r.finishSubmission.bind(r), r.setAllValues = r.setAllValues.bind(r), r.setAllTouched = r.setAllTouched.bind(r), r.callAsynchronousValidators = r.callAsynchronousValidators.bind(r), r;
        }

        return (0, T["default"])(t, e), (0, A["default"])(t, [{
          key: "getChildContext",
          value: function value() {
            return {
              formApi: this.api
            };
          }
        }, {
          key: "componentWillMount",
          value: function value() {
            this.props.getApi && this.props.getApi(this.api);
          }
        }, {
          key: "componentDidMount",
          value: function value() {
            this.props.dontValidateOnMount || (this.props.dispatch(Y.preValidate()), this.props.dispatch(Y.validate())), this.props.registerAsyncValidation && this.props.registerAsyncValidation(this.callAsynchronousValidators);
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value(e) {
            e.submits > this.props.submits && (this.props.dispatch(Y.preValidate()), this.props.dispatch(Y.validate()), this.props.dispatch(Y.submits()));
            var t = (0, O["default"])(e.formState) !== (0, O["default"])(this.props.formState);
            this.props.formDidUpdate && t && this.props.formDidUpdate(X(e.formState)), this.props.update && t && this.props.update(X(e.formState));
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.props.reset && this.props.resetFormOnUnmount && this.props.reset();
          }
        }, {
          key: "setAllTouched",
          value: function () {
            function e(e) {
              return t.apply(this, arguments);
            }

            var t = (0, p["default"])(l["default"].mark(function e(t) {
              var r,
                  a = this;
              return l["default"].wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      if (this.props.dispatch(Y.setAllTouched(t)), this.props.validateOnSubmit) {
                        e.next = 7;
                        break;
                      }

                      return this.props.dispatch(Y.preValidate()), this.props.dispatch(Y.validate()), r = this.props.asyncValidators ? (0, R["default"])(this.props.asyncValidators).map(function (e) {
                        return a.props.dispatch(Y.asyncValidate(e, a.props.asyncValidators));
                      }) : [], e.next = 7, c["default"].all(r);

                    case 7:
                    case "end":
                      return e.stop();
                  }
                }
              }, e, this);
            }));
            return e;
          }()
        }, {
          key: "setAllValues",
          value: function () {
            function e(e) {
              return t.apply(this, arguments);
            }

            var t = (0, p["default"])(l["default"].mark(function e(t) {
              var r,
                  a = this;
              return l["default"].wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      if (this.props.dispatch(Y.setAllValues(t)), this.props.validateOnSubmit) {
                        e.next = 7;
                        break;
                      }

                      return this.props.dispatch(Y.preValidate()), this.props.dispatch(Y.validate()), r = this.props.asyncValidators ? (0, R["default"])(this.props.asyncValidators).map(function (e) {
                        return a.props.dispatch(Y.asyncValidate(e, a.props.asyncValidators));
                      }) : [], e.next = 7, c["default"].all(r);

                    case 7:
                    case "end":
                      return e.stop();
                  }
                }
              }, e, this);
            }));
            return e;
          }()
        }, {
          key: "finishSubmission",
          value: function () {
            function e(e) {
              return t.apply(this, arguments);
            }

            var t = (0, p["default"])(l["default"].mark(function e(t) {
              var r, a, n;
              return l["default"].wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      return e.prev = 0, e.next = 3, this.callAsynchronousValidators();

                    case 3:
                      e.next = 9;
                      break;

                    case 5:
                      throw e.prev = 5, e.t0 = e["catch"](0), this.props.dispatch(Y.submitting(!1)), e.t0;

                    case 9:
                      if (r = this.errors, a = $(r), a && this.props.onSubmitFailure && this.props.onSubmitFailure(r, this.api), a || 0 !== this.props.formState.asyncValidations) {
                        e.next = 25;
                        break;
                      }

                      if (n = JSON.parse((0, O["default"])(this.props.formState.values)), this.props.preSubmit && (n = this.props.preSubmit(n, this.api)), this.props.dispatch(Y.submitted()), !this.props.onSubmit) {
                        e.next = 25;
                        break;
                      }

                      return e.prev = 17, e.next = 20, this.props.onSubmit(n, t, this.api);

                    case 20:
                      e.next = 25;
                      break;

                    case 22:
                      e.prev = 22, e.t1 = e["catch"](17), this.props.onSubmitFailure({}, this.api, e.t1);

                    case 25:
                      this.props.dispatch(Y.submitting(!1));

                    case 26:
                    case "end":
                      return e.stop();
                  }
                }
              }, e, this, [[0, 5], [17, 22]]);
            }));
            return e;
          }()
        }, {
          key: "callAsynchronousValidators",
          value: function () {
            function e() {
              return t.apply(this, arguments);
            }

            var t = (0, p["default"])(l["default"].mark(function e() {
              var t,
                  r,
                  a = this;
              return l["default"].wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      return t = this.props.asyncValidators ? (0, R["default"])(this.props.asyncValidators).map(function (e) {
                        return a.props.dispatch(Y.asyncValidate(e, a.props.asyncValidators));
                      }) : [], r = this.asyncValidators ? this.asyncValidators.map(function (e) {
                        return e();
                      }) : [], t = t.concat(r), e.next = 5, c["default"].all(t);

                    case 5:
                    case "end":
                      return e.stop();
                  }
                }
              }, e, this);
            }));
            return e;
          }()
        }, {
          key: "render",
          value: function value() {
            var e = this.props,
                t = e.children,
                r = e.component,
                a = e.render;
            return r ? k["default"].createElement(r, {
              formApi: this.api
            }) : a ? a(this.api) : "function" == typeof t ? t(this.api) : k["default"].cloneElement(t, {
              formApi: this.api
            });
          }
        }, {
          key: "api",
          get: function get() {
            return {
              values: this.props.formState.values,
              errors: this.errors,
              warnings: this.warnings,
              successes: this.successes,
              touched: this.props.formState.touched,
              asyncValidations: this.props.formState.asyncValidations,
              validating: this.props.formState.validating,
              validationFailures: this.props.formState.validationFailures,
              validationFailed: this.props.formState.validationFailed,
              submitForm: this.submitForm,
              setValue: this.setValue,
              getValue: this.getValue,
              setTouched: this.setTouched,
              getTouched: this.getTouched,
              getWarning: this.getWarning,
              getError: this.getError,
              getSuccess: this.getSuccess,
              getFormState: this.getFormState,
              setFormState: this.setFormState,
              setError: this.setError,
              setWarning: this.setWarning,
              setSuccess: this.setSuccess,
              format: this.format,
              submitted: this.props.formState.submitted,
              submits: this.props.formState.submits,
              submitting: this.props.formState.submitting,
              reset: this.reset,
              resetAll: this.resetAll,
              clearAll: this.clearAll,
              validatingField: this.validatingField,
              doneValidatingField: this.doneValidatingField,
              registerAsyncValidation: this.registerAsyncValidation,
              addValue: this.addValue,
              removeValue: this.removeValue,
              setAllValues: this.setAllValues,
              setAllTouched: this.setAllTouched,
              swapValues: this.swapValues
            };
          }
        }, {
          key: "errors",
          get: function get() {
            return (0, M["default"])({}, this.props.formState.errors, this.props.formState.asyncErrors);
          }
        }, {
          key: "warnings",
          get: function get() {
            return (0, M["default"])({}, this.props.formState.warnings, this.props.formState.asyncWarnings);
          }
        }, {
          key: "successes",
          get: function get() {
            return (0, M["default"])({}, this.props.formState.successes, this.props.formState.asyncSuccesses);
          }
        }, {
          key: "currentState",
          get: function get() {
            return (0, M["default"])(JSON.parse((0, O["default"])(this.props.formState)), {
              errors: this.errors,
              warnings: this.warnings,
              successes: this.successes
            });
          }
        }]), t;
      }(L.Component);

      Z.childContextTypes = {
        formApi: W["default"].object
      };

      var ee = function ee(e) {
        return {
          formState: e
        };
      },
          te = function te(e) {
        return {
          dispatch: e
        };
      },
          re = (0, j.connect)(ee, te)(Z),
          ae = function (e) {
        function t(e) {
          (0, S["default"])(this, t);
          var r = (0, V["default"])(this, (t.__proto__ || (0, m["default"])(t)).call(this, e)),
              a = e.validateError,
              n = e.validateWarning,
              u = e.validateSuccess,
              i = e.preValidate,
              s = e.defaultValues;
          return r.store = (0, B.createStore)(q["default"].build({
            validateError: a,
            validateWarning: n,
            validateSuccess: u,
            preValidate: i,
            defaultValues: s
          }), (0, B.applyMiddleware)(U["default"])), r;
        }

        return (0, T["default"])(t, e), (0, A["default"])(t, [{
          key: "render",
          value: function value() {
            var e = this.props,
                t = e.children,
                r = (0, s["default"])(e, ["children"]);
            return k["default"].createElement(re, (0, u["default"])({
              store: this.store
            }, r), t);
          }
        }]), t;
      }(L.Component);

      t["default"] = ae;
    }, function (e, t) {
      e.exports = __webpack_require__(162);
    }, function (e, t) {
      e.exports = __webpack_require__(378);
    }, function (e, t) {
      e.exports = __webpack_require__(167);
    }, function (e, t) {
      e.exports = __webpack_require__(379);
    }, function (e, t) {
      e.exports = __webpack_require__(398);
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var n = r(21),
          u = a(n),
          i = r(1),
          s = a(i),
          o = r(2),
          l = a(o),
          d = r(20),
          c = a(d),
          f = r(3),
          p = a(f),
          h = r(22),
          v = r(14),
          g = a(v),
          m = {
        values: {},
        touched: {},
        errors: {},
        warnings: {},
        successes: {},
        asyncErrors: {},
        asyncWarnings: {},
        asyncSuccesses: {},
        validating: {},
        validationFailed: {},
        validationFailures: 0,
        asyncValidations: 0,
        submitted: !1,
        submits: 0,
        submitting: !1
      },
          y = function y(e, t) {
        return (0, p["default"])({}, m, t.formState);
      },
          S = function S(e, t) {
        var r = t.field,
            a = t.value,
            n = JSON.parse((0, c["default"])(e.values));
        return n = g["default"].set(n, r, a), (0, p["default"])({}, e, {
          values: n
        });
      },
          _ = function _(e, t) {
        var r = t.values,
            a = JSON.parse((0, c["default"])(e.values));
        return (0, p["default"])({}, e, {
          values: (0, p["default"])({}, a, r)
        });
      },
          A = function A(e, t) {
        var r = t.field,
            a = JSON.parse((0, c["default"])(e.values));
        return a = g["default"].set(a, r, t.format(g["default"].get(a, r))), (0, p["default"])({}, e, {
          values: a
        });
      },
          E = function E(e, t) {
        var r = t.field,
            a = t.touched,
            n = JSON.parse((0, c["default"])(e.touched));
        return n = g["default"].set(n, r, a), (0, p["default"])({}, e, {
          touched: n
        });
      },
          V = function V(e, t) {
        var r = t.touched,
            a = JSON.parse((0, c["default"])(e.touched));
        return (0, p["default"])({}, e, {
          touched: (0, p["default"])({}, a, r)
        });
      },
          b = function b(e, t) {
        var r = t.field,
            a = t.warning,
            n = JSON.parse((0, c["default"])(e.warnings));
        return n = g["default"].set(n, r, a), (0, p["default"])({}, e, {
          warnings: n
        });
      },
          T = function T(e, t) {
        var r = t.field,
            a = t.error,
            n = JSON.parse((0, c["default"])(e.errors));
        return n = g["default"].set(n, r, a), (0, p["default"])({}, e, {
          errors: n
        });
      },
          C = function C(e, t) {
        var r = t.field,
            a = t.success,
            n = JSON.parse((0, c["default"])(e.successes));
        return n = g["default"].set(n, r, a), (0, p["default"])({}, e, {
          successes: n
        });
      },
          O = function O(e, t) {
        var r = t.field,
            a = t.warning,
            n = JSON.parse((0, c["default"])(e.asyncWarnings));
        return Array.isArray(r) ? n[r[0]] = a : n[r] = a, (0, p["default"])({}, e, {
          asyncWarnings: n
        });
      },
          N = function N(e, t) {
        var r = t.field,
            a = t.error,
            n = JSON.parse((0, c["default"])(e.asyncErrors));
        return Array.isArray(r) ? n[r[0]] = a : n[r] = a, (0, p["default"])({}, e, {
          asyncErrors: n
        });
      },
          M = function M(e, t) {
        var r = t.field,
            a = t.success,
            n = JSON.parse((0, c["default"])(e.asyncSuccesses));
        return Array.isArray(r) ? n[r[0]] = a : n[r] = a, (0, p["default"])({}, e, {
          asyncSuccesses: n
        });
      },
          x = function x(e, t) {
        var r = t.field,
            a = JSON.parse((0, c["default"])(e.asyncWarnings));
        return Array.isArray(r) ? delete a[r[0]] : delete a[r], (0, p["default"])({}, e, {
          asyncWarnings: a
        });
      },
          R = function R(e, t) {
        var r = t.field,
            a = JSON.parse((0, c["default"])(e.asyncErrors));
        return Array.isArray(r) ? delete a[r[0]] : delete a[r], (0, p["default"])({}, e, {
          asyncErrors: a
        });
      },
          I = function I(e, t) {
        var r = t.field,
            a = JSON.parse((0, c["default"])(e.asyncSuccesses));
        return Array.isArray(r) ? delete a[r[0]] : delete a[r], (0, p["default"])({}, e, {
          asyncSuccesses: a
        });
      },
          F = function F(e, t, r, a, n) {
        var u = r ? r(e.values) : {},
            i = a ? a(e.values) : {},
            s = n ? n(e.values, u) : {};
        return u = (0, p["default"])({}, e.errors, u), i = (0, p["default"])({}, e.warnings, i), s = (0, p["default"])({}, e.successes, s), (0, p["default"])({}, e, {
          errors: u,
          warnings: i,
          successes: s
        });
      },
          L = function L(e, t, r) {
        var a = r ? r(JSON.parse((0, c["default"])(e.values))) : e.values;
        return (0, p["default"])({}, e, {
          values: a
        });
      },
          k = function k(e) {
        return (0, p["default"])({}, e, {
          submits: e.submits + 1
        });
      },
          w = function w(e) {
        return (0, p["default"])({}, e, {
          submitted: !0
        });
      },
          W = function W(e, t) {
        return (0, p["default"])({}, e, {
          submitting: t.submitting
        });
      },
          D = function D(e, t) {
        var r = t.field,
            a = JSON.parse((0, c["default"])(e));
        return g["default"].set(a.values, r, void 0), g["default"].set(a.touched, r, void 0), g["default"].set(a.errors, r, void 0), g["default"].set(a.warnings, r, void 0), g["default"].set(a.successes, r, void 0), g["default"].set(a.asyncErrors, r, void 0), g["default"].set(a.asyncWarnings, r, void 0), g["default"].set(a.asyncSuccesses, r, void 0), (0, p["default"])({}, e, a);
      },
          U = function U(e, t) {
        var r = t.field,
            a = JSON.parse((0, c["default"])(e.validating)),
            n = e.asyncValidations;
        return Array.isArray(r) ? (n = a[r[0]] ? n : n + 1, a[r[0]] = !0) : (n = a[r] ? n : n + 1, a[r] = !0), (0, p["default"])({}, e, {
          asyncValidations: n,
          validating: a
        });
      },
          B = function B(e, t) {
        var r = t.field,
            a = JSON.parse((0, c["default"])(e.validating)),
            n = e.asyncValidations;
        return Array.isArray(r) ? (n = a[r[0]] ? n - 1 : n, a[r[0]] = !1) : (n = a[r] ? n - 1 : n, a[r] = !1), (0, p["default"])({}, e, {
          asyncValidations: n,
          validating: a
        });
      },
          j = function j(e, t) {
        var r = t.field,
            a = JSON.parse((0, c["default"])(e.validationFailed)),
            n = e.validationFailures;
        return Array.isArray(r) ? (n = !1 === a[r[0]] ? n + 1 : n, a[r[0]] = !0) : (n = a[r] ? n : n + 1, a[r] = !0), (0, p["default"])({}, e, {
          validationFailures: n,
          validationFailed: a
        });
      },
          P = function P(e, t) {
        var r = t.field,
            a = e.validationFailures,
            n = JSON.parse((0, c["default"])(e.validationFailed));
        return Array.isArray(r) ? (a = !0 === n[r[0]] ? a - 1 : a, n[r[0]] = !1) : (a = !0 === n[r] ? a - 1 : a, n[r] = !1), (0, p["default"])({}, e, {
          validationFailures: a,
          validationFailed: n
        });
      },
          q = function () {
        function e() {
          (0, s["default"])(this, e);
        }

        return (0, l["default"])(e, null, [{
          key: "build",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = e.validateError,
                r = e.validateWarning,
                a = e.validateSuccess,
                n = e.defaultValues,
                i = (0, u["default"])({}, m, {
              values: n || {}
            });
            return function () {
              var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : i,
                  u = arguments[1];

              switch (u.type) {
                case h.SET_FORM_STATE:
                  return y(0, u);

                case h.SET_VALUE:
                  return S(n, u);

                case h.SET_ALL_VALUES:
                  return _(n, u);

                case h.FORMAT:
                  return A(n, u);

                case h.SET_ERROR:
                  return T(n, u);

                case h.SET_WARNING:
                  return b(n, u);

                case h.SET_SUCCESS:
                  return C(n, u);

                case h.SET_ASYNC_ERROR:
                  return N(n, u);

                case h.SET_ASYNC_WARNING:
                  return O(n, u);

                case h.SET_ASYNC_SUCCESS:
                  return M(n, u);

                case h.SET_TOUCHED:
                  return E(n, u);

                case h.SET_ALL_TOUCHED:
                  return V(n, u);

                case h.REMOVE_ASYNC_ERROR:
                  return R(n, u);

                case h.REMOVE_ASYNC_WARNING:
                  return x(n, u);

                case h.REMOVE_ASYNC_SUCCESS:
                  return I(n, u);

                case h.PRE_VALIDATE:
                  return L(n, 0, e.preValidate);

                case h.VALIDATE:
                  return F(n, 0, t, r, a);

                case h.SUBMITTED:
                  return w(n);

                case h.SUBMITS:
                  return k(n);

                case h.SUBMITTING:
                  return W(n, u);

                case h.RESET:
                  return D(n, u);

                case h.RESET_ALL:
                  return i;

                case h.CLEAR_ALL:
                  return m;

                case h.VALIDATION_FAILURE:
                  return j(n, u);

                case h.VALIDATION_SUCCESS:
                  return P(n, u);

                case h.DONE_VALIDATING_FIELD:
                  return B(n, u);

                case h.VALIDATING_FIELD:
                  return U(n, u);

                default:
                  return n;
              }
            };
          }
        }]), e;
      }();

      t["default"] = q;
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var n = r(3),
          u = a(n),
          i = r(7),
          s = a(i),
          o = r(4),
          l = a(o),
          d = r(1),
          c = a(d),
          f = r(2),
          p = a(f),
          h = r(5),
          v = a(h),
          g = r(6),
          m = a(g),
          y = r(0),
          S = a(y),
          _ = r(8),
          A = a(_),
          E = function (e) {
        function t() {
          return (0, c["default"])(this, t), (0, v["default"])(this, (t.__proto__ || (0, l["default"])(t)).apply(this, arguments));
        }

        return (0, m["default"])(t, e), (0, p["default"])(t, [{
          key: "render",
          value: function value() {
            var e = this.props,
                t = e.fieldApi,
                r = e.onChange,
                a = e.onBlur,
                n = (0, s["default"])(e, ["fieldApi", "onChange", "onBlur"]),
                i = t.getValue,
                o = t.setValue,
                l = t.setTouched,
                d = i();
            return d || 0 === d || (d = ""), S["default"].createElement("input", (0, u["default"])({}, n, {
              value: d,
              onChange: function onChange(e) {
                o(e.target.value), r && r(e.target.value, e);
              },
              onBlur: function onBlur(e) {
                l(), a && a(e);
              }
            }));
          }
        }]), t;
      }(y.Component),
          V = (0, A["default"])(E);

      t["default"] = V;
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var n = r(3),
          u = a(n),
          i = r(4),
          s = a(i),
          o = r(1),
          l = a(o),
          d = r(2),
          c = a(d),
          f = r(5),
          p = a(f),
          h = r(6),
          v = a(h),
          g = r(0),
          m = a(g),
          y = r(12),
          S = a(y),
          _ = r(14),
          A = a(_),
          E = function (e) {
        function t() {
          return (0, l["default"])(this, t), (0, p["default"])(this, (t.__proto__ || (0, s["default"])(t)).apply(this, arguments));
        }

        return (0, v["default"])(t, e), (0, c["default"])(t, [{
          key: "componentWillReceiveProps",
          value: function value(e, t) {
            t.formApi.submitted === this.context.formApi.submitted || this.props.nestedForm || this.context.formApi.setTouched(this.props.field, !0, !1), t.formApi.submits === this.context.formApi.submits || this.props.nestedForm || this.context.formApi.setTouched(this.props.field, !0, !1);
          }
        }, {
          key: "shouldComponentUpdate",
          value: function value(e, t, r) {
            var a = this.props.field,
                n = this.context.formApi,
                i = r.formApi,
                s = (0, u["default"])({}, this.props.children.props),
                o = (0, u["default"])({}, e.children.props);
            return s.children = null, o.children = null, A["default"].get(i.values, a) !== A["default"].get(n.values, a) || A["default"].get(i.touched, a) !== A["default"].get(n.touched, a) || A["default"].get(i.errors, a) !== A["default"].get(n.errors, a) || A["default"].get(i.warnings, a) !== A["default"].get(n.warnings, a) || A["default"].get(i.successes, a) !== A["default"].get(n.successes, a) || !A["default"].isShallowEqual(o, s) || r.formApi.submits !== this.context.formApi.submits || !1;
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.context.formApi,
                t = this.props,
                r = t.children,
                a = t.field,
                n = {
              setValue: function setValue(t) {
                e.setValue(a, t);
              },
              setTouched: function setTouched(t) {
                e.setTouched(a, t);
              },
              setError: function setError(t) {
                e.setError(a, t);
              },
              setWarning: function setWarning(t) {
                e.setWarning(a, t);
              },
              setSuccess: function setSuccess(t) {
                e.setSuccess(a, t);
              },
              getValue: function getValue() {
                return e.getValue(a);
              },
              getTouched: function getTouched() {
                return e.getTouched(a);
              },
              getError: function getError() {
                return e.getError(a);
              },
              getWarning: function getWarning() {
                return e.getWarning(a);
              },
              getSuccess: function getSuccess() {
                return e.getSuccess(a);
              },
              validatingField: function validatingField() {
                return e.validatingField(a);
              },
              doneValidatingField: function doneValidatingField() {
                return e.doneValidatingField(a);
              },
              reset: function reset() {
                return e.reset(a);
              },
              registerAsyncValidation: e.registerAsyncValidation,
              submitted: e.submitted,
              submits: e.submits
            };
            return m["default"].cloneElement(r, {
              fieldApi: n
            });
          }
        }]), t;
      }(g.Component);

      E.contextTypes = {
        formApi: S["default"].object
      }, t["default"] = E;
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var n = r(3),
          u = a(n),
          i = r(7),
          s = a(i),
          o = r(4),
          l = a(o),
          d = r(1),
          c = a(d),
          f = r(2),
          p = a(f),
          h = r(5),
          v = a(h),
          g = r(6),
          m = a(g),
          y = r(0),
          S = a(y),
          _ = r(12),
          A = a(_),
          E = function (e) {
        function t() {
          return (0, c["default"])(this, t), (0, v["default"])(this, (t.__proto__ || (0, l["default"])(t)).apply(this, arguments));
        }

        return (0, m["default"])(t, e), (0, p["default"])(t, [{
          key: "render",
          value: function value() {
            var e = this.props,
                t = e.onClick,
                r = e.group,
                a = e.value,
                n = (0, s["default"])(e, ["onClick", "group", "value"]);
            return S["default"].createElement("input", (0, u["default"])({}, n, {
              checked: r.getValue() === a,
              onChange: function onChange(e) {
                e.target.checked && (r.setValue(a), r.onChange(a, e), t && t(e));
              },
              onBlur: function onBlur(e) {
                r.setTouched(), r.onBlur(e);
              },
              type: "radio"
            }));
          }
        }]), t;
      }(y.Component);

      E.propTypes = {
        value: A["default"].oneOfType([A["default"].string, A["default"].bool]).isRequired,
        group: A["default"].object.isRequired
      }, t["default"] = E;
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var n = r(3),
          u = a(n),
          i = r(7),
          s = a(i),
          o = r(4),
          l = a(o),
          d = r(1),
          c = a(d),
          f = r(2),
          p = a(f),
          h = r(5),
          v = a(h),
          g = r(6),
          m = a(g),
          y = r(0),
          S = a(y),
          _ = r(8),
          A = a(_),
          E = function (e) {
        function t() {
          return (0, c["default"])(this, t), (0, v["default"])(this, (t.__proto__ || (0, l["default"])(t)).apply(this, arguments));
        }

        return (0, m["default"])(t, e), (0, p["default"])(t, [{
          key: "render",
          value: function value() {
            var e = this.props,
                t = e.onChange,
                r = e.onBlur,
                a = e.fieldApi,
                n = (0, s["default"])(e, ["onChange", "onBlur", "fieldApi"]),
                i = a.getValue,
                o = a.setValue,
                l = a.setTouched;
            return S["default"].createElement("textarea", (0, u["default"])({}, n, {
              value: i() || "",
              onChange: function onChange(e) {
                o(e.target.value), t && t(e.target.value, e);
              },
              onBlur: function onBlur(e) {
                l(), r && r(e);
              }
            }));
          }
        }]), t;
      }(y.Component),
          V = (0, A["default"])(E);

      t["default"] = V;
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var n = r(3),
          u = a(n),
          i = r(15),
          s = a(i),
          o = r(7),
          l = a(o),
          d = r(4),
          c = a(d),
          f = r(1),
          p = a(f),
          h = r(2),
          v = a(h),
          g = r(5),
          m = a(g),
          y = r(6),
          S = a(y),
          _ = r(0),
          A = a(_),
          E = r(8),
          V = a(E),
          b = function (e) {
        function t() {
          return (0, p["default"])(this, t), (0, m["default"])(this, (t.__proto__ || (0, c["default"])(t)).apply(this, arguments));
        }

        return (0, S["default"])(t, e), (0, v["default"])(t, [{
          key: "render",
          value: function value() {
            var e = this.props,
                t = e.fieldApi,
                r = e.options,
                a = e.onChange,
                n = e.onBlur,
                i = e.placeholder,
                o = (0, l["default"])(e, ["fieldApi", "options", "onChange", "onBlur", "placeholder"]),
                d = t.getValue,
                c = t.setValue,
                f = t.setTouched,
                p = r.find(function (e) {
              return "" === e.value;
            }) ? r : [{
              label: i || "Select One...",
              value: "",
              disabled: !0
            }].concat((0, s["default"])(r)),
                h = p.findIndex(function (e) {
              return "" === e.value;
            }),
                v = p.findIndex(function (e) {
              return e.value === d();
            });
            return A["default"].createElement("select", (0, u["default"])({}, o, {
              value: v > -1 ? v : h,
              onChange: function onChange(e) {
                var t = p[e.target.value].value;
                c(t), a && a(t, e);
              },
              onBlur: function onBlur(e) {
                f(), n && n(e);
              }
            }), p.map(function (e, t) {
              return A["default"].createElement("option", {
                key: e.value,
                value: t,
                disabled: e.disabled
              }, e.label);
            }));
          }
        }]), t;
      }(_.Component),
          T = (0, V["default"])(b);

      t["default"] = T;
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var n = r(3),
          u = a(n),
          i = r(7),
          s = a(i),
          o = r(4),
          l = a(o),
          d = r(1),
          c = a(d),
          f = r(2),
          p = a(f),
          h = r(5),
          v = a(h),
          g = r(6),
          m = a(g),
          y = r(0),
          S = a(y),
          _ = r(8),
          A = a(_),
          E = function (e) {
        function t() {
          return (0, c["default"])(this, t), (0, v["default"])(this, (t.__proto__ || (0, l["default"])(t)).apply(this, arguments));
        }

        return (0, m["default"])(t, e), (0, p["default"])(t, [{
          key: "render",
          value: function value() {
            var e = this.props,
                t = e.fieldApi,
                r = e.onChange,
                a = e.onBlur,
                n = (0, s["default"])(e, ["fieldApi", "onChange", "onBlur"]),
                i = t.getValue,
                o = t.setValue,
                l = t.setTouched;
            return S["default"].createElement("input", (0, u["default"])({}, n, {
              checked: !!i(),
              onChange: function onChange(e) {
                o(e.target.checked), r && r(e.target.checked, e);
              },
              onBlur: function onBlur(e) {
                l(), a && a(e);
              },
              type: "checkbox"
            }));
          }
        }]), t;
      }(y.Component),
          V = (0, A["default"])(E);

      t["default"] = V;
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var n = r(4),
          u = a(n),
          i = r(1),
          s = a(i),
          o = r(2),
          l = a(o),
          d = r(5),
          c = a(d),
          f = r(6),
          p = a(f),
          h = r(0),
          v = a(h),
          g = r(8),
          m = a(g),
          y = function (e) {
        function t() {
          return (0, s["default"])(this, t), (0, c["default"])(this, (t.__proto__ || (0, u["default"])(t)).apply(this, arguments));
        }

        return (0, p["default"])(t, e), (0, l["default"])(t, [{
          key: "componentWillMount",
          value: function value() {
            this.props.value && this.props.fieldApi.setValue(this.props.value);
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.props,
                t = e.fieldApi,
                r = e.children,
                a = e.component,
                n = e.render,
                u = e.onChange,
                i = e.onBlur;
            return t.onChange = function (e) {
              u && u(e);
            }, t.onBlur = function () {
              i && i();
            }, a ? v["default"].createElement(a, {
              group: t
            }) : n ? n(t) : "function" == typeof r ? r(t) : v["default"].cloneElement(r, {
              group: t
            });
          }
        }]), t;
      }(h.Component),
          S = (0, m["default"])(y);

      t["default"] = S;
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var n = r(16),
          u = a(n),
          i = r(0),
          s = a(i),
          o = r(8),
          l = a(o),
          d = function d(e) {
        var t = e.children,
            r = e.fieldApi,
            a = r.setValue,
            n = r.setError,
            i = r.setWarning,
            o = r.setSuccess,
            l = r.setTouched,
            d = r.submitted,
            c = r.submits,
            f = r.validatingField,
            p = r.doneValidatingField,
            h = r.registerAsyncValidation,
            v = r.reset;
        return s["default"].cloneElement(t, {
          submitted: d,
          submits: c,
          reset: v,
          update: function update(e) {
            var t = e.values,
                r = e.errors,
                s = e.successes,
                d = e.warnings,
                c = e.touched,
                h = e.asyncValidations,
                v = !!r && (0, u["default"])(r).some(function (e) {
              return r[e];
            }),
                g = !!s && (0, u["default"])(s).some(function (e) {
              return s[e];
            }),
                m = !!d && (0, u["default"])(d).some(function (e) {
              return d[e];
            });
            a(t), l(c), n(v ? r : null), i(m ? d : null), o(g ? s : null), h > 0 ? f() : p();
          },
          registerAsyncValidation: h
        });
      },
          c = (0, l["default"])(d);

      t["default"] = c;
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var n = r(3),
          u = a(n),
          i = r(9),
          s = a(i),
          o = r(7),
          l = a(o),
          d = r(4),
          c = a(d),
          f = r(1),
          p = a(f),
          h = r(2),
          v = a(h),
          g = r(5),
          m = a(g),
          y = r(6),
          S = a(y),
          _ = r(0),
          A = a(_),
          E = r(10),
          V = a(E),
          b = r(8),
          T = a(b),
          C = r(13),
          O = a(C),
          N = r(11),
          M = a(N),
          x = function (e) {
        function t() {
          return (0, p["default"])(this, t), (0, m["default"])(this, (t.__proto__ || (0, c["default"])(t)).apply(this, arguments));
        }

        return (0, S["default"])(t, e), (0, v["default"])(t, [{
          key: "render",
          value: function value() {
            var e,
                t = this.props,
                r = t.fieldApi,
                a = t.onChange,
                n = t.onBlur,
                i = t.className,
                o = t.noMessage,
                d = t.messageBefore,
                c = t.touchValidation,
                f = t.valueValidation,
                p = (0, l["default"])(t, ["fieldApi", "onChange", "onBlur", "className", "noMessage", "messageBefore", "touchValidation", "valueValidation"]),
                h = r.getValue,
                v = r.getError,
                g = r.getWarning,
                m = r.getSuccess,
                y = r.getTouched,
                S = r.setValue,
                _ = r.setTouched,
                E = v(),
                b = g(),
                T = m(),
                C = y(),
                N = h(),
                x = M["default"].getMessageType(E, b, T),
                R = M["default"].shouldShowValidation({
              valueValidation: f,
              touchValidation: c,
              touched: C,
              value: N
            }),
                I = (0, V["default"])(i, "react-form-input", "react-form-text", (e = {}, (0, s["default"])(e, "react-form-input-" + x, x && R), (0, s["default"])(e, "react-form-text-" + x, x && R), e));
            return A["default"].createElement("div", null, x && R && !o && d ? A["default"].createElement(O["default"], {
              message: M["default"].getMessage(E, b, T),
              type: x
            }) : null, A["default"].createElement("input", (0, u["default"])({}, p, {
              className: I,
              value: h() || "",
              onChange: function onChange(e) {
                S(e.target.value), a && a(e.target.value, e);
              },
              onBlur: function onBlur(e) {
                _(), n && n(e);
              }
            })), x && R && !o && !d ? A["default"].createElement(O["default"], {
              message: M["default"].getMessage(E, b, T),
              type: x
            }) : null);
          }
        }]), t;
      }(_.Component),
          R = (0, T["default"])(x);

      t["default"] = R;
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var n = r(3),
          u = a(n),
          i = r(9),
          s = a(i),
          o = r(7),
          l = a(o),
          d = r(4),
          c = a(d),
          f = r(1),
          p = a(f),
          h = r(2),
          v = a(h),
          g = r(5),
          m = a(g),
          y = r(6),
          S = a(y),
          _ = r(0),
          A = a(_),
          E = r(10),
          V = a(E),
          b = r(12),
          T = a(b),
          C = r(11),
          O = a(C),
          N = function (e) {
        function t() {
          return (0, p["default"])(this, t), (0, m["default"])(this, (t.__proto__ || (0, c["default"])(t)).apply(this, arguments));
        }

        return (0, S["default"])(t, e), (0, v["default"])(t, [{
          key: "render",
          value: function value() {
            var e,
                t = this.props,
                r = t.onClick,
                a = t.group,
                n = t.value,
                i = t.label,
                o = t.className,
                d = t.valueValidation,
                c = t.touchValidation,
                f = (0, l["default"])(t, ["onClick", "group", "value", "label", "className", "valueValidation", "touchValidation"]),
                p = a.getError,
                h = a.getWarning,
                v = a.getSuccess,
                g = a.getTouched,
                m = p(),
                y = h(),
                S = v(),
                _ = g(),
                E = O["default"].getMessageType(m, y, S),
                b = O["default"].shouldShowValidation({
              valueValidation: d,
              touchValidation: c,
              touched: _,
              value: n
            }),
                T = (0, V["default"])(o, "react-form-control", "react-form-control-radio"),
                C = (0, V["default"])("react-form-control-indicator", "react-form-input", "react-form-radio", (e = {}, (0, s["default"])(e, "react-form-input-" + E, E && b), (0, s["default"])(e, "react-form-radio-" + E, E && b), e));

            return A["default"].createElement("label", {
              className: T,
              htmlFor: f.id
            }, i, A["default"].createElement("input", (0, u["default"])({}, f, {
              checked: a.getValue() === n,
              onChange: function onChange(e) {
                e.target.checked && (a.setValue(n), a.onChange(n, e), r && r(e));
              },
              onBlur: function onBlur(e) {
                a.setTouched(), a.onBlur(e);
              },
              type: "radio"
            })), A["default"].createElement("div", {
              className: C
            }));
          }
        }]), t;
      }(_.Component);

      N.propTypes = {
        value: T["default"].oneOfType([T["default"].string, T["default"].bool]).isRequired,
        group: T["default"].object.isRequired
      }, t["default"] = N;
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var n = r(3),
          u = a(n),
          i = r(9),
          s = a(i),
          o = r(7),
          l = a(o),
          d = r(4),
          c = a(d),
          f = r(1),
          p = a(f),
          h = r(2),
          v = a(h),
          g = r(5),
          m = a(g),
          y = r(6),
          S = a(y),
          _ = r(0),
          A = a(_),
          E = r(10),
          V = a(E),
          b = r(8),
          T = a(b),
          C = r(13),
          O = a(C),
          N = r(11),
          M = a(N),
          x = function (e) {
        function t() {
          return (0, p["default"])(this, t), (0, m["default"])(this, (t.__proto__ || (0, c["default"])(t)).apply(this, arguments));
        }

        return (0, S["default"])(t, e), (0, v["default"])(t, [{
          key: "render",
          value: function value() {
            var e,
                t = this.props,
                r = t.fieldApi,
                a = t.onChange,
                n = t.onBlur,
                i = t.className,
                o = t.noMessage,
                d = t.messageBefore,
                c = t.touchValidation,
                f = t.valueValidation,
                p = (0, l["default"])(t, ["fieldApi", "onChange", "onBlur", "className", "noMessage", "messageBefore", "touchValidation", "valueValidation"]),
                h = r.getValue,
                v = r.getError,
                g = r.getWarning,
                m = r.getSuccess,
                y = r.getTouched,
                S = r.setValue,
                _ = r.setTouched,
                E = v(),
                b = g(),
                T = m(),
                C = y(),
                N = h(),
                x = M["default"].getMessageType(E, b, T),
                R = M["default"].shouldShowValidation({
              valueValidation: f,
              touchValidation: c,
              touched: C,
              value: N
            }),
                I = (0, V["default"])(i, "react-form-input", "react-form-textarea", (e = {}, (0, s["default"])(e, "react-form-input-" + x, x && R), (0, s["default"])(e, "react-form-textarea-" + x, x && R), e));
            return A["default"].createElement("div", null, x && R && !o && d ? A["default"].createElement(O["default"], {
              message: M["default"].getMessage(E, b, T),
              type: x
            }) : null, A["default"].createElement("textarea", (0, u["default"])({}, p, {
              className: I,
              value: h() || "",
              onChange: function onChange(e) {
                S(e.target.value), a && a(e.target.value, e);
              },
              onBlur: function onBlur(e) {
                _(), n && n(e);
              }
            })), x && R && !o && !d ? A["default"].createElement(O["default"], {
              message: M["default"].getMessage(E, b, T),
              type: x
            }) : null);
          }
        }]), t;
      }(_.Component),
          R = (0, T["default"])(x);

      t["default"] = R;
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var n = r(3),
          u = a(n),
          i = r(15),
          s = a(i),
          o = r(9),
          l = a(o),
          d = r(7),
          c = a(d),
          f = r(4),
          p = a(f),
          h = r(1),
          v = a(h),
          g = r(2),
          m = a(g),
          y = r(5),
          S = a(y),
          _ = r(6),
          A = a(_),
          E = r(0),
          V = a(E),
          b = r(10),
          T = a(b),
          C = r(8),
          O = a(C),
          N = r(13),
          M = a(N),
          x = r(11),
          R = a(x),
          I = function (e) {
        function t() {
          return (0, v["default"])(this, t), (0, S["default"])(this, (t.__proto__ || (0, p["default"])(t)).apply(this, arguments));
        }

        return (0, A["default"])(t, e), (0, m["default"])(t, [{
          key: "render",
          value: function value() {
            var e,
                t = this.props,
                r = t.fieldApi,
                a = t.options,
                n = t.onChange,
                i = t.onBlur,
                o = t.placeholder,
                d = t.className,
                f = t.noMessage,
                p = t.messageBefore,
                h = t.valueValidation,
                v = t.touchValidation,
                g = (0, c["default"])(t, ["fieldApi", "options", "onChange", "onBlur", "placeholder", "className", "noMessage", "messageBefore", "valueValidation", "touchValidation"]),
                m = r.getValue,
                y = r.getError,
                S = r.getWarning,
                _ = r.getSuccess,
                A = r.getTouched,
                E = r.setValue,
                b = r.setTouched,
                C = y(),
                O = S(),
                N = _(),
                x = A(),
                I = m(),
                F = R["default"].getMessageType(C, O, N),
                L = R["default"].shouldShowValidation({
              valueValidation: h,
              touchValidation: v,
              touched: x,
              value: I
            }),
                k = (0, T["default"])(d, "react-form-input", "react-form-select", (e = {}, (0, l["default"])(e, "react-form-input-" + F, F && L), (0, l["default"])(e, "react-form-select-" + F, F && L), e)),
                w = a.find(function (e) {
              return "" === e.value;
            }) ? a : [{
              label: o || "Select One...",
              value: "",
              disabled: !0
            }].concat((0, s["default"])(a)),
                W = w.findIndex(function (e) {
              return "" === e.value;
            }),
                D = w.findIndex(function (e) {
              return e.value === m();
            });

            return V["default"].createElement("div", null, F && L && !f && p ? V["default"].createElement(M["default"], {
              message: R["default"].getMessage(C, O, N),
              type: F
            }) : null, V["default"].createElement("div", {
              className: k
            }, V["default"].createElement("select", (0, u["default"])({}, g, {
              value: D > -1 ? D : W,
              onChange: function onChange(e) {
                var t = w[e.target.value].value;
                E(t), n && n(t, e);
              },
              onBlur: function onBlur(e) {
                b(), i && i(e);
              }
            }), w.map(function (e, t) {
              return V["default"].createElement("option", {
                key: e.value,
                value: t,
                disabled: e.disabled
              }, e.label);
            })), V["default"].createElement("div", {
              className: "react-form-select-arrow"
            })), F && L && !f && !p ? V["default"].createElement(M["default"], {
              message: R["default"].getMessage(C, O, N),
              type: F
            }) : null);
          }
        }]), t;
      }(E.Component),
          F = (0, O["default"])(I);

      t["default"] = F;
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var n = r(3),
          u = a(n),
          i = r(9),
          s = a(i),
          o = r(7),
          l = a(o),
          d = r(4),
          c = a(d),
          f = r(1),
          p = a(f),
          h = r(2),
          v = a(h),
          g = r(5),
          m = a(g),
          y = r(6),
          S = a(y),
          _ = r(0),
          A = a(_),
          E = r(10),
          V = a(E),
          b = r(8),
          T = a(b),
          C = r(13),
          O = a(C),
          N = r(11),
          M = a(N),
          x = function (e) {
        function t() {
          return (0, p["default"])(this, t), (0, m["default"])(this, (t.__proto__ || (0, c["default"])(t)).apply(this, arguments));
        }

        return (0, S["default"])(t, e), (0, v["default"])(t, [{
          key: "render",
          value: function value() {
            var e,
                t = this.props,
                r = t.fieldApi,
                a = t.onChange,
                n = t.onBlur,
                i = t.label,
                o = t.noMessage,
                d = t.messageBefore,
                c = t.valueValidation,
                f = t.touchValidation,
                p = (0, l["default"])(t, ["fieldApi", "onChange", "onBlur", "label", "noMessage", "messageBefore", "valueValidation", "touchValidation"]),
                h = r.getValue,
                v = r.setValue,
                g = r.setTouched,
                m = r.getError,
                y = r.getWarning,
                S = r.getSuccess,
                _ = r.getTouched,
                E = m(),
                b = y(),
                T = S(),
                C = _(),
                N = h(),
                x = M["default"].getMessageType(E, b, T),
                R = M["default"].shouldShowValidation({
              valueValidation: c,
              touchValidation: f,
              touched: C,
              value: N
            }),
                I = (0, V["default"])("react-form-control", "react-form-control-checkbox", p.className || ""),
                F = (0, V["default"])("react-form-control-indicator", "react-form-input", "react-form-checkbox", (e = {}, (0, s["default"])(e, "react-form-input-" + x, x && R), (0, s["default"])(e, "react-form-checkbox-" + x, x && R), e));

            return A["default"].createElement("div", null, x && R && !o && d ? A["default"].createElement(O["default"], {
              message: M["default"].getMessage(E, b, T),
              type: x
            }) : null, A["default"].createElement("label", {
              className: I,
              htmlFor: p.id
            }, i, A["default"].createElement("input", (0, u["default"])({}, p, {
              checked: !!h(),
              onChange: function onChange(e) {
                v(e.target.checked), a && a(e.target.checked, e);
              },
              onBlur: function onBlur(e) {
                g(), n && n(e);
              },
              type: "checkbox"
            })), A["default"].createElement("div", {
              className: F
            })), x && R && !o && !d ? A["default"].createElement(O["default"], {
              message: M["default"].getMessage(E, b, T),
              type: x
            }) : null);
          }
        }]), t;
      }(_.Component),
          R = (0, T["default"])(x);

      t["default"] = R;
    }, function (e, t, r) {
      "use strict";

      function a(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var n = r(9),
          u = a(n),
          i = r(4),
          s = a(i),
          o = r(1),
          l = a(o),
          d = r(2),
          c = a(d),
          f = r(5),
          p = a(f),
          h = r(6),
          v = a(h),
          g = r(0),
          m = a(g),
          y = r(10),
          S = a(y),
          _ = r(8),
          A = a(_),
          E = r(13),
          V = a(E),
          b = r(11),
          T = a(b),
          C = function (e) {
        function t() {
          return (0, l["default"])(this, t), (0, p["default"])(this, (t.__proto__ || (0, s["default"])(t)).apply(this, arguments));
        }

        return (0, v["default"])(t, e), (0, c["default"])(t, [{
          key: "componentWillMount",
          value: function value() {
            this.props.value && this.props.fieldApi.setValue(this.props.value);
          }
        }, {
          key: "render",
          value: function value() {
            var e,
                t = this.props,
                r = t.fieldApi,
                a = t.children,
                n = t.component,
                i = t.render,
                s = t.onChange,
                o = t.onBlur,
                l = t.noMessage,
                d = t.className,
                c = t.messageBefore,
                f = t.valueValidation,
                p = t.touchValidation,
                h = r.getError,
                v = r.getWarning,
                g = r.getSuccess,
                y = r.getTouched,
                _ = r.getValue,
                A = h(),
                E = v(),
                b = g(),
                C = y(),
                O = _(),
                N = T["default"].getMessageType(A, E, b),
                M = T["default"].shouldShowValidation({
              valueValidation: f,
              touchValidation: p,
              touched: C,
              value: O
            }),
                x = (0, S["default"])(d, "react-form-input", "react-form-radio-group", (e = {}, (0, u["default"])(e, "react-form-input-" + N, N && M), (0, u["default"])(e, "react-form-radio-group-" + N, N && M), e));

            r.onChange = function (e) {
              s && s(e);
            }, r.onBlur = function () {
              o && o();
            };
            var R = void 0;
            return R = n ? m["default"].createElement(n, {
              group: r
            }) : i ? i(r) : "function" == typeof a ? a(r) : m["default"].cloneElement(a, {
              group: r
            }), m["default"].createElement("div", null, N && M && !l && c ? m["default"].createElement(V["default"], {
              message: T["default"].getMessage(A, E, b),
              type: N
            }) : null, m["default"].createElement("div", {
              className: x
            }, R), N && M && !l && !c ? m["default"].createElement(V["default"], {
              message: T["default"].getMessage(A, E, b),
              type: N
            }) : null);
          }
        }]), t;
      }(g.Component),
          O = (0, A["default"])(C);

      t["default"] = O;
    }, function (e, t, r) {
      "use strict";

      Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
        value: function value(e) {
          if (null == this) throw new TypeError('"this" is null or not defined');
          var t = Object(this),
              r = t.length >>> 0;
          if ("function" != typeof e) throw new TypeError("predicate must be a function");

          for (var a = arguments[1], n = 0; n < r;) {
            var u = t[n];
            if (e.call(a, u, n, t)) return u;
            n++;
          }
        }
      }), Array.prototype.findIndex || Object.defineProperty(Array.prototype, "findIndex", {
        value: function value(e) {
          if (null == this) throw new TypeError('"this" is null or not defined');
          var t = Object(this),
              r = t.length >>> 0;
          if ("function" != typeof e) throw new TypeError("predicate must be a function");

          for (var a = arguments[1], n = 0; n < r;) {
            var u = t[n];
            if (e.call(a, u, n, t)) return n;
            n++;
          }

          return -1;
        }
      });
    }, function (e, t, r) {
      "use strict";

      Array.prototype.includes || Object.defineProperty(Array.prototype, "includes", {
        value: function value(e, t) {
          if (null == this) throw new TypeError('"this" is null or not defined');
          var r = Object(this),
              a = r.length >>> 0;
          if (0 === a) return !1;

          for (var n = 0 | t, u = Math.max(n >= 0 ? n : a - Math.abs(n), 0); u < a;) {
            if (function (e, t) {
              return e === t || "number" == typeof e && "number" == typeof t && isNaN(e) && isNaN(t);
            }(r[u], e)) return !0;
            u++;
          }

          return !1;
        }
      });
    }]);
  });
  /***/
},
/* 47 */

/***/
function (module, exports, __webpack_require__) {
  var _Symbol3 = __webpack_require__(48),
      getRawTag = __webpack_require__(425),
      objectToString = __webpack_require__(426);
  /** `Object#toString` result references. */


  var nullTag = '[object Null]',
      undefinedTag = '[object Undefined]';
  /** Built-in value references. */

  var symToStringTag = _Symbol3 ? _Symbol3.toStringTag : undefined;
  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */

  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }

    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }

  module.exports = baseGetTag;
  /***/
},
/* 48 */

/***/
function (module, exports, __webpack_require__) {
  var root = __webpack_require__(20);
  /** Built-in value references. */


  var _Symbol4 = root.Symbol;
  module.exports = _Symbol4;
  /***/
},
/* 49 */

/***/
function (module, exports) {
  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject(value) {
    var type = _typeof4(value);

    return value != null && (type == 'object' || type == 'function');
  }

  module.exports = isObject;
  /***/
},
/* 50 */

/***/
function (module, exports) {
  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return value != null && _typeof4(value) == 'object';
  }

  module.exports = isObjectLike;
  /***/
},
/* 51 */

/***/
function (module, exports, __webpack_require__) {
  var isFunction = __webpack_require__(177),
      isLength = __webpack_require__(108);
  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */


  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }

  module.exports = isArrayLike;
  /***/
},
/* 52 */

/***/
function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(47),
      isObjectLike = __webpack_require__(50);
  /** `Object#toString` result references. */


  var symbolTag = '[object Symbol]';
  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */

  function isSymbol(value) {
    return _typeof4(value) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
  }

  module.exports = isSymbol;
  /***/
},
/* 53 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  var _from = __webpack_require__(193);

  var _from2 = _interopRequireDefault(_from);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  exports["default"] = function (arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return (0, _from2["default"])(arr);
    }
  };
  /***/

},
/* 54 */

/***/
function (module, exports) {
  module.exports = function (it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
  };
  /***/

},
/* 55 */

/***/
function (module, exports) {
  var id = 0;
  var px = Math.random();

  module.exports = function (key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
  };
  /***/

},
/* 56 */

/***/
function (module, exports, __webpack_require__) {
  var def = __webpack_require__(15).f;

  var has = __webpack_require__(27);

  var TAG = __webpack_require__(10)('toStringTag');

  module.exports = function (it, tag, stat) {
    if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
      configurable: true,
      value: tag
    });
  };
  /***/

},
/* 57 */

/***/
function (module, exports) {
  exports.f = {}.propertyIsEnumerable;
  /***/
},
/* 58 */

/***/
function (module, exports, __webpack_require__) {
  var root = __webpack_require__(19);
  /** Built-in value references. */


  var _Symbol5 = root.Symbol;
  module.exports = _Symbol5;
  /***/
},
/* 59 */

/***/
function (module, exports, __webpack_require__) {
  var listCacheClear = __webpack_require__(305),
      listCacheDelete = __webpack_require__(306),
      listCacheGet = __webpack_require__(307),
      listCacheHas = __webpack_require__(308),
      listCacheSet = __webpack_require__(309);
  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */


  function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  } // Add methods to `ListCache`.


  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;
  module.exports = ListCache;
  /***/
},
/* 60 */

/***/
function (module, exports, __webpack_require__) {
  var eq = __webpack_require__(153);
  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */


  function assocIndexOf(array, key) {
    var length = array.length;

    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }

    return -1;
  }

  module.exports = assocIndexOf;
  /***/
},
/* 61 */

/***/
function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(28);
  /* Built-in method references that are verified to be native. */


  var nativeCreate = getNative(Object, 'create');
  module.exports = nativeCreate;
  /***/
},
/* 62 */

/***/
function (module, exports, __webpack_require__) {
  var isKeyable = __webpack_require__(323);
  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */


  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
  }

  module.exports = getMapData;
  /***/
},
/* 63 */

/***/
function (module, exports, __webpack_require__) {
  var isSymbol = __webpack_require__(91);
  /** Used as references for various `Number` constants. */


  var INFINITY = 1 / 0;
  /**
   * Converts `value` to a string key if it's not a string or symbol.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {string|symbol} Returns the key.
   */

  function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) {
      return value;
    }

    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
  }

  module.exports = toKey;
  /***/
},
/* 64 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */

    /**
     * Use invariant() to assert state which your program assumes to be true.
     *
     * Provide sprintf-style format (only %s is supported) and arguments
     * to provide information about what broke and what you were
     * expecting.
     *
     * The invariant message will be stripped in production, but the invariant
     * will remain to ensure logic does not differ in production.
     */
    var invariant = function invariant(condition, format, a, b, c, d, e, f) {
      if (process.env.NODE_ENV !== 'production') {
        if (format === undefined) {
          throw new Error('invariant requires an error message argument');
        }
      }

      if (!condition) {
        var error;

        if (format === undefined) {
          error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
        } else {
          var args = [a, b, c, d, e, f];
          var argIndex = 0;
          error = new Error(format.replace(/%s/g, function () {
            return args[argIndex++];
          }));
          error.name = 'Invariant Violation';
        }

        error.framesToPop = 1; // we don't care about invariant's own frame

        throw error;
      }
    };

    module.exports = invariant;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(8));
  /***/
},
/* 65 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.arrayMove = exports.sortableHandle = exports.sortableElement = exports.sortableContainer = exports.SortableHandle = exports.SortableElement = exports.SortableContainer = undefined;

  var _utils = __webpack_require__(66);

  Object.defineProperty(exports, 'arrayMove', {
    enumerable: true,
    get: function get() {
      return _utils.arrayMove;
    }
  });

  var _SortableContainer2 = __webpack_require__(408);

  var _SortableContainer3 = _interopRequireDefault(_SortableContainer2);

  var _SortableElement2 = __webpack_require__(514);

  var _SortableElement3 = _interopRequireDefault(_SortableElement2);

  var _SortableHandle2 = __webpack_require__(515);

  var _SortableHandle3 = _interopRequireDefault(_SortableHandle2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  exports.SortableContainer = _SortableContainer3["default"];
  exports.SortableElement = _SortableElement3["default"];
  exports.SortableHandle = _SortableHandle3["default"];
  exports.sortableContainer = _SortableContainer3["default"];
  exports.sortableElement = _SortableElement3["default"];
  exports.sortableHandle = _SortableHandle3["default"];
  /***/
},
/* 66 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.arrayMove = arrayMove;
  exports.omit = omit;
  exports.closest = closest;
  exports.limit = limit;
  exports.getElementMargin = getElementMargin;
  exports.provideDisplayName = provideDisplayName;

  function arrayMove(arr, previousIndex, newIndex) {
    var array = arr.slice(0);

    if (newIndex >= array.length) {
      var k = newIndex - array.length;

      while (k-- + 1) {
        array.push(undefined);
      }
    }

    array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);
    return array;
  }

  function omit(obj) {
    for (var _len = arguments.length, keysToOmit = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      keysToOmit[_key - 1] = arguments[_key];
    }

    return Object.keys(obj).reduce(function (acc, key) {
      if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
      return acc;
    }, {});
  }

  var events = exports.events = {
    start: ['touchstart', 'mousedown'],
    move: ['touchmove', 'mousemove'],
    end: ['touchend', 'touchcancel', 'mouseup']
  };

  var vendorPrefix = exports.vendorPrefix = function () {
    if (typeof window === 'undefined' || typeof document === 'undefined') return ''; // server environment
    // fix for:
    //    https://bugzilla.mozilla.org/show_bug.cgi?id=548397
    //    window.getComputedStyle() returns null inside an iframe with display: none
    // in this case return an array with a fake mozilla style in it.

    var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
    var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];

    switch (pre) {
      case 'ms':
        return 'ms';

      default:
        return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
    }
  }();

  function closest(el, fn) {
    while (el) {
      if (fn(el)) return el;
      el = el.parentNode;
    }
  }

  function limit(min, max, value) {
    if (value < min) {
      return min;
    }

    if (value > max) {
      return max;
    }

    return value;
  }

  function getCSSPixelValue(stringValue) {
    if (stringValue.substr(-2) === 'px') {
      return parseFloat(stringValue);
    }

    return 0;
  }

  function getElementMargin(element) {
    var style = window.getComputedStyle(element);
    return {
      top: getCSSPixelValue(style.marginTop),
      right: getCSSPixelValue(style.marginRight),
      bottom: getCSSPixelValue(style.marginBottom),
      left: getCSSPixelValue(style.marginLeft)
    };
  }

  function provideDisplayName(prefix, Component) {
    var componentName = Component.displayName || Component.name;
    return componentName ? prefix + '(' + componentName + ')' : prefix;
  }
  /***/

},
/* 67 */

/***/
function (module, exports, __webpack_require__) {
  var listCacheClear = __webpack_require__(414),
      listCacheDelete = __webpack_require__(415),
      listCacheGet = __webpack_require__(416),
      listCacheHas = __webpack_require__(417),
      listCacheSet = __webpack_require__(418);
  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */


  function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  } // Add methods to `ListCache`.


  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;
  module.exports = ListCache;
  /***/
},
/* 68 */

/***/
function (module, exports, __webpack_require__) {
  var eq = __webpack_require__(103);
  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */


  function assocIndexOf(array, key) {
    var length = array.length;

    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }

    return -1;
  }

  module.exports = assocIndexOf;
  /***/
},
/* 69 */

/***/
function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(29);
  /* Built-in method references that are verified to be native. */


  var nativeCreate = getNative(Object, 'create');
  module.exports = nativeCreate;
  /***/
},
/* 70 */

/***/
function (module, exports, __webpack_require__) {
  var isKeyable = __webpack_require__(438);
  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */


  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
  }

  module.exports = getMapData;
  /***/
},
/* 71 */

/***/
function (module, exports, __webpack_require__) {
  var arrayLikeKeys = __webpack_require__(458),
      baseKeys = __webpack_require__(464),
      isArrayLike = __webpack_require__(51);
  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */


  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }

  module.exports = keys;
  /***/
},
/* 72 */

/***/
function (module, exports, __webpack_require__) {
  var isSymbol = __webpack_require__(52);
  /** Used as references for various `Number` constants. */


  var INFINITY = 1 / 0;
  /**
   * Converts `value` to a string key if it's not a string or symbol.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {string|symbol} Returns the key.
   */

  function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) {
      return value;
    }

    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
  }

  module.exports = toKey;
  /***/
},
/* 73 */

/***/
function (module, exports) {
  /**
   * This method returns the first argument it receives.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'a': 1 };
   *
   * console.log(_.identity(object) === object);
   * // => true
   */
  function identity(value) {
    return value;
  }

  module.exports = identity;
  /***/
},
/* 74 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $at = __webpack_require__(195)(true); // 21.1.3.27 String.prototype[@@iterator]()


  __webpack_require__(110)(String, 'String', function (iterated) {
    this._t = String(iterated); // target

    this._i = 0; // next index
    // 21.1.5.2.1 %StringIteratorPrototype%.next()
  }, function () {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
      value: undefined,
      done: true
    };
    point = $at(O, index);
    this._i += point.length;
    return {
      value: point,
      done: false
    };
  });
  /***/

},
/* 75 */

/***/
function (module, exports) {
  // 7.1.4 ToInteger
  var ceil = Math.ceil;
  var floor = Math.floor;

  module.exports = function (it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
  };
  /***/

},
/* 76 */

/***/
function (module, exports) {
  // 7.2.1 RequireObjectCoercible(argument)
  module.exports = function (it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
  };
  /***/

},
/* 77 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(22);

  var document = __webpack_require__(9).document; // typeof document.createElement is 'object' in old IE


  var is = isObject(document) && isObject(document.createElement);

  module.exports = function (it) {
    return is ? document.createElement(it) : {};
  };
  /***/

},
/* 78 */

/***/
function (module, exports, __webpack_require__) {
  // 7.1.1 ToPrimitive(input [, PreferredType])
  var isObject = __webpack_require__(22); // instead of the ES6 spec version, we didn't implement @@toPrimitive case
  // and the second argument - flag - preferred type is a string


  module.exports = function (it, S) {
    if (!isObject(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
  };
  /***/

},
/* 79 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
  var anObject = __webpack_require__(16);

  var dPs = __webpack_require__(197);

  var enumBugKeys = __webpack_require__(83);

  var IE_PROTO = __webpack_require__(81)('IE_PROTO');

  var Empty = function Empty() {
    /* empty */
  };

  var PROTOTYPE = 'prototype'; // Create object with fake `null` prototype: use iframe Object with cleared prototype

  var _createDict = function createDict() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = __webpack_require__(77)('iframe');

    var i = enumBugKeys.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';

    __webpack_require__(115).appendChild(iframe);

    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);

    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    _createDict = iframeDocument.F;

    while (i--) {
      delete _createDict[PROTOTYPE][enumBugKeys[i]];
    }

    return _createDict();
  };

  module.exports = Object.create || function create(O, Properties) {
    var result;

    if (O !== null) {
      Empty[PROTOTYPE] = anObject(O);
      result = new Empty();
      Empty[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

      result[IE_PROTO] = O;
    } else result = _createDict();

    return Properties === undefined ? result : dPs(result, Properties);
  };
  /***/

},
/* 80 */

/***/
function (module, exports, __webpack_require__) {
  // 7.1.15 ToLength
  var toInteger = __webpack_require__(75);

  var min = Math.min;

  module.exports = function (it) {
    return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
  };
  /***/

},
/* 81 */

/***/
function (module, exports, __webpack_require__) {
  var shared = __webpack_require__(82)('keys');

  var uid = __webpack_require__(55);

  module.exports = function (key) {
    return shared[key] || (shared[key] = uid(key));
  };
  /***/

},
/* 82 */

/***/
function (module, exports, __webpack_require__) {
  var core = __webpack_require__(7);

  var global = __webpack_require__(9);

  var SHARED = '__core-js_shared__';
  var store = global[SHARED] || (global[SHARED] = {});
  (module.exports = function (key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: core.version,
    mode: __webpack_require__(36) ? 'pure' : 'global',
    copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
  });
  /***/
},
/* 83 */

/***/
function (module, exports) {
  // IE 8- don't enum bug keys
  module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
  /***/
},
/* 84 */

/***/
function (module, exports) {
  exports.f = Object.getOwnPropertySymbols;
  /***/
},
/* 85 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  var _iterator = __webpack_require__(209);

  var _iterator2 = _interopRequireDefault(_iterator);

  var _symbol = __webpack_require__(214);

  var _symbol2 = _interopRequireDefault(_symbol);

  var _typeof = typeof _symbol2["default"] === "function" && _typeof4(_iterator2["default"]) === "symbol" ? function (obj) {
    return _typeof4(obj);
  } : function (obj) {
    return obj && typeof _symbol2["default"] === "function" && obj.constructor === _symbol2["default"] && obj !== _symbol2["default"].prototype ? "symbol" : _typeof4(obj);
  };

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  exports["default"] = typeof _symbol2["default"] === "function" && _typeof(_iterator2["default"]) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof(obj);
  } : function (obj) {
    return obj && typeof _symbol2["default"] === "function" && obj.constructor === _symbol2["default"] && obj !== _symbol2["default"].prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
  };
  /***/
},
/* 86 */

/***/
function (module, exports, __webpack_require__) {
  exports.f = __webpack_require__(10);
  /***/
},
/* 87 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(9);

  var core = __webpack_require__(7);

  var LIBRARY = __webpack_require__(36);

  var wksExt = __webpack_require__(86);

  var defineProperty = __webpack_require__(15).f;

  module.exports = function (name) {
    var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
      value: wksExt.f(name)
    });
  };
  /***/

},
/* 88 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  module.exports = ReactPropTypesSecret;
  /***/
},
/* 89 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.DEPRECATED_CONFIG_PROPS = exports.defaultProps = exports.propTypes = undefined;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  var string = _propTypes2['default'].string,
      bool = _propTypes2['default'].bool,
      number = _propTypes2['default'].number,
      array = _propTypes2['default'].array,
      oneOfType = _propTypes2['default'].oneOfType,
      shape = _propTypes2['default'].shape,
      object = _propTypes2['default'].object,
      func = _propTypes2['default'].func;
  var propTypes = exports.propTypes = {
    url: oneOfType([string, array]),
    playing: bool,
    loop: bool,
    controls: bool,
    volume: number,
    muted: bool,
    playbackRate: number,
    width: oneOfType([string, number]),
    height: oneOfType([string, number]),
    style: object,
    progressFrequency: number,
    playsinline: bool,
    config: shape({
      soundcloud: shape({
        options: object
      }),
      youtube: shape({
        playerVars: object,
        preload: bool
      }),
      facebook: shape({
        appId: string
      }),
      dailymotion: shape({
        params: object,
        preload: bool
      }),
      vimeo: shape({
        iframeParams: object,
        preload: bool
      }),
      vidme: shape({
        format: string
      }),
      file: shape({
        attributes: object,
        tracks: array,
        forceAudio: bool,
        forceHLS: bool,
        forceDASH: bool
      }),
      wistia: shape({
        options: object
      })
    }),
    onReady: func,
    onStart: func,
    onPlay: func,
    onPause: func,
    onBuffer: func,
    onEnded: func,
    onError: func,
    onDuration: func,
    onSeek: func,
    onProgress: func
  };
  var defaultProps = exports.defaultProps = {
    playing: false,
    loop: false,
    controls: false,
    volume: 0.8,
    muted: false,
    playbackRate: 1,
    width: 640,
    height: 360,
    style: {},
    progressFrequency: 1000,
    playsinline: false,
    config: {
      soundcloud: {
        options: {
          visual: true,
          // Undocumented, but makes player fill container and look better
          buying: false,
          liking: false,
          download: false,
          sharing: false,
          show_comments: false,
          show_playcount: false
        }
      },
      youtube: {
        playerVars: {
          autoplay: 0,
          playsinline: 1,
          showinfo: 0,
          rel: 0,
          iv_load_policy: 3
        },
        preload: false
      },
      facebook: {
        appId: '1309697205772819'
      },
      dailymotion: {
        params: {
          api: 1,
          'endscreen-enable': false
        },
        preload: false
      },
      vimeo: {
        playerOptions: {
          autopause: false,
          autoplay: false,
          byline: false,
          portrait: false,
          title: false
        },
        preload: false
      },
      vidme: {
        format: null
      },
      file: {
        attributes: {},
        tracks: [],
        forceAudio: false,
        forceHLS: false,
        forceDASH: false
      },
      wistia: {
        options: {}
      }
    },
    onReady: function onReady() {},
    onStart: function onStart() {},
    onPlay: function onPlay() {},
    onPause: function onPause() {},
    onBuffer: function onBuffer() {},
    onEnded: function onEnded() {},
    onError: function onError() {},
    onDuration: function onDuration() {},
    onSeek: function onSeek() {},
    onProgress: function onProgress() {}
  };
  var DEPRECATED_CONFIG_PROPS = exports.DEPRECATED_CONFIG_PROPS = ['soundcloudConfig', 'youtubeConfig', 'facebookConfig', 'dailymotionConfig', 'vimeoConfig', 'vidmeConfig', 'fileConfig', 'wistiaConfig'];
  /***/
},
/* 90 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(42);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(35);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(13);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11_lodash_upperFirst__ = __webpack_require__(256);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11_lodash_upperFirst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_upperFirst__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_12_recompose__ = __webpack_require__(18);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_13_react_transition_group__ = __webpack_require__(140);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_13_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_transition_group__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_14_react_popper__ = __webpack_require__(273);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_14_react_popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_popper__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_15__UI_Icon_Icon__ = __webpack_require__(34);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_16__UI_Modal_Modal__ = __webpack_require__(280);

  var _class,
      _temp2,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/Toolbar/Toolbar.js'; // Recompose
  // Motion
  // Popper
  // Components


  var Toolbar = (_temp2 = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Toolbar, _React$Component);

    function Toolbar() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Toolbar);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Toolbar.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Toolbar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        opened: false,
        tooltip: null,
        edition: null
      }, _this.triggerToggleOptions = function () {
        _this.setState({
          opened: true
        });
      }, _this.triggerAddBlock = function (block) {
        var blocks = _this.props.blocks; // Check if block has EditionComponent to fill

        if (blocks[block] && blocks[block].EditionComponent) {
          _this.setState({
            tooltip: block,
            edition: block
          });

          _this.props.setEditionMode && _this.props.setEditionMode(true);
        } else {
          _this.props.onAdd && _this.props.onAdd({
            id: Date.now(),
            type: block
          });

          _this.triggerClose();
        }
      }, _this.triggerSubmitBlock = function (block, content) {
        _this.props.onAdd && _this.props.onAdd({
          id: Date.now(),
          type: block,
          content: content
        });

        _this.triggerClose();
      }, _this.triggerClose = function () {
        // Close options
        _this.setState({
          opened: false,
          tooltip: null,
          edition: null
        });

        _this.props.setEditionMode && _this.props.setEditionMode(false);
      }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Toolbar, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.editionMode !== nextProps.editionMode && !nextProps.editionMode) {
          this.triggerClose();
        }
      }
      /**
       * UI EVENTS
       * - triggerToggleOptions
       * - triggerAddBlock
      */
      // Helpers

    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            blocks = _props.blocks,
            editionMode = _props.editionMode,
            exclude = _props.exclude,
            className = _props.className;
        var _state = this.state,
            opened = _state.opened,
            tooltip = _state.tooltip,
            edition = _state.edition;

        var classNames = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
          '-edition': edition
        }, className, !!className));

        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
          className: 'cw-wysiwyg-toolbar ' + classNames,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 106
          }
        }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
          className: 'toolbar-handler',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 107
          }
        }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_transition_group__["Transition"], {
          'in': !opened,
          timeout: 150,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 110
          }
        }, function (status) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
            className: 'toolbar-handler-button -' + status,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 112
            }
          }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('button', {
            type: 'button',
            className: 'cw-button -primary',
            onClick: function onClick() {
              return _this2.triggerToggleOptions();
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 113
            }
          }, 'Add', __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__UI_Icon_Icon__["a"
          /* default */
          ], {
            name: 'icon-add',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 119
            }
          })));
        }), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_transition_group__["Transition"], {
          'in': opened,
          timeout: 150,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 126
          }
        }, function (status) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('ul', {
            className: 'toolbar-handler-list -' + status,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 128
            }
          }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(blocks).filter(function (block) {
            return !exclude.includes(block);
          }).map(function (block) {
            var btnClassNames = __WEBPACK_IMPORTED_MODULE_10_classnames___default()({
              '-active': block === edition
            });

            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('li', {
              key: block,
              onMouseLeave: function onMouseLeave() {
                if (!edition && !editionMode) {
                  _this2.setState({
                    tooltip: null
                  });
                }
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 136
              }
            }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_popper__["Manager"], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 144
              }
            }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_popper__["Target"], {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 146
              }
            }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('button', {
              type: 'button',
              className: 'cw-button -small -round -primary ' + btnClassNames,
              onClick: function onClick() {
                return _this2.triggerAddBlock(block);
              },
              onMouseEnter: function onMouseEnter() {
                return !editionMode && _this2.setState({
                  tooltip: block,
                  edition: null
                });
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 147
              }
            }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__UI_Icon_Icon__["a"
            /* default */
            ], {
              name: blocks[block].icon || 'icon-' + block,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 155
              }
            }))), block === tooltip && !edition && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_popper__["Popper"], {
              placement: 'top',
              className: 'cw-tooltip',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 161
              }
            }, blocks[block].label || __WEBPACK_IMPORTED_MODULE_11_lodash_upperFirst___default()(block), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_popper__["Arrow"], {
              className: 'tooltip-arrow',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 163
              }
            })), block === tooltip && block === edition && blocks[block].renderer === 'tooltip' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_popper__["Popper"], {
              className: 'cw-tooltip -light',
              placement: 'bottom',
              modifiers: {
                preventOverflow: {
                  boundariesElement: 'viewport'
                }
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 169
              }
            }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(blocks[block].EditionComponent, {
              block: blocks[block],
              onSubmit: function onSubmit(content) {
                return _this2.triggerSubmitBlock(block, content);
              }
            }), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_popper__["Arrow"], {
              className: 'tooltip-arrow',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 185
              }
            })), block === tooltip && block === edition && blocks[block].renderer === 'modal' && Object(__WEBPACK_IMPORTED_MODULE_8_react_dom__["createPortal"])(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__UI_Modal_Modal__["a"
            /* default */
            ], {
              onClickClose: _this2.triggerClose,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 192
              }
            }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(blocks[block].EditionComponent, {
              block: blocks[block],
              onSubmit: function onSubmit(content) {
                return _this2.triggerSubmitBlock(block, content);
              }
            })), document.body)));
          }), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('li', {
            key: 'close',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 211
            }
          }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('button', {
            type: 'button',
            className: 'cw-button -small -round -close',
            onClick: _this2.triggerClose,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 212
            }
          }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__UI_Icon_Icon__["a"
          /* default */
          ], {
            name: 'icon-close',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 217
            }
          }))));
        })));
      }
    }]);

    return Toolbar;
  }(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _class.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
    blocks: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    editionMode: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    exclude: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.array,
    onAdd: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    setEditionMode: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
  }, _class.defaultProps = {
    className: '',
    blocks: {},
    editionMode: false,
    exclude: [],
    onAdd: null,
    setEditionMode: null
  }, _temp2);
  Toolbar.displayName = 'Toolbar';
  /* harmony default export */

  __webpack_exports__["a"] = Object(__WEBPACK_IMPORTED_MODULE_12_recompose__["a"
  /* getContext */
  ])({
    blocks: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    editionMode: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    setEditionMode: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
  })(Toolbar);
  /***/
},
/* 91 */

/***/
function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(43),
      isObjectLike = __webpack_require__(44);
  /** `Object#toString` result references. */


  var symbolTag = '[object Symbol]';
  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */

  function isSymbol(value) {
    return _typeof4(value) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
  }

  module.exports = isSymbol;
  /***/
},
/* 92 */

/***/
function (module, exports, __webpack_require__) {
  var baseAssignValue = __webpack_require__(281),
      baseForOwn = __webpack_require__(287),
      baseIteratee = __webpack_require__(302);
  /**
   * Creates an object with the same keys as `object` and values generated
   * by running each own enumerable string keyed property of `object` thru
   * `iteratee`. The iteratee is invoked with three arguments:
   * (value, key, object).
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Object
   * @param {Object} object The object to iterate over.
   * @param {Function} [iteratee=_.identity] The function invoked per iteration.
   * @returns {Object} Returns the new mapped object.
   * @see _.mapKeys
   * @example
   *
   * var users = {
   *   'fred':    { 'user': 'fred',    'age': 40 },
   *   'pebbles': { 'user': 'pebbles', 'age': 1 }
   * };
   *
   * _.mapValues(users, function(o) { return o.age; });
   * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
   *
   * // The `_.property` iteratee shorthand.
   * _.mapValues(users, 'age');
   * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
   */


  function mapValues(object, iteratee) {
    var result = {};
    iteratee = baseIteratee(iteratee, 3);
    baseForOwn(object, function (value, key, object) {
      baseAssignValue(result, key, iteratee(value, key, object));
    });
    return result;
  }

  module.exports = mapValues;
  /***/
},
/* 93 */

/***/
function (module, exports) {
  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject(value) {
    var type = _typeof4(value);

    return value != null && (type == 'object' || type == 'function');
  }

  module.exports = isObject;
  /***/
},
/* 94 */

/***/
function (module, exports, __webpack_require__) {
  var arrayLikeKeys = __webpack_require__(290),
      baseKeys = __webpack_require__(297),
      isArrayLike = __webpack_require__(301);
  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */


  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }

  module.exports = keys;
  /***/
},
/* 95 */

/***/
function (module, exports) {
  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;
  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */

  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }

  module.exports = isLength;
  /***/
},
/* 96 */

/***/
function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(28),
      root = __webpack_require__(19);
  /* Built-in method references that are verified to be native. */


  var Map = getNative(root, 'Map');
  module.exports = Map;
  /***/
},
/* 97 */

/***/
function (module, exports, __webpack_require__) {
  var mapCacheClear = __webpack_require__(315),
      mapCacheDelete = __webpack_require__(322),
      mapCacheGet = __webpack_require__(324),
      mapCacheHas = __webpack_require__(325),
      mapCacheSet = __webpack_require__(326);
  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */


  function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  } // Add methods to `MapCache`.


  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;
  module.exports = MapCache;
  /***/
},
/* 98 */

/***/
function (module, exports, __webpack_require__) {
  var isArray = __webpack_require__(25),
      isSymbol = __webpack_require__(91);
  /** Used to match property names within property paths. */


  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/;
  /**
   * Checks if `value` is a property name and not a property path.
   *
   * @private
   * @param {*} value The value to check.
   * @param {Object} [object] The object to query keys on.
   * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
   */

  function isKey(value, object) {
    if (isArray(value)) {
      return false;
    }

    var type = _typeof4(value);

    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
      return true;
    }

    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
  }

  module.exports = isKey;
  /***/
},
/* 99 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (module) {
    /*!
    * validate.js 0.12.0
    *
    * (c) 2013-2017 Nicklas Ansman, 2013 Wrapp
    * Validate.js may be freely distributed under the MIT license.
    * For all details and documentation:
    * http://validatejs.org/
    */
    (function (exports, module, define) {
      "use strict"; // The main function that calls the validators specified by the constraints.
      // The options are the following:
      //   - format (string) - An option that controls how the returned value is formatted
      //     * flat - Returns a flat array of just the error messages
      //     * grouped - Returns the messages grouped by attribute (default)
      //     * detailed - Returns an array of the raw validation data
      //   - fullMessages (boolean) - If `true` (default) the attribute name is prepended to the error.
      //
      // Please note that the options are also passed to each validator.

      var validate = function validate(attributes, constraints, options) {
        options = v.extend({}, v.options, options);
        var results = v.runValidations(attributes, constraints, options),
            attr,
            validator;

        if (results.some(function (r) {
          return v.isPromise(r.error);
        })) {
          throw new Error("Use validate.async if you want support for promises");
        }

        return validate.processValidationResults(results, options);
      };

      var v = validate; // Copies over attributes from one or more sources to a single destination.
      // Very much similar to underscore's extend.
      // The first argument is the target object and the remaining arguments will be
      // used as sources.

      v.extend = function (obj) {
        [].slice.call(arguments, 1).forEach(function (source) {
          for (var attr in source) {
            obj[attr] = source[attr];
          }
        });
        return obj;
      };

      v.extend(validate, {
        // This is the version of the library as a semver.
        // The toString function will allow it to be coerced into a string
        version: {
          major: 0,
          minor: 12,
          patch: 0,
          metadata: null,
          toString: function toString() {
            var version = v.format("%{major}.%{minor}.%{patch}", v.version);

            if (!v.isEmpty(v.version.metadata)) {
              version += "+" + v.version.metadata;
            }

            return version;
          }
        },
        // Below is the dependencies that are used in validate.js
        // The constructor of the Promise implementation.
        // If you are using Q.js, RSVP or any other A+ compatible implementation
        // override this attribute to be the constructor of that promise.
        // Since jQuery promises aren't A+ compatible they won't work.
        Promise: typeof Promise !== "undefined" ? Promise :
        /* istanbul ignore next */
        null,
        EMPTY_STRING_REGEXP: /^\s*$/,
        // Runs the validators specified by the constraints object.
        // Will return an array of the format:
        //     [{attribute: "<attribute name>", error: "<validation result>"}, ...]
        runValidations: function runValidations(attributes, constraints, options) {
          var results = [],
              attr,
              validatorName,
              value,
              validators,
              validator,
              validatorOptions,
              error;

          if (v.isDomElement(attributes) || v.isJqueryElement(attributes)) {
            attributes = v.collectFormValues(attributes);
          } // Loops through each constraints, finds the correct validator and run it.


          for (attr in constraints) {
            value = v.getDeepObjectValue(attributes, attr); // This allows the constraints for an attribute to be a function.
            // The function will be called with the value, attribute name, the complete dict of
            // attributes as well as the options and constraints passed in.
            // This is useful when you want to have different
            // validations depending on the attribute value.

            validators = v.result(constraints[attr], value, attributes, attr, options, constraints);

            for (validatorName in validators) {
              validator = v.validators[validatorName];

              if (!validator) {
                error = v.format("Unknown validator %{name}", {
                  name: validatorName
                });
                throw new Error(error);
              }

              validatorOptions = validators[validatorName]; // This allows the options to be a function. The function will be
              // called with the value, attribute name, the complete dict of
              // attributes as well as the options and constraints passed in.
              // This is useful when you want to have different
              // validations depending on the attribute value.

              validatorOptions = v.result(validatorOptions, value, attributes, attr, options, constraints);

              if (!validatorOptions) {
                continue;
              }

              results.push({
                attribute: attr,
                value: value,
                validator: validatorName,
                globalOptions: options,
                attributes: attributes,
                options: validatorOptions,
                error: validator.call(validator, value, validatorOptions, attr, attributes, options)
              });
            }
          }

          return results;
        },
        // Takes the output from runValidations and converts it to the correct
        // output format.
        processValidationResults: function processValidationResults(errors, options) {
          errors = v.pruneEmptyErrors(errors, options);
          errors = v.expandMultipleErrors(errors, options);
          errors = v.convertErrorMessages(errors, options);
          var format = options.format || "grouped";

          if (typeof v.formatters[format] === 'function') {
            errors = v.formatters[format](errors);
          } else {
            throw new Error(v.format("Unknown format %{format}", options));
          }

          return v.isEmpty(errors) ? undefined : errors;
        },
        // Runs the validations with support for promises.
        // This function will return a promise that is settled when all the
        // validation promises have been completed.
        // It can be called even if no validations returned a promise.
        async: function async(attributes, constraints, options) {
          options = v.extend({}, v.async.options, options);

          var WrapErrors = options.wrapErrors || function (errors) {
            return errors;
          }; // Removes unknown attributes


          if (options.cleanAttributes !== false) {
            attributes = v.cleanAttributes(attributes, constraints);
          }

          var results = v.runValidations(attributes, constraints, options);
          return new v.Promise(function (resolve, reject) {
            v.waitForResults(results).then(function () {
              var errors = v.processValidationResults(results, options);

              if (errors) {
                reject(new WrapErrors(errors, options, attributes, constraints));
              } else {
                resolve(attributes);
              }
            }, function (err) {
              reject(err);
            });
          });
        },
        single: function single(value, constraints, options) {
          options = v.extend({}, v.single.options, options, {
            format: "flat",
            fullMessages: false
          });
          return v({
            single: value
          }, {
            single: constraints
          }, options);
        },
        // Returns a promise that is resolved when all promises in the results array
        // are settled. The promise returned from this function is always resolved,
        // never rejected.
        // This function modifies the input argument, it replaces the promises
        // with the value returned from the promise.
        waitForResults: function waitForResults(results) {
          // Create a sequence of all the results starting with a resolved promise.
          return results.reduce(function (memo, result) {
            // If this result isn't a promise skip it in the sequence.
            if (!v.isPromise(result.error)) {
              return memo;
            }

            return memo.then(function () {
              return result.error.then(function (error) {
                result.error = error || null;
              });
            });
          }, new v.Promise(function (r) {
            r();
          })); // A resolved promise
        },
        // If the given argument is a call: function the and: function return the value
        // otherwise just return the value. Additional arguments will be passed as
        // arguments to the function.
        // Example:
        // ```
        // result('foo') // 'foo'
        // result(Math.max, 1, 2) // 2
        // ```
        result: function result(value) {
          var args = [].slice.call(arguments, 1);

          if (typeof value === 'function') {
            value = value.apply(null, args);
          }

          return value;
        },
        // Checks if the value is a number. This function does not consider NaN a
        // number like many other `isNumber` functions do.
        isNumber: function isNumber(value) {
          return typeof value === 'number' && !isNaN(value);
        },
        // Returns false if the object is not a function
        isFunction: function isFunction(value) {
          return typeof value === 'function';
        },
        // A simple check to verify that the value is an integer. Uses `isNumber`
        // and a simple modulo check.
        isInteger: function isInteger(value) {
          return v.isNumber(value) && value % 1 === 0;
        },
        // Checks if the value is a boolean
        isBoolean: function isBoolean(value) {
          return typeof value === 'boolean';
        },
        // Uses the `Object` function to check if the given argument is an object.
        isObject: function isObject(obj) {
          return obj === Object(obj);
        },
        // Simply checks if the object is an instance of a date
        isDate: function isDate(obj) {
          return obj instanceof Date;
        },
        // Returns false if the object is `null` of `undefined`
        isDefined: function isDefined(obj) {
          return obj !== null && obj !== undefined;
        },
        // Checks if the given argument is a promise. Anything with a `then`
        // function is considered a promise.
        isPromise: function isPromise(p) {
          return !!p && v.isFunction(p.then);
        },
        isJqueryElement: function isJqueryElement(o) {
          return o && v.isString(o.jquery);
        },
        isDomElement: function isDomElement(o) {
          if (!o) {
            return false;
          }

          if (!o.querySelectorAll || !o.querySelector) {
            return false;
          }

          if (v.isObject(document) && o === document) {
            return true;
          } // http://stackoverflow.com/a/384380/699304

          /* istanbul ignore else */


          if ((typeof HTMLElement === "undefined" ? "undefined" : _typeof4(HTMLElement)) === "object") {
            return o instanceof HTMLElement;
          } else {
            return o && _typeof4(o) === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string";
          }
        },
        isEmpty: function isEmpty(value) {
          var attr; // Null and undefined are empty

          if (!v.isDefined(value)) {
            return true;
          } // functions are non empty


          if (v.isFunction(value)) {
            return false;
          } // Whitespace only strings are empty


          if (v.isString(value)) {
            return v.EMPTY_STRING_REGEXP.test(value);
          } // For arrays we use the length property


          if (v.isArray(value)) {
            return value.length === 0;
          } // Dates have no attributes but aren't empty


          if (v.isDate(value)) {
            return false;
          } // If we find at least one property we consider it non empty


          if (v.isObject(value)) {
            for (attr in value) {
              return false;
            }

            return true;
          }

          return false;
        },
        // Formats the specified strings with the given values like so:
        // ```
        // format("Foo: %{foo}", {foo: "bar"}) // "Foo bar"
        // ```
        // If you want to write %{...} without having it replaced simply
        // prefix it with % like this `Foo: %%{foo}` and it will be returned
        // as `"Foo: %{foo}"`
        format: v.extend(function (str, vals) {
          if (!v.isString(str)) {
            return str;
          }

          return str.replace(v.format.FORMAT_REGEXP, function (m0, m1, m2) {
            if (m1 === '%') {
              return "%{" + m2 + "}";
            } else {
              return String(vals[m2]);
            }
          });
        }, {
          // Finds %{key} style patterns in the given string
          FORMAT_REGEXP: /(%?)%\{([^\}]+)\}/g
        }),
        // "Prettifies" the given string.
        // Prettifying means replacing [.\_-] with spaces as well as splitting
        // camel case words.
        prettify: function prettify(str) {
          if (v.isNumber(str)) {
            // If there are more than 2 decimals round it to two
            if (str * 100 % 1 === 0) {
              return "" + str;
            } else {
              return parseFloat(Math.round(str * 100) / 100).toFixed(2);
            }
          }

          if (v.isArray(str)) {
            return str.map(function (s) {
              return v.prettify(s);
            }).join(", ");
          }

          if (v.isObject(str)) {
            return str.toString();
          } // Ensure the string is actually a string


          str = "" + str;
          return str // Splits keys separated by periods
          .replace(/([^\s])\.([^\s])/g, '$1 $2') // Removes backslashes
          .replace(/\\+/g, '') // Replaces - and - with space
          .replace(/[_-]/g, ' ') // Splits camel cased words
          .replace(/([a-z])([A-Z])/g, function (m0, m1, m2) {
            return "" + m1 + " " + m2.toLowerCase();
          }).toLowerCase();
        },
        stringifyValue: function stringifyValue(value, options) {
          var prettify = options && options.prettify || v.prettify;
          return prettify(value);
        },
        isString: function isString(value) {
          return typeof value === 'string';
        },
        isArray: function isArray(value) {
          return {}.toString.call(value) === '[object Array]';
        },
        // Checks if the object is a hash, which is equivalent to an object that
        // is neither an array nor a function.
        isHash: function isHash(value) {
          return v.isObject(value) && !v.isArray(value) && !v.isFunction(value);
        },
        contains: function contains(obj, value) {
          if (!v.isDefined(obj)) {
            return false;
          }

          if (v.isArray(obj)) {
            return obj.indexOf(value) !== -1;
          }

          return value in obj;
        },
        unique: function unique(array) {
          if (!v.isArray(array)) {
            return array;
          }

          return array.filter(function (el, index, array) {
            return array.indexOf(el) == index;
          });
        },
        forEachKeyInKeypath: function forEachKeyInKeypath(object, keypath, callback) {
          if (!v.isString(keypath)) {
            return undefined;
          }

          var key = "",
              i,
              escape = false;

          for (i = 0; i < keypath.length; ++i) {
            switch (keypath[i]) {
              case '.':
                if (escape) {
                  escape = false;
                  key += '.';
                } else {
                  object = callback(object, key, false);
                  key = "";
                }

                break;

              case '\\':
                if (escape) {
                  escape = false;
                  key += '\\';
                } else {
                  escape = true;
                }

                break;

              default:
                escape = false;
                key += keypath[i];
                break;
            }
          }

          return callback(object, key, true);
        },
        getDeepObjectValue: function getDeepObjectValue(obj, keypath) {
          if (!v.isObject(obj)) {
            return undefined;
          }

          return v.forEachKeyInKeypath(obj, keypath, function (obj, key) {
            if (v.isObject(obj)) {
              return obj[key];
            }
          });
        },
        // This returns an object with all the values of the form.
        // It uses the input name as key and the value as value
        // So for example this:
        // <input type="text" name="email" value="foo@bar.com" />
        // would return:
        // {email: "foo@bar.com"}
        collectFormValues: function collectFormValues(form, options) {
          var values = {},
              i,
              j,
              input,
              inputs,
              option,
              value;

          if (v.isJqueryElement(form)) {
            form = form[0];
          }

          if (!form) {
            return values;
          }

          options = options || {};
          inputs = form.querySelectorAll("input[name], textarea[name]");

          for (i = 0; i < inputs.length; ++i) {
            input = inputs.item(i);

            if (v.isDefined(input.getAttribute("data-ignored"))) {
              continue;
            }

            name = input.name.replace(/\./g, "\\\\.");
            value = v.sanitizeFormValue(input.value, options);

            if (input.type === "number") {
              value = value ? +value : null;
            } else if (input.type === "checkbox") {
              if (input.attributes.value) {
                if (!input.checked) {
                  value = values[name] || null;
                }
              } else {
                value = input.checked;
              }
            } else if (input.type === "radio") {
              if (!input.checked) {
                value = values[name] || null;
              }
            }

            values[name] = value;
          }

          inputs = form.querySelectorAll("select[name]");

          for (i = 0; i < inputs.length; ++i) {
            input = inputs.item(i);

            if (v.isDefined(input.getAttribute("data-ignored"))) {
              continue;
            }

            if (input.multiple) {
              value = [];

              for (j in input.options) {
                option = input.options[j];

                if (option && option.selected) {
                  value.push(v.sanitizeFormValue(option.value, options));
                }
              }
            } else {
              var _val = typeof input.options[input.selectedIndex] !== 'undefined' ? input.options[input.selectedIndex].value : '';

              value = v.sanitizeFormValue(_val, options);
            }

            values[input.name] = value;
          }

          return values;
        },
        sanitizeFormValue: function sanitizeFormValue(value, options) {
          if (options.trim && v.isString(value)) {
            value = value.trim();
          }

          if (options.nullify !== false && value === "") {
            return null;
          }

          return value;
        },
        capitalize: function capitalize(str) {
          if (!v.isString(str)) {
            return str;
          }

          return str[0].toUpperCase() + str.slice(1);
        },
        // Remove all errors who's error attribute is empty (null or undefined)
        pruneEmptyErrors: function pruneEmptyErrors(errors) {
          return errors.filter(function (error) {
            return !v.isEmpty(error.error);
          });
        },
        // In
        // [{error: ["err1", "err2"], ...}]
        // Out
        // [{error: "err1", ...}, {error: "err2", ...}]
        //
        // All attributes in an error with multiple messages are duplicated
        // when expanding the errors.
        expandMultipleErrors: function expandMultipleErrors(errors) {
          var ret = [];
          errors.forEach(function (error) {
            // Removes errors without a message
            if (v.isArray(error.error)) {
              error.error.forEach(function (msg) {
                ret.push(v.extend({}, error, {
                  error: msg
                }));
              });
            } else {
              ret.push(error);
            }
          });
          return ret;
        },
        // Converts the error mesages by prepending the attribute name unless the
        // message is prefixed by ^
        convertErrorMessages: function convertErrorMessages(errors, options) {
          options = options || {};
          var ret = [],
              prettify = options.prettify || v.prettify;
          errors.forEach(function (errorInfo) {
            var error = v.result(errorInfo.error, errorInfo.value, errorInfo.attribute, errorInfo.options, errorInfo.attributes, errorInfo.globalOptions);

            if (!v.isString(error)) {
              ret.push(errorInfo);
              return;
            }

            if (error[0] === '^') {
              error = error.slice(1);
            } else if (options.fullMessages !== false) {
              error = v.capitalize(prettify(errorInfo.attribute)) + " " + error;
            }

            error = error.replace(/\\\^/g, "^");
            error = v.format(error, {
              value: v.stringifyValue(errorInfo.value, options)
            });
            ret.push(v.extend({}, errorInfo, {
              error: error
            }));
          });
          return ret;
        },
        // In:
        // [{attribute: "<attributeName>", ...}]
        // Out:
        // {"<attributeName>": [{attribute: "<attributeName>", ...}]}
        groupErrorsByAttribute: function groupErrorsByAttribute(errors) {
          var ret = {};
          errors.forEach(function (error) {
            var list = ret[error.attribute];

            if (list) {
              list.push(error);
            } else {
              ret[error.attribute] = [error];
            }
          });
          return ret;
        },
        // In:
        // [{error: "<message 1>", ...}, {error: "<message 2>", ...}]
        // Out:
        // ["<message 1>", "<message 2>"]
        flattenErrorsToArray: function flattenErrorsToArray(errors) {
          return errors.map(function (error) {
            return error.error;
          }).filter(function (value, index, self) {
            return self.indexOf(value) === index;
          });
        },
        cleanAttributes: function cleanAttributes(attributes, whitelist) {
          function whitelistCreator(obj, key, last) {
            if (v.isObject(obj[key])) {
              return obj[key];
            }

            return obj[key] = last ? true : {};
          }

          function buildObjectWhitelist(whitelist) {
            var ow = {},
                lastObject,
                attr;

            for (attr in whitelist) {
              if (!whitelist[attr]) {
                continue;
              }

              v.forEachKeyInKeypath(ow, attr, whitelistCreator);
            }

            return ow;
          }

          function cleanRecursive(attributes, whitelist) {
            if (!v.isObject(attributes)) {
              return attributes;
            }

            var ret = v.extend({}, attributes),
                w,
                attribute;

            for (attribute in attributes) {
              w = whitelist[attribute];

              if (v.isObject(w)) {
                ret[attribute] = cleanRecursive(ret[attribute], w);
              } else if (!w) {
                delete ret[attribute];
              }
            }

            return ret;
          }

          if (!v.isObject(whitelist) || !v.isObject(attributes)) {
            return {};
          }

          whitelist = buildObjectWhitelist(whitelist);
          return cleanRecursive(attributes, whitelist);
        },
        exposeModule: function exposeModule(validate, root, exports, module, define) {
          if (exports) {
            if (module && module.exports) {
              exports = module.exports = validate;
            }

            exports.validate = validate;
          } else {
            root.validate = validate;

            if (validate.isFunction(define) && define.amd) {
              define([], function () {
                return validate;
              });
            }
          }
        },
        warn: function warn(msg) {
          if (typeof console !== "undefined" && console.warn) {
            console.warn("[validate.js] " + msg);
          }
        },
        error: function error(msg) {
          if (typeof console !== "undefined" && console.error) {
            console.error("[validate.js] " + msg);
          }
        }
      });
      validate.validators = {
        // Presence validates that the value isn't empty
        presence: function presence(value, options) {
          options = v.extend({}, this.options, options);

          if (options.allowEmpty !== false ? !v.isDefined(value) : v.isEmpty(value)) {
            return options.message || this.message || "can't be blank";
          }
        },
        length: function length(value, options, attribute) {
          // Empty values are allowed
          if (!v.isDefined(value)) {
            return;
          }

          options = v.extend({}, this.options, options);

          var is = options.is,
              maximum = options.maximum,
              minimum = options.minimum,
              tokenizer = options.tokenizer || function (val) {
            return val;
          },
              err,
              errors = [];

          value = tokenizer(value);
          var length = value.length;

          if (!v.isNumber(length)) {
            v.error(v.format("Attribute %{attr} has a non numeric value for `length`", {
              attr: attribute
            }));
            return options.message || this.notValid || "has an incorrect length";
          } // Is checks


          if (v.isNumber(is) && length !== is) {
            err = options.wrongLength || this.wrongLength || "is the wrong length (should be %{count} characters)";
            errors.push(v.format(err, {
              count: is
            }));
          }

          if (v.isNumber(minimum) && length < minimum) {
            err = options.tooShort || this.tooShort || "is too short (minimum is %{count} characters)";
            errors.push(v.format(err, {
              count: minimum
            }));
          }

          if (v.isNumber(maximum) && length > maximum) {
            err = options.tooLong || this.tooLong || "is too long (maximum is %{count} characters)";
            errors.push(v.format(err, {
              count: maximum
            }));
          }

          if (errors.length > 0) {
            return options.message || errors;
          }
        },
        numericality: function numericality(value, options, attribute, attributes, globalOptions) {
          // Empty values are fine
          if (!v.isDefined(value)) {
            return;
          }

          options = v.extend({}, this.options, options);
          var errors = [],
              name,
              count,
              checks = {
            greaterThan: function greaterThan(v, c) {
              return v > c;
            },
            greaterThanOrEqualTo: function greaterThanOrEqualTo(v, c) {
              return v >= c;
            },
            equalTo: function equalTo(v, c) {
              return v === c;
            },
            lessThan: function lessThan(v, c) {
              return v < c;
            },
            lessThanOrEqualTo: function lessThanOrEqualTo(v, c) {
              return v <= c;
            },
            divisibleBy: function divisibleBy(v, c) {
              return v % c === 0;
            }
          },
              prettify = options.prettify || globalOptions && globalOptions.prettify || v.prettify; // Strict will check that it is a valid looking number

          if (v.isString(value) && options.strict) {
            var pattern = "^-?(0|[1-9]\\d*)";

            if (!options.onlyInteger) {
              pattern += "(\\.\\d+)?";
            }

            pattern += "$";

            if (!new RegExp(pattern).test(value)) {
              return options.message || options.notValid || this.notValid || this.message || "must be a valid number";
            }
          } // Coerce the value to a number unless we're being strict.


          if (options.noStrings !== true && v.isString(value) && !v.isEmpty(value)) {
            value = +value;
          } // If it's not a number we shouldn't continue since it will compare it.


          if (!v.isNumber(value)) {
            return options.message || options.notValid || this.notValid || this.message || "is not a number";
          } // Same logic as above, sort of. Don't bother with comparisons if this
          // doesn't pass.


          if (options.onlyInteger && !v.isInteger(value)) {
            return options.message || options.notInteger || this.notInteger || this.message || "must be an integer";
          }

          for (name in checks) {
            count = options[name];

            if (v.isNumber(count) && !checks[name](value, count)) {
              // This picks the default message if specified
              // For example the greaterThan check uses the message from
              // this.notGreaterThan so we capitalize the name and prepend "not"
              var key = "not" + v.capitalize(name);
              var msg = options[key] || this[key] || this.message || "must be %{type} %{count}";
              errors.push(v.format(msg, {
                count: count,
                type: prettify(name)
              }));
            }
          }

          if (options.odd && value % 2 !== 1) {
            errors.push(options.notOdd || this.notOdd || this.message || "must be odd");
          }

          if (options.even && value % 2 !== 0) {
            errors.push(options.notEven || this.notEven || this.message || "must be even");
          }

          if (errors.length) {
            return options.message || errors;
          }
        },
        datetime: v.extend(function (value, options) {
          if (!v.isFunction(this.parse) || !v.isFunction(this.format)) {
            throw new Error("Both the parse and format functions needs to be set to use the datetime/date validator");
          } // Empty values are fine


          if (!v.isDefined(value)) {
            return;
          }

          options = v.extend({}, this.options, options);
          var err,
              errors = [],
              earliest = options.earliest ? this.parse(options.earliest, options) : NaN,
              latest = options.latest ? this.parse(options.latest, options) : NaN;
          value = this.parse(value, options); // 86400000 is the number of milliseconds in a day, this is used to remove
          // the time from the date

          if (isNaN(value) || options.dateOnly && value % 86400000 !== 0) {
            err = options.notValid || options.message || this.notValid || "must be a valid date";
            return v.format(err, {
              value: arguments[0]
            });
          }

          if (!isNaN(earliest) && value < earliest) {
            err = options.tooEarly || options.message || this.tooEarly || "must be no earlier than %{date}";
            err = v.format(err, {
              value: this.format(value, options),
              date: this.format(earliest, options)
            });
            errors.push(err);
          }

          if (!isNaN(latest) && value > latest) {
            err = options.tooLate || options.message || this.tooLate || "must be no later than %{date}";
            err = v.format(err, {
              date: this.format(latest, options),
              value: this.format(value, options)
            });
            errors.push(err);
          }

          if (errors.length) {
            return v.unique(errors);
          }
        }, {
          parse: null,
          format: null
        }),
        date: function date(value, options) {
          options = v.extend({}, options, {
            dateOnly: true
          });
          return v.validators.datetime.call(v.validators.datetime, value, options);
        },
        format: function format(value, options) {
          if (v.isString(options) || options instanceof RegExp) {
            options = {
              pattern: options
            };
          }

          options = v.extend({}, this.options, options);
          var message = options.message || this.message || "is invalid",
              pattern = options.pattern,
              match; // Empty values are allowed

          if (!v.isDefined(value)) {
            return;
          }

          if (!v.isString(value)) {
            return message;
          }

          if (v.isString(pattern)) {
            pattern = new RegExp(options.pattern, options.flags);
          }

          match = pattern.exec(value);

          if (!match || match[0].length != value.length) {
            return message;
          }
        },
        inclusion: function inclusion(value, options) {
          // Empty values are fine
          if (!v.isDefined(value)) {
            return;
          }

          if (v.isArray(options)) {
            options = {
              within: options
            };
          }

          options = v.extend({}, this.options, options);

          if (v.contains(options.within, value)) {
            return;
          }

          var message = options.message || this.message || "^%{value} is not included in the list";
          return v.format(message, {
            value: value
          });
        },
        exclusion: function exclusion(value, options) {
          // Empty values are fine
          if (!v.isDefined(value)) {
            return;
          }

          if (v.isArray(options)) {
            options = {
              within: options
            };
          }

          options = v.extend({}, this.options, options);

          if (!v.contains(options.within, value)) {
            return;
          }

          var message = options.message || this.message || "^%{value} is restricted";
          return v.format(message, {
            value: value
          });
        },
        email: v.extend(function (value, options) {
          options = v.extend({}, this.options, options);
          var message = options.message || this.message || "is not a valid email"; // Empty values are fine

          if (!v.isDefined(value)) {
            return;
          }

          if (!v.isString(value)) {
            return message;
          }

          if (!this.PATTERN.exec(value)) {
            return message;
          }
        }, {
          PATTERN: /^[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i
        }),
        equality: function equality(value, options, attribute, attributes, globalOptions) {
          if (!v.isDefined(value)) {
            return;
          }

          if (v.isString(options)) {
            options = {
              attribute: options
            };
          }

          options = v.extend({}, this.options, options);
          var message = options.message || this.message || "is not equal to %{attribute}";

          if (v.isEmpty(options.attribute) || !v.isString(options.attribute)) {
            throw new Error("The attribute must be a non empty string");
          }

          var otherValue = v.getDeepObjectValue(attributes, options.attribute),
              comparator = options.comparator || function (v1, v2) {
            return v1 === v2;
          },
              prettify = options.prettify || globalOptions && globalOptions.prettify || v.prettify;

          if (!comparator(value, otherValue, options, attribute, attributes)) {
            return v.format(message, {
              attribute: prettify(options.attribute)
            });
          }
        },
        // A URL validator that is used to validate URLs with the ability to
        // restrict schemes and some domains.
        url: function url(value, options) {
          if (!v.isDefined(value)) {
            return;
          }

          options = v.extend({}, this.options, options);
          var message = options.message || this.message || "is not a valid url",
              schemes = options.schemes || this.schemes || ['http', 'https'],
              allowLocal = options.allowLocal || this.allowLocal || false;

          if (!v.isString(value)) {
            return message;
          } // https://gist.github.com/dperini/729294


          var regex = "^" + // protocol identifier
          "(?:(?:" + schemes.join("|") + ")://)" + // user:pass authentication
          "(?:\\S+(?::\\S*)?@)?" + "(?:";
          var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";

          if (allowLocal) {
            tld += "?";
          } else {
            regex += // IP address exclusion
            // private & local networks
            "(?!(?:10|127)(?:\\.\\d{1,3}){3})" + "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" + "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})";
          }

          regex += // IP address dotted notation octets
          // excludes loopback network 0.0.0.0
          // excludes reserved space >= 224.0.0.0
          // excludes network & broacast addresses
          // (first & last IP address of each class)
          "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" + "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" + "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" + "|" + // host name
          "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" + // domain name
          "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" + tld + ")" + // port number
          "(?::\\d{2,5})?" + // resource path
          "(?:[/?#]\\S*)?" + "$";
          var PATTERN = new RegExp(regex, 'i');

          if (!PATTERN.exec(value)) {
            return message;
          }
        }
      };
      validate.formatters = {
        detailed: function detailed(errors) {
          return errors;
        },
        flat: v.flattenErrorsToArray,
        grouped: function grouped(errors) {
          var attr;
          errors = v.groupErrorsByAttribute(errors);

          for (attr in errors) {
            errors[attr] = v.flattenErrorsToArray(errors[attr]);
          }

          return errors;
        },
        constraint: function constraint(errors) {
          var attr;
          errors = v.groupErrorsByAttribute(errors);

          for (attr in errors) {
            errors[attr] = errors[attr].map(function (result) {
              return result.validator;
            }).sort();
          }

          return errors;
        }
      };
      validate.exposeModule(validate, this, exports, module, __webpack_require__(160));
    }).call(this, true ?
    /* istanbul ignore next */
    exports : null, true ?
    /* istanbul ignore next */
    module : null, __webpack_require__(160));
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(45)(module));
  /***/
},
/* 100 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 25.4.1.5 NewPromiseCapability(C)

  var aFunction = __webpack_require__(54);

  function PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function ($$resolve, $$reject) {
      if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
      resolve = $$resolve;
      reject = $$reject;
    });
    this.resolve = aFunction(resolve);
    this.reject = aFunction(reject);
  }

  module.exports.f = function (C) {
    return new PromiseCapability(C);
  };
  /***/

},
/* 101 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (immutable) */

  __webpack_exports__["a"] = warning;
  /**
   * Prints a warning in the console if it exists.
   *
   * @param {String} message The warning message.
   * @returns {void}
   */

  function warning(message) {
    /* eslint-disable no-console */
    if (typeof console !== 'undefined' && typeof console.error === 'function') {
      console.error(message);
    }
    /* eslint-enable no-console */


    try {
      // This error was thrown as a convenience so that if you enable
      // "break on all exceptions" in your console,
      // it would pause the execution at this line.
      throw new Error(message);
      /* eslint-disable no-empty */
    } catch (e) {}
    /* eslint-enable no-empty */

  }
  /***/

},
/* 102 */

/***/
function (module, exports, __webpack_require__) {
  var baseMatches = __webpack_require__(412),
      baseMatchesProperty = __webpack_require__(474),
      identity = __webpack_require__(73),
      isArray = __webpack_require__(21),
      property = __webpack_require__(484);
  /**
   * The base implementation of `_.iteratee`.
   *
   * @private
   * @param {*} [value=_.identity] The value to convert to an iteratee.
   * @returns {Function} Returns the iteratee.
   */


  function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') {
      return value;
    }

    if (value == null) {
      return identity;
    }

    if (_typeof4(value) == 'object') {
      return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    }

    return property(value);
  }

  module.exports = baseIteratee;
  /***/
},
/* 103 */

/***/
function (module, exports) {
  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */
  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }

  module.exports = eq;
  /***/
},
/* 104 */

/***/
function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(29),
      root = __webpack_require__(20);
  /* Built-in method references that are verified to be native. */


  var Map = getNative(root, 'Map');
  module.exports = Map;
  /***/
},
/* 105 */

/***/
function (module, exports, __webpack_require__) {
  var mapCacheClear = __webpack_require__(430),
      mapCacheDelete = __webpack_require__(437),
      mapCacheGet = __webpack_require__(439),
      mapCacheHas = __webpack_require__(440),
      mapCacheSet = __webpack_require__(441);
  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */


  function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  } // Add methods to `MapCache`.


  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;
  module.exports = MapCache;
  /***/
},
/* 106 */

/***/
function (module, exports, __webpack_require__) {
  var baseIsArguments = __webpack_require__(460),
      isObjectLike = __webpack_require__(50);
  /** Used for built-in method references. */


  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /** Built-in value references. */

  var propertyIsEnumerable = objectProto.propertyIsEnumerable;
  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */

  var isArguments = baseIsArguments(function () {
    return arguments;
  }()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
  };
  module.exports = isArguments;
  /***/
},
/* 107 */

/***/
function (module, exports) {
  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;
  /** Used to detect unsigned integer values. */

  var reIsUint = /^(?:0|[1-9]\d*)$/;
  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */

  function isIndex(value, length) {
    var type = _typeof4(value);

    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }

  module.exports = isIndex;
  /***/
},
/* 108 */

/***/
function (module, exports) {
  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;
  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */

  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }

  module.exports = isLength;
  /***/
},
/* 109 */

/***/
function (module, exports, __webpack_require__) {
  var isArray = __webpack_require__(21),
      isSymbol = __webpack_require__(52);
  /** Used to match property names within property paths. */


  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/;
  /**
   * Checks if `value` is a property name and not a property path.
   *
   * @private
   * @param {*} value The value to check.
   * @param {Object} [object] The object to query keys on.
   * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
   */

  function isKey(value, object) {
    if (isArray(value)) {
      return false;
    }

    var type = _typeof4(value);

    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
      return true;
    }

    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
  }

  module.exports = isKey;
  /***/
},
/* 110 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var LIBRARY = __webpack_require__(36);

  var $export = __webpack_require__(11);

  var redefine = __webpack_require__(112);

  var hide = __webpack_require__(26);

  var Iterators = __webpack_require__(38);

  var $iterCreate = __webpack_require__(196);

  var setToStringTag = __webpack_require__(56);

  var getPrototypeOf = __webpack_require__(116);

  var ITERATOR = __webpack_require__(10)('iterator');

  var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`

  var FF_ITERATOR = '@@iterator';
  var KEYS = 'keys';
  var VALUES = 'values';

  var returnThis = function returnThis() {
    return this;
  };

  module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $iterCreate(Constructor, NAME, next);

    var getMethod = function getMethod(kind) {
      if (!BUGGY && kind in proto) return proto[kind];

      switch (kind) {
        case KEYS:
          return function keys() {
            return new Constructor(this, kind);
          };

        case VALUES:
          return function values() {
            return new Constructor(this, kind);
          };
      }

      return function entries() {
        return new Constructor(this, kind);
      };
    };

    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype; // Fix native

    if ($anyNative) {
      IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));

      if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
        // Set @@toStringTag to native iterators
        setToStringTag(IteratorPrototype, TAG, true); // fix for some old engines

        if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
      }
    } // fix Array#{values, @@iterator}.name in V8 / FF


    if (DEF_VALUES && $native && $native.name !== VALUES) {
      VALUES_BUG = true;

      $default = function values() {
        return $native.call(this);
      };
    } // Define iterator


    if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
      hide(proto, ITERATOR, $default);
    } // Plug for library


    Iterators[NAME] = $default;
    Iterators[TAG] = returnThis;

    if (DEFAULT) {
      methods = {
        values: DEF_VALUES ? $default : getMethod(VALUES),
        keys: IS_SET ? $default : getMethod(KEYS),
        entries: $entries
      };
      if (FORCED) for (key in methods) {
        if (!(key in proto)) redefine(proto, key, methods[key]);
      } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
    }

    return methods;
  };
  /***/

},
/* 111 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = !__webpack_require__(23) && !__webpack_require__(31)(function () {
    return Object.defineProperty(__webpack_require__(77)('div'), 'a', {
      get: function get() {
        return 7;
      }
    }).a != 7;
  });
  /***/
},
/* 112 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(26);
  /***/
},
/* 113 */

/***/
function (module, exports, __webpack_require__) {
  var has = __webpack_require__(27);

  var toIObject = __webpack_require__(32);

  var arrayIndexOf = __webpack_require__(198)(false);

  var IE_PROTO = __webpack_require__(81)('IE_PROTO');

  module.exports = function (object, names) {
    var O = toIObject(object);
    var i = 0;
    var result = [];
    var key;

    for (key in O) {
      if (key != IE_PROTO) has(O, key) && result.push(key);
    } // Don't enum bug & hidden keys


    while (names.length > i) {
      if (has(O, key = names[i++])) {
        ~arrayIndexOf(result, key) || result.push(key);
      }
    }

    return result;
  };
  /***/

},
/* 114 */

/***/
function (module, exports, __webpack_require__) {
  // fallback for non-array-like ES3 and non-enumerable old V8 strings
  var cof = __webpack_require__(40); // eslint-disable-next-line no-prototype-builtins


  module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
    return cof(it) == 'String' ? it.split('') : Object(it);
  };
  /***/
},
/* 115 */

/***/
function (module, exports, __webpack_require__) {
  var document = __webpack_require__(9).document;

  module.exports = document && document.documentElement;
  /***/
},
/* 116 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
  var has = __webpack_require__(27);

  var toObject = __webpack_require__(41);

  var IE_PROTO = __webpack_require__(81)('IE_PROTO');

  var ObjectProto = Object.prototype;

  module.exports = Object.getPrototypeOf || function (O) {
    O = toObject(O);
    if (has(O, IE_PROTO)) return O[IE_PROTO];

    if (typeof O.constructor == 'function' && O instanceof O.constructor) {
      return O.constructor.prototype;
    }

    return O instanceof Object ? ObjectProto : null;
  };
  /***/

},
/* 117 */

/***/
function (module, exports, __webpack_require__) {
  // call something on iterator step with safe closing on error
  var anObject = __webpack_require__(16);

  module.exports = function (iterator, fn, value, entries) {
    try {
      return entries ? fn(anObject(value)[0], value[1]) : fn(value); // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
      var ret = iterator['return'];
      if (ret !== undefined) anObject(ret.call(iterator));
      throw e;
    }
  };
  /***/

},
/* 118 */

/***/
function (module, exports, __webpack_require__) {
  // check on default Array iterator
  var Iterators = __webpack_require__(38);

  var ITERATOR = __webpack_require__(10)('iterator');

  var ArrayProto = Array.prototype;

  module.exports = function (it) {
    return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
  };
  /***/

},
/* 119 */

/***/
function (module, exports, __webpack_require__) {
  var classof = __webpack_require__(120);

  var ITERATOR = __webpack_require__(10)('iterator');

  var Iterators = __webpack_require__(38);

  module.exports = __webpack_require__(7).getIteratorMethod = function (it) {
    if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
  };
  /***/

},
/* 120 */

/***/
function (module, exports, __webpack_require__) {
  // getting tag from 19.1.3.6 Object.prototype.toString()
  var cof = __webpack_require__(40);

  var TAG = __webpack_require__(10)('toStringTag'); // ES3 wrong here


  var ARG = cof(function () {
    return arguments;
  }()) == 'Arguments'; // fallback for IE11 Script Access Denied error

  var tryGet = function tryGet(it, key) {
    try {
      return it[key];
    } catch (e) {
      /* empty */
    }
  };

  module.exports = function (it) {
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T // builtinTag case
    : ARG ? cof(O) // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
  };
  /***/

},
/* 121 */

/***/
function (module, exports, __webpack_require__) {
  var ITERATOR = __webpack_require__(10)('iterator');

  var SAFE_CLOSING = false;

  try {
    var riter = [7][ITERATOR]();

    riter['return'] = function () {
      SAFE_CLOSING = true;
    }; // eslint-disable-next-line no-throw-literal


    Array.from(riter, function () {
      throw 2;
    });
  } catch (e) {
    /* empty */
  }

  module.exports = function (exec, skipClosing) {
    if (!skipClosing && !SAFE_CLOSING) return false;
    var safe = false;

    try {
      var arr = [7];
      var iter = arr[ITERATOR]();

      iter.next = function () {
        return {
          done: safe = true
        };
      };

      arr[ITERATOR] = function () {
        return iter;
      };

      exec(arr);
    } catch (e) {
      /* empty */
    }

    return safe;
  };
  /***/

},
/* 122 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(202),
    __esModule: true
  };
  /***/
},
/* 123 */

/***/
function (module, exports, __webpack_require__) {
  // most Object methods by ES6 should accept primitives
  var $export = __webpack_require__(11);

  var core = __webpack_require__(7);

  var fails = __webpack_require__(31);

  module.exports = function (KEY, exec) {
    var fn = (core.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $export($export.S + $export.F * fails(function () {
      fn(1);
    }), 'Object', exp);
  };
  /***/

},
/* 124 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(207),
    __esModule: true
  };
  /***/
},
/* 125 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(211);

  var global = __webpack_require__(9);

  var hide = __webpack_require__(26);

  var Iterators = __webpack_require__(38);

  var TO_STRING_TAG = __webpack_require__(10)('toStringTag');

  var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');

  for (var i = 0; i < DOMIterables.length; i++) {
    var NAME = DOMIterables[i];
    var Collection = global[NAME];
    var proto = Collection && Collection.prototype;
    if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = Iterators.Array;
  }
  /***/

},
/* 126 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
  var $keys = __webpack_require__(113);

  var hiddenKeys = __webpack_require__(83).concat('length', 'prototype');

  exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $keys(O, hiddenKeys);
  };
  /***/

},
/* 127 */

/***/
function (module, exports, __webpack_require__) {
  var pIE = __webpack_require__(57);

  var createDesc = __webpack_require__(37);

  var toIObject = __webpack_require__(32);

  var toPrimitive = __webpack_require__(78);

  var has = __webpack_require__(27);

  var IE8_DOM_DEFINE = __webpack_require__(111);

  var gOPD = Object.getOwnPropertyDescriptor;
  exports.f = __webpack_require__(23) ? gOPD : function getOwnPropertyDescriptor(O, P) {
    O = toIObject(O);
    P = toPrimitive(P, true);
    if (IE8_DOM_DEFINE) try {
      return gOPD(O, P);
    } catch (e) {
      /* empty */
    }
    if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
  };
  /***/
},
/* 128 */

/***/
function (module, exports) {
  /***/
},
/* 129 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(130);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(24);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);

  var _class,
      _temp,
      _initialiseProps,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/Blocks/Text.js';

  var Text = (_temp = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Text, _React$Component);

    function Text(props) {
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Text);

      var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Text.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Text)).call(this, props));

      _initialiseProps.call(_this);

      if (typeof window !== 'undefined') {
        /* eslint-disable */
        _this.Editor = __webpack_require__(236); // include any custom quill plugins here

        if (_this.Editor) {} //const MagicUrl = require('quill-magic-url').default;
        //this.Editor.Quill.register('modules/magicUrl', MagicUrl);

        /* eslint-enable */

      }

      var content = void 0;

      try {
        content = JSON.parse(_this.props.item.content);
      } catch (error) {
        content = _this.props.item.content;
      }

      _this.state = {
        content: content
      };
      return _this;
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Text, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            block = _props.block,
            readOnly = _props.readOnly;
        var content = this.state.content;
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
          className: 'cw-wysiwyg-text',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 60
          }
        }, typeof document !== 'undefined' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(this.Editor, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, block, {
          readOnly: readOnly,
          className: 'cw-quill',
          defaultValue: content,
          onChange: this.triggerChange,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 62
          }
        })));
      }
    }]);

    return Text;
  }(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _class.propTypes = {
    item: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    block: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    readOnly: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
  }, _class.defaultProps = {
    item: {},
    block: {},
    readOnly: false,
    onChange: null
  }, _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.triggerChange = function (content) {
      _this2.setState({
        content: content
      }, function () {
        if (_this2.props.onChange) {
          _this2.props.onChange({
            content: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content)
          });
        }
      });
    };
  }, _temp);
  Text.displayName = 'Text';
  /* harmony default export */

  __webpack_exports__["a"] = Text;
  /***/
},
/* 130 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(235),
    __esModule: true
  };
  /***/
},
/* 131 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);

  var _class,
      _temp,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/Blocks/Image.js';

  var Image = (_temp = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Image, _React$Component);

    function Image() {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Image);

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Image.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Image)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Image, [{
      key: 'render',
      value: function render() {
        var _props$item$content = this.props.item.content,
            src = _props$item$content.src,
            alt = _props$item$content.alt;
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', {
          className: 'cw-wysiwyg-image',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 16
          }
        }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img', {
          src: src,
          alt: alt,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 17
          }
        }));
      }
    }]);

    return Image;
  }(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component), _class.propTypes = {
    item: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
  }, _class.defaultProps = {
    item: {}
  }, _temp);
  Image.displayName = 'Image';
  /* harmony default export */

  __webpack_exports__["a"] = Image;
  /***/
},
/* 132 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_react_player__ = __webpack_require__(237);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_react_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_player__);

  var _class,
      _temp,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/Blocks/Video.js'; // Components


  var Video = (_temp = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Video, _React$Component);

    function Video() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Video);

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Video.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Video)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Video, [{
      key: 'render',
      value: function render() {
        var block = this.props.block;
        var url = this.props.item.content.url;
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', {
          className: 'cw-wysiwyg-video',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 23
          }
        }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_player___default.a, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, block.options, {
          url: url,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 24
          }
        })));
      }
    }]);

    return Video;
  }(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component), _class.propTypes = {
    item: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
    block: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
  }, _class.defaultProps = {
    item: {},
    block: {}
  }, _temp);
  Video.displayName = 'Video';
  /* harmony default export */

  __webpack_exports__["a"] = Video;
  /***/
},
/* 133 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);

    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);

      if (parent === null) {
        return undefined;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;

      if (getter === undefined) {
        return undefined;
      }

      return getter.call(receiver);
    }
  };

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  var _Base2 = __webpack_require__(17);

  var _Base3 = _interopRequireDefault(_Base2);

  var _utils = __webpack_require__(12);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
  var VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)($|\?)/i;
  var HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
  var HLS_SDK_URL = 'https://cdn.jsdelivr.net/hls.js/latest/hls.min.js';
  var HLS_GLOBAL = 'Hls';
  var DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
  var DASH_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/dashjs/2.5.0/dash.all.min.js';
  var DASH_GLOBAL = 'dashjs';

  var FilePlayer = function (_Base) {
    _inherits(FilePlayer, _Base);

    function FilePlayer() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, FilePlayer);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilePlayer.__proto__ || Object.getPrototypeOf(FilePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.onSeek = function (e) {
        _this.props.onSeek(e.target.currentTime);
      }, _this.renderSource = function (source) {
        if (typeof source === 'string') {
          return _react2['default'].createElement('source', {
            key: source,
            src: source
          });
        }

        var src = source.src,
            type = source.type;
        return _react2['default'].createElement('source', {
          key: src,
          src: src,
          type: type
        });
      }, _this.renderTrack = function (track, index) {
        return _react2['default'].createElement('track', _extends({
          key: index
        }, track));
      }, _this.ref = function (player) {
        _this.player = player;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(FilePlayer, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.addListeners();

        _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'componentDidMount', this).call(this);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(nextProps)) {
          this.removeListeners();
        }

        _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'componentWillReceiveProps', this).call(this, nextProps);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(prevProps)) {
          this.addListeners();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.removeListeners();

        _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'componentWillUnmount', this).call(this);
      }
    }, {
      key: 'addListeners',
      value: function addListeners() {
        var _props = this.props,
            playsinline = _props.playsinline,
            onPause = _props.onPause,
            onEnded = _props.onEnded,
            onError = _props.onError;
        this.player.addEventListener('canplay', this.onReady);
        this.player.addEventListener('play', this.onPlay);
        this.player.addEventListener('pause', onPause);
        this.player.addEventListener('seeked', this.onSeek);
        this.player.addEventListener('ended', onEnded);
        this.player.addEventListener('error', onError);

        if (playsinline) {
          this.player.setAttribute('playsinline', '');
          this.player.setAttribute('webkit-playsinline', '');
        }
      }
    }, {
      key: 'removeListeners',
      value: function removeListeners() {
        var _props2 = this.props,
            onPause = _props2.onPause,
            onEnded = _props2.onEnded,
            onError = _props2.onError;
        this.player.removeEventListener('canplay', this.onReady);
        this.player.removeEventListener('play', this.onPlay);
        this.player.removeEventListener('pause', onPause);
        this.player.removeEventListener('seeked', this.onSeek);
        this.player.removeEventListener('ended', onEnded);
        this.player.removeEventListener('error', onError);
      }
    }, {
      key: 'shouldUseAudio',
      value: function shouldUseAudio(props) {
        return AUDIO_EXTENSIONS.test(props.url) || props.config.file.forceAudio;
      }
    }, {
      key: 'shouldUseHLS',
      value: function shouldUseHLS(url) {
        return HLS_EXTENSIONS.test(url) || this.props.config.file.forceHLS;
      }
    }, {
      key: 'shouldUseDASH',
      value: function shouldUseDASH(url) {
        return DASH_EXTENSIONS.test(url) || this.props.config.file.forceDASH;
      }
    }, {
      key: 'load',
      value: function load(url) {
        var _this2 = this;

        if (this.shouldUseHLS(url)) {
          (0, _utils.getSDK)(HLS_SDK_URL, HLS_GLOBAL).then(function (Hls) {
            _this2.hls = new Hls();

            _this2.hls.loadSource(url);

            _this2.hls.attachMedia(_this2.player);
          });
        }

        if (this.shouldUseDASH(url)) {
          (0, _utils.getSDK)(DASH_SDK_URL, DASH_GLOBAL).then(function (dashjs) {
            _this2.dash = dashjs.MediaPlayer().create();

            _this2.dash.initialize(_this2.player, url, true);

            _this2.dash.getDebug().setLogToBrowserConsole(false);
          });
        }
      }
    }, {
      key: 'play',
      value: function play() {
        this.player.play()['catch'](this.props.onError);
      }
    }, {
      key: 'pause',
      value: function pause() {
        this.player.pause();
      }
    }, {
      key: 'stop',
      value: function stop() {
        this.player.removeAttribute('src');

        if (this.hls) {
          this.hls.detachMedia();
        }
      }
    }, {
      key: 'seekTo',
      value: function seekTo(amount) {
        var seconds = _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'seekTo', this).call(this, amount);

        this.player.currentTime = seconds;
      }
    }, {
      key: 'setVolume',
      value: function setVolume(fraction) {
        this.player.volume = fraction;
      }
    }, {
      key: 'setPlaybackRate',
      value: function setPlaybackRate(rate) {
        this.player.playbackRate = rate;
      }
    }, {
      key: 'getDuration',
      value: function getDuration() {
        return this.player.duration;
      }
    }, {
      key: 'getCurrentTime',
      value: function getCurrentTime() {
        return this.player.currentTime;
      }
    }, {
      key: 'getSecondsLoaded',
      value: function getSecondsLoaded() {
        if (this.player.buffered.length === 0) return 0;
        return this.player.buffered.end(0);
      }
    }, {
      key: 'render',
      value: function render() {
        var _props3 = this.props,
            url = _props3.url,
            loop = _props3.loop,
            controls = _props3.controls,
            config = _props3.config,
            width = _props3.width,
            height = _props3.height;
        var useAudio = this.shouldUseAudio(this.props);
        var useHLS = this.shouldUseHLS(url);
        var useDASH = this.shouldUseDASH(url);
        var Element = useAudio ? 'audio' : 'video';
        var src = url instanceof Array || useHLS || useDASH ? undefined : url;
        var style = {
          width: !width || width === 'auto' ? width : '100%',
          height: !height || height === 'auto' ? height : '100%',
          display: url ? 'block' : 'none'
        };
        return _react2['default'].createElement(Element, _extends({
          ref: this.ref,
          src: src,
          style: style,
          preload: 'auto',
          controls: controls,
          loop: loop
        }, config.file.attributes), url instanceof Array && url.map(this.renderSource), config.file.tracks.map(this.renderTrack));
      }
    }], [{
      key: 'canPlay',
      value: function canPlay(url) {
        if (url instanceof Array) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = url[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              if (typeof item === 'string' && this.canPlay(item)) {
                return true;
              }

              if (this.canPlay(item.src)) {
                return true;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator['return']) {
                _iterator['return']();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          return false;
        }

        return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url);
      }
    }]);

    return FilePlayer;
  }(_Base3['default']);

  FilePlayer.displayName = 'FilePlayer';
  exports['default'] = FilePlayer;
  /***/
},
/* 134 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);

  var _class,
      _temp,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/Blocks/Embed.js';

  var Embed = (_temp = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Embed, _React$Component);

    function Embed() {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Embed);

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Embed.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Embed)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Embed, [{
      key: 'render',
      value: function render() {
        var _props$item$content = this.props.item.content,
            src = _props$item$content.src,
            width = _props$item$content.width,
            height = _props$item$content.height;
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', {
          className: 'cw-wysiwyg-embed',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 17
          }
        }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('iframe', {
          frameBorder: '0',
          src: src,
          width: width || '100%',
          height: height || '400px',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 18
          }
        }));
      }
    }]);

    return Embed;
  }(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component), _class.propTypes = {
    item: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
  }, _class.defaultProps = {
    item: {}
  }, _temp);
  Embed.displayName = 'Embed';
  /* harmony default export */

  __webpack_exports__["a"] = Embed;
  /***/
},
/* 135 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(53);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(13);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10_recompose__ = __webpack_require__(18);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11__UI_Icon_Icon__ = __webpack_require__(34);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_12__Toolbar_Toolbar__ = __webpack_require__(90);

  var _class,
      _temp2,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/Blocks/Grid.js'; // Recompose
  // Components
  // Blocks


  var Grid = (_temp2 = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Grid, _React$Component);

    function Grid() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Grid);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Grid.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Grid)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        // Change it
        content: _this.props.item.content || [null, null],
        edition: null
      }, _this.triggerAdd = function (payload, i) {
        var content = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this.state.content));

        if (!content[i]) {
          content[i] = [];
        }

        if (!Array.isArray(content[i])) {
          content[i] = [content[i]];
        }

        content[i].push(payload);

        _this.setState({
          content: content
        }, function () {
          _this.props.onChange && _this.props.onChange({
            content: content
          });
        });
      }, _this.triggerChange = function (payload, i, j) {
        var content = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this.state.content));
        content[i][j] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, content[i][j], payload);

        _this.setState({
          content: content
        }, function () {
          _this.props.onChange && _this.props.onChange({
            content: content
          });
        });
      }, _this.triggerSubmit = function (payload, i) {
        var content = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this.state.content));
        content[i] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, content[i], payload);

        _this.setState({
          content: content
        }, function () {
          _this.triggerClose();

          _this.props.onChange && _this.props.onChange({
            content: content
          });
        });
      }, _this.triggerEdit = function (block, i) {
        _this.setState({
          edition: block + i
        });

        _this.props.setEditionMode && _this.props.setEditionMode(true);
      }, _this.triggerRemove = function (i) {
        var j = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var content = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this.state.content));

        if (j !== null) {
          content[i][j] = null;
        } else {
          content[i] = null;
        }

        _this.setState({
          content: content
        }, function () {
          _this.props.onChange && _this.props.onChange({
            content: content
          });
        });
      }, _this.triggerClose = function () {
        // Close options
        _this.setState({
          edition: null
        });

        _this.props.setEditionMode && _this.props.setEditionMode(false);
      }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Grid, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.editionMode !== nextProps.editionMode && !nextProps.editionMode) {
          this.triggerClose();
        }
      }
      /**
       * UI EVENTS
       * - triggerAdd
       * - triggerChange
       * - triggerEdit
       * - triggerRemove
       * - triggerClose
       * - triggerSubmit
      */

    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            blocks = _props.blocks,
            readOnly = _props.readOnly;
        var content = this.state.content;

        var gridClassNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()({
          'small-12': true,
          'medium-6': content.length === 2,
          'medium-4': content.length === 3
        });

        var columnItemClasses = __WEBPACK_IMPORTED_MODULE_9_classnames___default()({
          'wysiwyg-grid-column__item': true,
          'wysiwyg-grid-column__item--with-actions': !readOnly
        });

        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
          className: 'cw-wysiwyg-grid',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 131
          }
        }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
          className: 'wysiwyg-grid-row row',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 132
          }
        }, content.map(function (item, i) {
          var items = Array.isArray(item) ? item : [item];
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
            key: i,
            className: 'column ' + gridClassNames,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 136
            }
          }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
            className: 'wysiwyg-grid-column',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 137
            }
          }, items.map(function (element, j) {
            if (!element) {
              return null;
            }

            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
              key: element.id,
              className: columnItemClasses,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 143
              }
            }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(blocks[element.type].Component, {
              item: element,
              readOnly: readOnly,
              block: blocks[element.type],
              onChange: function onChange(payload) {
                return _this2.triggerChange(payload, i, j);
              }
            }), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
              className: 'wysiwyg-grid-column-actions -inline',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 153
              }
            }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('ul', {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 154
              }
            }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('li', {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 155
              }
            }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('button', {
              type: 'button',
              className: 'cw-button -small -round -close',
              onClick: function onClick() {
                return _this2.triggerRemove(i, j);
              },
              __source: {
                fileName: _jsxFileName,
                lineNumber: 156
              }
            }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__UI_Icon_Icon__["a"
            /* default */
            ], {
              name: 'icon-delete',
              __source: {
                fileName: _jsxFileName,
                lineNumber: 161
              }
            }))))));
          }), !readOnly && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
            className: 'wysiwyg-grid-placeholder',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 170
            }
          }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Toolbar_Toolbar__["a"
          /* default */
          ], {
            className: '-no-cursor',
            exclude: ['grid'],
            onAdd: function onAdd(payload) {
              return _this2.triggerAdd(payload, i);
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 171
            }
          })), !readOnly && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
            className: 'wysiwyg-grid-column-actions',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 180
            }
          }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('ul', {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 181
            }
          }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('li', {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 182
            }
          }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('button', {
            type: 'button',
            className: 'cw-button -small -round -close',
            onClick: function onClick() {
              return _this2.triggerRemove(i);
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 183
            }
          }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__UI_Icon_Icon__["a"
          /* default */
          ], {
            name: 'icon-close',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 188
            }
          })))))));
        })));
      }
    }]);

    return Grid;
  }(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _class.propTypes = {
    item: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    blocks: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    readOnly: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    editionMode: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    setEditionMode: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
  }, _class.defaultProps = {
    item: {},
    blocks: {},
    readOnly: false,
    editionMode: false,
    setEditionMode: null
  }, _temp2);
  Grid.displayName = 'Grid';
  /* harmony default export */

  __webpack_exports__["a"] = Object(__WEBPACK_IMPORTED_MODULE_10_recompose__["a"
  /* getContext */
  ])({
    blocks: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    readOnly: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    editionMode: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    setEditionMode: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
  })(Grid);
  /***/
},
/* 136 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright 2015, Yahoo! Inc.
   * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
   */

  var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
  };
  var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
  };
  var defineProperty = Object.defineProperty;
  var getOwnPropertyNames = Object.getOwnPropertyNames;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var getPrototypeOf = Object.getPrototypeOf;
  var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

  function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
      // don't hoist over string (html) components
      if (objectPrototype) {
        var inheritedComponent = getPrototypeOf(sourceComponent);

        if (inheritedComponent && inheritedComponent !== objectPrototype) {
          hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
      }

      var keys = getOwnPropertyNames(sourceComponent);

      if (getOwnPropertySymbols) {
        keys = keys.concat(getOwnPropertySymbols(sourceComponent));
      }

      for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];

        if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
          var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

          try {
            // Avoid failures from read-only properties
            defineProperty(targetComponent, key, descriptor);
          } catch (e) {}
        }
      }

      return targetComponent;
    }

    return targetComponent;
  }

  module.exports = hoistNonReactStatics;
  /***/
},
/* 137 */

/***/
function (module, exports) {
  /** Used to compose unicode character classes. */
  var rsAstralRange = "\\ud800-\\udfff",
      rsComboMarksRange = "\\u0300-\\u036f",
      reComboHalfMarksRange = "\\ufe20-\\ufe2f",
      rsComboSymbolsRange = "\\u20d0-\\u20ff",
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsVarRange = "\\ufe0e\\ufe0f";
  /** Used to compose unicode capture groups. */

  var rsZWJ = "\\u200d";
  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */

  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */

  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  module.exports = hasUnicode;
  /***/
},
/* 138 */

/***/
function (module, exports, __webpack_require__) {
  var baseToString = __webpack_require__(263);
  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */


  function toString(value) {
    return value == null ? '' : baseToString(value);
  }

  module.exports = toString;
  /***/
},
/* 139 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global) {
    /** Detect free variable `global` from Node.js. */
    var freeGlobal = _typeof4(global) == 'object' && global && global.Object === Object && global;
    module.exports = freeGlobal;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(33));
  /***/
},
/* 140 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var _CSSTransition = __webpack_require__(267);

  var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

  var _ReplaceTransition = __webpack_require__(271);

  var _ReplaceTransition2 = _interopRequireDefault(_ReplaceTransition);

  var _TransitionGroup = __webpack_require__(144);

  var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

  var _Transition = __webpack_require__(141);

  var _Transition2 = _interopRequireDefault(_Transition);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  module.exports = {
    Transition: _Transition2["default"],
    TransitionGroup: _TransitionGroup2["default"],
    ReplaceTransition: _ReplaceTransition2["default"],
    CSSTransition: _CSSTransition2["default"]
  };
  /***/
},
/* 141 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    exports.__esModule = true;
    exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

    var _propTypes = __webpack_require__(1);

    var PropTypes = _interopRequireWildcard(_propTypes);

    var _react = __webpack_require__(0);

    var _react2 = _interopRequireDefault(_react);

    var _reactDom = __webpack_require__(35);

    var _reactDom2 = _interopRequireDefault(_reactDom);

    var _reactLifecyclesCompat = __webpack_require__(142);

    var _PropTypes = __webpack_require__(143);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }

    function _interopRequireWildcard(obj) {
      if (obj && obj.__esModule) {
        return obj;
      } else {
        var newObj = {};

        if (obj != null) {
          for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
          }
        }

        newObj["default"] = obj;
        return newObj;
      }
    }

    function _objectWithoutProperties(obj, keys) {
      var target = {};

      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }

      return target;
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
    var EXITED = exports.EXITED = 'exited';
    var ENTERING = exports.ENTERING = 'entering';
    var ENTERED = exports.ENTERED = 'entered';
    var EXITING = exports.EXITING = 'exiting';
    /**
     * The Transition component lets you describe a transition from one component
     * state to another _over time_ with a simple declarative API. Most commonly
     * it's used to animate the mounting and unmounting of a component, but can also
     * be used to describe in-place transition states as well.
     *
     * By default the `Transition` component does not alter the behavior of the
     * component it renders, it only tracks "enter" and "exit" states for the components.
     * It's up to you to give meaning and effect to those states. For example we can
     * add styles to a component when it enters or exits:
     *
     * ```jsx
     * import Transition from 'react-transition-group/Transition';
     *
     * const duration = 300;
     *
     * const defaultStyle = {
     *   transition: `opacity ${duration}ms ease-in-out`,
     *   opacity: 0,
     * }
     *
     * const transitionStyles = {
     *   entering: { opacity: 0 },
     *   entered:  { opacity: 1 },
     * };
     *
     * const Fade = ({ in: inProp }) => (
     *   <Transition in={inProp} timeout={duration}>
     *     {(state) => (
     *       <div style={{
     *         ...defaultStyle,
     *         ...transitionStyles[state]
     *       }}>
     *         I'm a fade Transition!
     *       </div>
     *     )}
     *   </Transition>
     * );
     * ```
     *
     * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
     * What it does do is track transition states over time so you can update the
     * component (such as by adding styles or classes) when it changes states.
     *
     * There are 4 main states a Transition can be in:
     *  - `'entering'`
     *  - `'entered'`
     *  - `'exiting'`
     *  - `'exited'`
     *
     * Transition state is toggled via the `in` prop. When `true` the component begins the
     * "Enter" stage. During this stage, the component will shift from its current transition state,
     * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
     * it's complete. Let's take the following example:
     *
     * ```jsx
     * state = { in: false };
     *
     * toggleEnterState = () => {
     *   this.setState({ in: true });
     * }
     *
     * render() {
     *   return (
     *     <div>
     *       <Transition in={this.state.in} timeout={500} />
     *       <button onClick={this.toggleEnterState}>Click to Enter</button>
     *     </div>
     *   );
     * }
     * ```
     *
     * When the button is clicked the component will shift to the `'entering'` state and
     * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
     *
     * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
     *
     * ## Timing
     *
     * Timing is often the trickiest part of animation, mistakes can result in slight delays
     * that are hard to pin down. A common example is when you want to add an exit transition,
     * you should set the desired final styles when the state is `'exiting'`. That's when the
     * transition to those styles will start and, if you matched the `timeout` prop with the
     * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
     *
     * > **Note**: For simpler transitions the `Transition` component might be enough, but
     * > take into account that it's platform-agnostic, while the `CSSTransition` component
     * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
     * > in order to make more complex transitions more predictable. For example, even though
     * > classes `example-enter` and `example-enter-active` are applied immediately one after
     * > another, you can still transition from one to the other because of the forced reflow
     * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
     * > for more info). Take this into account when choosing between `Transition` and
     * > `CSSTransition`.
     *
     * ## Example
     *
     * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
     *
     */

    var Transition = function (_React$Component) {
      _inherits(Transition, _React$Component);

      function Transition(props, context) {
        _classCallCheck(this, Transition);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

        var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus = void 0;
        _this.appearStatus = null;

        if (props["in"]) {
          if (appear) {
            initialStatus = EXITED;
            _this.appearStatus = ENTERING;
          } else {
            initialStatus = ENTERED;
          }
        } else {
          if (props.unmountOnExit || props.mountOnEnter) {
            initialStatus = UNMOUNTED;
          } else {
            initialStatus = EXITED;
          }
        }

        _this.state = {
          status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
      }

      Transition.prototype.getChildContext = function getChildContext() {
        return {
          transitionGroup: null // allows for nested Transitions

        };
      };

      Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref["in"];

        if (nextIn && prevState.status === UNMOUNTED) {
          return {
            status: EXITED
          };
        }

        return null;
      }; // getSnapshotBeforeUpdate(prevProps) {
      //   let nextStatus = null
      //   if (prevProps !== this.props) {
      //     const { status } = this.state
      //     if (this.props.in) {
      //       if (status !== ENTERING && status !== ENTERED) {
      //         nextStatus = ENTERING
      //       }
      //     } else {
      //       if (status === ENTERING || status === ENTERED) {
      //         nextStatus = EXITING
      //       }
      //     }
      //   }
      //   return { nextStatus }
      // }


      Transition.prototype.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
      };

      Transition.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;

        if (prevProps !== this.props) {
          var status = this.state.status;

          if (this.props["in"]) {
            if (status !== ENTERING && status !== ENTERED) {
              nextStatus = ENTERING;
            }
          } else {
            if (status === ENTERING || status === ENTERED) {
              nextStatus = EXITING;
            }
          }
        }

        this.updateStatus(false, nextStatus);
      };

      Transition.prototype.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
      };

      Transition.prototype.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit = void 0,
            enter = void 0,
            appear = void 0;
        exit = enter = appear = timeout;

        if (timeout != null && typeof timeout !== 'number') {
          exit = timeout.exit;
          enter = timeout.enter;
          appear = timeout.appear;
        }

        return {
          exit: exit,
          enter: enter,
          appear: appear
        };
      };

      Transition.prototype.updateStatus = function updateStatus() {
        var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var nextStatus = arguments[1];

        if (nextStatus !== null) {
          // nextStatus will always be ENTERING or EXITING.
          this.cancelNextCallback();

          var node = _reactDom2["default"].findDOMNode(this);

          if (nextStatus === ENTERING) {
            this.performEnter(node, mounting);
          } else {
            this.performExit(node);
          }
        } else if (this.props.unmountOnExit && this.state.status === EXITED) {
          this.setState({
            status: UNMOUNTED
          });
        }
      };

      Transition.prototype.performEnter = function performEnter(node, mounting) {
        var _this2 = this;

        var enter = this.props.enter;
        var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
        var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set

        if (!mounting && !enter) {
          this.safeSetState({
            status: ENTERED
          }, function () {
            _this2.props.onEntered(node);
          });
          return;
        }

        this.props.onEnter(node, appearing);
        this.safeSetState({
          status: ENTERING
        }, function () {
          _this2.props.onEntering(node, appearing); // FIXME: appear timeout?


          _this2.onTransitionEnd(node, timeouts.enter, function () {
            _this2.safeSetState({
              status: ENTERED
            }, function () {
              _this2.props.onEntered(node, appearing);
            });
          });
        });
      };

      Transition.prototype.performExit = function performExit(node) {
        var _this3 = this;

        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

        if (!exit) {
          this.safeSetState({
            status: EXITED
          }, function () {
            _this3.props.onExited(node);
          });
          return;
        }

        this.props.onExit(node);
        this.safeSetState({
          status: EXITING
        }, function () {
          _this3.props.onExiting(node);

          _this3.onTransitionEnd(node, timeouts.exit, function () {
            _this3.safeSetState({
              status: EXITED
            }, function () {
              _this3.props.onExited(node);
            });
          });
        });
      };

      Transition.prototype.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
          this.nextCallback.cancel();
          this.nextCallback = null;
        }
      };

      Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
      };

      Transition.prototype.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;

        var active = true;

        this.nextCallback = function (event) {
          if (active) {
            active = false;
            _this4.nextCallback = null;
            callback(event);
          }
        };

        this.nextCallback.cancel = function () {
          active = false;
        };

        return this.nextCallback;
      };

      Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);

        if (node) {
          if (this.props.addEndListener) {
            this.props.addEndListener(node, this.nextCallback);
          }

          if (timeout != null) {
            setTimeout(this.nextCallback, timeout);
          }
        } else {
          setTimeout(this.nextCallback, 0);
        }
      };

      Transition.prototype.render = function render() {
        var status = this.state.status;

        if (status === UNMOUNTED) {
          return null;
        }

        var _props = this.props,
            children = _props.children,
            childProps = _objectWithoutProperties(_props, ['children']); // filter props for Transtition


        delete childProps["in"];
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;

        if (typeof children === 'function') {
          return children(status, childProps);
        }

        var child = _react2["default"].Children.only(children);

        return _react2["default"].cloneElement(child, childProps);
      };

      return Transition;
    }(_react2["default"].Component);

    Transition.contextTypes = {
      transitionGroup: PropTypes.object
    };
    Transition.childContextTypes = {
      transitionGroup: function transitionGroup() {}
    };
    Transition.propTypes = process.env.NODE_ENV !== "production" ? {
      /**
       * A `function` child can be used instead of a React element.
       * This function is called with the current transition status
       * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
       * to apply context specific props to a component.
       *
       * ```jsx
       * <Transition timeout={150}>
       *   {(status) => (
       *     <MyComponent className={`fade fade-${status}`} />
       *   )}
       * </Transition>
       * ```
       */
      children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

      /**
       * Show the component; triggers the enter or exit states
       */
      "in": PropTypes.bool,

      /**
       * By default the child component is mounted immediately along with
       * the parent `Transition` component. If you want to "lazy mount" the component on the
       * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
       * mounted, even on "exited", unless you also specify `unmountOnExit`.
       */
      mountOnEnter: PropTypes.bool,

      /**
       * By default the child component stays mounted after it reaches the `'exited'` state.
       * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
       */
      unmountOnExit: PropTypes.bool,

      /**
       * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
       * If you want to transition on the first mount set `appear` to `true`, and the
       * component will transition in as soon as the `<Transition>` mounts.
       *
       * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
       */
      appear: PropTypes.bool,

      /**
       * Enable or disable enter transitions.
       */
      enter: PropTypes.bool,

      /**
       * Enable or disable exit transitions.
       */
      exit: PropTypes.bool,

      /**
       * The duration of the transition, in milliseconds.
       * Required unless `addEndListener` is provided
       *
       * You may specify a single timeout for all transitions like: `timeout={500}`,
       * or individually like:
       *
       * ```jsx
       * timeout={{
       *  enter: 300,
       *  exit: 500,
       * }}
       * ```
       *
       * @type {number | { enter?: number, exit?: number }}
       */
      timeout: function timeout(props) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var pt = _PropTypes.timeoutsShape;
        if (!props.addEndListener) pt = pt.isRequired;
        return pt.apply(undefined, [props].concat(args));
      },

      /**
       * Add a custom transition end trigger. Called with the transitioning
       * DOM node and a `done` callback. Allows for more fine grained transition end
       * logic. **Note:** Timeouts are still used as a fallback if provided.
       *
       * ```jsx
       * addEndListener={(node, done) => {
       *   // use the css transitionend event to mark the finish of a transition
       *   node.addEventListener('transitionend', done, false);
       * }}
       * ```
       */
      addEndListener: PropTypes.func,

      /**
       * Callback fired before the "entering" status is applied. An extra parameter
       * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
       *
       * @type Function(node: HtmlElement, isAppearing: bool) -> void
       */
      onEnter: PropTypes.func,

      /**
       * Callback fired after the "entering" status is applied. An extra parameter
       * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
       *
       * @type Function(node: HtmlElement, isAppearing: bool)
       */
      onEntering: PropTypes.func,

      /**
       * Callback fired after the "entered" status is applied. An extra parameter
       * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
       *
       * @type Function(node: HtmlElement, isAppearing: bool) -> void
       */
      onEntered: PropTypes.func,

      /**
       * Callback fired before the "exiting" status is applied.
       *
       * @type Function(node: HtmlElement) -> void
       */
      onExit: PropTypes.func,

      /**
       * Callback fired after the "exiting" status is applied.
       *
       * @type Function(node: HtmlElement) -> void
       */
      onExiting: PropTypes.func,

      /**
       * Callback fired after the "exited" status is applied.
       *
       * @type Function(node: HtmlElement) -> void
       */
      onExited: PropTypes.func // Name the function so it is clearer in the documentation

    } : {};

    function noop() {}

    Transition.defaultProps = {
      "in": false,
      mountOnEnter: false,
      unmountOnExit: false,
      appear: false,
      enter: true,
      exit: true,
      onEnter: noop,
      onEntering: noop,
      onEntered: noop,
      onExit: noop,
      onExiting: noop,
      onExited: noop
    };
    Transition.UNMOUNTED = 0;
    Transition.EXITED = 1;
    Transition.ENTERING = 2;
    Transition.ENTERED = 3;
    Transition.EXITING = 4;
    exports["default"] = (0, _reactLifecyclesCompat.polyfill)(Transition);
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(8));
  /***/
},
/* 142 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: true
  });
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "polyfill", function () {
    return polyfill;
  });
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */


  function componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);

    if (state !== null && state !== undefined) {
      this.setState(state);
    }
  }

  function componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
      var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
      return state !== null && state !== undefined ? state : null;
    } // Binding "this" is important for shallow renderer support.


    this.setState(updater.bind(this));
  }

  function componentWillUpdate(nextProps, nextState) {
    try {
      var prevProps = this.props;
      var prevState = this.state;
      this.props = nextProps;
      this.state = nextState;
      this.__reactInternalSnapshotFlag = true;
      this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally {
      this.props = prevProps;
      this.state = prevState;
    }
  } // React may warn about cWM/cWRP/cWU methods being deprecated.
  // Add a flag to suppress these warnings for this special case.


  componentWillMount.__suppressDeprecationWarning = true;
  componentWillReceiveProps.__suppressDeprecationWarning = true;
  componentWillUpdate.__suppressDeprecationWarning = true;

  function polyfill(Component) {
    var prototype = Component.prototype;

    if (!prototype || !prototype.isReactComponent) {
      throw new Error('Can only polyfill class components');
    }

    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') {
      return Component;
    } // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.


    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;

    if (typeof prototype.componentWillMount === 'function') {
      foundWillMountName = 'componentWillMount';
    } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
      foundWillMountName = 'UNSAFE_componentWillMount';
    }

    if (typeof prototype.componentWillReceiveProps === 'function') {
      foundWillReceivePropsName = 'componentWillReceiveProps';
    } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
      foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    }

    if (typeof prototype.componentWillUpdate === 'function') {
      foundWillUpdateName = 'componentWillUpdate';
    } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
      foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    }

    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
      var componentName = Component.displayName || Component.name;
      var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
      throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    } // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.


    if (typeof Component.getDerivedStateFromProps === 'function') {
      prototype.componentWillMount = componentWillMount;
      prototype.componentWillReceiveProps = componentWillReceiveProps;
    } // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.


    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
      if (typeof prototype.componentDidUpdate !== 'function') {
        throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
      }

      prototype.componentWillUpdate = componentWillUpdate;
      var componentDidUpdate = prototype.componentDidUpdate;

      prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
        // 16.3+ will not execute our will-update method;
        // It will pass a snapshot value to did-update though.
        // Older versions will require our polyfilled will-update value.
        // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
        // Because for <= 15.x versions this might be a "prevContext" object.
        // We also can't just check "__reactInternalSnapshot",
        // Because get-snapshot might return a falsy value.
        // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
        var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
        componentDidUpdate.call(this, prevProps, prevState, snapshot);
      };
    }

    return Component;
  }
  /***/

},
/* 143 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  exports.classNamesShape = exports.timeoutsShape = undefined;
  exports.transitionTimeout = transitionTimeout;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function transitionTimeout(transitionType) {
    var timeoutPropName = 'transition' + transitionType + 'Timeout';
    var enabledPropName = 'transition' + transitionType;
    return function (props) {
      // If the transition is enabled
      if (props[enabledPropName]) {
        // If no timeout duration is provided
        if (props[timeoutPropName] == null) {
          return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.'); // If the duration isn't a number
        } else if (typeof props[timeoutPropName] !== 'number') {
          return new Error(timeoutPropName + ' must be a number (in milliseconds)');
        }
      }

      return null;
    };
  }

  var timeoutsShape = exports.timeoutsShape = _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].shape({
    enter: _propTypes2["default"].number,
    exit: _propTypes2["default"].number
  }).isRequired]);

  var classNamesShape = exports.classNamesShape = _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].shape({
    enter: _propTypes2["default"].string,
    exit: _propTypes2["default"].string,
    active: _propTypes2["default"].string
  }), _propTypes2["default"].shape({
    enter: _propTypes2["default"].string,
    enterDone: _propTypes2["default"].string,
    enterActive: _propTypes2["default"].string,
    exit: _propTypes2["default"].string,
    exitDone: _propTypes2["default"].string,
    exitActive: _propTypes2["default"].string
  })]);
  /***/

},
/* 144 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    exports.__esModule = true;

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    var _propTypes = __webpack_require__(1);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _react = __webpack_require__(0);

    var _react2 = _interopRequireDefault(_react);

    var _reactLifecyclesCompat = __webpack_require__(142);

    var _ChildMapping = __webpack_require__(272);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }

    function _objectWithoutProperties(obj, keys) {
      var target = {};

      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }

      return target;
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var values = Object.values || function (obj) {
      return Object.keys(obj).map(function (k) {
        return obj[k];
      });
    };

    var propTypes = {
      /**
       * `<TransitionGroup>` renders a `<div>` by default. You can change this
       * behavior by providing a `component` prop.
       * If you use React v16+ and would like to avoid a wrapping `<div>` element
       * you can pass in `component={null}`. This is useful if the wrapping div
       * borks your css styles.
       */
      component: _propTypes2["default"].any,

      /**
       * A set of `<Transition>` components, that are toggled `in` and out as they
       * leave. the `<TransitionGroup>` will inject specific transition props, so
       * remember to spread them through if you are wrapping the `<Transition>` as
       * with our `<Fade>` example.
       */
      children: _propTypes2["default"].node,

      /**
       * A convenience prop that enables or disables appear animations
       * for all children. Note that specifying this will override any defaults set
       * on individual children Transitions.
       */
      appear: _propTypes2["default"].bool,

      /**
       * A convenience prop that enables or disables enter animations
       * for all children. Note that specifying this will override any defaults set
       * on individual children Transitions.
       */
      enter: _propTypes2["default"].bool,

      /**
       * A convenience prop that enables or disables exit animations
       * for all children. Note that specifying this will override any defaults set
       * on individual children Transitions.
       */
      exit: _propTypes2["default"].bool,

      /**
       * You may need to apply reactive updates to a child as it is exiting.
       * This is generally done by using `cloneElement` however in the case of an exiting
       * child the element has already been removed and not accessible to the consumer.
       *
       * If you do need to update a child as it leaves you can provide a `childFactory`
       * to wrap every child, even the ones that are leaving.
       *
       * @type Function(child: ReactElement) -> ReactElement
       */
      childFactory: _propTypes2["default"].func
    };
    var defaultProps = {
      component: 'div',
      childFactory: function childFactory(child) {
        return child;
      }
      /**
       * The `<TransitionGroup>` component manages a set of `<Transition>` components
       * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
       * state machine for managing the mounting and unmounting of components over
       * time.
       *
       * Consider the example below using the `Fade` CSS transition from before.
       * As items are removed or added to the TodoList the `in` prop is toggled
       * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
       * component in a `<TransitionGroup>`, not just css.
       *
       * ## Example
       *
       * <iframe src="https://codesandbox.io/embed/00rqyo26kn?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
       *
       * Note that `<TransitionGroup>`  does not define any animation behavior!
       * Exactly _how_ a list item animates is up to the individual `<Transition>`
       * components. This means you can mix and match animations across different
       * list items.
       */

    };

    var TransitionGroup = function (_React$Component) {
      _inherits(TransitionGroup, _React$Component);

      function TransitionGroup(props, context) {
        _classCallCheck(this, TransitionGroup);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

        var handleExited = _this.handleExited.bind(_this); // Initial children should all be entering, dependent on appear


        _this.state = {
          handleExited: handleExited,
          firstRender: true
        };
        return _this;
      }

      TransitionGroup.prototype.getChildContext = function getChildContext() {
        return {
          transitionGroup: {
            isMounting: !this.appeared
          }
        };
      };

      TransitionGroup.prototype.componentDidMount = function componentDidMount() {
        this.appeared = true;
      };

      TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children,
            handleExited = _ref.handleExited,
            firstRender = _ref.firstRender;
        return {
          children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
          firstRender: false
        };
      };

      TransitionGroup.prototype.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;

        if (child.props.onExited) {
          child.props.onExited(node);
        }

        this.setState(function (state) {
          var children = _extends({}, state.children);

          delete children[child.key];
          return {
            children: children
          };
        });
      };

      TransitionGroup.prototype.render = function render() {
        var _props = this.props,
            Component = _props.component,
            childFactory = _props.childFactory,
            props = _objectWithoutProperties(_props, ['component', 'childFactory']);

        var children = values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;

        if (Component === null) {
          return children;
        }

        return _react2["default"].createElement(Component, props, children);
      };

      return TransitionGroup;
    }(_react2["default"].Component);

    TransitionGroup.childContextTypes = {
      transitionGroup: _propTypes2["default"].object.isRequired
    };
    TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
    TransitionGroup.defaultProps = defaultProps;
    exports["default"] = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
    module.exports = exports['default'];
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(8));
  /***/
},
/* 145 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(42);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(13);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10_lodash_mapValues__ = __webpack_require__(92);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_mapValues__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11_validate_js__ = __webpack_require__(99);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_validate_js__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_12_react_form__ = __webpack_require__(46);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_12_react_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_form__);

  var _class,
      _temp2,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/Blocks/Edition/ImageEdition.js';

  var ImageEdition = (_temp2 = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ImageEdition, _React$Component);

    function ImageEdition() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ImageEdition);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ImageEdition.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ImageEdition)).call.apply(_ref, [this].concat(args))), _this), _this.VALIDATIONS = __WEBPACK_IMPORTED_MODULE_10_lodash_mapValues___default()(_this.props.block.model, function (m) {
        return m.validations;
      }), _this.MODEL = _this.props.block.model, _this.triggerSubmit = function (values) {
        if (_this.props.onSubmit) _this.props.onSubmit(values);
      }, _this.triggerValidateError = function (values) {
        var errors = {};

        var errorValidations = __WEBPACK_IMPORTED_MODULE_11_validate_js___default()(values, _this.VALIDATIONS); // Map throuhg the model keys to set the errors


        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this.MODEL).map(function (k) {
          return errors[k] = errorValidations && errorValidations[k];
        });

        return errors;
      }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ImageEdition, [{
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
          className: 'cw-wysiwyg-edition',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 40
          }
        }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_form__["Form"], {
          defaultValues: __WEBPACK_IMPORTED_MODULE_10_lodash_mapValues___default()(this.MODEL, function (m) {
            return m.defaultValue;
          }),
          onSubmit: this.triggerSubmit,
          validateError: this.triggerValidateError,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 41
          }
        }, function (formApi) {
          var touched = formApi.touched,
              errors = formApi.errors;
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('form', {
            id: 'form',
            className: 'cw-form',
            autoComplete: 'off',
            onSubmit: formApi.submitForm,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 50
            }
          }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('fieldset', {
            className: 'cw-fieldset',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 56
            }
          }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.MODEL).map(function (f) {
            var fieldClassNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, '-' + _this2.MODEL[f].type, !!_this2.MODEL[f].type));

            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
              key: _this2.MODEL[f].id,
              className: 'cw-field ' + fieldClassNames,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 63
              }
            }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('label', {
              className: 'label',
              htmlFor: _this2.MODEL[f].id,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 64
              }
            }, _this2.MODEL[f].label), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(_this2.MODEL[f].Component, {
              field: _this2.MODEL[f].id,
              id: _this2.MODEL[f].id,
              options: _this2.MODEL[f].options || {}
            }), !!touched[f] && !!errors[f] && errors[f].map(function (e, i) {
              return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
                key: i,
                className: 'error',
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 80
                }
              }, e);
            }));
          })), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
            className: 'form-actions',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 86
            }
          }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('button', {
            type: 'button',
            className: 'cw-button -primary',
            onClick: formApi.submitForm,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 87
            }
          }, 'Submit')));
        }));
      }
    }]);

    return ImageEdition;
  }(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _class.propTypes = {
    block: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    onSubmit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
  }, _class.defaultProps = {
    block: {}
  }, _temp2);
  ImageEdition.displayName = 'ImageEdition';
  /* harmony default export */

  __webpack_exports__["a"] = ImageEdition;
  /***/
},
/* 146 */

/***/
function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(43),
      isObject = __webpack_require__(93);
  /** `Object#toString` result references. */


  var asyncTag = '[object AsyncFunction]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      proxyTag = '[object Proxy]';
  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */

  function isFunction(value) {
    if (!isObject(value)) {
      return false;
    } // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.


    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }

  module.exports = isFunction;
  /***/
},
/* 147 */

/***/
function (module, exports) {
  /** Used for built-in method references. */
  var funcProto = Function.prototype;
  /** Used to resolve the decompiled source of functions. */

  var funcToString = funcProto.toString;
  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to convert.
   * @returns {string} Returns the source code.
   */

  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}

      try {
        return func + '';
      } catch (e) {}
    }

    return '';
  }

  module.exports = toSource;
  /***/
},
/* 148 */

/***/
function (module, exports, __webpack_require__) {
  var baseIsArguments = __webpack_require__(292),
      isObjectLike = __webpack_require__(44);
  /** Used for built-in method references. */


  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /** Built-in value references. */

  var propertyIsEnumerable = objectProto.propertyIsEnumerable;
  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */

  var isArguments = baseIsArguments(function () {
    return arguments;
  }()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
  };
  module.exports = isArguments;
  /***/
},
/* 149 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (module) {
    var root = __webpack_require__(19),
        stubFalse = __webpack_require__(293);
    /** Detect free variable `exports`. */


    var freeExports = _typeof4(exports) == 'object' && exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */

    var freeModule = freeExports && _typeof4(module) == 'object' && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */

    var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Built-in value references. */

    var Buffer = moduleExports ? root.Buffer : undefined;
    /* Built-in method references for those with the same name as other `lodash` methods. */

    var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */

    var isBuffer = nativeIsBuffer || stubFalse;
    module.exports = isBuffer;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(45)(module));
  /***/
},
/* 150 */

/***/
function (module, exports) {
  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;
  /** Used to detect unsigned integer values. */

  var reIsUint = /^(?:0|[1-9]\d*)$/;
  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */

  function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }

  module.exports = isIndex;
  /***/
},
/* 151 */

/***/
function (module, exports, __webpack_require__) {
  var baseIsTypedArray = __webpack_require__(294),
      baseUnary = __webpack_require__(295),
      nodeUtil = __webpack_require__(296);
  /* Node.js helper references. */


  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */

  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
  module.exports = isTypedArray;
  /***/
},
/* 152 */

/***/
function (module, exports, __webpack_require__) {
  var ListCache = __webpack_require__(59),
      stackClear = __webpack_require__(310),
      stackDelete = __webpack_require__(311),
      stackGet = __webpack_require__(312),
      stackHas = __webpack_require__(313),
      stackSet = __webpack_require__(314);
  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */


  function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  } // Add methods to `Stack`.


  Stack.prototype.clear = stackClear;
  Stack.prototype['delete'] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  module.exports = Stack;
  /***/
},
/* 153 */

/***/
function (module, exports) {
  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */
  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }

  module.exports = eq;
  /***/
},
/* 154 */

/***/
function (module, exports, __webpack_require__) {
  var baseIsEqualDeep = __webpack_require__(327),
      isObjectLike = __webpack_require__(44);
  /**
   * The base implementation of `_.isEqual` which supports partial comparisons
   * and tracks traversed objects.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @param {boolean} bitmask The bitmask flags.
   *  1 - Unordered comparison
   *  2 - Partial comparison
   * @param {Function} [customizer] The function to customize comparisons.
   * @param {Object} [stack] Tracks traversed `value` and `other` objects.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   */


  function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }

    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
      return value !== value && other !== other;
    }

    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
  }

  module.exports = baseIsEqual;
  /***/
},
/* 155 */

/***/
function (module, exports, __webpack_require__) {
  var SetCache = __webpack_require__(328),
      arraySome = __webpack_require__(331),
      cacheHas = __webpack_require__(332);
  /** Used to compose bitmasks for value comparisons. */


  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;
  /**
   * A specialized version of `baseIsEqualDeep` for arrays with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Array} array The array to compare.
   * @param {Array} other The other array to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `array` and `other` objects.
   * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
   */

  function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        arrLength = array.length,
        othLength = other.length;

    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    } // Assume cyclic values are equal.


    var stacked = stack.get(array);

    if (stacked && stack.get(other)) {
      return stacked == other;
    }

    var index = -1,
        result = true,
        seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
    stack.set(array, other);
    stack.set(other, array); // Ignore non-index properties.

    while (++index < arrLength) {
      var arrValue = array[index],
          othValue = other[index];

      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }

      if (compared !== undefined) {
        if (compared) {
          continue;
        }

        result = false;
        break;
      } // Recursively compare arrays (susceptible to call stack limits).


      if (seen) {
        if (!arraySome(other, function (othValue, othIndex) {
          if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result = false;
        break;
      }
    }

    stack['delete'](array);
    stack['delete'](other);
    return result;
  }

  module.exports = equalArrays;
  /***/
},
/* 156 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(93);
  /**
   * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` if suitable for strict
   *  equality comparisons, else `false`.
   */


  function isStrictComparable(value) {
    return value === value && !isObject(value);
  }

  module.exports = isStrictComparable;
  /***/
},
/* 157 */

/***/
function (module, exports) {
  /**
   * A specialized version of `matchesProperty` for source values suitable
   * for strict equality comparisons, i.e. `===`.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @param {*} srcValue The value to match.
   * @returns {Function} Returns the new spec function.
   */
  function matchesStrictComparable(key, srcValue) {
    return function (object) {
      if (object == null) {
        return false;
      }

      return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
  }

  module.exports = matchesStrictComparable;
  /***/
},
/* 158 */

/***/
function (module, exports, __webpack_require__) {
  var castPath = __webpack_require__(159),
      toKey = __webpack_require__(63);
  /**
   * The base implementation of `_.get` without support for default values.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @returns {*} Returns the resolved value.
   */


  function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0,
        length = path.length;

    while (object != null && index < length) {
      object = object[toKey(path[index++])];
    }

    return index && index == length ? object : undefined;
  }

  module.exports = baseGet;
  /***/
},
/* 159 */

/***/
function (module, exports, __webpack_require__) {
  var isArray = __webpack_require__(25),
      isKey = __webpack_require__(98),
      stringToPath = __webpack_require__(352),
      toString = __webpack_require__(138);
  /**
   * Casts `value` to a path array if it's not one.
   *
   * @private
   * @param {*} value The value to inspect.
   * @param {Object} [object] The object to query keys on.
   * @returns {Array} Returns the cast property path array.
   */


  function castPath(value, object) {
    if (isArray(value)) {
      return value;
    }

    return isKey(value, object) ? [value] : stringToPath(toString(value));
  }

  module.exports = castPath;
  /***/
},
/* 160 */

/***/
function (module, exports) {
  module.exports = function () {
    throw new Error("define cannot be used indirect");
  };
  /***/

},
/* 161 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  exports["default"] = function (obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  };
  /***/

},
/* 162 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(367),
    __esModule: true
  };
  /***/
},
/* 163 */

/***/
function (module, exports, __webpack_require__) {
  // 7.3.20 SpeciesConstructor(O, defaultConstructor)
  var anObject = __webpack_require__(16);

  var aFunction = __webpack_require__(54);

  var SPECIES = __webpack_require__(10)('species');

  module.exports = function (O, D) {
    var C = anObject(O).constructor;
    var S;
    return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
  };
  /***/

},
/* 164 */

/***/
function (module, exports, __webpack_require__) {
  var ctx = __webpack_require__(30);

  var invoke = __webpack_require__(371);

  var html = __webpack_require__(115);

  var cel = __webpack_require__(77);

  var global = __webpack_require__(9);

  var process = global.process;
  var setTask = global.setImmediate;
  var clearTask = global.clearImmediate;
  var MessageChannel = global.MessageChannel;
  var Dispatch = global.Dispatch;
  var counter = 0;
  var queue = {};
  var ONREADYSTATECHANGE = 'onreadystatechange';
  var defer, channel, port;

  var run = function run() {
    var id = +this; // eslint-disable-next-line no-prototype-builtins

    if (queue.hasOwnProperty(id)) {
      var fn = queue[id];
      delete queue[id];
      fn();
    }
  };

  var listener = function listener(event) {
    run.call(event.data);
  }; // Node.js 0.9+ & IE10+ has setImmediate, otherwise:


  if (!setTask || !clearTask) {
    setTask = function setImmediate(fn) {
      var args = [];
      var i = 1;

      while (arguments.length > i) {
        args.push(arguments[i++]);
      }

      queue[++counter] = function () {
        // eslint-disable-next-line no-new-func
        invoke(typeof fn == 'function' ? fn : Function(fn), args);
      };

      defer(counter);
      return counter;
    };

    clearTask = function clearImmediate(id) {
      delete queue[id];
    }; // Node.js 0.8-


    if (__webpack_require__(40)(process) == 'process') {
      defer = function defer(id) {
        process.nextTick(ctx(run, id, 1));
      }; // Sphere (JS game engine) Dispatch API

    } else if (Dispatch && Dispatch.now) {
      defer = function defer(id) {
        Dispatch.now(ctx(run, id, 1));
      }; // Browsers with MessageChannel, includes WebWorkers

    } else if (MessageChannel) {
      channel = new MessageChannel();
      port = channel.port2;
      channel.port1.onmessage = listener;
      defer = ctx(port.postMessage, port, 1); // Browsers with postMessage, skip WebWorkers
      // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
      defer = function defer(id) {
        global.postMessage(id + '', '*');
      };

      global.addEventListener('message', listener, false); // IE8-
    } else if (ONREADYSTATECHANGE in cel('script')) {
      defer = function defer(id) {
        html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
          html.removeChild(this);
          run.call(id);
        };
      }; // Rest old browsers

    } else {
      defer = function defer(id) {
        setTimeout(ctx(run, id, 1), 0);
      };
    }
  }

  module.exports = {
    set: setTask,
    clear: clearTask
  };
  /***/
},
/* 165 */

/***/
function (module, exports) {
  module.exports = function (exec) {
    try {
      return {
        e: false,
        v: exec()
      };
    } catch (e) {
      return {
        e: true,
        v: e
      };
    }
  };
  /***/

},
/* 166 */

/***/
function (module, exports, __webpack_require__) {
  var anObject = __webpack_require__(16);

  var isObject = __webpack_require__(22);

  var newPromiseCapability = __webpack_require__(100);

  module.exports = function (C, x) {
    anObject(C);
    if (isObject(x) && x.constructor === C) return x;
    var promiseCapability = newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
  };
  /***/

},
/* 167 */

/***/
function (module, exports) {
  module.exports = require("redux");
  /***/
},
/* 168 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "b", function () {
    return subscriptionShape;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return storeShape;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

  var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
  });

  var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
  });
  /***/

},
/* 169 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /* harmony export (immutable) */
    __webpack_exports__["a"] = connectAdvanced;
    /* harmony import */

    var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(136);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(64);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(381);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(168);

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    function _objectWithoutProperties(obj, keys) {
      var target = {};

      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }

      return target;
    }

    var hotReloadingVersion = 0;
    var dummyState = {};

    function noop() {}

    function makeSelectorStateful(sourceSelector, store) {
      // wrap the selector in an object that tracks its results between runs.
      var selector = {
        run: function runComponentSelector(props) {
          try {
            var nextProps = sourceSelector(store.getState(), props);

            if (nextProps !== selector.props || selector.error) {
              selector.shouldComponentUpdate = true;
              selector.props = nextProps;
              selector.error = null;
            }
          } catch (error) {
            selector.shouldComponentUpdate = true;
            selector.error = error;
          }
        }
      };
      return selector;
    }

    function connectAdvanced(
    /*
      selectorFactory is a func that is responsible for returning the selector function used to
      compute new props from state, props, and dispatch. For example:
         export default connectAdvanced((dispatch, options) => (state, props) => ({
          thing: state.things[props.thingId],
          saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
        }))(YourComponent)
       Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
      outside of their selector as an optimization. Options passed to connectAdvanced are passed to
      the selectorFactory, along with displayName and WrappedComponent, as the second argument.
       Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
      props. Do not use connectAdvanced directly without memoizing results between calls to your
      selector, otherwise the Connect component will re-render on every state or props change.
    */
    selectorFactory) {
      var _contextTypes, _childContextTypes;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$getDisplayName = _ref.getDisplayName,
          getDisplayName = _ref$getDisplayName === undefined ? function (name) {
        return 'ConnectAdvanced(' + name + ')';
      } : _ref$getDisplayName,
          _ref$methodName = _ref.methodName,
          methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
          _ref$renderCountProp = _ref.renderCountProp,
          renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
          _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
          shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
          _ref$storeKey = _ref.storeKey,
          storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
          _ref$withRef = _ref.withRef,
          withRef = _ref$withRef === undefined ? false : _ref$withRef,
          connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

      var subscriptionKey = storeKey + 'Subscription';
      var version = hotReloadingVersion++;
      var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a"
      /* storeShape */
      ], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b"
      /* subscriptionShape */
      ], _contextTypes);
      var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b"
      /* subscriptionShape */
      ], _childContextTypes);
      return function wrapWithConnect(WrappedComponent) {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);

        var selectorFactoryOptions = _extends({}, connectOptions, {
          getDisplayName: getDisplayName,
          methodName: methodName,
          renderCountProp: renderCountProp,
          shouldHandleStateChanges: shouldHandleStateChanges,
          storeKey: storeKey,
          withRef: withRef,
          displayName: displayName,
          wrappedComponentName: wrappedComponentName,
          WrappedComponent: WrappedComponent
        });

        var Connect = function (_Component) {
          _inherits(Connect, _Component);

          function Connect(props, context) {
            _classCallCheck(this, Connect);

            var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

            _this.version = version;
            _this.state = {};
            _this.renderCount = 0;
            _this.store = props[storeKey] || context[storeKey];
            _this.propsMode = Boolean(props[storeKey]);
            _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

            __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

            _this.initSelector();

            _this.initSubscription();

            return _this;
          }

          Connect.prototype.getChildContext = function getChildContext() {
            var _ref2; // If this component received store from props, its subscription should be transparent
            // to any descendants receiving store+subscription from context; it passes along
            // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
            // Connect to control ordering of notifications to flow top-down.


            var subscription = this.propsMode ? null : this.subscription;
            return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
          };

          Connect.prototype.componentDidMount = function componentDidMount() {
            if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
            // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
            // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
            // To handle the case where a child component may have triggered a state change by
            // dispatching an action in its componentWillMount, we have to re-run the select and maybe
            // re-render.

            this.subscription.trySubscribe();
            this.selector.run(this.props);
            if (this.selector.shouldComponentUpdate) this.forceUpdate();
          };

          Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            this.selector.run(nextProps);
          };

          Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
            return this.selector.shouldComponentUpdate;
          };

          Connect.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.subscription) this.subscription.tryUnsubscribe();
            this.subscription = null;
            this.notifyNestedSubs = noop;
            this.store = null;
            this.selector.run = noop;
            this.selector.shouldComponentUpdate = false;
          };

          Connect.prototype.getWrappedInstance = function getWrappedInstance() {
            __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));

            return this.wrappedInstance;
          };

          Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
            this.wrappedInstance = ref;
          };

          Connect.prototype.initSelector = function initSelector() {
            var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
            this.selector = makeSelectorStateful(sourceSelector, this.store);
            this.selector.run(this.props);
          };

          Connect.prototype.initSubscription = function initSubscription() {
            if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
            // connected to the store via props shouldn't use subscription from context, or vice versa.

            var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
            this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a"
            /* default */
            ](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
            // the middle of the notification loop, where `this.subscription` will then be null. An
            // extra null check every change can be avoided by copying the method onto `this` and then
            // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
            // listeners logic is changed to not call listeners that have been unsubscribed in the
            // middle of the notification loop.

            this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
          };

          Connect.prototype.onStateChange = function onStateChange() {
            this.selector.run(this.props);

            if (!this.selector.shouldComponentUpdate) {
              this.notifyNestedSubs();
            } else {
              this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
              this.setState(dummyState);
            }
          };

          Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
            // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
            // needs to notify nested subs. Once called, it unimplements itself until further state
            // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
            // a boolean check every time avoids an extra method call most of the time, resulting
            // in some perf boost.
            this.componentDidUpdate = undefined;
            this.notifyNestedSubs();
          };

          Connect.prototype.isSubscribed = function isSubscribed() {
            return Boolean(this.subscription) && this.subscription.isSubscribed();
          };

          Connect.prototype.addExtraProps = function addExtraProps(props) {
            if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
            // this is especially important for 'ref' since that's a reference back to the component
            // instance. a singleton memoized selector would then be holding a reference to the
            // instance, preventing the instance from being garbage collected, and that would be bad

            var withExtras = _extends({}, props);

            if (withRef) withExtras.ref = this.setWrappedInstance;
            if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
            if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
            return withExtras;
          };

          Connect.prototype.render = function render() {
            var selector = this.selector;
            selector.shouldComponentUpdate = false;

            if (selector.error) {
              throw selector.error;
            } else {
              return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
            }
          };

          return Connect;
        }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = displayName;
        Connect.childContextTypes = childContextTypes;
        Connect.contextTypes = contextTypes;
        Connect.propTypes = contextTypes;

        if (process.env.NODE_ENV !== 'production') {
          Connect.prototype.componentWillUpdate = function componentWillUpdate() {
            var _this2 = this; // We are hot reloading!


            if (this.version !== version) {
              this.version = version;
              this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
              // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
              // listeners, this does mean that the old versions of connected descendants will still be
              // notified of state changes; however, their onStateChange function is a no-op so this
              // isn't a huge deal.

              var oldListeners = [];

              if (this.subscription) {
                oldListeners = this.subscription.listeners.get();
                this.subscription.tryUnsubscribe();
              }

              this.initSubscription();

              if (shouldHandleStateChanges) {
                this.subscription.trySubscribe();
                oldListeners.forEach(function (listener) {
                  return _this2.subscription.listeners.subscribe(listener);
                });
              }
            }
          };
        }

        return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
      };
    }
    /* WEBPACK VAR INJECTION */

  }).call(__webpack_exports__, __webpack_require__(8));
  /***/
},
/* 170 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /* harmony export (immutable) */
    __webpack_exports__["a"] = wrapMapToPropsConstant;
    /* unused harmony export getDependsOnOwnProps */

    /* harmony export (immutable) */

    __webpack_exports__["b"] = wrapMapToPropsFunc;
    /* harmony import */

    var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(171);

    function wrapMapToPropsConstant(getConstant) {
      return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);

        function constantSelector() {
          return constant;
        }

        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
      };
    } // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
    // to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
    // whether mapToProps needs to be invoked when props have changed.
    // 
    // A length of one signals that mapToProps does not depend on props from the parent component.
    // A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
    // therefore not reporting its length accurately..


    function getDependsOnOwnProps(mapToProps) {
      return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
    } // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
    // this function wraps mapToProps in a proxy function which does several things:
    // 
    //  * Detects whether the mapToProps function being called depends on props, which
    //    is used by selectorFactory to decide if it should reinvoke on props changes.
    //    
    //  * On first call, handles mapToProps if returns another function, and treats that
    //    new function as the true mapToProps for subsequent calls.
    //    
    //  * On first call, verifies the first result is a plain object, in order to warn
    //    the developer that their mapToProps function is not returning a valid result.
    //    


    function wrapMapToPropsFunc(mapToProps, methodName) {
      return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;

        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
          return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps


        proxy.dependsOnOwnProps = true;

        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
          proxy.mapToProps = mapToProps;
          proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
          var props = proxy(stateOrDispatch, ownProps);

          if (typeof props === 'function') {
            proxy.mapToProps = props;
            proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
            props = proxy(stateOrDispatch, ownProps);
          }

          if (process.env.NODE_ENV !== 'production') Object(__WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__["a"
          /* default */
          ])(props, displayName, methodName);
          return props;
        };

        return proxy;
      };
    }
    /* WEBPACK VAR INJECTION */

  }).call(__webpack_exports__, __webpack_require__(8));
  /***/
},
/* 171 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (immutable) */

  __webpack_exports__["a"] = verifyPlainObject;
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(385);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(101);

  function verifyPlainObject(value, displayName, methodName) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a"
    /* default */
    ])(value)) {
      Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a"
      /* default */
      ])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
    }
  }
  /***/

},
/* 172 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(387);
  /** Built-in value references. */


  var _Symbol6 = __WEBPACK_IMPORTED_MODULE_0__root_js__["a"
  /* default */
  ].Symbol;
  /* harmony default export */

  __webpack_exports__["a"] = _Symbol6;
  /***/
},
/* 173 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(42);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(13);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10_lodash_mapValues__ = __webpack_require__(92);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_mapValues__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11_validate_js__ = __webpack_require__(99);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_validate_js__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_12_react_form__ = __webpack_require__(46);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_12_react_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_form__);

  var _class,
      _temp2,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/Blocks/Edition/VideoEdition.js';

  var VideoEdition = (_temp2 = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(VideoEdition, _React$Component);

    function VideoEdition() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, VideoEdition);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = VideoEdition.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(VideoEdition)).call.apply(_ref, [this].concat(args))), _this), _this.VALIDATIONS = __WEBPACK_IMPORTED_MODULE_10_lodash_mapValues___default()(_this.props.block.model, function (m) {
        return m.validations;
      }), _this.MODEL = _this.props.block.model, _this.triggerSubmit = function (values) {
        if (_this.props.onSubmit) _this.props.onSubmit(values);
      }, _this.triggerValidateError = function (values) {
        var errors = {};

        var errorValidations = __WEBPACK_IMPORTED_MODULE_11_validate_js___default()(values, _this.VALIDATIONS); // Map throuhg the model keys to set the errors


        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this.MODEL).map(function (k) {
          return errors[k] = errorValidations && errorValidations[k];
        });

        return errors;
      }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(VideoEdition, [{
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
          className: 'cw-wysiwyg-edition',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 40
          }
        }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_form__["Form"], {
          defaultValues: __WEBPACK_IMPORTED_MODULE_10_lodash_mapValues___default()(this.MODEL, function (m) {
            return m.defaultValue;
          }),
          onSubmit: this.triggerSubmit,
          validateError: this.triggerValidateError,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 41
          }
        }, function (formApi) {
          var touched = formApi.touched,
              errors = formApi.errors;
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('form', {
            id: 'form',
            className: 'cw-form',
            autoComplete: 'off',
            onSubmit: formApi.submitForm,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 50
            }
          }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('fieldset', {
            className: 'cw-fieldset',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 56
            }
          }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.MODEL).map(function (f) {
            var fieldClassNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, '-' + _this2.MODEL[f].type, !!_this2.MODEL[f].type));

            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
              key: _this2.MODEL[f].id,
              className: 'cw-field ' + fieldClassNames,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 63
              }
            }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('label', {
              className: 'label',
              htmlFor: _this2.MODEL[f].id,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 64
              }
            }, _this2.MODEL[f].label), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(_this2.MODEL[f].Component, {
              field: _this2.MODEL[f].id,
              id: _this2.MODEL[f].id,
              options: _this2.MODEL[f].options || {}
            }), !!touched[f] && !!errors[f] && errors[f].map(function (e, i) {
              return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
                key: i,
                className: 'error',
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 80
                }
              }, e);
            }));
          })), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
            className: 'form-actions',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 86
            }
          }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('button', {
            type: 'button',
            className: 'cw-button -primary',
            onClick: formApi.submitForm,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 87
            }
          }, 'Submit')));
        }));
      }
    }]);

    return VideoEdition;
  }(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _class.propTypes = {
    block: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    onSubmit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
  }, _class.defaultProps = {
    block: {}
  }, _temp2);
  VideoEdition.displayName = 'VideoEdition';
  /* harmony default export */

  __webpack_exports__["a"] = VideoEdition;
  /***/
},
/* 174 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(42);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(13);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11_lodash_mapValues__ = __webpack_require__(92);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_mapValues__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_12_validate_js__ = __webpack_require__(99);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_12_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_validate_js__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_13_react_form__ = __webpack_require__(46);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_13_react_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_form__);

  var _class,
      _temp2,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/Blocks/Edition/EmbedEdition.js';

  var EmbedEdition = (_temp2 = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(EmbedEdition, _React$Component);

    function EmbedEdition() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, EmbedEdition);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = EmbedEdition.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(EmbedEdition)).call.apply(_ref, [this].concat(args))), _this), _this.VALIDATIONS = __WEBPACK_IMPORTED_MODULE_11_lodash_mapValues___default()(_this.props.block.model, function (m) {
        return m.validations;
      }), _this.MODEL = _this.props.block.model, _this.triggerSubmit = function (values) {
        if (_this.props.onSubmit) _this.props.onSubmit(values);
      }, _this.triggerValidateError = function (values) {
        var errors = {};

        var errorValidations = __WEBPACK_IMPORTED_MODULE_12_validate_js___default()(values, _this.VALIDATIONS); // Map throuhg the model keys to set the errors


        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this.MODEL).map(function (k) {
          return errors[k] = errorValidations && errorValidations[k];
        });

        return errors;
      }, _temp), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(EmbedEdition, [{
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', {
          className: 'cw-wysiwyg-edition',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 40
          }
        }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_form__["Form"], {
          defaultValues: __WEBPACK_IMPORTED_MODULE_11_lodash_mapValues___default()(this.MODEL, function (m) {
            return m.defaultValue;
          }),
          onSubmit: this.triggerSubmit,
          validateError: this.triggerValidateError,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 41
          }
        }, function (formApi) {
          var touched = formApi.touched,
              errors = formApi.errors;
          return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('form', {
            id: 'form',
            className: 'cw-form',
            autoComplete: 'off',
            onSubmit: formApi.submitForm,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 50
            }
          }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('fieldset', {
            className: 'cw-fieldset',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 56
            }
          }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this2.MODEL).map(function (f) {
            var fieldClassNames = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, '-' + _this2.MODEL[f].type, !!_this2.MODEL[f].type));

            return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', {
              key: _this2.MODEL[f].id,
              className: 'cw-field ' + fieldClassNames,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 63
              }
            }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('label', {
              className: 'label',
              htmlFor: _this2.MODEL[f].id,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 64
              }
            }, _this2.MODEL[f].label), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(_this2.MODEL[f].Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              field: _this2.MODEL[f].id,
              id: _this2.MODEL[f].id,
              options: _this2.MODEL[f].options || {}
            }, _this2.MODEL[f].inputProps)), !!touched[f] && !!errors[f] && errors[f].map(function (e, i) {
              return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', {
                key: i,
                className: 'error',
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 81
                }
              }, e);
            }));
          })), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', {
            className: 'form-actions',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 87
            }
          }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('button', {
            type: 'button',
            className: 'cw-button -primary',
            onClick: formApi.submitForm,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 88
            }
          }, 'Submit')));
        }));
      }
    }]);

    return EmbedEdition;
  }(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component), _class.propTypes = {
    block: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    onSubmit: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
  }, _class.defaultProps = {
    block: {}
  }, _temp2);
  EmbedEdition.displayName = 'EmbedEdition';
  /* harmony default export */

  __webpack_exports__["a"] = EmbedEdition;
  /***/
},
/* 175 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__UI_Icon_Icon__ = __webpack_require__(34);

  var _class,
      _temp2,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/Blocks/Edition/GridEdition.js';

  var GridEdition = (_temp2 = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(GridEdition, _React$Component);

    function GridEdition() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GridEdition);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = GridEdition.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(GridEdition)).call.apply(_ref, [this].concat(args))), _this), _this.MODEL = _this.props.block.model, _this.triggerSubmit = function (columns) {
        var content = Array(columns).fill();
        if (_this.props.onSubmit) _this.props.onSubmit(content);
      }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(GridEdition, [{
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', {
          className: 'cw-wysiwyg-grid-edition',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 26
          }
        }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', {
          className: 'grid-edition-row',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 27
          }
        }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', {
          className: 'grid-edition-column',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 28
          }
        }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('button', {
          className: 'cw-button -clean -full',
          onClick: function onClick() {
            return _this2.triggerSubmit(2);
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 29
          }
        }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', {
          className: 'grid-edition-placeholder',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 33
          }
        }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', {
          className: '-small-6',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 34
          }
        }), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', {
          className: '-small-6',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 35
          }
        })))), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', {
          className: 'grid-edition-column',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 40
          }
        }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('button', {
          className: 'cw-button -clean -full',
          onClick: function onClick() {
            return _this2.triggerSubmit(3);
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 41
          }
        }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', {
          className: 'grid-edition-placeholder',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 45
          }
        }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', {
          className: '-small-4',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 46
          }
        }), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', {
          className: '-small-4',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 47
          }
        }), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', {
          className: '-small-4',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 48
          }
        }))))));
      }
    }]);

    return GridEdition;
  }(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component), _class.propTypes = {
    block: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    onSubmit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  }, _class.defaultProps = {
    block: {}
  }, _temp2);
  GridEdition.displayName = 'GridEdition';
  /* harmony default export */

  __webpack_exports__["a"] = GridEdition;
  /***/
},
/* 176 */

/***/
function (module, exports, __webpack_require__) {
  var ListCache = __webpack_require__(67),
      stackClear = __webpack_require__(419),
      stackDelete = __webpack_require__(420),
      stackGet = __webpack_require__(421),
      stackHas = __webpack_require__(422),
      stackSet = __webpack_require__(423);
  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */


  function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  } // Add methods to `Stack`.


  Stack.prototype.clear = stackClear;
  Stack.prototype['delete'] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  module.exports = Stack;
  /***/
},
/* 177 */

/***/
function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(47),
      isObject = __webpack_require__(49);
  /** `Object#toString` result references. */


  var asyncTag = '[object AsyncFunction]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      proxyTag = '[object Proxy]';
  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */

  function isFunction(value) {
    if (!isObject(value)) {
      return false;
    } // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.


    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }

  module.exports = isFunction;
  /***/
},
/* 178 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global) {
    /** Detect free variable `global` from Node.js. */
    var freeGlobal = _typeof4(global) == 'object' && global && global.Object === Object && global;
    module.exports = freeGlobal;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(33));
  /***/
},
/* 179 */

/***/
function (module, exports) {
  /** Used for built-in method references. */
  var funcProto = Function.prototype;
  /** Used to resolve the decompiled source of functions. */

  var funcToString = funcProto.toString;
  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to convert.
   * @returns {string} Returns the source code.
   */

  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}

      try {
        return func + '';
      } catch (e) {}
    }

    return '';
  }

  module.exports = toSource;
  /***/
},
/* 180 */

/***/
function (module, exports, __webpack_require__) {
  var baseIsEqualDeep = __webpack_require__(442),
      isObjectLike = __webpack_require__(50);
  /**
   * The base implementation of `_.isEqual` which supports partial comparisons
   * and tracks traversed objects.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @param {boolean} bitmask The bitmask flags.
   *  1 - Unordered comparison
   *  2 - Partial comparison
   * @param {Function} [customizer] The function to customize comparisons.
   * @param {Object} [stack] Tracks traversed `value` and `other` objects.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   */


  function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }

    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
      return value !== value && other !== other;
    }

    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
  }

  module.exports = baseIsEqual;
  /***/
},
/* 181 */

/***/
function (module, exports, __webpack_require__) {
  var SetCache = __webpack_require__(443),
      arraySome = __webpack_require__(446),
      cacheHas = __webpack_require__(447);
  /** Used to compose bitmasks for value comparisons. */


  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;
  /**
   * A specialized version of `baseIsEqualDeep` for arrays with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Array} array The array to compare.
   * @param {Array} other The other array to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `array` and `other` objects.
   * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
   */

  function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        arrLength = array.length,
        othLength = other.length;

    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    } // Assume cyclic values are equal.


    var stacked = stack.get(array);

    if (stacked && stack.get(other)) {
      return stacked == other;
    }

    var index = -1,
        result = true,
        seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
    stack.set(array, other);
    stack.set(other, array); // Ignore non-index properties.

    while (++index < arrLength) {
      var arrValue = array[index],
          othValue = other[index];

      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }

      if (compared !== undefined) {
        if (compared) {
          continue;
        }

        result = false;
        break;
      } // Recursively compare arrays (susceptible to call stack limits).


      if (seen) {
        if (!arraySome(other, function (othValue, othIndex) {
          if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result = false;
        break;
      }
    }

    stack['delete'](array);
    stack['delete'](other);
    return result;
  }

  module.exports = equalArrays;
  /***/
},
/* 182 */

/***/
function (module, exports) {
  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }

    return array;
  }

  module.exports = arrayPush;
  /***/
},
/* 183 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (module) {
    var root = __webpack_require__(20),
        stubFalse = __webpack_require__(461);
    /** Detect free variable `exports`. */


    var freeExports = _typeof4(exports) == 'object' && exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */

    var freeModule = freeExports && _typeof4(module) == 'object' && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */

    var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Built-in value references. */

    var Buffer = moduleExports ? root.Buffer : undefined;
    /* Built-in method references for those with the same name as other `lodash` methods. */

    var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */

    var isBuffer = nativeIsBuffer || stubFalse;
    module.exports = isBuffer;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(45)(module));
  /***/
},
/* 184 */

/***/
function (module, exports, __webpack_require__) {
  var baseIsTypedArray = __webpack_require__(462),
      baseUnary = __webpack_require__(185),
      nodeUtil = __webpack_require__(463);
  /* Node.js helper references. */


  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */

  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
  module.exports = isTypedArray;
  /***/
},
/* 185 */

/***/
function (module, exports) {
  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }

  module.exports = baseUnary;
  /***/
},
/* 186 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(49);
  /**
   * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` if suitable for strict
   *  equality comparisons, else `false`.
   */


  function isStrictComparable(value) {
    return value === value && !isObject(value);
  }

  module.exports = isStrictComparable;
  /***/
},
/* 187 */

/***/
function (module, exports) {
  /**
   * A specialized version of `matchesProperty` for source values suitable
   * for strict equality comparisons, i.e. `===`.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @param {*} srcValue The value to match.
   * @returns {Function} Returns the new spec function.
   */
  function matchesStrictComparable(key, srcValue) {
    return function (object) {
      if (object == null) {
        return false;
      }

      return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
  }

  module.exports = matchesStrictComparable;
  /***/
},
/* 188 */

/***/
function (module, exports, __webpack_require__) {
  var castPath = __webpack_require__(189),
      toKey = __webpack_require__(72);
  /**
   * The base implementation of `_.get` without support for default values.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @returns {*} Returns the resolved value.
   */


  function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0,
        length = path.length;

    while (object != null && index < length) {
      object = object[toKey(path[index++])];
    }

    return index && index == length ? object : undefined;
  }

  module.exports = baseGet;
  /***/
},
/* 189 */

/***/
function (module, exports, __webpack_require__) {
  var isArray = __webpack_require__(21),
      isKey = __webpack_require__(109),
      stringToPath = __webpack_require__(476),
      toString = __webpack_require__(479);
  /**
   * Casts `value` to a path array if it's not one.
   *
   * @private
   * @param {*} value The value to inspect.
   * @param {Object} [object] The object to query keys on.
   * @returns {Array} Returns the cast property path array.
   */


  function castPath(value, object) {
    if (isArray(value)) {
      return value;
    }

    return isKey(value, object) ? [value] : stringToPath(toString(value));
  }

  module.exports = castPath;
  /***/
},
/* 190 */

/***/
function (module, exports) {
  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }

    return result;
  }

  module.exports = arrayMap;
  /***/
},
/* 191 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: true
  });
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__Wysiwyg__ = __webpack_require__(192);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "default", function () {
    return __WEBPACK_IMPORTED_MODULE_0__Wysiwyg__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__Blocks_Embed__ = __webpack_require__(134);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "EmbedBlock", function () {
    return __WEBPACK_IMPORTED_MODULE_1__Blocks_Embed__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__Blocks_Grid__ = __webpack_require__(135);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GridBlock", function () {
    return __WEBPACK_IMPORTED_MODULE_2__Blocks_Grid__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__Blocks_Image__ = __webpack_require__(131);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "ImageBlock", function () {
    return __WEBPACK_IMPORTED_MODULE_3__Blocks_Image__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__Blocks_Text__ = __webpack_require__(129);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "TextBlock", function () {
    return __WEBPACK_IMPORTED_MODULE_4__Blocks_Text__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__Blocks_Video__ = __webpack_require__(132);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "VideoBlock", function () {
    return __WEBPACK_IMPORTED_MODULE_5__Blocks_Video__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__Blocks_Edition_EmbedEdition__ = __webpack_require__(174);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "EmbedEditionBlock", function () {
    return __WEBPACK_IMPORTED_MODULE_6__Blocks_Edition_EmbedEdition__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__Blocks_Edition_GridEdition__ = __webpack_require__(175);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GridEditionBlock", function () {
    return __WEBPACK_IMPORTED_MODULE_7__Blocks_Edition_GridEdition__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__Blocks_Edition_ImageEdition__ = __webpack_require__(145);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "ImageEditionBlock", function () {
    return __WEBPACK_IMPORTED_MODULE_8__Blocks_Edition_ImageEdition__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__Blocks_Edition_VideoEdition__ = __webpack_require__(173);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "VideoEditionBlock", function () {
    return __WEBPACK_IMPORTED_MODULE_9__Blocks_Edition_VideoEdition__["a"];
  }); // Blocks

  /***/

},
/* 192 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(53);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(24);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(234);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10__WysiwygProvider__ = __webpack_require__(406);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11__Content_Content__ = __webpack_require__(407);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_12__UI_Icons_Icons__ = __webpack_require__(521);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_13__UI_Backdrop_Backdrop__ = __webpack_require__(522);

  var _class,
      _temp2,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/Wysiwyg.js'; // Provider
  // Components


  var Wysiwyg = (_temp2 = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Wysiwyg, _React$Component);

    function Wysiwyg() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Wysiwyg);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Wysiwyg.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Wysiwyg)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        items: _this.props.items || [],
        blocks: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_9__constants__["a"
        /* DEFAULT_BLOCKS */
        ], _this.props.blocks),
        readOnly: _this.props.readOnly,
        editionMode: false,
        cursor: null
      }, _this.setBlocks = function (blocks) {
        _this.setState({
          blocks: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.state.blocks, blocks)
        });
      }, _this.setCursor = function (cursor) {
        _this.setState({
          cursor: cursor
        });
      }, _this.setEditionMode = function (mode) {
        _this.setState({
          editionMode: mode
        });
      }, _this.setItems = function (items) {
        _this.setState({
          items: items
        }, function () {
          _this.props.onChange && _this.props.onChange(_this.state.items);
        });
      }, _this.addItem = function (item, index) {
        var items = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.state.items));
        var cursor = index || _this.state.cursor;
        items.splice(cursor, 0, item);

        _this.setItems(items);
      }, _this.updateItem = function (item) {
        var items = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.state.items));
        var index = items.findIndex(function (i) {
          return i.id === item.id;
        });
        items[index] = item;

        _this.setItems(items);
      }, _this.removeItem = function (item) {
        var items = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.state.items));
        var index = items.findIndex(function (i) {
          return i.id === item.id;
        });
        items.splice(index, 1);

        _this.setItems(items);
      }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Wysiwyg, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.id !== this.props.id) {
          // Set items
          this.setItems(nextProps.items); // // Set blocks
          // this.setBlocks({ ...DEFAULT_BLOCKS, ...nextProps.blocks });
        }

        if (nextProps.readOnly !== this.state.readOnly) {
          this.setState({
            readOnly: nextProps.readOnly
          });
        }
      } // Blocks
      // Toolbar
      // Items

    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
          className: 'cw-wysiwyg',
          onMouseLeave: function onMouseLeave() {
            !_this2.state.editionMode && _this2.setCursor(null);
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 113
          }
        }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__UI_Icons_Icons__["a"
        /* default */
        ], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 119
          }
        }), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__WysiwygProvider__["a"
        /* default */
        ], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.state, {
          setToolbar: this.setToolbar,
          setCursor: this.setCursor,
          setEditionMode: this.setEditionMode,
          setItems: this.setItems,
          addItem: this.addItem,
          updateItem: this.updateItem,
          removeItem: this.removeItem,
          onUploadImage: this.props.onUploadImage,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 121
          }
        }), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Content_Content__["a"
        /* default */
        ], {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 132
          }
        })), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__UI_Backdrop_Backdrop__["a"
        /* default */
        ], {
          isActive: this.state.editionMode,
          onClick: function onClick() {
            return _this2.setEditionMode(false);
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 135
          }
        }));
      }
    }]);

    return Wysiwyg;
  }(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _class.propTypes = {
    /** id: Will handle re-renders */
    id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,

    /** items: Initial state of wysiwyg [Check item types](#wysiwyg-items) */
    items: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array,

    /** blocks: Different types of blocks handled by wysiwyg [Check block types](#wysiwyg-blocks) */
    blocks: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,

    /** function is called each time there is change in state of wysiwyg. */
    onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

    /** function is called each time there is an upload of an image. It must return a promise */
    onUploadImage: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

    /** bool */
    readOnly: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
  }, _class.defaultProps = {
    id: undefined,
    items: [],
    blocks: __WEBPACK_IMPORTED_MODULE_9__constants__["a"
    /* DEFAULT_BLOCKS */
    ],
    readOnly: false,
    onChange: null,
    onUploadImage: null
  }, _temp2);
  Wysiwyg.displayName = 'Wysiwyg';
  /* harmony default export */

  __webpack_exports__["a"] = Wysiwyg;
  /***/
},
/* 193 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(194),
    __esModule: true
  };
  /***/
},
/* 194 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(74);

  __webpack_require__(200);

  module.exports = __webpack_require__(7).Array.from;
  /***/
},
/* 195 */

/***/
function (module, exports, __webpack_require__) {
  var toInteger = __webpack_require__(75);

  var defined = __webpack_require__(76); // true  -> String#at
  // false -> String#codePointAt


  module.exports = function (TO_STRING) {
    return function (that, pos) {
      var s = String(defined(that));
      var i = toInteger(pos);
      var l = s.length;
      var a, b;
      if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
      a = s.charCodeAt(i);
      return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
  };
  /***/

},
/* 196 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var create = __webpack_require__(79);

  var descriptor = __webpack_require__(37);

  var setToStringTag = __webpack_require__(56);

  var IteratorPrototype = {}; // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()

  __webpack_require__(26)(IteratorPrototype, __webpack_require__(10)('iterator'), function () {
    return this;
  });

  module.exports = function (Constructor, NAME, next) {
    Constructor.prototype = create(IteratorPrototype, {
      next: descriptor(1, next)
    });
    setToStringTag(Constructor, NAME + ' Iterator');
  };
  /***/

},
/* 197 */

/***/
function (module, exports, __webpack_require__) {
  var dP = __webpack_require__(15);

  var anObject = __webpack_require__(16);

  var getKeys = __webpack_require__(39);

  module.exports = __webpack_require__(23) ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject(O);
    var keys = getKeys(Properties);
    var length = keys.length;
    var i = 0;
    var P;

    while (length > i) {
      dP.f(O, P = keys[i++], Properties[P]);
    }

    return O;
  };
  /***/
},
/* 198 */

/***/
function (module, exports, __webpack_require__) {
  // false -> Array#indexOf
  // true  -> Array#includes
  var toIObject = __webpack_require__(32);

  var toLength = __webpack_require__(80);

  var toAbsoluteIndex = __webpack_require__(199);

  module.exports = function (IS_INCLUDES) {
    return function ($this, el, fromIndex) {
      var O = toIObject($this);
      var length = toLength(O.length);
      var index = toAbsoluteIndex(fromIndex, length);
      var value; // Array#includes uses SameValueZero equality algorithm
      // eslint-disable-next-line no-self-compare

      if (IS_INCLUDES && el != el) while (length > index) {
        value = O[index++]; // eslint-disable-next-line no-self-compare

        if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
      } else for (; length > index; index++) {
        if (IS_INCLUDES || index in O) {
          if (O[index] === el) return IS_INCLUDES || index || 0;
        }
      }
      return !IS_INCLUDES && -1;
    };
  };
  /***/

},
/* 199 */

/***/
function (module, exports, __webpack_require__) {
  var toInteger = __webpack_require__(75);

  var max = Math.max;
  var min = Math.min;

  module.exports = function (index, length) {
    index = toInteger(index);
    return index < 0 ? max(index + length, 0) : min(index, length);
  };
  /***/

},
/* 200 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ctx = __webpack_require__(30);

  var $export = __webpack_require__(11);

  var toObject = __webpack_require__(41);

  var call = __webpack_require__(117);

  var isArrayIter = __webpack_require__(118);

  var toLength = __webpack_require__(80);

  var createProperty = __webpack_require__(201);

  var getIterFn = __webpack_require__(119);

  $export($export.S + $export.F * !__webpack_require__(121)(function (iter) {
    Array.from(iter);
  }), 'Array', {
    // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
    from: function from(arrayLike
    /* , mapfn = undefined, thisArg = undefined */
    ) {
      var O = toObject(arrayLike);
      var C = typeof this == 'function' ? this : Array;
      var aLen = arguments.length;
      var mapfn = aLen > 1 ? arguments[1] : undefined;
      var mapping = mapfn !== undefined;
      var index = 0;
      var iterFn = getIterFn(O);
      var length, result, step, iterator;
      if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2); // if object isn't iterable or it's array with default iterator - use simple case

      if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
        for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
          createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
        }
      } else {
        length = toLength(O.length);

        for (result = new C(length); length > index; index++) {
          createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
        }
      }

      result.length = index;
      return result;
    }
  });
  /***/
},
/* 201 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $defineProperty = __webpack_require__(15);

  var createDesc = __webpack_require__(37);

  module.exports = function (object, index, value) {
    if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
  };
  /***/

},
/* 202 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(203);

  module.exports = __webpack_require__(7).Object.assign;
  /***/
},
/* 203 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.3.1 Object.assign(target, source)
  var $export = __webpack_require__(11);

  $export($export.S + $export.F, 'Object', {
    assign: __webpack_require__(204)
  });
  /***/
},
/* 204 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 19.1.2.1 Object.assign(target, source, ...)

  var getKeys = __webpack_require__(39);

  var gOPS = __webpack_require__(84);

  var pIE = __webpack_require__(57);

  var toObject = __webpack_require__(41);

  var IObject = __webpack_require__(114);

  var $assign = Object.assign; // should work with symbols and should have deterministic property order (V8 bug)

  module.exports = !$assign || __webpack_require__(31)(function () {
    var A = {};
    var B = {}; // eslint-disable-next-line no-undef

    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function (k) {
      B[k] = k;
    });
    return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
  }) ? function assign(target, source) {
    // eslint-disable-line no-unused-vars
    var T = toObject(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = gOPS.f;
    var isEnum = pIE.f;

    while (aLen > index) {
      var S = IObject(arguments[index++]);
      var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
      var length = keys.length;
      var j = 0;
      var key;

      while (length > j) {
        if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
      }
    }

    return T;
  } : $assign;
  /***/
},
/* 205 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(206);

  module.exports = __webpack_require__(7).Object.getPrototypeOf;
  /***/
},
/* 206 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.9 Object.getPrototypeOf(O)
  var toObject = __webpack_require__(41);

  var $getPrototypeOf = __webpack_require__(116);

  __webpack_require__(123)('getPrototypeOf', function () {
    return function getPrototypeOf(it) {
      return $getPrototypeOf(toObject(it));
    };
  });
  /***/

},
/* 207 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(208);

  var $Object = __webpack_require__(7).Object;

  module.exports = function defineProperty(it, key, desc) {
    return $Object.defineProperty(it, key, desc);
  };
  /***/

},
/* 208 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(11); // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)


  $export($export.S + $export.F * !__webpack_require__(23), 'Object', {
    defineProperty: __webpack_require__(15).f
  });
  /***/
},
/* 209 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(210),
    __esModule: true
  };
  /***/
},
/* 210 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(74);

  __webpack_require__(125);

  module.exports = __webpack_require__(86).f('iterator');
  /***/
},
/* 211 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var addToUnscopables = __webpack_require__(212);

  var step = __webpack_require__(213);

  var Iterators = __webpack_require__(38);

  var toIObject = __webpack_require__(32); // 22.1.3.4 Array.prototype.entries()
  // 22.1.3.13 Array.prototype.keys()
  // 22.1.3.29 Array.prototype.values()
  // 22.1.3.30 Array.prototype[@@iterator]()


  module.exports = __webpack_require__(110)(Array, 'Array', function (iterated, kind) {
    this._t = toIObject(iterated); // target

    this._i = 0; // next index

    this._k = kind; // kind
    // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
  }, function () {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;

    if (!O || index >= O.length) {
      this._t = undefined;
      return step(1);
    }

    if (kind == 'keys') return step(0, index);
    if (kind == 'values') return step(0, O[index]);
    return step(0, [index, O[index]]);
  }, 'values'); // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)

  Iterators.Arguments = Iterators.Array;
  addToUnscopables('keys');
  addToUnscopables('values');
  addToUnscopables('entries');
  /***/
},
/* 212 */

/***/
function (module, exports) {
  module.exports = function () {
    /* empty */
  };
  /***/

},
/* 213 */

/***/
function (module, exports) {
  module.exports = function (done, value) {
    return {
      value: value,
      done: !!done
    };
  };
  /***/

},
/* 214 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(215),
    __esModule: true
  };
  /***/
},
/* 215 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(216);

  __webpack_require__(128);

  __webpack_require__(221);

  __webpack_require__(222);

  module.exports = __webpack_require__(7).Symbol;
  /***/
},
/* 216 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // ECMAScript 6 symbols shim

  var global = __webpack_require__(9);

  var has = __webpack_require__(27);

  var DESCRIPTORS = __webpack_require__(23);

  var $export = __webpack_require__(11);

  var redefine = __webpack_require__(112);

  var META = __webpack_require__(217).KEY;

  var $fails = __webpack_require__(31);

  var shared = __webpack_require__(82);

  var setToStringTag = __webpack_require__(56);

  var uid = __webpack_require__(55);

  var wks = __webpack_require__(10);

  var wksExt = __webpack_require__(86);

  var wksDefine = __webpack_require__(87);

  var enumKeys = __webpack_require__(218);

  var isArray = __webpack_require__(219);

  var anObject = __webpack_require__(16);

  var isObject = __webpack_require__(22);

  var toIObject = __webpack_require__(32);

  var toPrimitive = __webpack_require__(78);

  var createDesc = __webpack_require__(37);

  var _create = __webpack_require__(79);

  var gOPNExt = __webpack_require__(220);

  var $GOPD = __webpack_require__(127);

  var $DP = __webpack_require__(15);

  var $keys = __webpack_require__(39);

  var gOPD = $GOPD.f;
  var dP = $DP.f;
  var gOPN = gOPNExt.f;
  var $Symbol = global.Symbol;
  var $JSON = global.JSON;

  var _stringify = $JSON && $JSON.stringify;

  var PROTOTYPE = 'prototype';
  var HIDDEN = wks('_hidden');
  var TO_PRIMITIVE = wks('toPrimitive');
  var isEnum = {}.propertyIsEnumerable;
  var SymbolRegistry = shared('symbol-registry');
  var AllSymbols = shared('symbols');
  var OPSymbols = shared('op-symbols');
  var ObjectProto = Object[PROTOTYPE];
  var USE_NATIVE = typeof $Symbol == 'function';
  var QObject = global.QObject; // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

  var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

  var setSymbolDesc = DESCRIPTORS && $fails(function () {
    return _create(dP({}, 'a', {
      get: function get() {
        return dP(this, 'a', {
          value: 7
        }).a;
      }
    })).a != 7;
  }) ? function (it, key, D) {
    var protoDesc = gOPD(ObjectProto, key);
    if (protoDesc) delete ObjectProto[key];
    dP(it, key, D);
    if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
  } : dP;

  var wrap = function wrap(tag) {
    var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);

    sym._k = tag;
    return sym;
  };

  var isSymbol = USE_NATIVE && _typeof4($Symbol.iterator) == 'symbol' ? function (it) {
    return _typeof4(it) == 'symbol';
  } : function (it) {
    return it instanceof $Symbol;
  };

  var $defineProperty = function defineProperty(it, key, D) {
    if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
    anObject(it);
    key = toPrimitive(key, true);
    anObject(D);

    if (has(AllSymbols, key)) {
      if (!D.enumerable) {
        if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
        it[HIDDEN][key] = true;
      } else {
        if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
        D = _create(D, {
          enumerable: createDesc(0, false)
        });
      }

      return setSymbolDesc(it, key, D);
    }

    return dP(it, key, D);
  };

  var $defineProperties = function defineProperties(it, P) {
    anObject(it);
    var keys = enumKeys(P = toIObject(P));
    var i = 0;
    var l = keys.length;
    var key;

    while (l > i) {
      $defineProperty(it, key = keys[i++], P[key]);
    }

    return it;
  };

  var $create = function create(it, P) {
    return P === undefined ? _create(it) : $defineProperties(_create(it), P);
  };

  var $propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = isEnum.call(this, key = toPrimitive(key, true));
    if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
    return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
  };

  var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = toIObject(it);
    key = toPrimitive(key, true);
    if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
    var D = gOPD(it, key);
    if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
    return D;
  };

  var $getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = gOPN(toIObject(it));
    var result = [];
    var i = 0;
    var key;

    while (names.length > i) {
      if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
    }

    return result;
  };

  var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === ObjectProto;
    var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
    var result = [];
    var i = 0;
    var key;

    while (names.length > i) {
      if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
    }

    return result;
  }; // 19.4.1.1 Symbol([description])


  if (!USE_NATIVE) {
    $Symbol = function _Symbol7() {
      if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
      var tag = uid(arguments.length > 0 ? arguments[0] : undefined);

      var $set = function $set(value) {
        if (this === ObjectProto) $set.call(OPSymbols, value);
        if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
        setSymbolDesc(this, tag, createDesc(1, value));
      };

      if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
        configurable: true,
        set: $set
      });
      return wrap(tag);
    };

    redefine($Symbol[PROTOTYPE], 'toString', function toString() {
      return this._k;
    });
    $GOPD.f = $getOwnPropertyDescriptor;
    $DP.f = $defineProperty;
    __webpack_require__(126).f = gOPNExt.f = $getOwnPropertyNames;
    __webpack_require__(57).f = $propertyIsEnumerable;
    __webpack_require__(84).f = $getOwnPropertySymbols;

    if (DESCRIPTORS && !__webpack_require__(36)) {
      redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
    }

    wksExt.f = function (name) {
      return wrap(wks(name));
    };
  }

  $export($export.G + $export.W + $export.F * !USE_NATIVE, {
    Symbol: $Symbol
  });

  for (var es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
    wks(es6Symbols[j++]);
  }

  for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
    wksDefine(wellKnownSymbols[k++]);
  }

  $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function _for(key) {
      return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
      if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');

      for (var key in SymbolRegistry) {
        if (SymbolRegistry[key] === sym) return key;
      }
    },
    useSetter: function useSetter() {
      setter = true;
    },
    useSimple: function useSimple() {
      setter = false;
    }
  });
  $export($export.S + $export.F * !USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $getOwnPropertySymbols
  }); // 24.3.2 JSON.stringify(value [, replacer [, space]])

  $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
    var S = $Symbol(); // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols

    return _stringify([S]) != '[null]' || _stringify({
      a: S
    }) != '{}' || _stringify(Object(S)) != '{}';
  })), 'JSON', {
    stringify: function stringify(it) {
      var args = [it];
      var i = 1;
      var replacer, $replacer;

      while (arguments.length > i) {
        args.push(arguments[i++]);
      }

      $replacer = replacer = args[1];
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

      if (!isArray(replacer)) replacer = function replacer(key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return _stringify.apply($JSON, args);
    }
  }); // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)

  $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(26)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf); // 19.4.3.5 Symbol.prototype[@@toStringTag]

  setToStringTag($Symbol, 'Symbol'); // 20.2.1.9 Math[@@toStringTag]

  setToStringTag(Math, 'Math', true); // 24.3.3 JSON[@@toStringTag]

  setToStringTag(global.JSON, 'JSON', true);
  /***/
},
/* 217 */

/***/
function (module, exports, __webpack_require__) {
  var META = __webpack_require__(55)('meta');

  var isObject = __webpack_require__(22);

  var has = __webpack_require__(27);

  var setDesc = __webpack_require__(15).f;

  var id = 0;

  var isExtensible = Object.isExtensible || function () {
    return true;
  };

  var FREEZE = !__webpack_require__(31)(function () {
    return isExtensible(Object.preventExtensions({}));
  });

  var setMeta = function setMeta(it) {
    setDesc(it, META, {
      value: {
        i: 'O' + ++id,
        // object ID
        w: {} // weak collections IDs

      }
    });
  };

  var fastKey = function fastKey(it, create) {
    // return primitive with prefix
    if (!isObject(it)) return _typeof4(it) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

    if (!has(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return 'F'; // not necessary to add metadata

      if (!create) return 'E'; // add missing metadata

      setMeta(it); // return object ID
    }

    return it[META].i;
  };

  var getWeak = function getWeak(it, create) {
    if (!has(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return true; // not necessary to add metadata

      if (!create) return false; // add missing metadata

      setMeta(it); // return hash weak collections IDs
    }

    return it[META].w;
  }; // add metadata on freeze-family methods calling


  var onFreeze = function onFreeze(it) {
    if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
    return it;
  };

  var meta = module.exports = {
    KEY: META,
    NEED: false,
    fastKey: fastKey,
    getWeak: getWeak,
    onFreeze: onFreeze
  };
  /***/
},
/* 218 */

/***/
function (module, exports, __webpack_require__) {
  // all enumerable object keys, includes symbols
  var getKeys = __webpack_require__(39);

  var gOPS = __webpack_require__(84);

  var pIE = __webpack_require__(57);

  module.exports = function (it) {
    var result = getKeys(it);
    var getSymbols = gOPS.f;

    if (getSymbols) {
      var symbols = getSymbols(it);
      var isEnum = pIE.f;
      var i = 0;
      var key;

      while (symbols.length > i) {
        if (isEnum.call(it, key = symbols[i++])) result.push(key);
      }
    }

    return result;
  };
  /***/

},
/* 219 */

/***/
function (module, exports, __webpack_require__) {
  // 7.2.2 IsArray(argument)
  var cof = __webpack_require__(40);

  module.exports = Array.isArray || function isArray(arg) {
    return cof(arg) == 'Array';
  };
  /***/

},
/* 220 */

/***/
function (module, exports, __webpack_require__) {
  // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
  var toIObject = __webpack_require__(32);

  var gOPN = __webpack_require__(126).f;

  var toString = {}.toString;
  var windowNames = (typeof window === "undefined" ? "undefined" : _typeof4(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

  var getWindowNames = function getWindowNames(it) {
    try {
      return gOPN(it);
    } catch (e) {
      return windowNames.slice();
    }
  };

  module.exports.f = function getOwnPropertyNames(it) {
    return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
  };
  /***/

},
/* 221 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(87)('asyncIterator');
  /***/

},
/* 222 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(87)('observable');
  /***/

},
/* 223 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(224),
    __esModule: true
  };
  /***/
},
/* 224 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(225);

  module.exports = __webpack_require__(7).Object.setPrototypeOf;
  /***/
},
/* 225 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.3.19 Object.setPrototypeOf(O, proto)
  var $export = __webpack_require__(11);

  $export($export.S, 'Object', {
    setPrototypeOf: __webpack_require__(226).set
  });
  /***/
},
/* 226 */

/***/
function (module, exports, __webpack_require__) {
  // Works with __proto__ only. Old v8 can't work with null proto objects.

  /* eslint-disable no-proto */
  var isObject = __webpack_require__(22);

  var anObject = __webpack_require__(16);

  var check = function check(O, proto) {
    anObject(O);
    if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
  };

  module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(30)(Function.call, __webpack_require__(127).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) {
        buggy = true;
      }

      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
    check: check
  };
  /***/
},
/* 227 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(228),
    __esModule: true
  };
  /***/
},
/* 228 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(229);

  var $Object = __webpack_require__(7).Object;

  module.exports = function create(P, D) {
    return $Object.create(P, D);
  };
  /***/

},
/* 229 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(11); // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])


  $export($export.S, 'Object', {
    create: __webpack_require__(79)
  });
  /***/
},
/* 230 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    var assign = __webpack_require__(231);

    var ReactPropTypesSecret = __webpack_require__(88);

    var checkPropTypes = __webpack_require__(232);

    var printWarning = function printWarning() {};

    if (process.env.NODE_ENV !== 'production') {
      printWarning = function printWarning(text) {
        var message = 'Warning: ' + text;

        if (typeof console !== 'undefined') {
          console.error(message);
        }

        try {
          // --- Welcome to debugging React ---
          // This error was thrown as a convenience so that you can use this stack
          // to find the callsite that caused this warning to fire.
          throw new Error(message);
        } catch (x) {}
      };
    }

    function emptyFunctionThatReturnsNull() {
      return null;
    }

    module.exports = function (isValidElement, throwOnDirectAccess) {
      /* global Symbol */
      var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

      /**
       * Returns the iterator method function contained on the iterable object.
       *
       * Be sure to invoke the function with the iterable as context:
       *
       *     var iteratorFn = getIteratorFn(myIterable);
       *     if (iteratorFn) {
       *       var iterator = iteratorFn.call(myIterable);
       *       ...
       *     }
       *
       * @param {?object} maybeIterable
       * @return {?function}
       */

      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

        if (typeof iteratorFn === 'function') {
          return iteratorFn;
        }
      }
      /**
       * Collection of methods that allow declaration and validation of props that are
       * supplied to React components. Example usage:
       *
       *   var Props = require('ReactPropTypes');
       *   var MyArticle = React.createClass({
       *     propTypes: {
       *       // An optional string prop named "description".
       *       description: Props.string,
       *
       *       // A required enum prop named "category".
       *       category: Props.oneOf(['News','Photos']).isRequired,
       *
       *       // A prop named "dialog" that requires an instance of Dialog.
       *       dialog: Props.instanceOf(Dialog).isRequired
       *     },
       *     render: function() { ... }
       *   });
       *
       * A more formal specification of how these methods are used:
       *
       *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
       *   decl := ReactPropTypes.{type}(.isRequired)?
       *
       * Each and every declaration produces a function with the same signature. This
       * allows the creation of custom validation functions. For example:
       *
       *  var MyLink = React.createClass({
       *    propTypes: {
       *      // An optional string or URI prop named "href".
       *      href: function(props, propName, componentName) {
       *        var propValue = props[propName];
       *        if (propValue != null && typeof propValue !== 'string' &&
       *            !(propValue instanceof URI)) {
       *          return new Error(
       *            'Expected a string or an URI for ' + propName + ' in ' +
       *            componentName
       *          );
       *        }
       *      }
       *    },
       *    render: function() {...}
       *  });
       *
       * @internal
       */


      var ANONYMOUS = '<<anonymous>>'; // Important!
      // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

      var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      /**
       * inlined Object.is polyfill to avoid requiring consumers ship their own
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
       */

      /*eslint-disable no-self-compare*/

      function is(x, y) {
        // SameValue algorithm
        if (x === y) {
          // Steps 1-5, 7-10
          // Steps 6.b-6.e: +0 != -0
          return x !== 0 || 1 / x === 1 / y;
        } else {
          // Step 6.a: NaN == NaN
          return x !== x && y !== y;
        }
      }
      /*eslint-enable no-self-compare*/

      /**
       * We use an Error-like object for backward compatibility as people may call
       * PropTypes directly and inspect their output. However, we don't use real
       * Errors anymore. We don't inspect their stack anyway, and creating them
       * is prohibitively expensive if they are created too often, such as what
       * happens in oneOfType() for any type before the one that matched.
       */


      function PropTypeError(message) {
        this.message = message;
        this.stack = '';
      } // Make `instanceof Error` still work for returned errors.


      PropTypeError.prototype = Error.prototype;

      function createChainableTypeChecker(validate) {
        if (process.env.NODE_ENV !== 'production') {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }

        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;

          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              // New behavior only for users of `prop-types` package
              var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
              err.name = 'Invariant Violation';
              throw err;
            } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
              // Old behavior for people using React.PropTypes
              var cacheKey = componentName + ':' + propName;

              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }

          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
              }

              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
            }

            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }

        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }

      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== expectedType) {
            // `propValue` being instance of, say, date/regexp, pass the 'object'
            // check, but we can offer a more precise error message here rather than
            // 'of type `object`'.
            var preciseType = getPreciseType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }

      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== 'function') {
            return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
          }

          var propValue = props[propName];

          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
          }

          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);

            if (error instanceof Error) {
              return error;
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];

          if (!isValidElement(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
          return emptyFunctionThatReturnsNull;
        }

        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];

          for (var i = 0; i < expectedValues.length; i++) {
            if (is(propValue, expectedValues[i])) {
              return null;
            }
          }

          var valuesString = JSON.stringify(expectedValues);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }

        return createChainableTypeChecker(validate);
      }

      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== 'function') {
            return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
          }

          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
          }

          for (var key in propValue) {
            if (propValue.hasOwnProperty(key)) {
              var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

              if (error instanceof Error) {
                return error;
              }
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
          return emptyFunctionThatReturnsNull;
        }

        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];

          if (typeof checker !== 'function') {
            printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
            return emptyFunctionThatReturnsNull;
          }
        }

        function validate(props, propName, componentName, location, propFullName) {
          for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
            var checker = arrayOfTypeCheckers[i];

            if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
              return null;
            }
          }

          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
        }

        return createChainableTypeChecker(validate);
      }

      function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
          }

          for (var key in shapeTypes) {
            var checker = shapeTypes[key];

            if (!checker) {
              continue;
            }

            var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

            if (error) {
              return error;
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
          } // We need to check all keys in case some are required but missing from
          // props.


          var allKeys = assign({}, props[propName], shapeTypes);

          for (var key in allKeys) {
            var checker = shapeTypes[key];

            if (!checker) {
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
            }

            var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

            if (error) {
              return error;
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function isNode(propValue) {
        switch (_typeof4(propValue)) {
          case 'number':
          case 'string':
          case 'undefined':
            return true;

          case 'boolean':
            return !propValue;

          case 'object':
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }

            if (propValue === null || isValidElement(propValue)) {
              return true;
            }

            var iteratorFn = getIteratorFn(propValue);

            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;

              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                // Iterator will provide entry [k,v] tuples rather than values.
                while (!(step = iterator.next()).done) {
                  var entry = step.value;

                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }

            return true;

          default:
            return false;
        }
      }

      function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') {
          return true;
        } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


        if (propValue['@@toStringTag'] === 'Symbol') {
          return true;
        } // Fallback for non-spec compliant Symbols which are polyfilled.


        if (typeof Symbol === 'function' && propValue instanceof Symbol) {
          return true;
        }

        return false;
      } // Equivalent of `typeof` but with special handling for array and regexp.


      function getPropType(propValue) {
        var propType = _typeof4(propValue);

        if (Array.isArray(propValue)) {
          return 'array';
        }

        if (propValue instanceof RegExp) {
          // Old webkits (at least until Android 4.0) return 'function' rather than
          // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
          // passes PropTypes.object.
          return 'object';
        }

        if (isSymbol(propType, propValue)) {
          return 'symbol';
        }

        return propType;
      } // This handles more types than `getPropType`. Only used for error messages.
      // See `createPrimitiveTypeChecker`.


      function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) {
          return '' + propValue;
        }

        var propType = getPropType(propValue);

        if (propType === 'object') {
          if (propValue instanceof Date) {
            return 'date';
          } else if (propValue instanceof RegExp) {
            return 'regexp';
          }
        }

        return propType;
      } // Returns a string that is postfixed to a warning about an invalid type.
      // For example, "undefined" or "of type array"


      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);

        switch (type) {
          case 'array':
          case 'object':
            return 'an ' + type;

          case 'boolean':
          case 'date':
          case 'regexp':
            return 'a ' + type;

          default:
            return type;
        }
      } // Returns class name of the object, if any.


      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }

        return propValue.constructor.name;
      }

      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(8));
  /***/
},
/* 231 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  /* eslint-disable no-unused-vars */

  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;

  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }

    return Object(val);
  }

  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      } // Detect buggy property enumeration order in older V8 versions.
      // https://bugs.chromium.org/p/v8/issues/detail?id=4118


      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

      test1[5] = 'de';

      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test2 = {};

      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }

      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });

      if (order2.join('') !== '0123456789') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });

      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }

      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }

  module.exports = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;

    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);

      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }

      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);

        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }

    return to;
  };
  /***/
},
/* 232 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    var printWarning = function printWarning() {};

    if (process.env.NODE_ENV !== 'production') {
      var ReactPropTypesSecret = __webpack_require__(88);

      var loggedTypeFailures = {};

      printWarning = function printWarning(text) {
        var message = 'Warning: ' + text;

        if (typeof console !== 'undefined') {
          console.error(message);
        }

        try {
          // --- Welcome to debugging React ---
          // This error was thrown as a convenience so that you can use this stack
          // to find the callsite that caused this warning to fire.
          throw new Error(message);
        } catch (x) {}
      };
    }
    /**
     * Assert that the values match with the type specs.
     * Error messages are memorized and will only be shown once.
     *
     * @param {object} typeSpecs Map of name to a ReactPropType
     * @param {object} values Runtime values that need to be type-checked
     * @param {string} location e.g. "prop", "context", "child context"
     * @param {string} componentName Name of the component for error messages.
     * @param {?Function} getStack Returns the component stack.
     * @private
     */


    function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
      if (process.env.NODE_ENV !== 'production') {
        for (var typeSpecName in typeSpecs) {
          if (typeSpecs.hasOwnProperty(typeSpecName)) {
            var error; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.

            try {
              // This is intentionally an invariant that gets caught. It's the same
              // behavior as without this statement except with a better message.
              if (typeof typeSpecs[typeSpecName] !== 'function') {
                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + _typeof4(typeSpecs[typeSpecName]) + '`.');
                err.name = 'Invariant Violation';
                throw err;
              }

              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }

            if (error && !(error instanceof Error)) {
              printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + _typeof4(error) + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
            }

            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              // Only monitor this failure once because there tends to be a lot of the
              // same error.
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : '';
              printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
            }
          }
        }
      }
    }

    module.exports = checkPropTypes;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(8));
  /***/
},
/* 233 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret = __webpack_require__(88);

  function emptyFunction() {}

  module.exports = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        // It is still safe when called from React.
        return;
      }

      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }

    ;
    shim.isRequired = shim;

    function getShim() {
      return shim;
    }

    ; // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

    var ReactPropTypes = {
      array: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim
    };
    ReactPropTypes.checkPropTypes = emptyFunction;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  /***/

},
/* 234 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return DEFAULT_BLOCKS;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__Blocks_Text__ = __webpack_require__(129);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__Blocks_Image__ = __webpack_require__(131);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__Blocks_Video__ = __webpack_require__(132);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__Blocks_Embed__ = __webpack_require__(134);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__Blocks_Grid__ = __webpack_require__(135);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__Blocks_Edition_ImageEdition__ = __webpack_require__(145);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__Blocks_Edition_VideoEdition__ = __webpack_require__(173);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__Blocks_Edition_EmbedEdition__ = __webpack_require__(174);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__Blocks_Edition_GridEdition__ = __webpack_require__(175);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_react_form__ = __webpack_require__(46);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_react_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_form__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10__Form__ = __webpack_require__(399); // Visual Blocks
  // Edition Blocks
  // Form


  var DEFAULT_BLOCKS = {
    text: {
      Component: __WEBPACK_IMPORTED_MODULE_0__Blocks_Text__["a"
      /* default */
      ],
      // Placeholder
      placeholder: 'Type your text',
      theme: 'bubble',
      modules: {
        toolbar: [[{
          header: [1, 2, false]
        }], ['bold', 'italic', 'underline'], [{
          list: 'ordered'
        }, {
          list: 'bullet'
        }], ['link']]
      }
    },
    image: {
      Component: __WEBPACK_IMPORTED_MODULE_1__Blocks_Image__["a"
      /* default */
      ],
      EditionComponent: __WEBPACK_IMPORTED_MODULE_5__Blocks_Edition_ImageEdition__["a"
      /* default */
      ],
      renderer: 'tooltip',
      model: {
        src: {
          Component: __WEBPACK_IMPORTED_MODULE_10__Form__["a"
          /* File */
          ],
          id: 'src',
          label: 'Src',
          validations: {
            presence: {
              allowEmpty: false
            },
            url: true
          },
          options: {
            // https://react-dropzone.netlify.com/#proptypes
            multiple: false,
            disableClick: true,
            disablePreview: true,
            maxSize: 1000000,
            accept: ['image/jpeg', 'image/png', 'image/gif']
          }
        },
        alt: {
          Component: __WEBPACK_IMPORTED_MODULE_9_react_form__["Text"],
          id: 'alt',
          label: 'Alt',
          validations: {
            presence: {
              allowEmpty: false
            }
          }
        }
      },
      options: {}
    },
    video: {
      Component: __WEBPACK_IMPORTED_MODULE_2__Blocks_Video__["a"
      /* default */
      ],
      EditionComponent: __WEBPACK_IMPORTED_MODULE_6__Blocks_Edition_VideoEdition__["a"
      /* default */
      ],
      renderer: 'tooltip',
      model: {
        url: {
          Component: __WEBPACK_IMPORTED_MODULE_9_react_form__["Text"],
          id: 'url',
          label: 'Url',
          validations: {
            presence: {
              allowEmpty: false
            },
            url: true
          }
        }
      },
      // react player props
      // https://github.com/CookPete/react-player#props
      options: {
        controls: true,
        width: '100%'
      }
    },
    embed: {
      Component: __WEBPACK_IMPORTED_MODULE_3__Blocks_Embed__["a"
      /* default */
      ],
      EditionComponent: __WEBPACK_IMPORTED_MODULE_7__Blocks_Edition_EmbedEdition__["a"
      /* default */
      ],
      renderer: 'tooltip',
      model: {
        src: {
          Component: __WEBPACK_IMPORTED_MODULE_9_react_form__["Text"],
          id: 'src',
          label: 'Src',
          validations: {
            presence: {
              allowEmpty: false
            },
            url: true
          }
        },
        height: {
          Component: __WEBPACK_IMPORTED_MODULE_9_react_form__["Text"],
          id: 'height',
          label: 'Height',
          defaultValue: 400,
          inputProps: {
            min: 300,
            type: 'number'
          },
          validations: {
            presence: {
              allowEmpty: false
            }
          }
        }
      },
      options: {}
    },
    grid: {
      Component: __WEBPACK_IMPORTED_MODULE_4__Blocks_Grid__["a"
      /* default */
      ],
      EditionComponent: __WEBPACK_IMPORTED_MODULE_8__Blocks_Edition_GridEdition__["a"
      /* default */
      ],
      renderer: 'tooltip',
      model: {// columns: {
        //   type: 'select',
        //   id: 'columns',
        //   label: 'Columns',
        //   defaultValue: 2,
        //   options: [
        //     { label: 2, value: 2 },
        //     { label: 3, value: 3 }
        //   ],
        //   validations: {
        //     presence: { allowEmpty: false }
        //   }
        // }
      },
      options: {}
    }
  };
  /***/
},
/* 235 */

/***/
function (module, exports, __webpack_require__) {
  var core = __webpack_require__(7);

  var $JSON = core.JSON || (core.JSON = {
    stringify: JSON.stringify
  });

  module.exports = function stringify(it) {
    // eslint-disable-line no-unused-vars
    return $JSON.stringify.apply($JSON, arguments);
  };
  /***/

},
/* 236 */

/***/
function (module, exports) {
  module.exports = require("react-quill");
  /***/
},
/* 237 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  var _props2 = __webpack_require__(89);

  var _utils = __webpack_require__(12);

  var _YouTube = __webpack_require__(240);

  var _YouTube2 = _interopRequireDefault(_YouTube);

  var _SoundCloud = __webpack_require__(241);

  var _SoundCloud2 = _interopRequireDefault(_SoundCloud);

  var _Vimeo = __webpack_require__(242);

  var _Vimeo2 = _interopRequireDefault(_Vimeo);

  var _Facebook = __webpack_require__(243);

  var _Facebook2 = _interopRequireDefault(_Facebook);

  var _FilePlayer = __webpack_require__(133);

  var _FilePlayer2 = _interopRequireDefault(_FilePlayer);

  var _Streamable = __webpack_require__(244);

  var _Streamable2 = _interopRequireDefault(_Streamable);

  var _Vidme = __webpack_require__(245);

  var _Vidme2 = _interopRequireDefault(_Vidme);

  var _Wistia = __webpack_require__(246);

  var _Wistia2 = _interopRequireDefault(_Wistia);

  var _DailyMotion = __webpack_require__(247);

  var _DailyMotion2 = _interopRequireDefault(_DailyMotion);

  var _Twitch = __webpack_require__(248);

  var _Twitch2 = _interopRequireDefault(_Twitch);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SUPPORTED_PROPS = Object.keys(_props2.propTypes);
  var SUPPORTED_PLAYERS = [_YouTube2['default'], _SoundCloud2['default'], _Vimeo2['default'], _Facebook2['default'], _Streamable2['default'], _Vidme2['default'], _Wistia2['default'], _Twitch2['default'], _DailyMotion2['default']];

  var ReactPlayer = function (_Component) {
    _inherits(ReactPlayer, _Component);

    function ReactPlayer() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ReactPlayer);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPlayer.__proto__ || Object.getPrototypeOf(ReactPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.config = (0, _utils.getConfig)(_this.props, _props2.defaultProps, true), _this.seekTo = function (fraction) {
        if (!_this.player) return null;

        _this.player.seekTo(fraction);
      }, _this.getDuration = function () {
        if (!_this.player) return null;
        return _this.player.getDuration();
      }, _this.getCurrentTime = function () {
        if (!_this.player) return null;
        return _this.player.getCurrentTime();
      }, _this.getInternalPlayer = function () {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
        if (!_this.player) return null;
        return _this.player[key];
      }, _this.progress = function () {
        if (_this.props.url && _this.player && _this.player.isReady) {
          var playedSeconds = _this.player.getCurrentTime() || 0;

          var loadedSeconds = _this.player.getSecondsLoaded();

          var duration = _this.player.getDuration();

          if (duration) {
            var progress = {
              playedSeconds: playedSeconds,
              played: playedSeconds / duration
            };

            if (loadedSeconds !== null) {
              progress.loadedSeconds = loadedSeconds;
              progress.loaded = loadedSeconds / duration;
            } // Only call onProgress if values have changed


            if (progress.played !== _this.prevPlayed || progress.loaded !== _this.prevLoaded) {
              _this.props.onProgress(progress);
            }

            _this.prevPlayed = progress.played;
            _this.prevLoaded = progress.loaded;
          }
        }

        _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency);
      }, _this.renderPlayer = function (Player) {
        return _react2['default'].createElement(Player, _extends({}, _this.props, {
          ref: _this.activePlayerRef,
          key: Player.displayName,
          config: _this.config
        }));
      }, _this.activePlayerRef = function (player) {
        _this.player = player;
      }, _this.wrapperRef = function (wrapper) {
        _this.wrapper = wrapper;
      }, _this.renderPreloadPlayer = function (Player) {
        return _react2['default'].createElement(Player, {
          key: Player.displayName,
          config: _this.config
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ReactPlayer, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.progress();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        clearTimeout(this.progressTimeout);
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return this.props.url !== nextProps.url || this.props.playing !== nextProps.playing || this.props.volume !== nextProps.volume || this.props.muted !== nextProps.muted || this.props.playbackRate !== nextProps.playbackRate || this.props.height !== nextProps.height || this.props.width !== nextProps.width || this.props.hidden !== nextProps.hidden;
      }
    }, {
      key: 'renderActivePlayer',
      value: function renderActivePlayer(url) {
        if (!url) return null;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = SUPPORTED_PLAYERS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var Player = _step.value;

            if (Player.canPlay(url)) {
              return this.renderPlayer(Player);
            }
          } // Fall back to FilePlayer if nothing else can play the URL

        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator['return']) {
              _iterator['return']();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return this.renderPlayer(_FilePlayer2['default']);
      }
    }, {
      key: 'renderPreloadPlayers',
      value: function renderPreloadPlayers(url) {
        // Render additional players if preload config is set
        var preloadPlayers = [];

        if (!_YouTube2['default'].canPlay(url) && this.config.youtube.preload) {
          preloadPlayers.push(_YouTube2['default']);
        }

        if (!_Vimeo2['default'].canPlay(url) && this.config.vimeo.preload) {
          preloadPlayers.push(_Vimeo2['default']);
        }

        if (!_DailyMotion2['default'].canPlay(url) && this.config.dailymotion.preload) {
          preloadPlayers.push(_DailyMotion2['default']);
        }

        return preloadPlayers.map(this.renderPreloadPlayer);
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            url = _props.url,
            style = _props.style,
            width = _props.width,
            height = _props.height;
        var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props2.DEPRECATED_CONFIG_PROPS);
        var activePlayer = this.renderActivePlayer(url);
        var preloadPlayers = this.renderPreloadPlayers(url);
        return _react2['default'].createElement('div', _extends({
          ref: this.wrapperRef,
          style: _extends({}, style, {
            width: width,
            height: height
          })
        }, otherProps), activePlayer, preloadPlayers);
      }
    }]);

    return ReactPlayer;
  }(_react.Component);

  ReactPlayer.displayName = 'ReactPlayer';
  ReactPlayer.propTypes = _props2.propTypes;
  ReactPlayer.defaultProps = _props2.defaultProps;

  ReactPlayer.canPlay = function (url) {
    var players = [].concat(SUPPORTED_PLAYERS, [_FilePlayer2['default']]);
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = players[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var Player = _step2.value;

        if (Player.canPlay(url)) {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2['return']) {
          _iterator2['return']();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return false;
  };

  exports['default'] = ReactPlayer;
  /***/
},
/* 238 */

/***/
function (module, exports) {
  module.exports = function load(src, opts, cb) {
    var head = document.head || document.getElementsByTagName('head')[0];
    var script = document.createElement('script');

    if (typeof opts === 'function') {
      cb = opts;
      opts = {};
    }

    opts = opts || {};

    cb = cb || function () {};

    script.type = opts.type || 'text/javascript';
    script.charset = opts.charset || 'utf8';
    script.async = 'async' in opts ? !!opts.async : true;
    script.src = src;

    if (opts.attrs) {
      setAttributes(script, opts.attrs);
    }

    if (opts.text) {
      script.text = '' + opts.text;
    }

    var onend = 'onload' in script ? stdOnEnd : ieOnEnd;
    onend(script, cb); // some good legacy browsers (firefox) fail the 'in' detection above
    // so as a fallback we always set onload
    // old IE will ignore this and new IE will set onload

    if (!script.onload) {
      stdOnEnd(script, cb);
    }

    head.appendChild(script);
  };

  function setAttributes(script, attrs) {
    for (var attr in attrs) {
      script.setAttribute(attr, attrs[attr]);
    }
  }

  function stdOnEnd(script, cb) {
    script.onload = function () {
      this.onerror = this.onload = null;
      cb(null, script);
    };

    script.onerror = function () {
      // this.onload = null here is necessary
      // because even IE9 works not like others
      this.onerror = this.onload = null;
      cb(new Error('Failed to load ' + this.src), script);
    };
  }

  function ieOnEnd(script, cb) {
    script.onreadystatechange = function () {
      if (this.readyState != 'complete' && this.readyState != 'loaded') return;
      this.onreadystatechange = null;
      cb(null, script); // there is no way to catch loading errors in IE8
    };
  }
  /***/

},
/* 239 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var isMergeableObject = function isMergeableObject(value) {
    return isNonNullObject(value) && !isSpecial(value);
  };

  function isNonNullObject(value) {
    return !!value && _typeof4(value) === 'object';
  }

  function isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
  } // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25


  var canUseSymbol = typeof Symbol === 'function' && Symbol["for"];
  var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol["for"]('react.element') : 0xeac7;

  function isReactElement(value) {
    return value.$$typeof === REACT_ELEMENT_TYPE;
  }

  function emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
  }

  function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return clone && isMergeableObject(value) ? deepmerge(emptyTarget(value), value, optionsArgument) : value;
  }

  function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function (e, i) {
      if (typeof destination[i] === 'undefined') {
        destination[i] = cloneIfNecessary(e, optionsArgument);
      } else if (isMergeableObject(e)) {
        destination[i] = deepmerge(target[i], e, optionsArgument);
      } else if (target.indexOf(e) === -1) {
        destination.push(cloneIfNecessary(e, optionsArgument));
      }
    });
    return destination;
  }

  function mergeObject(target, source, optionsArgument) {
    var destination = {};

    if (isMergeableObject(target)) {
      Object.keys(target).forEach(function (key) {
        destination[key] = cloneIfNecessary(target[key], optionsArgument);
      });
    }

    Object.keys(source).forEach(function (key) {
      if (!isMergeableObject(source[key]) || !target[key]) {
        destination[key] = cloneIfNecessary(source[key], optionsArgument);
      } else {
        destination[key] = deepmerge(target[key], source[key], optionsArgument);
      }
    });
    return destination;
  }

  function deepmerge(target, source, optionsArgument) {
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var options = optionsArgument || {
      arrayMerge: defaultArrayMerge
    };
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

    if (!sourceAndTargetTypesMatch) {
      return cloneIfNecessary(source, optionsArgument);
    } else if (sourceIsArray) {
      var arrayMerge = options.arrayMerge || defaultArrayMerge;
      return arrayMerge(target, source, optionsArgument);
    } else {
      return mergeObject(target, source, optionsArgument);
    }
  }

  deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
      throw new Error('first argument should be an array with at least two elements');
    } // we are sure there are at least 2 values, so it is safe to have no initial value


    return array.reduce(function (prev, next) {
      return deepmerge(prev, next, optionsArgument);
    });
  };

  var deepmerge_1 = deepmerge;
  module.exports = deepmerge_1;
  /***/
},
/* 240 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);

    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);

      if (parent === null) {
        return undefined;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;

      if (getter === undefined) {
        return undefined;
      }

      return getter.call(receiver);
    }
  };

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  var _Base2 = __webpack_require__(17);

  var _Base3 = _interopRequireDefault(_Base2);

  var _utils = __webpack_require__(12);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SDK_URL = 'https://www.youtube.com/iframe_api';
  var SDK_GLOBAL = 'YT';
  var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
  var MATCH_URL = /^(?:https?:\/\/)?(?:www\.|m\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
  var BLANK_VIDEO_URL = 'https://www.youtube.com/watch?v=GlCmAC4MHek';

  var YouTube = function (_Base) {
    _inherits(YouTube, _Base);

    function YouTube() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, YouTube);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call.apply(_ref, [this].concat(args))), _this), _this.onStateChange = function (_ref2) {
        var data = _ref2.data;
        var _this$props = _this.props,
            onPause = _this$props.onPause,
            onBuffer = _this$props.onBuffer;
        var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
            PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
            PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
            BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
            ENDED = _window$SDK_GLOBAL$Pl.ENDED,
            CUED = _window$SDK_GLOBAL$Pl.CUED;
        if (data === PLAYING) _this.onPlay();
        if (data === PAUSED) onPause();
        if (data === BUFFERING) onBuffer();
        if (data === ENDED) _this.onEnded();
        if (data === CUED) _this.onReady();
      }, _this.onEnded = function () {
        var _this$props2 = _this.props,
            loop = _this$props2.loop,
            onEnded = _this$props2.onEnded;

        if (loop) {
          _this.seekTo(0);
        }

        onEnded();
      }, _this.ref = function (container) {
        _this.container = container;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(YouTube, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
            url = _props.url,
            config = _props.config;

        if (!url && config.youtube.preload) {
          this.preloading = true;
          this.load(BLANK_VIDEO_URL);
        }

        _get(YouTube.prototype.__proto__ || Object.getPrototypeOf(YouTube.prototype), 'componentDidMount', this).call(this);
      }
    }, {
      key: 'load',
      value: function load(url) {
        var _this2 = this;

        var _props2 = this.props,
            playsinline = _props2.playsinline,
            controls = _props2.controls,
            config = _props2.config,
            _onError = _props2.onError;
        var id = url && url.match(MATCH_URL)[1];

        if (this.isReady) {
          this.player.cueVideoById({
            videoId: id,
            startSeconds: (0, _utils.parseStartTime)(url)
          });
          return;
        }

        if (this.loadingSDK) {
          this.loadOnReady = url;
          return;
        }

        this.loadingSDK = true;
        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (YT) {
          return YT.loaded;
        }).then(function (YT) {
          _this2.player = new YT.Player(_this2.container, {
            width: '100%',
            height: '100%',
            videoId: id,
            playerVars: _extends({
              controls: controls ? 1 : 0,
              start: (0, _utils.parseStartTime)(url),
              origin: window.location.origin,
              playsinline: playsinline
            }, config.youtube.playerVars),
            events: {
              onReady: _this2.onReady,
              onStateChange: _this2.onStateChange,
              onError: function onError(event) {
                return _onError(event.data);
              }
            }
          });
        }, _onError);
      }
    }, {
      key: 'play',
      value: function play() {
        this.callPlayer('playVideo');
      }
    }, {
      key: 'pause',
      value: function pause() {
        this.callPlayer('pauseVideo');
      }
    }, {
      key: 'stop',
      value: function stop() {
        if (this.preloading) return;
        if (!document.body.contains(this.callPlayer('getIframe'))) return;
        this.callPlayer('stopVideo');
      }
    }, {
      key: 'seekTo',
      value: function seekTo(amount) {
        var seconds = _get(YouTube.prototype.__proto__ || Object.getPrototypeOf(YouTube.prototype), 'seekTo', this).call(this, amount);

        this.callPlayer('seekTo', seconds);
      }
    }, {
      key: 'setVolume',
      value: function setVolume(fraction) {
        this.callPlayer('setVolume', fraction * 100);
      }
    }, {
      key: 'setPlaybackRate',
      value: function setPlaybackRate(rate) {
        this.callPlayer('setPlaybackRate', rate);
      }
    }, {
      key: 'getDuration',
      value: function getDuration() {
        return this.callPlayer('getDuration');
      }
    }, {
      key: 'getCurrentTime',
      value: function getCurrentTime() {
        return this.callPlayer('getCurrentTime');
      }
    }, {
      key: 'getSecondsLoaded',
      value: function getSecondsLoaded() {
        return this.callPlayer('getVideoLoadedFraction') * this.getDuration();
      }
    }, {
      key: 'render',
      value: function render() {
        var style = {
          width: '100%',
          height: '100%',
          display: this.props.url ? 'block' : 'none'
        };
        return _react2['default'].createElement('div', {
          style: style
        }, _react2['default'].createElement('div', {
          ref: this.ref
        }));
      }
    }], [{
      key: 'canPlay',
      value: function canPlay(url) {
        return MATCH_URL.test(url);
      }
    }]);

    return YouTube;
  }(_Base3['default']);

  YouTube.displayName = 'YouTube';
  exports['default'] = YouTube;
  /***/
},
/* 241 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);

    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);

      if (parent === null) {
        return undefined;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;

      if (getter === undefined) {
        return undefined;
      }

      return getter.call(receiver);
    }
  };

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  var _Base2 = __webpack_require__(17);

  var _Base3 = _interopRequireDefault(_Base2);

  var _utils = __webpack_require__(12);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SDK_URL = 'https://w.soundcloud.com/player/api.js';
  var SDK_GLOBAL = 'SC';
  var MATCH_URL = /^https?:\/\/(soundcloud.com|snd.sc)\/([a-z0-9-_]+\/[a-z0-9-_]+)$/;
  var DEFAULT_OPTIONS = {
    visual: true,
    // Undocumented, but makes player fill container and look better
    buying: false,
    liking: false,
    download: false,
    sharing: false,
    show_comments: false,
    show_playcount: false
  };

  var SoundCloud = function (_Base) {
    _inherits(SoundCloud, _Base);

    function SoundCloud() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, SoundCloud);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SoundCloud.__proto__ || Object.getPrototypeOf(SoundCloud)).call.apply(_ref, [this].concat(args))), _this), _this.duration = null, _this.currentTime = null, _this.fractionLoaded = null, _this.ref = function (iframe) {
        _this.iframe = iframe;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SoundCloud, [{
      key: 'load',
      value: function load(url) {
        var _this2 = this;

        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (SC) {
          var _SC$Widget$Events = SC.Widget.Events,
              PLAY = _SC$Widget$Events.PLAY,
              PLAY_PROGRESS = _SC$Widget$Events.PLAY_PROGRESS,
              PAUSE = _SC$Widget$Events.PAUSE,
              FINISH = _SC$Widget$Events.FINISH,
              ERROR = _SC$Widget$Events.ERROR;

          if (!_this2.isReady) {
            _this2.player = SC.Widget(_this2.iframe);

            _this2.player.bind(PLAY, function () {
              // Use widgetIsPlaying to prevent calling play() when widget
              // is playing, which causes bugs with the SC widget
              _this2.widgetIsPlaying = true;

              _this2.onPlay();
            });

            _this2.player.bind(PAUSE, function () {
              _this2.widgetIsPlaying = false;

              _this2.props.onPause();
            });

            _this2.player.bind(PLAY_PROGRESS, function (e) {
              _this2.currentTime = e.currentPosition / 1000;
              _this2.fractionLoaded = e.loadedProgress;
            });

            _this2.player.bind(FINISH, function () {
              return _this2.props.onEnded();
            });

            _this2.player.bind(ERROR, function (e) {
              return _this2.props.onError(e);
            });
          }

          _this2.player.load(url, _extends({}, DEFAULT_OPTIONS, _this2.props.config.soundcloud.options, {
            callback: function callback() {
              _this2.widgetIsPlaying = false;

              _this2.player.getDuration(function (duration) {
                _this2.duration = duration / 1000;

                _this2.onReady();
              });
            }
          }));
        });
      }
    }, {
      key: 'play',
      value: function play() {
        if (!this.widgetIsPlaying) {
          this.callPlayer('play');
        }
      }
    }, {
      key: 'pause',
      value: function pause() {
        if (this.widgetIsPlaying) {
          this.callPlayer('pause');
        }
      }
    }, {
      key: 'stop',
      value: function stop() {// Nothing to do
      }
    }, {
      key: 'seekTo',
      value: function seekTo(amount) {
        var seconds = _get(SoundCloud.prototype.__proto__ || Object.getPrototypeOf(SoundCloud.prototype), 'seekTo', this).call(this, amount);

        this.callPlayer('seekTo', seconds * 1000);
      }
    }, {
      key: 'setVolume',
      value: function setVolume(fraction) {
        this.callPlayer('setVolume', fraction * 100);
      }
    }, {
      key: 'getDuration',
      value: function getDuration() {
        return this.duration;
      }
    }, {
      key: 'getCurrentTime',
      value: function getCurrentTime() {
        return this.currentTime;
      }
    }, {
      key: 'getSecondsLoaded',
      value: function getSecondsLoaded() {
        return this.fractionLoaded * this.duration;
      }
    }, {
      key: 'render',
      value: function render() {
        var style = {
          width: '100%',
          height: '100%'
        };
        return _react2['default'].createElement('iframe', {
          ref: this.ref,
          src: 'https://w.soundcloud.com/player/?url=' + encodeURIComponent(this.props.url),
          style: style,
          frameBorder: 0
        });
      }
    }], [{
      key: 'canPlay',
      value: function canPlay(url) {
        return MATCH_URL.test(url);
      }
    }]);

    return SoundCloud;
  }(_Base3['default']);

  SoundCloud.displayName = 'SoundCloud';
  exports['default'] = SoundCloud;
  /***/
},
/* 242 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);

    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);

      if (parent === null) {
        return undefined;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;

      if (getter === undefined) {
        return undefined;
      }

      return getter.call(receiver);
    }
  };

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  var _Base2 = __webpack_require__(17);

  var _Base3 = _interopRequireDefault(_Base2);

  var _utils = __webpack_require__(12);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SDK_URL = 'https://player.vimeo.com/api/player.js';
  var SDK_GLOBAL = 'Vimeo';
  var MATCH_URL = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
  var BLANK_VIDEO_URL = 'https://vimeo.com/127250231';

  var Vimeo = function (_Base) {
    _inherits(Vimeo, _Base);

    function Vimeo() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Vimeo);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Vimeo.__proto__ || Object.getPrototypeOf(Vimeo)).call.apply(_ref, [this].concat(args))), _this), _this.ref = function (container) {
        _this.container = container;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Vimeo, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
            url = _props.url,
            config = _props.config;

        if (!url && config.vimeo.preload) {
          this.preloading = true;
          this.load(BLANK_VIDEO_URL);
        }

        _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'componentDidMount', this).call(this);
      }
    }, {
      key: 'load',
      value: function load(url) {
        var _this2 = this;

        var id = url.match(MATCH_URL)[3];
        this.duration = null;

        if (this.isReady) {
          this.player.loadVideo(id);
          return;
        }

        if (this.loadingSDK) {
          this.loadOnReady = url;
          return;
        }

        this.loadingSDK = true;
        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Vimeo) {
          _this2.player = new Vimeo.Player(_this2.container, _extends({}, _this2.props.config.vimeo.playerOptions, {
            url: url,
            loop: _this2.props.loop
          }));

          _this2.player.on('loaded', function () {
            _this2.onReady();

            var iframe = _this2.container.querySelector('iframe');

            iframe.style.width = '100%';
            iframe.style.height = '100%';
          });

          _this2.player.on('play', function (_ref2) {
            var duration = _ref2.duration;
            _this2.duration = duration;

            _this2.onPlay();
          });

          _this2.player.on('pause', _this2.props.onPause);

          _this2.player.on('seeked', function (e) {
            return _this2.props.onSeek(e.seconds);
          });

          _this2.player.on('ended', _this2.props.onEnded);

          _this2.player.on('error', _this2.props.onError);

          _this2.player.on('timeupdate', function (_ref3) {
            var seconds = _ref3.seconds;
            _this2.currentTime = seconds;
          });

          _this2.player.on('progress', function (_ref4) {
            var seconds = _ref4.seconds;
            _this2.secondsLoaded = seconds;
          });
        }, this.props.onError);
      }
    }, {
      key: 'play',
      value: function play() {
        this.callPlayer('play');
      }
    }, {
      key: 'pause',
      value: function pause() {
        this.callPlayer('pause');
      }
    }, {
      key: 'stop',
      value: function stop() {
        if (this.preloading) return;
        this.callPlayer('unload');
      }
    }, {
      key: 'seekTo',
      value: function seekTo(amount) {
        var seconds = _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'seekTo', this).call(this, amount);

        this.callPlayer('setCurrentTime', seconds);
      }
    }, {
      key: 'setVolume',
      value: function setVolume(fraction) {
        this.callPlayer('setVolume', fraction);
      }
    }, {
      key: 'getDuration',
      value: function getDuration() {
        return this.duration;
      }
    }, {
      key: 'getCurrentTime',
      value: function getCurrentTime() {
        return this.currentTime;
      }
    }, {
      key: 'getSecondsLoaded',
      value: function getSecondsLoaded() {
        return this.secondsLoaded;
      }
    }, {
      key: 'render',
      value: function render() {
        var style = {
          height: '100%',
          display: this.props.url ? 'block' : 'none'
        };
        return _react2['default'].createElement('div', {
          style: style,
          ref: this.ref
        });
      }
    }], [{
      key: 'canPlay',
      value: function canPlay(url) {
        return MATCH_URL.test(url);
      }
    }]);

    return Vimeo;
  }(_Base3['default']);

  Vimeo.displayName = 'Vimeo';
  exports['default'] = Vimeo;
  /***/
},
/* 243 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);

    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);

      if (parent === null) {
        return undefined;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;

      if (getter === undefined) {
        return undefined;
      }

      return getter.call(receiver);
    }
  };

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  var _Base2 = __webpack_require__(17);

  var _Base3 = _interopRequireDefault(_Base2);

  var _utils = __webpack_require__(12);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SDK_URL = '//connect.facebook.net/en_US/sdk.js';
  var SDK_GLOBAL = 'FB';
  var SDK_GLOBAL_READY = 'fbAsyncInit';
  var MATCH_URL = /^https:\/\/www\.facebook\.com\/([^/?].+\/)?video(s|\.php)[/?].*$/;
  var PLAYER_ID_PREFIX = 'facebook-player-';

  var Facebook = function (_Base) {
    _inherits(Facebook, _Base);

    function Facebook() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Facebook);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Facebook.__proto__ || Object.getPrototypeOf(Facebook)).call.apply(_ref, [this].concat(args))), _this), _this.playerID = PLAYER_ID_PREFIX + (0, _utils.randomString)(), _this.onEnded = function () {
        var _this$props = _this.props,
            loop = _this$props.loop,
            onEnded = _this$props.onEnded;

        if (loop) {
          _this.seekTo(0);
        }

        onEnded();
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Facebook, [{
      key: 'load',
      value: function load(url) {
        var _this2 = this;

        if (this.isReady) {
          (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
            return FB.XFBML.parse();
          });
          return;
        }

        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
          FB.init({
            appId: _this2.props.config.facebook.appId,
            xfbml: true,
            version: 'v2.5'
          });
          FB.Event.subscribe('xfbml.ready', function (msg) {
            if (msg.type === 'video' && msg.id === _this2.playerID) {
              _this2.player = msg.instance;

              _this2.player.subscribe('startedPlaying', _this2.onPlay);

              _this2.player.subscribe('paused', _this2.props.onPause);

              _this2.player.subscribe('finishedPlaying', _this2.onEnded);

              _this2.player.subscribe('startedBuffering', _this2.props.onBuffer);

              _this2.player.subscribe('error', _this2.props.onError);

              _this2.onReady();
            }
          });
        });
      }
    }, {
      key: 'play',
      value: function play() {
        this.callPlayer('play');
      }
    }, {
      key: 'pause',
      value: function pause() {
        this.callPlayer('pause');
      }
    }, {
      key: 'stop',
      value: function stop() {// Nothing to do
      }
    }, {
      key: 'seekTo',
      value: function seekTo(amount) {
        var seconds = _get(Facebook.prototype.__proto__ || Object.getPrototypeOf(Facebook.prototype), 'seekTo', this).call(this, amount);

        this.player.seek(seconds);
      }
    }, {
      key: 'setVolume',
      value: function setVolume(fraction) {
        if (fraction !== 0) {
          this.callPlayer('unmute');
        }

        this.player.setVolume(fraction);
      }
    }, {
      key: 'getDuration',
      value: function getDuration() {
        return this.callPlayer('getDuration');
      }
    }, {
      key: 'getCurrentTime',
      value: function getCurrentTime() {
        return this.callPlayer('getCurrentPosition');
      }
    }, {
      key: 'getSecondsLoaded',
      value: function getSecondsLoaded() {
        return null;
      }
    }, {
      key: 'render',
      value: function render() {
        var style = {
          width: '100%',
          height: '100%',
          backgroundColor: 'black'
        };
        return _react2['default'].createElement('div', {
          style: style,
          id: this.playerID,
          className: 'fb-video',
          'data-href': this.props.url,
          'data-allowfullscreen': 'true',
          'data-controls': !this.props.controls ? 'false' : undefined
        });
      }
    }], [{
      key: 'canPlay',
      value: function canPlay(url) {
        return MATCH_URL.test(url);
      }
    }]);

    return Facebook;
  }(_Base3['default']);

  Facebook.displayName = 'Facebook';
  exports['default'] = Facebook;
  /***/
},
/* 244 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);

    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);

      if (parent === null) {
        return undefined;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;

      if (getter === undefined) {
        return undefined;
      }

      return getter.call(receiver);
    }
  };

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  var _Base2 = __webpack_require__(17);

  var _Base3 = _interopRequireDefault(_Base2);

  var _utils = __webpack_require__(12);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SDK_URL = '//cdn.embed.ly/player-0.0.12.min.js';
  var SDK_GLOBAL = 'playerjs';
  var MATCH_URL = /^https?:\/\/streamable.com\/([a-z0-9]+)$/;

  var Streamable = function (_Base) {
    _inherits(Streamable, _Base);

    function Streamable() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Streamable);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Streamable.__proto__ || Object.getPrototypeOf(Streamable)).call.apply(_ref, [this].concat(args))), _this), _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.ref = function (iframe) {
        _this.iframe = iframe;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Streamable, [{
      key: 'load',
      value: function load(url) {
        var _this2 = this;

        if (this.loadingSDK) {
          this.loadOnReady = url;
          return;
        }

        this.loadingSDK = true;
        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
          _this2.player = new playerjs.Player(_this2.iframe);

          _this2.player.on('ready', _this2.onReady);

          _this2.player.on('play', _this2.onPlay);

          _this2.player.on('pause', _this2.props.onPause);

          _this2.player.on('seeked', _this2.props.onSeek);

          _this2.player.on('ended', _this2.props.onEnded);

          _this2.player.on('error', _this2.props.onError);

          _this2.player.on('timeupdate', function (_ref2) {
            var duration = _ref2.duration,
                seconds = _ref2.seconds;
            _this2.duration = duration;
            _this2.currentTime = seconds;
          });

          _this2.player.on('progress', function (_ref3) {
            var percent = _ref3.percent;

            if (_this2.duration) {
              _this2.secondsLoaded = _this2.duration * percent;
            }
          });
        }, this.props.onError);
      }
    }, {
      key: 'play',
      value: function play() {
        this.callPlayer('play');
      }
    }, {
      key: 'pause',
      value: function pause() {
        this.callPlayer('pause');
      }
    }, {
      key: 'stop',
      value: function stop() {// Nothing to do
      }
    }, {
      key: 'seekTo',
      value: function seekTo(amount) {
        var seconds = _get(Streamable.prototype.__proto__ || Object.getPrototypeOf(Streamable.prototype), 'seekTo', this).call(this, amount);

        this.callPlayer('setCurrentTime', seconds);
      }
    }, {
      key: 'setVolume',
      value: function setVolume(fraction) {
        this.callPlayer('setVolume', fraction * 100);
      }
    }, {
      key: 'getDuration',
      value: function getDuration() {
        return this.duration;
      }
    }, {
      key: 'getCurrentTime',
      value: function getCurrentTime() {
        return this.currentTime;
      }
    }, {
      key: 'getSecondsLoaded',
      value: function getSecondsLoaded() {
        return this.secondsLoaded;
      }
    }, {
      key: 'render',
      value: function render() {
        var id = this.props.url.match(MATCH_URL)[1];
        var style = {
          width: '100%',
          height: '100%'
        };
        return _react2['default'].createElement('iframe', {
          ref: this.ref,
          src: 'https://streamable.com/o/' + id,
          frameBorder: '0',
          scrolling: 'no',
          style: style,
          allowFullScreen: true
        });
      }
    }], [{
      key: 'canPlay',
      value: function canPlay(url) {
        return MATCH_URL.test(url);
      }
    }]);

    return Streamable;
  }(_Base3['default']);

  Streamable.displayName = 'Streamable';
  exports['default'] = Streamable;
  /***/
},
/* 245 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _FilePlayer2 = __webpack_require__(133);

  var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var RESOLVE_URL = 'https://api.vid.me/videoByUrl/';
  var MATCH_URL = /^https?:\/\/vid.me\/([a-z0-9]+)$/i;
  var cache = {}; // Cache song data requests

  var Vidme = function (_FilePlayer) {
    _inherits(Vidme, _FilePlayer);

    function Vidme() {
      _classCallCheck(this, Vidme);

      return _possibleConstructorReturn(this, (Vidme.__proto__ || Object.getPrototypeOf(Vidme)).apply(this, arguments));
    }

    _createClass(Vidme, [{
      key: 'getData',
      value: function getData(url) {
        var onError = this.props.onError;
        var id = url.match(MATCH_URL)[1];

        if (cache[id]) {
          return Promise.resolve(cache[id]);
        }

        return window.fetch(RESOLVE_URL + id).then(function (response) {
          if (response.status === 200) {
            cache[id] = response.json();
            return cache[id];
          } else {
            onError(new Error('Vidme track could not be resolved'));
          }
        });
      }
    }, {
      key: 'getURL',
      value: function getURL(_ref) {
        var video = _ref.video;
        var config = this.props.config;

        if (config.vidme.format && video.formats && video.formats.length !== 0) {
          var index = video.formats.findIndex(function (f) {
            return f.type === config.vidme.format;
          });

          if (index !== -1) {
            return video.formats[index].uri;
          } else {
            console.warn('Vidme format "' + config.vidme.format + '" was not found for ' + video.full_url);
          }
        }

        return video.complete_url;
      }
    }, {
      key: 'load',
      value: function load(url) {
        var _this2 = this;

        var onError = this.props.onError;
        this.stop();
        this.getData(url).then(function (data) {
          if (!_this2.mounted) return;
          _this2.player.src = _this2.getURL(data);
        }, onError);
      }
    }], [{
      key: 'canPlay',
      value: function canPlay(url) {
        return MATCH_URL.test(url);
      }
    }]);

    return Vidme;
  }(_FilePlayer3['default']);

  Vidme.displayName = 'Vidme';
  exports['default'] = Vidme;
  /***/
},
/* 246 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);

    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);

      if (parent === null) {
        return undefined;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;

      if (getter === undefined) {
        return undefined;
      }

      return getter.call(receiver);
    }
  };

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  var _Base2 = __webpack_require__(17);

  var _Base3 = _interopRequireDefault(_Base2);

  var _utils = __webpack_require__(12);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SDK_URL = '//fast.wistia.com/assets/external/E-v1.js';
  var SDK_GLOBAL = 'Wistia';
  var MATCH_URL = /^https?:\/\/(.+)?(wistia.com|wi.st)\/(medias|embed)\/(.*)$/;

  var Wistia = function (_Base) {
    _inherits(Wistia, _Base);

    function Wistia() {
      _classCallCheck(this, Wistia);

      return _possibleConstructorReturn(this, (Wistia.__proto__ || Object.getPrototypeOf(Wistia)).apply(this, arguments));
    }

    _createClass(Wistia, [{
      key: 'getID',
      value: function getID(url) {
        return url && url.match(MATCH_URL)[4];
      }
    }, {
      key: 'load',
      value: function load(url) {
        var _this2 = this;

        var _props = this.props,
            controls = _props.controls,
            onStart = _props.onStart,
            onPause = _props.onPause,
            onSeek = _props.onSeek,
            onEnded = _props.onEnded,
            config = _props.config;
        this.loadingSDK = true;
        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function () {
          window._wq = window._wq || [];

          window._wq.push({
            id: _this2.getID(url),
            options: _extends({
              controlsVisibleOnLoad: controls
            }, config.wistia.options),
            onReady: function onReady(player) {
              _this2.player = player;

              _this2.player.bind('start', onStart);

              _this2.player.bind('play', _this2.onPlay);

              _this2.player.bind('pause', onPause);

              _this2.player.bind('seek', onSeek);

              _this2.player.bind('end', onEnded);

              _this2.onReady();
            }
          });
        });
      }
    }, {
      key: 'play',
      value: function play() {
        this.callPlayer('play');
      }
    }, {
      key: 'pause',
      value: function pause() {
        this.callPlayer('pause');
      }
    }, {
      key: 'stop',
      value: function stop() {
        this.callPlayer('remove');
      }
    }, {
      key: 'seekTo',
      value: function seekTo(amount) {
        var seconds = _get(Wistia.prototype.__proto__ || Object.getPrototypeOf(Wistia.prototype), 'seekTo', this).call(this, amount);

        this.callPlayer('time', seconds);
      }
    }, {
      key: 'setVolume',
      value: function setVolume(fraction) {
        this.callPlayer('volume', fraction);
      }
    }, {
      key: 'setPlaybackRate',
      value: function setPlaybackRate(rate) {
        this.callPlayer('playbackRate', rate);
      }
    }, {
      key: 'getDuration',
      value: function getDuration() {
        return this.callPlayer('duration');
      }
    }, {
      key: 'getCurrentTime',
      value: function getCurrentTime() {
        return this.callPlayer('time');
      }
    }, {
      key: 'getSecondsLoaded',
      value: function getSecondsLoaded() {
        return null;
      }
    }, {
      key: 'render',
      value: function render() {
        var id = this.getID(this.props.url);
        var className = 'wistia_embed wistia_async_' + id;
        var style = {
          width: '100%',
          height: '100%',
          display: this.props.url ? 'block' : 'none'
        };
        return _react2['default'].createElement('div', {
          key: id,
          className: className,
          style: style
        });
      }
    }], [{
      key: 'canPlay',
      value: function canPlay(url) {
        return MATCH_URL.test(url);
      }
    }]);

    return Wistia;
  }(_Base3['default']);

  Wistia.displayName = 'Wistia';
  exports['default'] = Wistia;
  /***/
},
/* 247 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);

    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);

      if (parent === null) {
        return undefined;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;

      if (getter === undefined) {
        return undefined;
      }

      return getter.call(receiver);
    }
  };

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  var _Base2 = __webpack_require__(17);

  var _Base3 = _interopRequireDefault(_Base2);

  var _utils = __webpack_require__(12);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SDK_URL = 'https://api.dmcdn.net/all.js';
  var SDK_GLOBAL = 'DM';
  var SDK_GLOBAL_READY = 'dmAsyncInit';
  var MATCH_URL = /^.+dailymotion.com\/(video|hub)\/([^_]+)[^#]*(#video=([^_&]+))?/;
  var BLANK_VIDEO_URL = 'http://www.dailymotion.com/video/x522udb';

  var DailyMotion = function (_Base) {
    _inherits(DailyMotion, _Base);

    function DailyMotion() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, DailyMotion);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DailyMotion.__proto__ || Object.getPrototypeOf(DailyMotion)).call.apply(_ref, [this].concat(args))), _this), _this.onDurationChange = function (event) {
        var onDuration = _this.props.onDuration;

        var duration = _this.getDuration();

        onDuration(duration);
      }, _this.onEnded = function () {
        var _this$props = _this.props,
            loop = _this$props.loop,
            onEnded = _this$props.onEnded;

        if (loop) {
          _this.seekTo(0);
        }

        onEnded();
      }, _this.ref = function (container) {
        _this.container = container;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(DailyMotion, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
            url = _props.url,
            config = _props.config;

        if (!url && config.dailymotion.preload) {
          this.preloading = true;
          this.load(BLANK_VIDEO_URL);
        }

        _get(DailyMotion.prototype.__proto__ || Object.getPrototypeOf(DailyMotion.prototype), 'componentDidMount', this).call(this);
      }
    }, {
      key: 'parseId',
      value: function parseId(url) {
        var m = url.match(MATCH_URL);
        return m[4] || m[2];
      }
    }, {
      key: 'load',
      value: function load(url) {
        var _this2 = this;

        var _props2 = this.props,
            controls = _props2.controls,
            config = _props2.config,
            onError = _props2.onError,
            playing = _props2.playing;
        var id = this.parseId(url);

        if (this.player) {
          this.player.load(id, {
            start: (0, _utils.parseStartTime)(url),
            autoplay: playing
          });
          return;
        }

        if (this.loadingSDK) {
          this.loadOnReady = url;
          return;
        }

        this.loadingSDK = true;
        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (DM) {
          return DM.player;
        }).then(function (DM) {
          var Player = DM.player;
          _this2.player = new Player(_this2.container, {
            width: '100%',
            height: '100%',
            video: id,
            params: _extends({
              controls: controls,
              autoplay: _this2.props.playing,
              start: (0, _utils.parseStartTime)(url),
              origin: window.location.origin
            }, config.dailymotion.params),
            events: {
              apiready: function apiready() {
                _this2.loadingSDK = false;

                _this2.onReady();
              },
              seeked: function seeked() {
                return _this2.props.onSeek(_this2.player.currentTime);
              },
              video_end: _this2.onEnded,
              durationchange: _this2.onDurationChange,
              pause: _this2.props.onPause,
              playing: _this2.onPlay,
              waiting: _this2.props.onBuffer,
              error: function error(event) {
                return onError(event);
              }
            }
          });
        }, onError);
      }
    }, {
      key: 'play',
      value: function play() {
        this.callPlayer('play');
      }
    }, {
      key: 'pause',
      value: function pause() {
        this.callPlayer('pause');
      }
    }, {
      key: 'stop',
      value: function stop() {// Nothing to do
      }
    }, {
      key: 'seekTo',
      value: function seekTo(amount) {
        var seconds = _get(DailyMotion.prototype.__proto__ || Object.getPrototypeOf(DailyMotion.prototype), 'seekTo', this).call(this, amount);

        this.callPlayer('seek', seconds);
      }
    }, {
      key: 'setVolume',
      value: function setVolume(fraction) {
        this.callPlayer('setVolume', fraction);
      }
    }, {
      key: 'getDuration',
      value: function getDuration() {
        if (!this.isReady) return null;
        return this.player.duration || null;
      }
    }, {
      key: 'getCurrentTime',
      value: function getCurrentTime() {
        return this.player.currentTime;
      }
    }, {
      key: 'getSecondsLoaded',
      value: function getSecondsLoaded() {
        return this.player.bufferedTime;
      }
    }, {
      key: 'render',
      value: function render() {
        var style = {
          width: '100%',
          height: '100%',
          backgroundColor: 'black',
          display: this.props.url ? 'block' : 'none'
        };
        return _react2['default'].createElement('div', {
          style: style
        }, _react2['default'].createElement('div', {
          ref: this.ref
        }));
      }
    }], [{
      key: 'canPlay',
      value: function canPlay(url) {
        return MATCH_URL.test(url);
      }
    }]);

    return DailyMotion;
  }(_Base3['default']);

  DailyMotion.displayName = 'DailyMotion';
  exports['default'] = DailyMotion;
  /***/
},
/* 248 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);

    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);

      if (parent === null) {
        return undefined;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;

      if (getter === undefined) {
        return undefined;
      }

      return getter.call(receiver);
    }
  };

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  var _Base2 = __webpack_require__(17);

  var _Base3 = _interopRequireDefault(_Base2);

  var _utils = __webpack_require__(12);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SDK_URL = '//player.twitch.tv/js/embed/v1.js';
  var SDK_GLOBAL = 'Twitch';
  var MATCH_VIDEO_URL = /^(?:https?:\/\/)?(?:www\.)twitch\.tv\/videos\/(\d+)($|\?)/;
  var MATCH_CHANNEL_URL = /^(?:https?:\/\/)?(?:www\.)twitch\.tv\/([a-z0-9_]+)($|\?)/;
  var PLAYER_ID_PREFIX = 'twitch-player-';

  var Twitch = function (_Base) {
    _inherits(Twitch, _Base);

    function Twitch() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Twitch);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Twitch.__proto__ || Object.getPrototypeOf(Twitch)).call.apply(_ref, [this].concat(args))), _this), _this.playerID = PLAYER_ID_PREFIX + (0, _utils.randomString)(), _this.onEnded = function () {
        var _this$props = _this.props,
            loop = _this$props.loop,
            onEnded = _this$props.onEnded;

        if (loop) {
          _this.seekTo(0);
        }

        onEnded();
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Twitch, [{
      key: 'load',
      value: function load(url) {
        var _this2 = this;

        var _props = this.props,
            playsinline = _props.playsinline,
            onError = _props.onError;
        var isChannel = MATCH_CHANNEL_URL.test(url);
        var id = isChannel ? url.match(MATCH_CHANNEL_URL)[1] : url.match(MATCH_VIDEO_URL)[1];

        if (this.isReady) {
          if (isChannel) {
            this.player.setChannel(id);
          } else {
            this.player.setVideo('v' + id);
          }

          return;
        }

        if (this.loadingSDK) {
          this.loadOnReady = url;
          return;
        }

        this.loadingSDK = true;
        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Twitch) {
          _this2.player = new Twitch.Player(_this2.playerID, {
            video: isChannel ? '' : id,
            channel: isChannel ? id : '',
            height: '100%',
            width: '100%',
            playsinline: playsinline
          });
          var _Twitch$Player = Twitch.Player,
              READY = _Twitch$Player.READY,
              PLAY = _Twitch$Player.PLAY,
              PAUSE = _Twitch$Player.PAUSE,
              ENDED = _Twitch$Player.ENDED;

          _this2.player.addEventListener(READY, _this2.onReady);

          _this2.player.addEventListener(PLAY, _this2.onPlay);

          _this2.player.addEventListener(PAUSE, _this2.props.onPause);

          _this2.player.addEventListener(ENDED, _this2.onEnded);
        }, onError);
      }
    }, {
      key: 'play',
      value: function play() {
        this.callPlayer('play');
      }
    }, {
      key: 'pause',
      value: function pause() {
        this.callPlayer('pause');
      }
    }, {
      key: 'stop',
      value: function stop() {
        this.callPlayer('pause');
      }
    }, {
      key: 'seekTo',
      value: function seekTo(amount) {
        var seconds = _get(Twitch.prototype.__proto__ || Object.getPrototypeOf(Twitch.prototype), 'seekTo', this).call(this, amount);

        this.callPlayer('seek', seconds);
      }
    }, {
      key: 'setVolume',
      value: function setVolume(fraction) {
        this.callPlayer('setVolume', fraction);
      }
    }, {
      key: 'getDuration',
      value: function getDuration() {
        return this.callPlayer('getDuration');
      }
    }, {
      key: 'getCurrentTime',
      value: function getCurrentTime() {
        return this.callPlayer('getCurrentTime');
      }
    }, {
      key: 'getSecondsLoaded',
      value: function getSecondsLoaded() {
        return null;
      }
    }, {
      key: 'render',
      value: function render() {
        var style = {
          width: '100%',
          height: '100%'
        };
        return _react2['default'].createElement('div', {
          style: style,
          id: this.playerID
        });
      }
    }], [{
      key: 'canPlay',
      value: function canPlay(url) {
        return MATCH_VIDEO_URL.test(url) || MATCH_CHANNEL_URL.test(url);
      }
    }]);

    return Twitch;
  }(_Base3['default']);

  Twitch.displayName = 'Twitch';
  exports['default'] = Twitch;
  /***/
},
/* 249 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * @typechecks
   * 
   */

  /*eslint-disable no-self-compare */

  var hasOwnProperty = Object.prototype.hasOwnProperty;
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      // Added the nonzero y check to make Flow happy, but it is redundant
      return x !== 0 || y !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /**
   * Performs equality by iterating through keys on an object and returning false
   * when any key has values which are not strictly equal between the arguments.
   * Returns true when the values of all keys are strictly equal.
   */


  function shallowEqual(objA, objB) {
    if (is(objA, objB)) {
      return true;
    }

    if (_typeof4(objA) !== 'object' || objA === null || _typeof4(objB) !== 'object' || objB === null) {
      return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if (keysA.length !== keysB.length) {
      return false;
    } // Test for A's keys different from B.


    for (var i = 0; i < keysA.length; i++) {
      if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
        return false;
      }
    }

    return true;
  }

  module.exports = shallowEqual;
  /***/
},
/* 250 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
    var currentListeners = [];
    var nextListeners = currentListeners;

    function ensureCanMutateNextListeners() {
      if (nextListeners === currentListeners) {
        nextListeners = currentListeners.slice();
      }
    }

    function listen(listener) {
      if (typeof listener !== 'function') {
        throw new Error('Expected listener to be a function.');
      }

      var isSubscribed = true;
      ensureCanMutateNextListeners();
      nextListeners.push(listener);
      return function () {
        if (!isSubscribed) {
          return;
        }

        isSubscribed = false;
        ensureCanMutateNextListeners();
        var index = nextListeners.indexOf(listener);
        nextListeners.splice(index, 1);
      };
    }

    function emit() {
      currentListeners = nextListeners;
      var listeners = currentListeners;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i].apply(listeners, arguments);
      }
    }

    return {
      listen: listen,
      emit: emit
    };
  };
  /***/

},
/* 251 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (global, module) {
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(253);
    /* global window */


    var root;

    if (typeof self !== 'undefined') {
      root = self;
    } else if (typeof window !== 'undefined') {
      root = window;
    } else if (typeof global !== 'undefined') {
      root = global;
    } else if (true) {
      root = module;
    } else {
      root = Function('return this')();
    }

    var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a"
    /* default */
    ])(root);
    /* harmony default export */

    __webpack_exports__["a"] = result;
    /* WEBPACK VAR INJECTION */
  }).call(__webpack_exports__, __webpack_require__(33), __webpack_require__(252)(module));
  /***/
},
/* 252 */

/***/
function (module, exports) {
  module.exports = function (originalModule) {
    if (!originalModule.webpackPolyfill) {
      var module = Object.create(originalModule); // module.parent = undefined by default

      if (!module.children) module.children = [];
      Object.defineProperty(module, "loaded", {
        enumerable: true,
        get: function get() {
          return module.l;
        }
      });
      Object.defineProperty(module, "id", {
        enumerable: true,
        get: function get() {
          return module.i;
        }
      });
      Object.defineProperty(module, "exports", {
        enumerable: true
      });
      module.webpackPolyfill = 1;
    }

    return module;
  };
  /***/

},
/* 253 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (immutable) */

  __webpack_exports__["a"] = symbolObservablePonyfill;

  function symbolObservablePonyfill(root) {
    var result;
    var _Symbol8 = root.Symbol;

    if (typeof _Symbol8 === 'function') {
      if (_Symbol8.observable) {
        result = _Symbol8.observable;
      } else {
        result = _Symbol8('observable');
        _Symbol8.observable = result;
      }
    } else {
      result = '@@observable';
    }

    return result;
  }

  ;
  /***/
},
/* 254 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(255);

  module.exports = __webpack_require__(7).Object.keys;
  /***/
},
/* 255 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.14 Object.keys(O)
  var toObject = __webpack_require__(41);

  var $keys = __webpack_require__(39);

  __webpack_require__(123)('keys', function () {
    return function keys(it) {
      return $keys(toObject(it));
    };
  });
  /***/

},
/* 256 */

/***/
function (module, exports, __webpack_require__) {
  var createCaseFirst = __webpack_require__(257);
  /**
   * Converts the first character of `string` to upper case.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category String
   * @param {string} [string=''] The string to convert.
   * @returns {string} Returns the converted string.
   * @example
   *
   * _.upperFirst('fred');
   * // => 'Fred'
   *
   * _.upperFirst('FRED');
   * // => 'FRED'
   */


  var upperFirst = createCaseFirst('toUpperCase');
  module.exports = upperFirst;
  /***/
},
/* 257 */

/***/
function (module, exports, __webpack_require__) {
  var castSlice = __webpack_require__(258),
      hasUnicode = __webpack_require__(137),
      stringToArray = __webpack_require__(260),
      toString = __webpack_require__(138);
  /**
   * Creates a function like `_.lowerFirst`.
   *
   * @private
   * @param {string} methodName The name of the `String` case method to use.
   * @returns {Function} Returns the new case function.
   */


  function createCaseFirst(methodName) {
    return function (string) {
      string = toString(string);
      var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
      var chr = strSymbols ? strSymbols[0] : string.charAt(0);
      var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
      return chr[methodName]() + trailing;
    };
  }

  module.exports = createCaseFirst;
  /***/
},
/* 258 */

/***/
function (module, exports, __webpack_require__) {
  var baseSlice = __webpack_require__(259);
  /**
   * Casts `array` to a slice if it's needed.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {number} start The start position.
   * @param {number} [end=array.length] The end position.
   * @returns {Array} Returns the cast slice.
   */


  function castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : baseSlice(array, start, end);
  }

  module.exports = castSlice;
  /***/
},
/* 259 */

/***/
function (module, exports) {
  /**
   * The base implementation of `_.slice` without an iteratee call guard.
   *
   * @private
   * @param {Array} array The array to slice.
   * @param {number} [start=0] The start position.
   * @param {number} [end=array.length] The end position.
   * @returns {Array} Returns the slice of `array`.
   */
  function baseSlice(array, start, end) {
    var index = -1,
        length = array.length;

    if (start < 0) {
      start = -start > length ? 0 : length + start;
    }

    end = end > length ? length : end;

    if (end < 0) {
      end += length;
    }

    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);

    while (++index < length) {
      result[index] = array[index + start];
    }

    return result;
  }

  module.exports = baseSlice;
  /***/
},
/* 260 */

/***/
function (module, exports, __webpack_require__) {
  var asciiToArray = __webpack_require__(261),
      hasUnicode = __webpack_require__(137),
      unicodeToArray = __webpack_require__(262);
  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */


  function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
  }

  module.exports = stringToArray;
  /***/
},
/* 261 */

/***/
function (module, exports) {
  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  module.exports = asciiToArray;
  /***/
},
/* 262 */

/***/
function (module, exports) {
  /** Used to compose unicode character classes. */
  var rsAstralRange = "\\ud800-\\udfff",
      rsComboMarksRange = "\\u0300-\\u036f",
      reComboHalfMarksRange = "\\ufe20-\\ufe2f",
      rsComboSymbolsRange = "\\u20d0-\\u20ff",
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsVarRange = "\\ufe0e\\ufe0f";
  /** Used to compose unicode capture groups. */

  var rsAstral = '[' + rsAstralRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsFitz = "\\ud83c[\\udffb-\\udfff]",
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      rsZWJ = "\\u200d";
  /** Used to compose unicode regexes. */

  var reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */

  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */

  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  module.exports = unicodeToArray;
  /***/
},
/* 263 */

/***/
function (module, exports, __webpack_require__) {
  var _Symbol9 = __webpack_require__(58),
      arrayMap = __webpack_require__(264),
      isArray = __webpack_require__(25),
      isSymbol = __webpack_require__(91);
  /** Used as references for various `Number` constants. */


  var INFINITY = 1 / 0;
  /** Used to convert symbols to primitives and strings. */

  var symbolProto = _Symbol9 ? _Symbol9.prototype : undefined,
      symbolToString = symbolProto ? symbolProto.toString : undefined;
  /**
   * The base implementation of `_.toString` which doesn't convert nullish
   * values to empty strings.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */

  function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
      return value;
    }

    if (isArray(value)) {
      // Recursively convert values (susceptible to call stack limits).
      return arrayMap(value, baseToString) + '';
    }

    if (isSymbol(value)) {
      return symbolToString ? symbolToString.call(value) : '';
    }

    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
  }

  module.exports = baseToString;
  /***/
},
/* 264 */

/***/
function (module, exports) {
  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }

    return result;
  }

  module.exports = arrayMap;
  /***/
},
/* 265 */

/***/
function (module, exports, __webpack_require__) {
  var _Symbol10 = __webpack_require__(58);
  /** Used for built-in method references. */


  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */

  var nativeObjectToString = objectProto.toString;
  /** Built-in value references. */

  var symToStringTag = _Symbol10 ? _Symbol10.toStringTag : undefined;
  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */

  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

    try {
      value[symToStringTag] = undefined;
      var unmasked = true;
    } catch (e) {}

    var result = nativeObjectToString.call(value);

    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }

    return result;
  }

  module.exports = getRawTag;
  /***/
},
/* 266 */

/***/
function (module, exports) {
  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */

  var nativeObjectToString = objectProto.toString;
  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */

  function objectToString(value) {
    return nativeObjectToString.call(value);
  }

  module.exports = objectToString;
  /***/
},
/* 267 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    exports.__esModule = true;

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    var _propTypes = __webpack_require__(1);

    var PropTypes = _interopRequireWildcard(_propTypes);

    var _addClass = __webpack_require__(268);

    var _addClass2 = _interopRequireDefault(_addClass);

    var _removeClass = __webpack_require__(270);

    var _removeClass2 = _interopRequireDefault(_removeClass);

    var _react = __webpack_require__(0);

    var _react2 = _interopRequireDefault(_react);

    var _Transition = __webpack_require__(141);

    var _Transition2 = _interopRequireDefault(_Transition);

    var _PropTypes = __webpack_require__(143);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }

    function _interopRequireWildcard(obj) {
      if (obj && obj.__esModule) {
        return obj;
      } else {
        var newObj = {};

        if (obj != null) {
          for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
          }
        }

        newObj["default"] = obj;
        return newObj;
      }
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var addClass = function addClass(node, classes) {
      return node && classes && classes.split(' ').forEach(function (c) {
        return (0, _addClass2["default"])(node, c);
      });
    };

    var removeClass = function removeClass(node, classes) {
      return node && classes && classes.split(' ').forEach(function (c) {
        return (0, _removeClass2["default"])(node, c);
      });
    };

    var propTypes = _extends({}, _Transition2["default"].propTypes, {
      /**
       * The animation classNames applied to the component as it enters, exits or has finished the transition.
       * A single name can be provided and it will be suffixed for each stage: e.g.
       *
       * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
       * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
       * Each individual classNames can also be specified independently like:
       *
       * ```js
       * classNames={{
       *  appear: 'my-appear',
       *  appearActive: 'my-active-appear',
       *  enter: 'my-enter',
       *  enterActive: 'my-active-enter',
       *  enterDone: 'my-done-enter',
       *  exit: 'my-exit',
       *  exitActive: 'my-active-exit',
       *  exitDone: 'my-done-exit',
       * }}
       * ```
       *
       * If you want to set these classes using CSS Modules:
       *
       * ```js
       * import styles from './styles.css';
       * ```
       *
       * you might want to use camelCase in your CSS file, that way could simply spread
       * them instead of listing them one by one:
       *
       * ```js
       * classNames={{ ...styles }}
       * ```
       *
       * @type {string | {
       *  appear?: string,
       *  appearActive?: string,
       *  enter?: string,
       *  enterActive?: string,
       *  enterDone?: string,
       *  exit?: string,
       *  exitActive?: string,
       *  exitDone?: string,
       * }}
       */
      classNames: _PropTypes.classNamesShape,

      /**
       * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
       * applied.
       *
       * @type Function(node: HtmlElement, isAppearing: bool)
       */
      onEnter: PropTypes.func,

      /**
       * A `<Transition>` callback fired immediately after the 'enter-active' or
       * 'appear-active' class is applied.
       *
       * @type Function(node: HtmlElement, isAppearing: bool)
       */
      onEntering: PropTypes.func,

      /**
       * A `<Transition>` callback fired immediately after the 'enter' or
       * 'appear' classes are **removed** and the `done` class is added to the DOM node.
       *
       * @type Function(node: HtmlElement, isAppearing: bool)
       */
      onEntered: PropTypes.func,

      /**
       * A `<Transition>` callback fired immediately after the 'exit' class is
       * applied.
       *
       * @type Function(node: HtmlElement)
       */
      onExit: PropTypes.func,

      /**
       * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
       *
       * @type Function(node: HtmlElement
       */
      onExiting: PropTypes.func,

      /**
       * A `<Transition>` callback fired immediately after the 'exit' classes
       * are **removed** and the `exit-done` class is added to the DOM node.
       *
       * @type Function(node: HtmlElement)
       */
      onExited: PropTypes.func
    });
    /**
     * A `Transition` component using CSS transitions and animations.
     * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
     *
     * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
     * and `exit` stages of the transition. The first class is applied and then a
     * second "active" class in order to activate the css animation. After the animation,
     * matching `done` class names are applied to persist the animation state.
     *
     * When the `in` prop is toggled to `true` the Component will get
     * the `example-enter` CSS class and the `example-enter-active` CSS class
     * added in the next tick. This is a convention based on the `classNames` prop.
     *
     * ## Example
     *
     * <iframe src="https://codesandbox.io/embed/m77l2vp00x?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
     */


    var CSSTransition = function (_React$Component) {
      _inherits(CSSTransition, _React$Component);

      function CSSTransition() {
        var _temp, _this, _ret;

        _classCallCheck(this, CSSTransition);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
          var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
              className = _this$getClassNames.className;

          _this.removeClasses(node, 'exit');

          addClass(node, className);

          if (_this.props.onEnter) {
            _this.props.onEnter(node);
          }
        }, _this.onEntering = function (node, appearing) {
          var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
              activeClassName = _this$getClassNames2.activeClassName;

          _this.reflowAndAddClass(node, activeClassName);

          if (_this.props.onEntering) {
            _this.props.onEntering(node);
          }
        }, _this.onEntered = function (node, appearing) {
          var _this$getClassNames3 = _this.getClassNames('enter'),
              doneClassName = _this$getClassNames3.doneClassName;

          _this.removeClasses(node, appearing ? 'appear' : 'enter');

          addClass(node, doneClassName);

          if (_this.props.onEntered) {
            _this.props.onEntered(node);
          }
        }, _this.onExit = function (node) {
          var _this$getClassNames4 = _this.getClassNames('exit'),
              className = _this$getClassNames4.className;

          _this.removeClasses(node, 'appear');

          _this.removeClasses(node, 'enter');

          addClass(node, className);

          if (_this.props.onExit) {
            _this.props.onExit(node);
          }
        }, _this.onExiting = function (node) {
          var _this$getClassNames5 = _this.getClassNames('exit'),
              activeClassName = _this$getClassNames5.activeClassName;

          _this.reflowAndAddClass(node, activeClassName);

          if (_this.props.onExiting) {
            _this.props.onExiting(node);
          }
        }, _this.onExited = function (node) {
          var _this$getClassNames6 = _this.getClassNames('exit'),
              doneClassName = _this$getClassNames6.doneClassName;

          _this.removeClasses(node, 'exit');

          addClass(node, doneClassName);

          if (_this.props.onExited) {
            _this.props.onExited(node);
          }
        }, _this.getClassNames = function (type) {
          var classNames = _this.props.classNames;
          var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
          var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
          var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
          return {
            className: className,
            activeClassName: activeClassName,
            doneClassName: doneClassName
          };
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
        var _getClassNames = this.getClassNames(type),
            className = _getClassNames.className,
            activeClassName = _getClassNames.activeClassName,
            doneClassName = _getClassNames.doneClassName;

        className && removeClass(node, className);
        activeClassName && removeClass(node, activeClassName);
        doneClassName && removeClass(node, doneClassName);
      };

      CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (className) {
          /* eslint-disable no-unused-expressions */
          node && node.scrollTop;
          /* eslint-enable no-unused-expressions */

          addClass(node, className);
        }
      };

      CSSTransition.prototype.render = function render() {
        var props = _extends({}, this.props);

        delete props.classNames;
        return _react2["default"].createElement(_Transition2["default"], _extends({}, props, {
          onEnter: this.onEnter,
          onEntered: this.onEntered,
          onEntering: this.onEntering,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        }));
      };

      return CSSTransition;
    }(_react2["default"].Component);

    CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
    exports["default"] = CSSTransition;
    module.exports = exports['default'];
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(8));
  /***/
},
/* 268 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = addClass;

  var _hasClass = __webpack_require__(269);

  var _hasClass2 = _interopRequireDefault(_hasClass);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function addClass(element, className) {
    if (element.classList) element.classList.add(className);else if (!(0, _hasClass2["default"])(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
  }

  module.exports = exports['default'];
  /***/
},
/* 269 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = hasClass;

  function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
  }

  module.exports = exports["default"];
  /***/
},
/* 270 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
  }

  module.exports = function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  };
  /***/

},
/* 271 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    exports.__esModule = true;

    var _propTypes = __webpack_require__(1);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _react = __webpack_require__(0);

    var _react2 = _interopRequireDefault(_react);

    var _reactDom = __webpack_require__(35);

    var _TransitionGroup = __webpack_require__(144);

    var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }

    function _objectWithoutProperties(obj, keys) {
      var target = {};

      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }

      return target;
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var propTypes = {
      "in": _propTypes2["default"].bool.isRequired,
      children: function children(props, propName) {
        if (_react2["default"].Children.count(props[propName]) !== 2) return new Error('"' + propName + '" must be exactly two transition components.');
        return null;
      }
    };
    /**
     * The `<ReplaceTransition>` component is a specialized `Transition` component
     * that animates between two children.
     *
     * ```jsx
     * <ReplaceTransition in>
     *   <Fade><div>I appear first</div></Fade>
     *   <Fade><div>I replace the above</div></Fade>
     * </ReplaceTransition>
     * ```
     */

    var ReplaceTransition = function (_React$Component) {
      _inherits(ReplaceTransition, _React$Component);

      function ReplaceTransition() {
        var _temp, _this, _ret;

        _classCallCheck(this, ReplaceTransition);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
      }

      ReplaceTransition.prototype.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;

        var children = this.props.children;

        var child = _react2["default"].Children.toArray(children)[idx];

        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
      };

      ReplaceTransition.prototype.render = function render() {
        var _props = this.props,
            children = _props.children,
            inProp = _props["in"],
            props = _objectWithoutProperties(_props, ['children', 'in']);

        var _React$Children$toArr = _react2["default"].Children.toArray(children),
            first = _React$Children$toArr[0],
            second = _React$Children$toArr[1];

        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return _react2["default"].createElement(_TransitionGroup2["default"], props, inProp ? _react2["default"].cloneElement(first, {
          key: 'first',
          onEnter: this.handleEnter,
          onEntering: this.handleEntering,
          onEntered: this.handleEntered
        }) : _react2["default"].cloneElement(second, {
          key: 'second',
          onEnter: this.handleExit,
          onEntering: this.handleExiting,
          onEntered: this.handleExited
        }));
      };

      return ReplaceTransition;
    }(_react2["default"].Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.handleEnter = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return _this2.handleLifecycle('onEnter', 0, args);
      };

      this.handleEntering = function () {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        return _this2.handleLifecycle('onEntering', 0, args);
      };

      this.handleEntered = function () {
        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        return _this2.handleLifecycle('onEntered', 0, args);
      };

      this.handleExit = function () {
        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          args[_key5] = arguments[_key5];
        }

        return _this2.handleLifecycle('onExit', 1, args);
      };

      this.handleExiting = function () {
        for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
          args[_key6] = arguments[_key6];
        }

        return _this2.handleLifecycle('onExiting', 1, args);
      };

      this.handleExited = function () {
        for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
          args[_key7] = arguments[_key7];
        }

        return _this2.handleLifecycle('onExited', 1, args);
      };
    };

    ReplaceTransition.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
    exports["default"] = ReplaceTransition;
    module.exports = exports['default'];
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(8));
  /***/
},
/* 272 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  exports.getChildMapping = getChildMapping;
  exports.mergeChildMappings = mergeChildMappings;
  exports.getInitialChildMapping = getInitialChildMapping;
  exports.getNextChildMapping = getNextChildMapping;

  var _react = __webpack_require__(0);
  /**
   * Given `this.props.children`, return an object mapping key to child.
   *
   * @param {*} children `this.props.children`
   * @return {object} Mapping of key to child
   */


  function getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
      return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
    };

    var result = Object.create(null);
    if (children) _react.Children.map(children, function (c) {
      return c;
    }).forEach(function (child) {
      // run the map function here instead so that the key is the computed one
      result[child.key] = mapper(child);
    });
    return result;
  }
  /**
   * When you're adding or removing children some may be added or removed in the
   * same render pass. We want to show *both* since we want to simultaneously
   * animate elements in and out. This function takes a previous set of keys
   * and a new set of keys and merges them with its best guess of the correct
   * ordering. In the future we may expose some of the utilities in
   * ReactMultiChild to make this easy, but for now React itself does not
   * directly have this concept of the union of prevChildren and nextChildren
   * so we implement it here.
   *
   * @param {object} prev prev children as returned from
   * `ReactTransitionChildMapping.getChildMapping()`.
   * @param {object} next next children as returned from
   * `ReactTransitionChildMapping.getChildMapping()`.
   * @return {object} a key set that contains all keys in `prev` and all keys
   * in `next` in a reasonable order.
   */


  function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};

    function getValueForKey(key) {
      return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list


    var nextKeysPending = Object.create(null);
    var pendingKeys = [];

    for (var prevKey in prev) {
      if (prevKey in next) {
        if (pendingKeys.length) {
          nextKeysPending[prevKey] = pendingKeys;
          pendingKeys = [];
        }
      } else {
        pendingKeys.push(prevKey);
      }
    }

    var i = void 0;
    var childMapping = {};

    for (var nextKey in next) {
      if (nextKeysPending[nextKey]) {
        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
          var pendingNextKey = nextKeysPending[nextKey][i];
          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
      }

      childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`


    for (i = 0; i < pendingKeys.length; i++) {
      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    }

    return childMapping;
  }

  function getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
  }

  function getInitialChildMapping(props, onExited) {
    return getChildMapping(props.children, function (child) {
      return (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        "in": true,
        appear: getProp(child, 'appear', props),
        enter: getProp(child, 'enter', props),
        exit: getProp(child, 'exit', props)
      });
    });
  }

  function getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = getChildMapping(nextProps.children);
    var children = mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function (key) {
      var child = children[key];
      if (!(0, _react.isValidElement)(child)) return;
      var hasPrev = key in prevChildMapping;
      var hasNext = key in nextChildMapping;
      var prevChild = prevChildMapping[key];
      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props["in"]; // item is new (entering)

      if (hasNext && (!hasPrev || isLeaving)) {
        // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
          onExited: onExited.bind(null, child),
          "in": true,
          exit: getProp(child, 'exit', nextProps),
          enter: getProp(child, 'enter', nextProps)
        });
      } else if (!hasNext && hasPrev && !isLeaving) {
        // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, _react.cloneElement)(child, {
          "in": false
        });
      } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
        // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, _react.cloneElement)(child, {
          onExited: onExited.bind(null, child),
          "in": prevChild.props["in"],
          exit: getProp(child, 'exit', nextProps),
          enter: getProp(child, 'enter', nextProps)
        });
      }
    });
    return children;
  }
  /***/

},
/* 273 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Arrow = exports.Popper = exports.Target = exports.Manager = undefined;

  var _Manager2 = __webpack_require__(274);

  var _Manager3 = _interopRequireDefault(_Manager2);

  var _Target2 = __webpack_require__(275);

  var _Target3 = _interopRequireDefault(_Target2);

  var _Popper2 = __webpack_require__(276);

  var _Popper3 = _interopRequireDefault(_Popper2);

  var _Arrow2 = __webpack_require__(278);

  var _Arrow3 = _interopRequireDefault(_Arrow2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  exports.Manager = _Manager3["default"];
  exports.Target = _Target3["default"];
  exports.Popper = _Popper3["default"];
  exports.Arrow = _Arrow3["default"];
  /***/
},
/* 274 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Manager = function (_Component) {
    _inherits(Manager, _Component);

    function Manager() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Manager);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
        _this._targetNode = node;
      }, _this._getTargetNode = function () {
        return _this._targetNode;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Manager, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          popperManager: {
            setTargetNode: this._setTargetNode,
            getTargetNode: this._getTargetNode
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            tag = _props.tag,
            children = _props.children,
            restProps = _objectWithoutProperties(_props, ['tag', 'children']);

        if (tag !== false) {
          return (0, _react.createElement)(tag, restProps, children);
        } else {
          return children;
        }
      }
    }]);

    return Manager;
  }(_react.Component);

  Manager.childContextTypes = {
    popperManager: _propTypes2["default"].object.isRequired
  };
  Manager.propTypes = {
    tag: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].bool])
  };
  Manager.defaultProps = {
    tag: 'div'
  };
  exports["default"] = Manager;
  /***/
},
/* 275 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Target = function Target(props, context) {
    var _props$component = props.component,
        component = _props$component === undefined ? 'div' : _props$component,
        innerRef = props.innerRef,
        children = props.children,
        restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

    var popperManager = context.popperManager;

    var targetRef = function targetRef(node) {
      popperManager.setTargetNode(node);

      if (typeof innerRef === 'function') {
        innerRef(node);
      }
    };

    if (typeof children === 'function') {
      var targetProps = {
        ref: targetRef
      };
      return children({
        targetProps: targetProps,
        restProps: restProps
      });
    }

    var componentProps = _extends({}, restProps);

    if (typeof component === 'string') {
      componentProps.ref = targetRef;
    } else {
      componentProps.innerRef = targetRef;
    }

    return (0, _react.createElement)(component, componentProps, children);
  };

  Target.contextTypes = {
    popperManager: _propTypes2["default"].object.isRequired
  };
  Target.propTypes = {
    component: _propTypes2["default"].oneOfType([_propTypes2["default"].node, _propTypes2["default"].func]),
    innerRef: _propTypes2["default"].func,
    children: _propTypes2["default"].oneOfType([_propTypes2["default"].node, _propTypes2["default"].func])
  };
  exports["default"] = Target;
  /***/
},
/* 276 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _popper = __webpack_require__(277);

  var _popper2 = _interopRequireDefault(_popper);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Popper = function (_Component) {
    _inherits(Popper, _Component);

    function Popper() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Popper);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
        _this._arrowNode = node;
      }, _this._getTargetNode = function () {
        return _this.context.popperManager.getTargetNode();
      }, _this._getOffsets = function (data) {
        return Object.keys(data.offsets).map(function (key) {
          return data.offsets[key];
        });
      }, _this._isDataDirty = function (data) {
        if (_this.state.data) {
          return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
        } else {
          return true;
        }
      }, _this._updateStateModifier = {
        enabled: true,
        order: 900,
        fn: function fn(data) {
          if (_this._isDataDirty(data)) {
            _this.setState({
              data: data
            });
          }

          return data;
        }
      }, _this._getPopperStyle = function () {
        var data = _this.state.data; // If Popper isn't instantiated, hide the popperElement
        // to avoid flash of unstyled content

        if (!data) {
          return {
            position: 'absolute',
            pointerEvents: 'none',
            opacity: 0
          };
        }

        var _data$offsets$popper = data.offsets.popper,
            top = _data$offsets$popper.top,
            left = _data$offsets$popper.left,
            position = _data$offsets$popper.position;
        return _extends({
          position: position
        }, data.styles);
      }, _this._getPopperPlacement = function () {
        return _this.state.data ? _this.state.data.placement : undefined;
      }, _this._getPopperHide = function () {
        return !!_this.state.data && _this.state.data.hide ? '' : undefined;
      }, _this._getArrowStyle = function () {
        if (!_this.state.data || !_this.state.data.offsets.arrow) {
          return {};
        } else {
          var _this$state$data$offs = _this.state.data.offsets.arrow,
              top = _this$state$data$offs.top,
              left = _this$state$data$offs.left;
          return {
            top: top,
            left: left
          };
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Popper, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          popper: {
            setArrowNode: this._setArrowNode,
            getArrowStyle: this._getArrowStyle
          }
        };
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(lastProps) {
        if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled) {
          this._destroyPopper();

          this._createPopper();
        }

        if (lastProps.children !== this.props.children) {
          this._popper.scheduleUpdate();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this._destroyPopper();
      }
    }, {
      key: '_createPopper',
      value: function _createPopper() {
        var _props = this.props,
            placement = _props.placement,
            eventsEnabled = _props.eventsEnabled;

        var modifiers = _extends({}, this.props.modifiers, {
          applyStyle: {
            enabled: false
          },
          updateState: this._updateStateModifier
        });

        if (this._arrowNode) {
          modifiers.arrow = {
            element: this._arrowNode
          };
        }

        this._popper = new _popper2["default"](this._getTargetNode(), this._node, {
          placement: placement,
          eventsEnabled: eventsEnabled,
          modifiers: modifiers
        }); // schedule an update to make sure everything gets positioned correctly
        // after being instantiated

        this._popper.scheduleUpdate();
      }
    }, {
      key: '_destroyPopper',
      value: function _destroyPopper() {
        if (this._popper) {
          this._popper.destroy();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props2 = this.props,
            component = _props2.component,
            innerRef = _props2.innerRef,
            placement = _props2.placement,
            eventsEnabled = _props2.eventsEnabled,
            modifiers = _props2.modifiers,
            children = _props2.children,
            restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);

        var popperRef = function popperRef(node) {
          _this2._node = node;

          if (node) {
            _this2._createPopper();
          } else {
            _this2._destroyPopper();
          }

          if (typeof innerRef === 'function') {
            innerRef(node);
          }
        };

        var popperStyle = this._getPopperStyle();

        var popperPlacement = this._getPopperPlacement();

        var popperHide = this._getPopperHide();

        if (typeof children === 'function') {
          var _popperProps;

          var popperProps = (_popperProps = {
            ref: popperRef,
            style: popperStyle
          }, _defineProperty(_popperProps, 'data-placement', popperPlacement), _defineProperty(_popperProps, 'data-x-out-of-boundaries', popperHide), _popperProps);
          return children({
            popperProps: popperProps,
            restProps: restProps,
            scheduleUpdate: function scheduleUpdate() {
              // _createPopper will scheduleUpdate,
              // so calling this before this._popper exists
              // can be a noop.
              _this2._popper && _this2._popper.scheduleUpdate();
            }
          });
        }

        var componentProps = _extends({}, restProps, {
          style: _extends({}, restProps.style, popperStyle),
          'data-placement': popperPlacement,
          'data-x-out-of-boundaries': popperHide
        });

        if (typeof component === 'string') {
          componentProps.ref = popperRef;
        } else {
          componentProps.innerRef = popperRef;
        }

        return (0, _react.createElement)(component, componentProps, children);
      }
    }]);

    return Popper;
  }(_react.Component);

  Popper.contextTypes = {
    popperManager: _propTypes2["default"].object.isRequired
  };
  Popper.childContextTypes = {
    popper: _propTypes2["default"].object.isRequired
  };
  Popper.propTypes = {
    component: _propTypes2["default"].oneOfType([_propTypes2["default"].node, _propTypes2["default"].func]),
    innerRef: _propTypes2["default"].func,
    placement: _propTypes2["default"].oneOf(_popper2["default"].placements),
    eventsEnabled: _propTypes2["default"].bool,
    modifiers: _propTypes2["default"].object,
    children: _propTypes2["default"].oneOfType([_propTypes2["default"].node, _propTypes2["default"].func])
  };
  Popper.defaultProps = {
    component: 'div',
    placement: 'bottom',
    eventsEnabled: true,
    modifiers: {}
  };
  exports["default"] = Popper;
  /***/
},
/* 277 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: true
  });
  /* WEBPACK VAR INJECTION */

  (function (global) {
    /**!
    * @fileOverview Kickass library to create and place poppers near their reference elements.
    * @version 1.14.3
    * @license
    * Copyright (c) 2016 Federico Zivolo and contributors
    *
    * Permission is hereby granted, free of charge, to any person obtaining a copy
    * of this software and associated documentation files (the "Software"), to deal
    * in the Software without restriction, including without limitation the rights
    * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    * copies of the Software, and to permit persons to whom the Software is
    * furnished to do so, subject to the following conditions:
    *
    * The above copyright notice and this permission notice shall be included in all
    * copies or substantial portions of the Software.
    *
    * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    * SOFTWARE.
    */
    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
    var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
    var timeoutDuration = 0;

    for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
      if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
        timeoutDuration = 1;
        break;
      }
    }

    function microtaskDebounce(fn) {
      var called = false;
      return function () {
        if (called) {
          return;
        }

        called = true;
        window.Promise.resolve().then(function () {
          called = false;
          fn();
        });
      };
    }

    function taskDebounce(fn) {
      var scheduled = false;
      return function () {
        if (!scheduled) {
          scheduled = true;
          setTimeout(function () {
            scheduled = false;
            fn();
          }, timeoutDuration);
        }
      };
    }

    var supportsMicroTasks = isBrowser && window.Promise;
    /**
    * Create a debounced version of a method, that's asynchronously deferred
    * but called in the minimum time possible.
    *
    * @method
    * @memberof Popper.Utils
    * @argument {Function} fn
    * @returns {Function}
    */

    var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
    /**
     * Check if the given variable is a function
     * @method
     * @memberof Popper.Utils
     * @argument {Any} functionToCheck - variable to check
     * @returns {Boolean} answer to: is a function?
     */

    function isFunction(functionToCheck) {
      var getType = {};
      return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
    }
    /**
     * Get CSS computed property of the given element
     * @method
     * @memberof Popper.Utils
     * @argument {Eement} element
     * @argument {String} property
     */


    function getStyleComputedProperty(element, property) {
      if (element.nodeType !== 1) {
        return [];
      } // NOTE: 1 DOM access here


      var css = getComputedStyle(element, null);
      return property ? css[property] : css;
    }
    /**
     * Returns the parentNode or the host of the element
     * @method
     * @memberof Popper.Utils
     * @argument {Element} element
     * @returns {Element} parent
     */


    function getParentNode(element) {
      if (element.nodeName === 'HTML') {
        return element;
      }

      return element.parentNode || element.host;
    }
    /**
     * Returns the scrolling parent of the given element
     * @method
     * @memberof Popper.Utils
     * @argument {Element} element
     * @returns {Element} scroll parent
     */


    function getScrollParent(element) {
      // Return body, `getScroll` will take care to get the correct `scrollTop` from it
      if (!element) {
        return document.body;
      }

      switch (element.nodeName) {
        case 'HTML':
        case 'BODY':
          return element.ownerDocument.body;

        case '#document':
          return element.body;
      } // Firefox want us to check `-x` and `-y` variations as well


      var _getStyleComputedProp = getStyleComputedProperty(element),
          overflow = _getStyleComputedProp.overflow,
          overflowX = _getStyleComputedProp.overflowX,
          overflowY = _getStyleComputedProp.overflowY;

      if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
        return element;
      }

      return getScrollParent(getParentNode(element));
    }

    var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
    var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
    /**
     * Determines if the browser is Internet Explorer
     * @method
     * @memberof Popper.Utils
     * @param {Number} version to check
     * @returns {Boolean} isIE
     */

    function isIE(version) {
      if (version === 11) {
        return isIE11;
      }

      if (version === 10) {
        return isIE10;
      }

      return isIE11 || isIE10;
    }
    /**
     * Returns the offset parent of the given element
     * @method
     * @memberof Popper.Utils
     * @argument {Element} element
     * @returns {Element} offset parent
     */


    function getOffsetParent(element) {
      if (!element) {
        return document.documentElement;
      }

      var noOffsetParent = isIE(10) ? document.body : null; // NOTE: 1 DOM access here

      var offsetParent = element.offsetParent; // Skip hidden elements which don't have an offsetParent

      while (offsetParent === noOffsetParent && element.nextElementSibling) {
        offsetParent = (element = element.nextElementSibling).offsetParent;
      }

      var nodeName = offsetParent && offsetParent.nodeName;

      if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
        return element ? element.ownerDocument.documentElement : document.documentElement;
      } // .offsetParent will return the closest TD or TABLE in case
      // no offsetParent is present, I hate this job...


      if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
        return getOffsetParent(offsetParent);
      }

      return offsetParent;
    }

    function isOffsetContainer(element) {
      var nodeName = element.nodeName;

      if (nodeName === 'BODY') {
        return false;
      }

      return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
    }
    /**
     * Finds the root node (document, shadowDOM root) of the given element
     * @method
     * @memberof Popper.Utils
     * @argument {Element} node
     * @returns {Element} root node
     */


    function getRoot(node) {
      if (node.parentNode !== null) {
        return getRoot(node.parentNode);
      }

      return node;
    }
    /**
     * Finds the offset parent common to the two provided nodes
     * @method
     * @memberof Popper.Utils
     * @argument {Element} element1
     * @argument {Element} element2
     * @returns {Element} common offset parent
     */


    function findCommonOffsetParent(element1, element2) {
      // This check is needed to avoid errors in case one of the elements isn't defined for any reason
      if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
        return document.documentElement;
      } // Here we make sure to give as "start" the element that comes first in the DOM


      var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
      var start = order ? element1 : element2;
      var end = order ? element2 : element1; // Get common ancestor container

      var range = document.createRange();
      range.setStart(start, 0);
      range.setEnd(end, 0);
      var commonAncestorContainer = range.commonAncestorContainer; // Both nodes are inside #document

      if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if (isOffsetContainer(commonAncestorContainer)) {
          return commonAncestorContainer;
        }

        return getOffsetParent(commonAncestorContainer);
      } // one of the nodes is inside shadowDOM, find which one


      var element1root = getRoot(element1);

      if (element1root.host) {
        return findCommonOffsetParent(element1root.host, element2);
      } else {
        return findCommonOffsetParent(element1, getRoot(element2).host);
      }
    }
    /**
     * Gets the scroll value of the given element in the given side (top and left)
     * @method
     * @memberof Popper.Utils
     * @argument {Element} element
     * @argument {String} side `top` or `left`
     * @returns {number} amount of scrolled pixels
     */


    function getScroll(element) {
      var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
      var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
      var nodeName = element.nodeName;

      if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
      }

      return element[upperSide];
    }
    /*
     * Sum or subtract the element scroll values (left and top) from a given rect object
     * @method
     * @memberof Popper.Utils
     * @param {Object} rect - Rect object you want to change
     * @param {HTMLElement} element - The element from the function reads the scroll values
     * @param {Boolean} subtract - set to true if you want to subtract the scroll values
     * @return {Object} rect - The modifier rect object
     */


    function includeScroll(rect, element) {
      var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      var modifier = subtract ? -1 : 1;
      rect.top += scrollTop * modifier;
      rect.bottom += scrollTop * modifier;
      rect.left += scrollLeft * modifier;
      rect.right += scrollLeft * modifier;
      return rect;
    }
    /*
     * Helper to detect borders of a given element
     * @method
     * @memberof Popper.Utils
     * @param {CSSStyleDeclaration} styles
     * Result of `getStyleComputedProperty` on the given element
     * @param {String} axis - `x` or `y`
     * @return {number} borders - The borders size of the given axis
     */


    function getBordersSize(styles, axis) {
      var sideA = axis === 'x' ? 'Left' : 'Top';
      var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
      return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
    }

    function getSize(axis, body, html, computedStyle) {
      return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
    }

    function getWindowSizes() {
      var body = document.body;
      var html = document.documentElement;
      var computedStyle = isIE(10) && getComputedStyle(html);
      return {
        height: getSize('Height', body, html, computedStyle),
        width: getSize('Width', body, html, computedStyle)
      };
    }

    var classCallCheck = function classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    };

    var createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    var defineProperty = function defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    };

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };
    /**
     * Given element offsets, generate an output similar to getBoundingClientRect
     * @method
     * @memberof Popper.Utils
     * @argument {Object} offsets
     * @returns {Object} ClientRect like output
     */


    function getClientRect(offsets) {
      return _extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
      });
    }
    /**
     * Get bounding client rect of given element
     * @method
     * @memberof Popper.Utils
     * @param {HTMLElement} element
     * @return {Object} client rect
     */


    function getBoundingClientRect(element) {
      var rect = {}; // IE10 10 FIX: Please, don't ask, the element isn't
      // considered in DOM in some circumstances...
      // This isn't reproducible in IE10 compatibility mode of IE11

      try {
        if (isIE(10)) {
          rect = element.getBoundingClientRect();
          var scrollTop = getScroll(element, 'top');
          var scrollLeft = getScroll(element, 'left');
          rect.top += scrollTop;
          rect.left += scrollLeft;
          rect.bottom += scrollTop;
          rect.right += scrollLeft;
        } else {
          rect = element.getBoundingClientRect();
        }
      } catch (e) {}

      var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
      }; // subtract scrollbar size from sizes

      var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
      var width = sizes.width || element.clientWidth || result.right - result.left;
      var height = sizes.height || element.clientHeight || result.bottom - result.top;
      var horizScrollbar = element.offsetWidth - width;
      var vertScrollbar = element.offsetHeight - height; // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
      // we make this check conditional for performance reasons

      if (horizScrollbar || vertScrollbar) {
        var styles = getStyleComputedProperty(element);
        horizScrollbar -= getBordersSize(styles, 'x');
        vertScrollbar -= getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
      }

      return getClientRect(result);
    }

    function getOffsetRectRelativeToArbitraryNode(children, parent) {
      var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var isIE10 = isIE(10);
      var isHTML = parent.nodeName === 'HTML';
      var childrenRect = getBoundingClientRect(children);
      var parentRect = getBoundingClientRect(parent);
      var scrollParent = getScrollParent(children);
      var styles = getStyleComputedProperty(parent);
      var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
      var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10); // In cases where the parent is fixed, we must ignore negative scroll in offset calc

      if (fixedPosition && parent.nodeName === 'HTML') {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
      }

      var offsets = getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
      });
      offsets.marginTop = 0;
      offsets.marginLeft = 0; // Subtract margins of documentElement in case it's being used as parent
      // we do this only on HTML because it's the only element that behaves
      // differently when margins are applied to it. The margins are included in
      // the box of the documentElement, in the other cases not.

      if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop, 10);
        var marginLeft = parseFloat(styles.marginLeft, 10);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft; // Attach marginTop and marginLeft because in some circumstances we may need them

        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
      }

      if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
        offsets = includeScroll(offsets, parent);
      }

      return offsets;
    }

    function getViewportOffsetRectRelativeToArtbitraryNode(element) {
      var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var html = element.ownerDocument.documentElement;
      var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
      var width = Math.max(html.clientWidth, window.innerWidth || 0);
      var height = Math.max(html.clientHeight, window.innerHeight || 0);
      var scrollTop = !excludeScroll ? getScroll(html) : 0;
      var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
      var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
      };
      return getClientRect(offset);
    }
    /**
     * Check if the given element is fixed or is inside a fixed parent
     * @method
     * @memberof Popper.Utils
     * @argument {Element} element
     * @argument {Element} customContainer
     * @returns {Boolean} answer to "isFixed?"
     */


    function isFixed(element) {
      var nodeName = element.nodeName;

      if (nodeName === 'BODY' || nodeName === 'HTML') {
        return false;
      }

      if (getStyleComputedProperty(element, 'position') === 'fixed') {
        return true;
      }

      return isFixed(getParentNode(element));
    }
    /**
     * Finds the first parent of an element that has a transformed property defined
     * @method
     * @memberof Popper.Utils
     * @argument {Element} element
     * @returns {Element} first transformed parent or documentElement
     */


    function getFixedPositionOffsetParent(element) {
      // This check is needed to avoid errors in case one of the elements isn't defined for any reason
      if (!element || !element.parentElement || isIE()) {
        return document.documentElement;
      }

      var el = element.parentElement;

      while (el && getStyleComputedProperty(el, 'transform') === 'none') {
        el = el.parentElement;
      }

      return el || document.documentElement;
    }
    /**
     * Computed the boundaries limits and return them
     * @method
     * @memberof Popper.Utils
     * @param {HTMLElement} popper
     * @param {HTMLElement} reference
     * @param {number} padding
     * @param {HTMLElement} boundariesElement - Element used to define the boundaries
     * @param {Boolean} fixedPosition - Is in fixed position mode
     * @returns {Object} Coordinates of the boundaries
     */


    function getBoundaries(popper, reference, padding, boundariesElement) {
      var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false; // NOTE: 1 DOM access here

      var boundaries = {
        top: 0,
        left: 0
      };
      var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference); // Handle viewport case

      if (boundariesElement === 'viewport') {
        boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
      } else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;

        if (boundariesElement === 'scrollParent') {
          boundariesNode = getScrollParent(getParentNode(reference));

          if (boundariesNode.nodeName === 'BODY') {
            boundariesNode = popper.ownerDocument.documentElement;
          }
        } else if (boundariesElement === 'window') {
          boundariesNode = popper.ownerDocument.documentElement;
        } else {
          boundariesNode = boundariesElement;
        }

        var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition); // In case of HTML, we need a different computation

        if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
          var _getWindowSizes = getWindowSizes(),
              height = _getWindowSizes.height,
              width = _getWindowSizes.width;

          boundaries.top += offsets.top - offsets.marginTop;
          boundaries.bottom = height + offsets.top;
          boundaries.left += offsets.left - offsets.marginLeft;
          boundaries.right = width + offsets.left;
        } else {
          // for all the other DOM elements, this one is good
          boundaries = offsets;
        }
      } // Add paddings


      boundaries.left += padding;
      boundaries.top += padding;
      boundaries.right -= padding;
      boundaries.bottom -= padding;
      return boundaries;
    }

    function getArea(_ref) {
      var width = _ref.width,
          height = _ref.height;
      return width * height;
    }
    /**
     * Utility used to transform the `auto` placement to the placement with more
     * available space.
     * @method
     * @memberof Popper.Utils
     * @argument {Object} data - The data object generated by update method
     * @argument {Object} options - Modifiers configuration and options
     * @returns {Object} The data object, properly modified
     */


    function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
      var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

      if (placement.indexOf('auto') === -1) {
        return placement;
      }

      var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
      var rects = {
        top: {
          width: boundaries.width,
          height: refRect.top - boundaries.top
        },
        right: {
          width: boundaries.right - refRect.right,
          height: boundaries.height
        },
        bottom: {
          width: boundaries.width,
          height: boundaries.bottom - refRect.bottom
        },
        left: {
          width: refRect.left - boundaries.left,
          height: boundaries.height
        }
      };
      var sortedAreas = Object.keys(rects).map(function (key) {
        return _extends({
          key: key
        }, rects[key], {
          area: getArea(rects[key])
        });
      }).sort(function (a, b) {
        return b.area - a.area;
      });
      var filteredAreas = sortedAreas.filter(function (_ref2) {
        var width = _ref2.width,
            height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
      });
      var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
      var variation = placement.split('-')[1];
      return computedPlacement + (variation ? '-' + variation : '');
    }
    /**
     * Get offsets to the reference element
     * @method
     * @memberof Popper.Utils
     * @param {Object} state
     * @param {Element} popper - the popper element
     * @param {Element} reference - the reference element (the popper will be relative to this)
     * @param {Element} fixedPosition - is in fixed position mode
     * @returns {Object} An object containing the offsets which will be applied to the popper
     */


    function getReferenceOffsets(state, popper, reference) {
      var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
      return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
    }
    /**
     * Get the outer sizes of the given element (offset size + margins)
     * @method
     * @memberof Popper.Utils
     * @argument {Element} element
     * @returns {Object} object containing width and height properties
     */


    function getOuterSizes(element) {
      var styles = getComputedStyle(element);
      var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
      var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
      var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
      };
      return result;
    }
    /**
     * Get the opposite placement of the given one
     * @method
     * @memberof Popper.Utils
     * @argument {String} placement
     * @returns {String} flipped placement
     */


    function getOppositePlacement(placement) {
      var hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
      };
      return placement.replace(/left|right|bottom|top/g, function (matched) {
        return hash[matched];
      });
    }
    /**
     * Get offsets to the popper
     * @method
     * @memberof Popper.Utils
     * @param {Object} position - CSS position the Popper will get applied
     * @param {HTMLElement} popper - the popper element
     * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
     * @param {String} placement - one of the valid placement options
     * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
     */


    function getPopperOffsets(popper, referenceOffsets, placement) {
      placement = placement.split('-')[0]; // Get popper node sizes

      var popperRect = getOuterSizes(popper); // Add position, width and height to our offsets object

      var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
      }; // depending by the popper placement we have to compute its offsets slightly differently

      var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
      var mainSide = isHoriz ? 'top' : 'left';
      var secondarySide = isHoriz ? 'left' : 'top';
      var measurement = isHoriz ? 'height' : 'width';
      var secondaryMeasurement = !isHoriz ? 'height' : 'width';
      popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;

      if (placement === secondarySide) {
        popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
      } else {
        popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
      }

      return popperOffsets;
    }
    /**
     * Mimics the `find` method of Array
     * @method
     * @memberof Popper.Utils
     * @argument {Array} arr
     * @argument prop
     * @argument value
     * @returns index or -1
     */


    function find(arr, check) {
      // use native find if supported
      if (Array.prototype.find) {
        return arr.find(check);
      } // use `filter` to obtain the same behavior of `find`


      return arr.filter(check)[0];
    }
    /**
     * Return the index of the matching object
     * @method
     * @memberof Popper.Utils
     * @argument {Array} arr
     * @argument prop
     * @argument value
     * @returns index or -1
     */


    function findIndex(arr, prop, value) {
      // use native findIndex if supported
      if (Array.prototype.findIndex) {
        return arr.findIndex(function (cur) {
          return cur[prop] === value;
        });
      } // use `find` + `indexOf` if `findIndex` isn't supported


      var match = find(arr, function (obj) {
        return obj[prop] === value;
      });
      return arr.indexOf(match);
    }
    /**
     * Loop trough the list of modifiers and run them in order,
     * each of them will then edit the data object.
     * @method
     * @memberof Popper.Utils
     * @param {dataObject} data
     * @param {Array} modifiers
     * @param {String} ends - Optional modifier name used as stopper
     * @returns {dataObject}
     */


    function runModifiers(modifiers, data, ends) {
      var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
      modifiersToRun.forEach(function (modifier) {
        if (modifier['function']) {
          // eslint-disable-line dot-notation
          console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        }

        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation

        if (modifier.enabled && isFunction(fn)) {
          // Add properties to offsets to make them a complete clientRect object
          // we do this before each modifier to make sure the previous one doesn't
          // mess with these values
          data.offsets.popper = getClientRect(data.offsets.popper);
          data.offsets.reference = getClientRect(data.offsets.reference);
          data = fn(data, modifier);
        }
      });
      return data;
    }
    /**
     * Updates the position of the popper, computing the new offsets and applying
     * the new style.<br />
     * Prefer `scheduleUpdate` over `update` because of performance reasons.
     * @method
     * @memberof Popper
     */


    function update() {
      // if popper is destroyed, don't perform any further update
      if (this.state.isDestroyed) {
        return;
      }

      var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
      }; // compute reference element offsets

      data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed); // compute auto placement, store placement inside the data object,
      // modifiers will be able to edit `placement` if needed
      // and refer to originalPlacement to know the original value

      data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding); // store the computed placement inside `originalPlacement`

      data.originalPlacement = data.placement;
      data.positionFixed = this.options.positionFixed; // compute the popper offsets

      data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
      data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute'; // run the modifiers

      data = runModifiers(this.modifiers, data); // the first `update` will call `onCreate` callback
      // the other ones will call `onUpdate` callback

      if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
      } else {
        this.options.onUpdate(data);
      }
    }
    /**
     * Helper used to know if the given modifier is enabled.
     * @method
     * @memberof Popper.Utils
     * @returns {Boolean}
     */


    function isModifierEnabled(modifiers, modifierName) {
      return modifiers.some(function (_ref) {
        var name = _ref.name,
            enabled = _ref.enabled;
        return enabled && name === modifierName;
      });
    }
    /**
     * Get the prefixed supported property name
     * @method
     * @memberof Popper.Utils
     * @argument {String} property (camelCase)
     * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
     */


    function getSupportedPropertyName(property) {
      var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
      var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

      for (var i = 0; i < prefixes.length; i++) {
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;

        if (typeof document.body.style[toCheck] !== 'undefined') {
          return toCheck;
        }
      }

      return null;
    }
    /**
     * Destroy the popper
     * @method
     * @memberof Popper
     */


    function destroy() {
      this.state.isDestroyed = true; // touch DOM only if `applyStyle` modifier is enabled

      if (isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[getSupportedPropertyName('transform')] = '';
      }

      this.disableEventListeners(); // remove the popper if user explicity asked for the deletion on destroy
      // do not use `remove` because IE11 doesn't support it

      if (this.options.removeOnDestroy) {
        this.popper.parentNode.removeChild(this.popper);
      }

      return this;
    }
    /**
     * Get the window associated with the element
     * @argument {Element} element
     * @returns {Window}
     */


    function getWindow(element) {
      var ownerDocument = element.ownerDocument;
      return ownerDocument ? ownerDocument.defaultView : window;
    }

    function attachToScrollParents(scrollParent, event, callback, scrollParents) {
      var isBody = scrollParent.nodeName === 'BODY';
      var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
      target.addEventListener(event, callback, {
        passive: true
      });

      if (!isBody) {
        attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
      }

      scrollParents.push(target);
    }
    /**
     * Setup needed event listeners used to update the popper position
     * @method
     * @memberof Popper.Utils
     * @private
     */


    function setupEventListeners(reference, options, state, updateBound) {
      // Resize event listener on window
      state.updateBound = updateBound;
      getWindow(reference).addEventListener('resize', state.updateBound, {
        passive: true
      }); // Scroll event listener on scroll parents

      var scrollElement = getScrollParent(reference);
      attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
      state.scrollElement = scrollElement;
      state.eventsEnabled = true;
      return state;
    }
    /**
     * It will add resize/scroll events and start recalculating
     * position of the popper element when they are triggered.
     * @method
     * @memberof Popper
     */


    function enableEventListeners() {
      if (!this.state.eventsEnabled) {
        this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
      }
    }
    /**
     * Remove event listeners used to update the popper position
     * @method
     * @memberof Popper.Utils
     * @private
     */


    function removeEventListeners(reference, state) {
      // Remove resize event listener on window
      getWindow(reference).removeEventListener('resize', state.updateBound); // Remove scroll event listener on scroll parents

      state.scrollParents.forEach(function (target) {
        target.removeEventListener('scroll', state.updateBound);
      }); // Reset state

      state.updateBound = null;
      state.scrollParents = [];
      state.scrollElement = null;
      state.eventsEnabled = false;
      return state;
    }
    /**
     * It will remove resize/scroll events and won't recalculate popper position
     * when they are triggered. It also won't trigger onUpdate callback anymore,
     * unless you call `update` method manually.
     * @method
     * @memberof Popper
     */


    function disableEventListeners() {
      if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = removeEventListeners(this.reference, this.state);
      }
    }
    /**
     * Tells if a given input is a number
     * @method
     * @memberof Popper.Utils
     * @param {*} input to check
     * @return {Boolean}
     */


    function isNumeric(n) {
      return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
    }
    /**
     * Set the style to the given popper
     * @method
     * @memberof Popper.Utils
     * @argument {Element} element - Element to apply the style to
     * @argument {Object} styles
     * Object with a list of properties and values which will be applied to the element
     */


    function setStyles(element, styles) {
      Object.keys(styles).forEach(function (prop) {
        var unit = ''; // add unit if the value is numeric and is one of the following

        if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
          unit = 'px';
        }

        element.style[prop] = styles[prop] + unit;
      });
    }
    /**
     * Set the attributes to the given popper
     * @method
     * @memberof Popper.Utils
     * @argument {Element} element - Element to apply the attributes to
     * @argument {Object} styles
     * Object with a list of properties and values which will be applied to the element
     */


    function setAttributes(element, attributes) {
      Object.keys(attributes).forEach(function (prop) {
        var value = attributes[prop];

        if (value !== false) {
          element.setAttribute(prop, attributes[prop]);
        } else {
          element.removeAttribute(prop);
        }
      });
    }
    /**
     * @function
     * @memberof Modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @argument {Object} data.styles - List of style properties - values to apply to popper element
     * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
     * @argument {Object} options - Modifiers configuration and options
     * @returns {Object} The same data object
     */


    function applyStyle(data) {
      // any property present in `data.styles` will be applied to the popper,
      // in this way we can make the 3rd party modifiers add custom styles to it
      // Be aware, modifiers could override the properties defined in the previous
      // lines of this modifier!
      setStyles(data.instance.popper, data.styles); // any property present in `data.attributes` will be applied to the popper,
      // they will be set as HTML attributes of the element

      setAttributes(data.instance.popper, data.attributes); // if arrowElement is defined and arrowStyles has some properties

      if (data.arrowElement && Object.keys(data.arrowStyles).length) {
        setStyles(data.arrowElement, data.arrowStyles);
      }

      return data;
    }
    /**
     * Set the x-placement attribute before everything else because it could be used
     * to add margins to the popper margins needs to be calculated to get the
     * correct popper offsets.
     * @method
     * @memberof Popper.modifiers
     * @param {HTMLElement} reference - The reference element used to position the popper
     * @param {HTMLElement} popper - The HTML element used as popper
     * @param {Object} options - Popper.js options
     */


    function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
      // compute reference element offsets
      var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed); // compute auto placement, store placement inside the data object,
      // modifiers will be able to edit `placement` if needed
      // and refer to originalPlacement to know the original value

      var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
      popper.setAttribute('x-placement', placement); // Apply `position` to popper before anything else because
      // without the position applied we can't guarantee correct computations

      setStyles(popper, {
        position: options.positionFixed ? 'fixed' : 'absolute'
      });
      return options;
    }
    /**
     * @function
     * @memberof Modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @argument {Object} options - Modifiers configuration and options
     * @returns {Object} The data object, properly modified
     */


    function computeStyle(data, options) {
      var x = options.x,
          y = options.y;
      var popper = data.offsets.popper; // Remove this legacy support in Popper.js v2

      var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
        return modifier.name === 'applyStyle';
      }).gpuAcceleration;

      if (legacyGpuAccelerationOption !== undefined) {
        console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
      }

      var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
      var offsetParent = getOffsetParent(data.instance.popper);
      var offsetParentRect = getBoundingClientRect(offsetParent); // Styles

      var styles = {
        position: popper.position
      }; // Avoid blurry text by using full pixel integers.
      // For pixel-perfect positioning, top/bottom prefers rounded
      // values, while left/right prefers floored values.

      var offsets = {
        left: Math.floor(popper.left),
        top: Math.round(popper.top),
        bottom: Math.round(popper.bottom),
        right: Math.floor(popper.right)
      };
      var sideA = x === 'bottom' ? 'top' : 'bottom';
      var sideB = y === 'right' ? 'left' : 'right'; // if gpuAcceleration is set to `true` and transform is supported,
      //  we use `translate3d` to apply the position to the popper we
      // automatically use the supported prefixed version if needed

      var prefixedProperty = getSupportedPropertyName('transform'); // now, let's make a step back and look at this code closely (wtf?)
      // If the content of the popper grows once it's been positioned, it
      // may happen that the popper gets misplaced because of the new content
      // overflowing its reference element
      // To avoid this problem, we provide two options (x and y), which allow
      // the consumer to define the offset origin.
      // If we position a popper on top of a reference element, we can set
      // `x` to `top` to make the popper grow towards its top instead of
      // its bottom.

      var left = void 0,
          top = void 0;

      if (sideA === 'bottom') {
        top = -offsetParentRect.height + offsets.bottom;
      } else {
        top = offsets.top;
      }

      if (sideB === 'right') {
        left = -offsetParentRect.width + offsets.right;
      } else {
        left = offsets.left;
      }

      if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
      } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
      } // Attributes


      var attributes = {
        'x-placement': data.placement
      }; // Update `data` attributes, styles and arrowStyles

      data.attributes = _extends({}, attributes, data.attributes);
      data.styles = _extends({}, styles, data.styles);
      data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
      return data;
    }
    /**
     * Helper used to know if the given modifier depends from another one.<br />
     * It checks if the needed modifier is listed and enabled.
     * @method
     * @memberof Popper.Utils
     * @param {Array} modifiers - list of modifiers
     * @param {String} requestingName - name of requesting modifier
     * @param {String} requestedName - name of requested modifier
     * @returns {Boolean}
     */


    function isModifierRequired(modifiers, requestingName, requestedName) {
      var requesting = find(modifiers, function (_ref) {
        var name = _ref.name;
        return name === requestingName;
      });
      var isRequired = !!requesting && modifiers.some(function (modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
      });

      if (!isRequired) {
        var _requesting = '`' + requestingName + '`';

        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
      }

      return isRequired;
    }
    /**
     * @function
     * @memberof Modifiers
     * @argument {Object} data - The data object generated by update method
     * @argument {Object} options - Modifiers configuration and options
     * @returns {Object} The data object, properly modified
     */


    function arrow(data, options) {
      var _data$offsets$arrow; // arrow depends on keepTogether in order to work


      if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
        return data;
      }

      var arrowElement = options.element; // if arrowElement is a string, suppose it's a CSS selector

      if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement); // if arrowElement is not found, don't run the modifier

        if (!arrowElement) {
          return data;
        }
      } else {
        // if the arrowElement isn't a query selector we must check that the
        // provided DOM node is child of its popper node
        if (!data.instance.popper.contains(arrowElement)) {
          console.warn('WARNING: `arrow.element` must be child of its popper element!');
          return data;
        }
      }

      var placement = data.placement.split('-')[0];
      var _data$offsets = data.offsets,
          popper = _data$offsets.popper,
          reference = _data$offsets.reference;
      var isVertical = ['left', 'right'].indexOf(placement) !== -1;
      var len = isVertical ? 'height' : 'width';
      var sideCapitalized = isVertical ? 'Top' : 'Left';
      var side = sideCapitalized.toLowerCase();
      var altSide = isVertical ? 'left' : 'top';
      var opSide = isVertical ? 'bottom' : 'right';
      var arrowElementSize = getOuterSizes(arrowElement)[len]; //
      // extends keepTogether behavior making sure the popper and its
      // reference have enough pixels in conjuction
      //
      // top/left side

      if (reference[opSide] - arrowElementSize < popper[side]) {
        data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
      } // bottom/right side


      if (reference[side] + arrowElementSize > popper[opSide]) {
        data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
      }

      data.offsets.popper = getClientRect(data.offsets.popper); // compute center of the popper

      var center = reference[side] + reference[len] / 2 - arrowElementSize / 2; // Compute the sideValue using the updated popper offsets
      // take popper margin in account because we don't have this info available

      var css = getStyleComputedProperty(data.instance.popper);
      var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
      var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
      var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide; // prevent arrowElement from being placed not contiguously to its popper

      sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
      data.arrowElement = arrowElement;
      data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
      return data;
    }
    /**
     * Get the opposite placement variation of the given one
     * @method
     * @memberof Popper.Utils
     * @argument {String} placement variation
     * @returns {String} flipped placement variation
     */


    function getOppositeVariation(variation) {
      if (variation === 'end') {
        return 'start';
      } else if (variation === 'start') {
        return 'end';
      }

      return variation;
    }
    /**
     * List of accepted placements to use as values of the `placement` option.<br />
     * Valid placements are:
     * - `auto`
     * - `top`
     * - `right`
     * - `bottom`
     * - `left`
     *
     * Each placement can have a variation from this list:
     * - `-start`
     * - `-end`
     *
     * Variations are interpreted easily if you think of them as the left to right
     * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
     * is right.<br />
     * Vertically (`left` and `right`), `start` is top and `end` is bottom.
     *
     * Some valid examples are:
     * - `top-end` (on top of reference, right aligned)
     * - `right-start` (on right of reference, top aligned)
     * - `bottom` (on bottom, centered)
     * - `auto-right` (on the side with more space available, alignment depends by placement)
     *
     * @static
     * @type {Array}
     * @enum {String}
     * @readonly
     * @method placements
     * @memberof Popper
     */


    var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start']; // Get rid of `auto` `auto-start` and `auto-end`

    var validPlacements = placements.slice(3);
    /**
     * Given an initial placement, returns all the subsequent placements
     * clockwise (or counter-clockwise).
     *
     * @method
     * @memberof Popper.Utils
     * @argument {String} placement - A valid placement (it accepts variations)
     * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
     * @returns {Array} placements including their variations
     */

    function clockwise(placement) {
      var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var index = validPlacements.indexOf(placement);
      var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
      return counter ? arr.reverse() : arr;
    }

    var BEHAVIORS = {
      FLIP: 'flip',
      CLOCKWISE: 'clockwise',
      COUNTERCLOCKWISE: 'counterclockwise'
    };
    /**
     * @function
     * @memberof Modifiers
     * @argument {Object} data - The data object generated by update method
     * @argument {Object} options - Modifiers configuration and options
     * @returns {Object} The data object, properly modified
     */

    function flip(data, options) {
      // if `inner` modifier is enabled, we can't use the `flip` modifier
      if (isModifierEnabled(data.instance.modifiers, 'inner')) {
        return data;
      }

      if (data.flipped && data.placement === data.originalPlacement) {
        // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
        return data;
      }

      var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
      var placement = data.placement.split('-')[0];
      var placementOpposite = getOppositePlacement(placement);
      var variation = data.placement.split('-')[1] || '';
      var flipOrder = [];

      switch (options.behavior) {
        case BEHAVIORS.FLIP:
          flipOrder = [placement, placementOpposite];
          break;

        case BEHAVIORS.CLOCKWISE:
          flipOrder = clockwise(placement);
          break;

        case BEHAVIORS.COUNTERCLOCKWISE:
          flipOrder = clockwise(placement, true);
          break;

        default:
          flipOrder = options.behavior;
      }

      flipOrder.forEach(function (step, index) {
        if (placement !== step || flipOrder.length === index + 1) {
          return data;
        }

        placement = data.placement.split('-')[0];
        placementOpposite = getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference; // using floor because the reference offsets may contain decimals we are not going to consider here

        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom; // flip the variation if required

        var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
        var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

        if (overlapsRef || overflowsBoundaries || flippedVariation) {
          // this boolean to detect any flip loop
          data.flipped = true;

          if (overlapsRef || overflowsBoundaries) {
            placement = flipOrder[index + 1];
          }

          if (flippedVariation) {
            variation = getOppositeVariation(variation);
          }

          data.placement = placement + (variation ? '-' + variation : ''); // this object contains `position`, we want to preserve it along with
          // any additional property we may add in the future

          data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
          data = runModifiers(data.instance.modifiers, data, 'flip');
        }
      });
      return data;
    }
    /**
     * @function
     * @memberof Modifiers
     * @argument {Object} data - The data object generated by update method
     * @argument {Object} options - Modifiers configuration and options
     * @returns {Object} The data object, properly modified
     */


    function keepTogether(data) {
      var _data$offsets = data.offsets,
          popper = _data$offsets.popper,
          reference = _data$offsets.reference;
      var placement = data.placement.split('-')[0];
      var floor = Math.floor;
      var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
      var side = isVertical ? 'right' : 'bottom';
      var opSide = isVertical ? 'left' : 'top';
      var measurement = isVertical ? 'width' : 'height';

      if (popper[side] < floor(reference[opSide])) {
        data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
      }

      if (popper[opSide] > floor(reference[side])) {
        data.offsets.popper[opSide] = floor(reference[side]);
      }

      return data;
    }
    /**
     * Converts a string containing value + unit into a px value number
     * @function
     * @memberof {modifiers~offset}
     * @private
     * @argument {String} str - Value + unit string
     * @argument {String} measurement - `height` or `width`
     * @argument {Object} popperOffsets
     * @argument {Object} referenceOffsets
     * @returns {Number|String}
     * Value in pixels, or original string if no values were extracted
     */


    function toValue(str, measurement, popperOffsets, referenceOffsets) {
      // separate value from unit
      var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
      var value = +split[1];
      var unit = split[2]; // If it's not a number it's an operator, I guess

      if (!value) {
        return str;
      }

      if (unit.indexOf('%') === 0) {
        var element = void 0;

        switch (unit) {
          case '%p':
            element = popperOffsets;
            break;

          case '%':
          case '%r':
          default:
            element = referenceOffsets;
        }

        var rect = getClientRect(element);
        return rect[measurement] / 100 * value;
      } else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;

        if (unit === 'vh') {
          size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        } else {
          size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        }

        return size / 100 * value;
      } else {
        // if is an explicit pixel unit, we get rid of the unit and keep the value
        // if is an implicit unit, it's px, and we return just the value
        return value;
      }
    }
    /**
     * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
     * @function
     * @memberof {modifiers~offset}
     * @private
     * @argument {String} offset
     * @argument {Object} popperOffsets
     * @argument {Object} referenceOffsets
     * @argument {String} basePlacement
     * @returns {Array} a two cells array with x and y offsets in numbers
     */


    function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
      var offsets = [0, 0]; // Use height if placement is left or right and index is 0 otherwise use width
      // in this way the first offset will use an axis and the second one
      // will use the other one

      var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1; // Split the offset string to obtain a list of values and operands
      // The regex addresses values with the plus or minus sign in front (+10, -20, etc)

      var fragments = offset.split(/(\+|\-)/).map(function (frag) {
        return frag.trim();
      }); // Detect if the offset string contains a pair of values or a single one
      // they could be separated by comma or space

      var divider = fragments.indexOf(find(fragments, function (frag) {
        return frag.search(/,|\s/) !== -1;
      }));

      if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
        console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
      } // If divider is found, we divide the list of values and operands to divide
      // them by ofset X and Y.


      var splitRegex = /\s*,\s*|\s+/;
      var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments]; // Convert the values with units to absolute pixels to allow our computations

      ops = ops.map(function (op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op // This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function (a, b) {
          if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
            a[a.length - 1] = b;
            mergeWithPrevious = true;
            return a;
          } else if (mergeWithPrevious) {
            a[a.length - 1] += b;
            mergeWithPrevious = false;
            return a;
          } else {
            return a.concat(b);
          }
        }, []) // Here we convert the string values into number values (in px)
        .map(function (str) {
          return toValue(str, measurement, popperOffsets, referenceOffsets);
        });
      }); // Loop trough the offsets arrays and execute the operations

      ops.forEach(function (op, index) {
        op.forEach(function (frag, index2) {
          if (isNumeric(frag)) {
            offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
          }
        });
      });
      return offsets;
    }
    /**
     * @function
     * @memberof Modifiers
     * @argument {Object} data - The data object generated by update method
     * @argument {Object} options - Modifiers configuration and options
     * @argument {Number|String} options.offset=0
     * The offset value as described in the modifier description
     * @returns {Object} The data object, properly modified
     */


    function offset(data, _ref) {
      var offset = _ref.offset;
      var placement = data.placement,
          _data$offsets = data.offsets,
          popper = _data$offsets.popper,
          reference = _data$offsets.reference;
      var basePlacement = placement.split('-')[0];
      var offsets = void 0;

      if (isNumeric(+offset)) {
        offsets = [+offset, 0];
      } else {
        offsets = parseOffset(offset, popper, reference, basePlacement);
      }

      if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
      } else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
      } else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
      } else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
      }

      data.popper = popper;
      return data;
    }
    /**
     * @function
     * @memberof Modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @argument {Object} options - Modifiers configuration and options
     * @returns {Object} The data object, properly modified
     */


    function preventOverflow(data, options) {
      var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper); // If offsetParent is the reference element, we really want to
      // go one step up and use the next offsetParent as reference to
      // avoid to make this modifier completely useless and look like broken

      if (data.instance.reference === boundariesElement) {
        boundariesElement = getOffsetParent(boundariesElement);
      } // NOTE: DOM access here
      // resets the popper's position so that the document size can be calculated excluding
      // the size of the popper element itself


      var transformProp = getSupportedPropertyName('transform');
      var popperStyles = data.instance.popper.style; // assignment to help minification

      var top = popperStyles.top,
          left = popperStyles.left,
          transform = popperStyles[transformProp];
      popperStyles.top = '';
      popperStyles.left = '';
      popperStyles[transformProp] = '';
      var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed); // NOTE: DOM access here
      // restores the original style properties after the offsets have been computed

      popperStyles.top = top;
      popperStyles.left = left;
      popperStyles[transformProp] = transform;
      options.boundaries = boundaries;
      var order = options.priority;
      var popper = data.offsets.popper;
      var check = {
        primary: function primary(placement) {
          var value = popper[placement];

          if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
            value = Math.max(popper[placement], boundaries[placement]);
          }

          return defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
          var mainSide = placement === 'right' ? 'left' : 'top';
          var value = popper[mainSide];

          if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
            value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
          }

          return defineProperty({}, mainSide, value);
        }
      };
      order.forEach(function (placement) {
        var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = _extends({}, popper, check[side](placement));
      });
      data.offsets.popper = popper;
      return data;
    }
    /**
     * @function
     * @memberof Modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @argument {Object} options - Modifiers configuration and options
     * @returns {Object} The data object, properly modified
     */


    function shift(data) {
      var placement = data.placement;
      var basePlacement = placement.split('-')[0];
      var shiftvariation = placement.split('-')[1]; // if shift shiftvariation is specified, run the modifier

      if (shiftvariation) {
        var _data$offsets = data.offsets,
            reference = _data$offsets.reference,
            popper = _data$offsets.popper;
        var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
          start: defineProperty({}, side, reference[side]),
          end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
      }

      return data;
    }
    /**
     * @function
     * @memberof Modifiers
     * @argument {Object} data - The data object generated by update method
     * @argument {Object} options - Modifiers configuration and options
     * @returns {Object} The data object, properly modified
     */


    function hide(data) {
      if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
        return data;
      }

      var refRect = data.offsets.reference;
      var bound = find(data.instance.modifiers, function (modifier) {
        return modifier.name === 'preventOverflow';
      }).boundaries;

      if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) {
          return data;
        }

        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
      } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) {
          return data;
        }

        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
      }

      return data;
    }
    /**
     * @function
     * @memberof Modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @argument {Object} options - Modifiers configuration and options
     * @returns {Object} The data object, properly modified
     */


    function inner(data) {
      var placement = data.placement;
      var basePlacement = placement.split('-')[0];
      var _data$offsets = data.offsets,
          popper = _data$offsets.popper,
          reference = _data$offsets.reference;
      var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
      var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
      popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
      data.placement = getOppositePlacement(placement);
      data.offsets.popper = getClientRect(popper);
      return data;
    }
    /**
     * Modifier function, each modifier can have a function of this type assigned
     * to its `fn` property.<br />
     * These functions will be called on each update, this means that you must
     * make sure they are performant enough to avoid performance bottlenecks.
     *
     * @function ModifierFn
     * @argument {dataObject} data - The data object generated by `update` method
     * @argument {Object} options - Modifiers configuration and options
     * @returns {dataObject} The data object, properly modified
     */

    /**
     * Modifiers are plugins used to alter the behavior of your poppers.<br />
     * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
     * needed by the library.
     *
     * Usually you don't want to override the `order`, `fn` and `onLoad` props.
     * All the other properties are configurations that could be tweaked.
     * @namespace modifiers
     */


    var modifiers = {
      /**
       * Modifier used to shift the popper on the start or end of its reference
       * element.<br />
       * It will read the variation of the `placement` property.<br />
       * It can be one either `-end` or `-start`.
       * @memberof modifiers
       * @inner
       */
      shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */
        order: 100,

        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,

        /** @prop {ModifierFn} */
        fn: shift
      },

      /**
       * The `offset` modifier can shift your popper on both its axis.
       *
       * It accepts the following units:
       * - `px` or unitless, interpreted as pixels
       * - `%` or `%r`, percentage relative to the length of the reference element
       * - `%p`, percentage relative to the length of the popper element
       * - `vw`, CSS viewport width unit
       * - `vh`, CSS viewport height unit
       *
       * For length is intended the main axis relative to the placement of the popper.<br />
       * This means that if the placement is `top` or `bottom`, the length will be the
       * `width`. In case of `left` or `right`, it will be the height.
       *
       * You can provide a single value (as `Number` or `String`), or a pair of values
       * as `String` divided by a comma or one (or more) white spaces.<br />
       * The latter is a deprecated method because it leads to confusion and will be
       * removed in v2.<br />
       * Additionally, it accepts additions and subtractions between different units.
       * Note that multiplications and divisions aren't supported.
       *
       * Valid examples are:
       * ```
       * 10
       * '10%'
       * '10, 10'
       * '10%, 10'
       * '10 + 10%'
       * '10 - 5vh + 3%'
       * '-10px + 5vh, 5px - 6%'
       * ```
       * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
       * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
       * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
       *
       * @memberof modifiers
       * @inner
       */
      offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */
        order: 200,

        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,

        /** @prop {ModifierFn} */
        fn: offset,

        /** @prop {Number|String} offset=0
         * The offset value as described in the modifier description
         */
        offset: 0
      },

      /**
       * Modifier used to prevent the popper from being positioned outside the boundary.
       *
       * An scenario exists where the reference itself is not within the boundaries.<br />
       * We can say it has "escaped the boundaries" — or just "escaped".<br />
       * In this case we need to decide whether the popper should either:
       *
       * - detach from the reference and remain "trapped" in the boundaries, or
       * - if it should ignore the boundary and "escape with its reference"
       *
       * When `escapeWithReference` is set to`true` and reference is completely
       * outside its boundaries, the popper will overflow (or completely leave)
       * the boundaries in order to remain attached to the edge of the reference.
       *
       * @memberof modifiers
       * @inner
       */
      preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */
        order: 300,

        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,

        /** @prop {ModifierFn} */
        fn: preventOverflow,

        /**
         * @prop {Array} [priority=['left','right','top','bottom']]
         * Popper will try to prevent overflow following these priorities by default,
         * then, it could overflow on the left and on top of the `boundariesElement`
         */
        priority: ['left', 'right', 'top', 'bottom'],

        /**
         * @prop {number} padding=5
         * Amount of pixel used to define a minimum distance between the boundaries
         * and the popper this makes sure the popper has always a little padding
         * between the edges of its container
         */
        padding: 5,

        /**
         * @prop {String|HTMLElement} boundariesElement='scrollParent'
         * Boundaries used by the modifier, can be `scrollParent`, `window`,
         * `viewport` or any DOM element.
         */
        boundariesElement: 'scrollParent'
      },

      /**
       * Modifier used to make sure the reference and its popper stay near eachothers
       * without leaving any gap between the two. Expecially useful when the arrow is
       * enabled and you want to assure it to point to its reference element.
       * It cares only about the first axis, you can still have poppers with margin
       * between the popper and its reference element.
       * @memberof modifiers
       * @inner
       */
      keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */
        order: 400,

        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,

        /** @prop {ModifierFn} */
        fn: keepTogether
      },

      /**
       * This modifier is used to move the `arrowElement` of the popper to make
       * sure it is positioned between the reference element and its popper element.
       * It will read the outer size of the `arrowElement` node to detect how many
       * pixels of conjuction are needed.
       *
       * It has no effect if no `arrowElement` is provided.
       * @memberof modifiers
       * @inner
       */
      arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */
        order: 500,

        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,

        /** @prop {ModifierFn} */
        fn: arrow,

        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
        element: '[x-arrow]'
      },

      /**
       * Modifier used to flip the popper's placement when it starts to overlap its
       * reference element.
       *
       * Requires the `preventOverflow` modifier before it in order to work.
       *
       * **NOTE:** this modifier will interrupt the current update cycle and will
       * restart it if it detects the need to flip the placement.
       * @memberof modifiers
       * @inner
       */
      flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */
        order: 600,

        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,

        /** @prop {ModifierFn} */
        fn: flip,

        /**
         * @prop {String|Array} behavior='flip'
         * The behavior used to change the popper's placement. It can be one of
         * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
         * placements (with optional variations).
         */
        behavior: 'flip',

        /**
         * @prop {number} padding=5
         * The popper will flip if it hits the edges of the `boundariesElement`
         */
        padding: 5,

        /**
         * @prop {String|HTMLElement} boundariesElement='viewport'
         * The element which will define the boundaries of the popper position,
         * the popper will never be placed outside of the defined boundaries
         * (except if keepTogether is enabled)
         */
        boundariesElement: 'viewport'
      },

      /**
       * Modifier used to make the popper flow toward the inner of the reference element.
       * By default, when this modifier is disabled, the popper will be placed outside
       * the reference element.
       * @memberof modifiers
       * @inner
       */
      inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */
        order: 700,

        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
        enabled: false,

        /** @prop {ModifierFn} */
        fn: inner
      },

      /**
       * Modifier used to hide the popper when its reference element is outside of the
       * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
       * be used to hide with a CSS selector the popper when its reference is
       * out of boundaries.
       *
       * Requires the `preventOverflow` modifier before it in order to work.
       * @memberof modifiers
       * @inner
       */
      hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */
        order: 800,

        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,

        /** @prop {ModifierFn} */
        fn: hide
      },

      /**
       * Computes the style that will be applied to the popper element to gets
       * properly positioned.
       *
       * Note that this modifier will not touch the DOM, it just prepares the styles
       * so that `applyStyle` modifier can apply it. This separation is useful
       * in case you need to replace `applyStyle` with a custom implementation.
       *
       * This modifier has `850` as `order` value to maintain backward compatibility
       * with previous versions of Popper.js. Expect the modifiers ordering method
       * to change in future major versions of the library.
       *
       * @memberof modifiers
       * @inner
       */
      computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */
        order: 850,

        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,

        /** @prop {ModifierFn} */
        fn: computeStyle,

        /**
         * @prop {Boolean} gpuAcceleration=true
         * If true, it uses the CSS 3d transformation to position the popper.
         * Otherwise, it will use the `top` and `left` properties.
         */
        gpuAcceleration: true,

        /**
         * @prop {string} [x='bottom']
         * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
         * Change this if your popper should grow in a direction different from `bottom`
         */
        x: 'bottom',

        /**
         * @prop {string} [x='left']
         * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
         * Change this if your popper should grow in a direction different from `right`
         */
        y: 'right'
      },

      /**
       * Applies the computed styles to the popper element.
       *
       * All the DOM manipulations are limited to this modifier. This is useful in case
       * you want to integrate Popper.js inside a framework or view library and you
       * want to delegate all the DOM manipulations to it.
       *
       * Note that if you disable this modifier, you must make sure the popper element
       * has its position set to `absolute` before Popper.js can do its work!
       *
       * Just disable this modifier and define you own to achieve the desired effect.
       *
       * @memberof modifiers
       * @inner
       */
      applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */
        order: 900,

        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,

        /** @prop {ModifierFn} */
        fn: applyStyle,

        /** @prop {Function} */
        onLoad: applyStyleOnLoad,

        /**
         * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
         * @prop {Boolean} gpuAcceleration=true
         * If true, it uses the CSS 3d transformation to position the popper.
         * Otherwise, it will use the `top` and `left` properties.
         */
        gpuAcceleration: undefined
      }
    };
    /**
     * The `dataObject` is an object containing all the informations used by Popper.js
     * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
     * @name dataObject
     * @property {Object} data.instance The Popper.js instance
     * @property {String} data.placement Placement applied to popper
     * @property {String} data.originalPlacement Placement originally defined on init
     * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
     * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
     * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
     * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
     * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
     * @property {Object} data.boundaries Offsets of the popper boundaries
     * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
     * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
     * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
     * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
     */

    /**
     * Default options provided to Popper.js constructor.<br />
     * These can be overriden using the `options` argument of Popper.js.<br />
     * To override an option, simply pass as 3rd argument an object with the same
     * structure of this object, example:
     * ```
     * new Popper(ref, pop, {
     *   modifiers: {
     *     preventOverflow: { enabled: false }
     *   }
     * })
     * ```
     * @type {Object}
     * @static
     * @memberof Popper
     */

    var Defaults = {
      /**
       * Popper's placement
       * @prop {Popper.placements} placement='bottom'
       */
      placement: 'bottom',

      /**
       * Set this to true if you want popper to position it self in 'fixed' mode
       * @prop {Boolean} positionFixed=false
       */
      positionFixed: false,

      /**
       * Whether events (resize, scroll) are initially enabled
       * @prop {Boolean} eventsEnabled=true
       */
      eventsEnabled: true,

      /**
       * Set to true if you want to automatically remove the popper when
       * you call the `destroy` method.
       * @prop {Boolean} removeOnDestroy=false
       */
      removeOnDestroy: false,

      /**
       * Callback called when the popper is created.<br />
       * By default, is set to no-op.<br />
       * Access Popper.js instance with `data.instance`.
       * @prop {onCreate}
       */
      onCreate: function onCreate() {},

      /**
       * Callback called when the popper is updated, this callback is not called
       * on the initialization/creation of the popper, but only on subsequent
       * updates.<br />
       * By default, is set to no-op.<br />
       * Access Popper.js instance with `data.instance`.
       * @prop {onUpdate}
       */
      onUpdate: function onUpdate() {},

      /**
       * List of modifiers used to modify the offsets before they are applied to the popper.
       * They provide most of the functionalities of Popper.js
       * @prop {modifiers}
       */
      modifiers: modifiers
    };
    /**
     * @callback onCreate
     * @param {dataObject} data
     */

    /**
     * @callback onUpdate
     * @param {dataObject} data
     */
    // Utils
    // Methods

    var Popper = function () {
      /**
       * Create a new Popper.js instance
       * @class Popper
       * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
       * @param {HTMLElement} popper - The HTML element used as popper.
       * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
       * @return {Object} instance - The generated Popper.js instance
       */
      function Popper(reference, popper) {
        var _this = this;

        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        classCallCheck(this, Popper);

        this.scheduleUpdate = function () {
          return requestAnimationFrame(_this.update);
        }; // make update() debounced, so that it only runs at most once-per-tick


        this.update = debounce(this.update.bind(this)); // with {} we create a new object with the options inside it

        this.options = _extends({}, Popper.Defaults, options); // init state

        this.state = {
          isDestroyed: false,
          isCreated: false,
          scrollParents: []
        }; // get reference and popper elements (allow jQuery wrappers)

        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper; // Deep merge modifiers options

        this.options.modifiers = {};
        Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
          _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        }); // Refactoring modifiers' list (Object => Array)

        this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
          return _extends({
            name: name
          }, _this.options.modifiers[name]);
        }) // sort the modifiers by order
        .sort(function (a, b) {
          return a.order - b.order;
        }); // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!

        this.modifiers.forEach(function (modifierOptions) {
          if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
            modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
          }
        }); // fire the first update to position the popper in the right place

        this.update();
        var eventsEnabled = this.options.eventsEnabled;

        if (eventsEnabled) {
          // setup event listeners, they will take care of update the position in specific situations
          this.enableEventListeners();
        }

        this.state.eventsEnabled = eventsEnabled;
      } // We can't use class properties because they don't get listed in the
      // class prototype and break stuff like Sinon stubs


      createClass(Popper, [{
        key: 'update',
        value: function update$$1() {
          return update.call(this);
        }
      }, {
        key: 'destroy',
        value: function destroy$$1() {
          return destroy.call(this);
        }
      }, {
        key: 'enableEventListeners',
        value: function enableEventListeners$$1() {
          return enableEventListeners.call(this);
        }
      }, {
        key: 'disableEventListeners',
        value: function disableEventListeners$$1() {
          return disableEventListeners.call(this);
        }
        /**
         * Schedule an update, it will run on the next UI update available
         * @method scheduleUpdate
         * @memberof Popper
         */

        /**
         * Collection of utilities useful when writing custom modifiers.
         * Starting from version 1.7, this method is available only if you
         * include `popper-utils.js` before `popper.js`.
         *
         * **DEPRECATION**: This way to access PopperUtils is deprecated
         * and will be removed in v2! Use the PopperUtils module directly instead.
         * Due to the high instability of the methods contained in Utils, we can't
         * guarantee them to follow semver. Use them at your own risk!
         * @static
         * @private
         * @type {Object}
         * @deprecated since version 1.8
         * @member Utils
         * @memberof Popper
         */

      }]);
      return Popper;
    }();
    /**
     * The `referenceObject` is an object that provides an interface compatible with Popper.js
     * and lets you use it as replacement of a real DOM node.<br />
     * You can use this method to position a popper relatively to a set of coordinates
     * in case you don't have a DOM node to use as reference.
     *
     * ```
     * new Popper(referenceObject, popperNode);
     * ```
     *
     * NB: This feature isn't supported in Internet Explorer 10
     * @name referenceObject
     * @property {Function} data.getBoundingClientRect
     * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
     * @property {number} data.clientWidth
     * An ES6 getter that will return the width of the virtual reference element.
     * @property {number} data.clientHeight
     * An ES6 getter that will return the height of the virtual reference element.
     */


    Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
    Popper.placements = placements;
    Popper.Defaults = Defaults;
    /* harmony default export */

    __webpack_exports__["default"] = Popper;
    /* WEBPACK VAR INJECTION */
  }).call(__webpack_exports__, __webpack_require__(33));
  /***/
},
/* 278 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var Arrow = function Arrow(props, context) {
    var _props$component = props.component,
        component = _props$component === undefined ? 'span' : _props$component,
        innerRef = props.innerRef,
        children = props.children,
        restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

    var popper = context.popper;

    var arrowRef = function arrowRef(node) {
      popper.setArrowNode(node);

      if (typeof innerRef === 'function') {
        innerRef(node);
      }
    };

    var arrowStyle = popper.getArrowStyle();

    if (typeof children === 'function') {
      var arrowProps = {
        ref: arrowRef,
        style: arrowStyle
      };
      return children({
        arrowProps: arrowProps,
        restProps: restProps
      });
    }

    var componentProps = _extends({}, restProps, {
      style: _extends({}, arrowStyle, restProps.style)
    });

    if (typeof component === 'string') {
      componentProps.ref = arrowRef;
    } else {
      componentProps.innerRef = arrowRef;
    }

    return (0, _react.createElement)(component, componentProps, children);
  };

  Arrow.contextTypes = {
    popper: _propTypes2["default"].object.isRequired
  };
  Arrow.propTypes = {
    component: _propTypes2["default"].oneOfType([_propTypes2["default"].node, _propTypes2["default"].func]),
    innerRef: _propTypes2["default"].func,
    children: _propTypes2["default"].oneOfType([_propTypes2["default"].node, _propTypes2["default"].func])
  };
  exports["default"] = Arrow;
  /***/
},,
/* 279 */

/* 280 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__Icon_Icon__ = __webpack_require__(34);

  var _class,
      _temp,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/UI/Modal/Modal.js'; // Components


  var Modal = (_temp = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Modal, _React$Component);

    function Modal() {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Modal);

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Modal.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Modal)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Modal, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', {
          className: 'cw-modal',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 20
          }
        }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', {
          className: 'modal-container',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 21
          }
        }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('button', {
          className: 'cw-button -close -small -round modal-close',
          onClick: this.props.onClickClose,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 22
          }
        }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Icon_Icon__["a"
        /* default */
        ], {
          name: 'icon-close',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 26
          }
        })), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', {
          className: 'modal-content',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 28
          }
        }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.map(this.props.children, function (child) {
          return child;
        }))), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('button', {
          className: 'modal-backdrop cw-button -clean',
          onClick: this.props.onClickClose,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 34
          }
        }));
      }
    }]);

    return Modal;
  }(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component), _class.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    onClickClose: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  }, _class.defaultProps = {
    children: [],
    onClickClose: null
  }, _temp);
  Modal.displayName = 'Modal';
  /* harmony default export */

  __webpack_exports__["a"] = Modal;
  /***/
},
/* 281 */

/***/
function (module, exports, __webpack_require__) {
  var defineProperty = __webpack_require__(282);
  /**
   * The base implementation of `assignValue` and `assignMergeValue` without
   * value checks.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */


  function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) {
      defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
      });
    } else {
      object[key] = value;
    }
  }

  module.exports = baseAssignValue;
  /***/
},
/* 282 */

/***/
function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(28);

  var defineProperty = function () {
    try {
      var func = getNative(Object, 'defineProperty');
      func({}, '', {});
      return func;
    } catch (e) {}
  }();

  module.exports = defineProperty;
  /***/
},
/* 283 */

/***/
function (module, exports, __webpack_require__) {
  var isFunction = __webpack_require__(146),
      isMasked = __webpack_require__(284),
      isObject = __webpack_require__(93),
      toSource = __webpack_require__(147);
  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */


  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  /** Used to detect host constructors (Safari). */

  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  /** Used for built-in method references. */

  var funcProto = Function.prototype,
      objectProto = Object.prototype;
  /** Used to resolve the decompiled source of functions. */

  var funcToString = funcProto.toString;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /** Used to detect if a method is native. */

  var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */

  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }

    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }

  module.exports = baseIsNative;
  /***/
},
/* 284 */

/***/
function (module, exports, __webpack_require__) {
  var coreJsData = __webpack_require__(285);
  /** Used to detect methods masquerading as native. */


  var maskSrcKey = function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
  }();
  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */


  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }

  module.exports = isMasked;
  /***/
},
/* 285 */

/***/
function (module, exports, __webpack_require__) {
  var root = __webpack_require__(19);
  /** Used to detect overreaching core-js shims. */


  var coreJsData = root['__core-js_shared__'];
  module.exports = coreJsData;
  /***/
},
/* 286 */

/***/
function (module, exports) {
  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  module.exports = getValue;
  /***/
},
/* 287 */

/***/
function (module, exports, __webpack_require__) {
  var baseFor = __webpack_require__(288),
      keys = __webpack_require__(94);
  /**
   * The base implementation of `_.forOwn` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Object} Returns `object`.
   */


  function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
  }

  module.exports = baseForOwn;
  /***/
},
/* 288 */

/***/
function (module, exports, __webpack_require__) {
  var createBaseFor = __webpack_require__(289);
  /**
   * The base implementation of `baseForOwn` which iterates over `object`
   * properties returned by `keysFunc` and invokes `iteratee` for each property.
   * Iteratee functions may exit iteration early by explicitly returning `false`.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @returns {Object} Returns `object`.
   */


  var baseFor = createBaseFor();
  module.exports = baseFor;
  /***/
},
/* 289 */

/***/
function (module, exports) {
  /**
   * Creates a base function for methods like `_.forIn` and `_.forOwn`.
   *
   * @private
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */
  function createBaseFor(fromRight) {
    return function (object, iteratee, keysFunc) {
      var index = -1,
          iterable = Object(object),
          props = keysFunc(object),
          length = props.length;

      while (length--) {
        var key = props[fromRight ? length : ++index];

        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }

      return object;
    };
  }

  module.exports = createBaseFor;
  /***/
},
/* 290 */

/***/
function (module, exports, __webpack_require__) {
  var baseTimes = __webpack_require__(291),
      isArguments = __webpack_require__(148),
      isArray = __webpack_require__(25),
      isBuffer = __webpack_require__(149),
      isIndex = __webpack_require__(150),
      isTypedArray = __webpack_require__(151);
  /** Used for built-in method references. */


  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */

  function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value),
        isArg = !isArr && isArguments(value),
        isBuff = !isArr && !isArg && isBuffer(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;

    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
      key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
      isIndex(key, length)))) {
        result.push(key);
      }
    }

    return result;
  }

  module.exports = arrayLikeKeys;
  /***/
},
/* 291 */

/***/
function (module, exports) {
  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }

    return result;
  }

  module.exports = baseTimes;
  /***/
},
/* 292 */

/***/
function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(43),
      isObjectLike = __webpack_require__(44);
  /** `Object#toString` result references. */


  var argsTag = '[object Arguments]';
  /**
   * The base implementation of `_.isArguments`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   */

  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
  }

  module.exports = baseIsArguments;
  /***/
},
/* 293 */

/***/
function (module, exports) {
  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */
  function stubFalse() {
    return false;
  }

  module.exports = stubFalse;
  /***/
},
/* 294 */

/***/
function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(43),
      isLength = __webpack_require__(95),
      isObjectLike = __webpack_require__(44);
  /** `Object#toString` result references. */


  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';
  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';
  /** Used to identify `toStringTag` values of typed arrays. */

  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */

  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }

  module.exports = baseIsTypedArray;
  /***/
},
/* 295 */

/***/
function (module, exports) {
  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }

  module.exports = baseUnary;
  /***/
},
/* 296 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (module) {
    var freeGlobal = __webpack_require__(139);
    /** Detect free variable `exports`. */


    var freeExports = _typeof4(exports) == 'object' && exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */

    var freeModule = freeExports && _typeof4(module) == 'object' && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */

    var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */

    var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */

    var nodeUtil = function () {
      try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
      } catch (e) {}
    }();

    module.exports = nodeUtil;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(45)(module));
  /***/
},
/* 297 */

/***/
function (module, exports, __webpack_require__) {
  var isPrototype = __webpack_require__(298),
      nativeKeys = __webpack_require__(299);
  /** Used for built-in method references. */


  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */

  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }

    var result = [];

    for (var key in Object(object)) {
      if (hasOwnProperty.call(object, key) && key != 'constructor') {
        result.push(key);
      }
    }

    return result;
  }

  module.exports = baseKeys;
  /***/
},
/* 298 */

/***/
function (module, exports) {
  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */

  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
  }

  module.exports = isPrototype;
  /***/
},
/* 299 */

/***/
function (module, exports, __webpack_require__) {
  var overArg = __webpack_require__(300);
  /* Built-in method references for those with the same name as other `lodash` methods. */


  var nativeKeys = overArg(Object.keys, Object);
  module.exports = nativeKeys;
  /***/
},
/* 300 */

/***/
function (module, exports) {
  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }

  module.exports = overArg;
  /***/
},
/* 301 */

/***/
function (module, exports, __webpack_require__) {
  var isFunction = __webpack_require__(146),
      isLength = __webpack_require__(95);
  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */


  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }

  module.exports = isArrayLike;
  /***/
},
/* 302 */

/***/
function (module, exports, __webpack_require__) {
  var baseMatches = __webpack_require__(303),
      baseMatchesProperty = __webpack_require__(350),
      identity = __webpack_require__(358),
      isArray = __webpack_require__(25),
      property = __webpack_require__(359);
  /**
   * The base implementation of `_.iteratee`.
   *
   * @private
   * @param {*} [value=_.identity] The value to convert to an iteratee.
   * @returns {Function} Returns the iteratee.
   */


  function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') {
      return value;
    }

    if (value == null) {
      return identity;
    }

    if (_typeof4(value) == 'object') {
      return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    }

    return property(value);
  }

  module.exports = baseIteratee;
  /***/
},
/* 303 */

/***/
function (module, exports, __webpack_require__) {
  var baseIsMatch = __webpack_require__(304),
      getMatchData = __webpack_require__(349),
      matchesStrictComparable = __webpack_require__(157);
  /**
   * The base implementation of `_.matches` which doesn't clone `source`.
   *
   * @private
   * @param {Object} source The object of property values to match.
   * @returns {Function} Returns the new spec function.
   */


  function baseMatches(source) {
    var matchData = getMatchData(source);

    if (matchData.length == 1 && matchData[0][2]) {
      return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    }

    return function (object) {
      return object === source || baseIsMatch(object, source, matchData);
    };
  }

  module.exports = baseMatches;
  /***/
},
/* 304 */

/***/
function (module, exports, __webpack_require__) {
  var Stack = __webpack_require__(152),
      baseIsEqual = __webpack_require__(154);
  /** Used to compose bitmasks for value comparisons. */


  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;
  /**
   * The base implementation of `_.isMatch` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to inspect.
   * @param {Object} source The object of property values to match.
   * @param {Array} matchData The property names, values, and compare flags to match.
   * @param {Function} [customizer] The function to customize comparisons.
   * @returns {boolean} Returns `true` if `object` is a match, else `false`.
   */

  function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length,
        length = index,
        noCustomizer = !customizer;

    if (object == null) {
      return !length;
    }

    object = Object(object);

    while (index--) {
      var data = matchData[index];

      if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
        return false;
      }
    }

    while (++index < length) {
      data = matchData[index];
      var key = data[0],
          objValue = object[key],
          srcValue = data[1];

      if (noCustomizer && data[2]) {
        if (objValue === undefined && !(key in object)) {
          return false;
        }
      } else {
        var stack = new Stack();

        if (customizer) {
          var result = customizer(objValue, srcValue, key, object, source, stack);
        }

        if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
          return false;
        }
      }
    }

    return true;
  }

  module.exports = baseIsMatch;
  /***/
},
/* 305 */

/***/
function (module, exports) {
  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */
  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }

  module.exports = listCacheClear;
  /***/
},
/* 306 */

/***/
function (module, exports, __webpack_require__) {
  var assocIndexOf = __webpack_require__(60);
  /** Used for built-in method references. */


  var arrayProto = Array.prototype;
  /** Built-in value references. */

  var splice = arrayProto.splice;
  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */

  function listCacheDelete(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }

    var lastIndex = data.length - 1;

    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }

    --this.size;
    return true;
  }

  module.exports = listCacheDelete;
  /***/
},
/* 307 */

/***/
function (module, exports, __webpack_require__) {
  var assocIndexOf = __webpack_require__(60);
  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function listCacheGet(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
  }

  module.exports = listCacheGet;
  /***/
},
/* 308 */

/***/
function (module, exports, __webpack_require__) {
  var assocIndexOf = __webpack_require__(60);
  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }

  module.exports = listCacheHas;
  /***/
},
/* 309 */

/***/
function (module, exports, __webpack_require__) {
  var assocIndexOf = __webpack_require__(60);
  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */


  function listCacheSet(key, value) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }

    return this;
  }

  module.exports = listCacheSet;
  /***/
},
/* 310 */

/***/
function (module, exports, __webpack_require__) {
  var ListCache = __webpack_require__(59);
  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */


  function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
  }

  module.exports = stackClear;
  /***/
},
/* 311 */

/***/
function (module, exports) {
  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function stackDelete(key) {
    var data = this.__data__,
        result = data['delete'](key);
    this.size = data.size;
    return result;
  }

  module.exports = stackDelete;
  /***/
},
/* 312 */

/***/
function (module, exports) {
  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function stackGet(key) {
    return this.__data__.get(key);
  }

  module.exports = stackGet;
  /***/
},
/* 313 */

/***/
function (module, exports) {
  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function stackHas(key) {
    return this.__data__.has(key);
  }

  module.exports = stackHas;
  /***/
},
/* 314 */

/***/
function (module, exports, __webpack_require__) {
  var ListCache = __webpack_require__(59),
      Map = __webpack_require__(96),
      MapCache = __webpack_require__(97);
  /** Used as the size to enable large array optimizations. */


  var LARGE_ARRAY_SIZE = 200;
  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */

  function stackSet(key, value) {
    var data = this.__data__;

    if (data instanceof ListCache) {
      var pairs = data.__data__;

      if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }

      data = this.__data__ = new MapCache(pairs);
    }

    data.set(key, value);
    this.size = data.size;
    return this;
  }

  module.exports = stackSet;
  /***/
},
/* 315 */

/***/
function (module, exports, __webpack_require__) {
  var Hash = __webpack_require__(316),
      ListCache = __webpack_require__(59),
      Map = __webpack_require__(96);
  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */


  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      'hash': new Hash(),
      'map': new (Map || ListCache)(),
      'string': new Hash()
    };
  }

  module.exports = mapCacheClear;
  /***/
},
/* 316 */

/***/
function (module, exports, __webpack_require__) {
  var hashClear = __webpack_require__(317),
      hashDelete = __webpack_require__(318),
      hashGet = __webpack_require__(319),
      hashHas = __webpack_require__(320),
      hashSet = __webpack_require__(321);
  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */


  function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  } // Add methods to `Hash`.


  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;
  module.exports = Hash;
  /***/
},
/* 317 */

/***/
function (module, exports, __webpack_require__) {
  var nativeCreate = __webpack_require__(61);
  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */


  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
  }

  module.exports = hashClear;
  /***/
},
/* 318 */

/***/
function (module, exports) {
  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }

  module.exports = hashDelete;
  /***/
},
/* 319 */

/***/
function (module, exports, __webpack_require__) {
  var nativeCreate = __webpack_require__(61);
  /** Used to stand-in for `undefined` hash values. */


  var HASH_UNDEFINED = '__lodash_hash_undefined__';
  /** Used for built-in method references. */

  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */

  function hashGet(key) {
    var data = this.__data__;

    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }

    return hasOwnProperty.call(data, key) ? data[key] : undefined;
  }

  module.exports = hashGet;
  /***/
},
/* 320 */

/***/
function (module, exports, __webpack_require__) {
  var nativeCreate = __webpack_require__(61);
  /** Used for built-in method references. */


  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */

  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
  }

  module.exports = hashHas;
  /***/
},
/* 321 */

/***/
function (module, exports, __webpack_require__) {
  var nativeCreate = __webpack_require__(61);
  /** Used to stand-in for `undefined` hash values. */


  var HASH_UNDEFINED = '__lodash_hash_undefined__';
  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */

  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
  }

  module.exports = hashSet;
  /***/
},
/* 322 */

/***/
function (module, exports, __webpack_require__) {
  var getMapData = __webpack_require__(62);
  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
  }

  module.exports = mapCacheDelete;
  /***/
},
/* 323 */

/***/
function (module, exports) {
  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */
  function isKeyable(value) {
    var type = _typeof4(value);

    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
  }

  module.exports = isKeyable;
  /***/
},
/* 324 */

/***/
function (module, exports, __webpack_require__) {
  var getMapData = __webpack_require__(62);
  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }

  module.exports = mapCacheGet;
  /***/
},
/* 325 */

/***/
function (module, exports, __webpack_require__) {
  var getMapData = __webpack_require__(62);
  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }

  module.exports = mapCacheHas;
  /***/
},
/* 326 */

/***/
function (module, exports, __webpack_require__) {
  var getMapData = __webpack_require__(62);
  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */


  function mapCacheSet(key, value) {
    var data = getMapData(this, key),
        size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  }

  module.exports = mapCacheSet;
  /***/
},
/* 327 */

/***/
function (module, exports, __webpack_require__) {
  var Stack = __webpack_require__(152),
      equalArrays = __webpack_require__(155),
      equalByTag = __webpack_require__(333),
      equalObjects = __webpack_require__(337),
      getTag = __webpack_require__(344),
      isArray = __webpack_require__(25),
      isBuffer = __webpack_require__(149),
      isTypedArray = __webpack_require__(151);
  /** Used to compose bitmasks for value comparisons. */


  var COMPARE_PARTIAL_FLAG = 1;
  /** `Object#toString` result references. */

  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      objectTag = '[object Object]';
  /** Used for built-in method references. */

  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * A specialized version of `baseIsEqual` for arrays and objects which performs
   * deep comparisons and tracks traversed objects enabling objects with circular
   * references to be compared.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} [stack] Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */

  function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object),
        othIsArr = isArray(other),
        objTag = objIsArr ? arrayTag : getTag(object),
        othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag,
        othIsObj = othTag == objectTag,
        isSameTag = objTag == othTag;

    if (isSameTag && isBuffer(object)) {
      if (!isBuffer(other)) {
        return false;
      }

      objIsArr = true;
      objIsObj = false;
    }

    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack());
      return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }

    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
      var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
          othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object,
            othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }

    if (!isSameTag) {
      return false;
    }

    stack || (stack = new Stack());
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
  }

  module.exports = baseIsEqualDeep;
  /***/
},
/* 328 */

/***/
function (module, exports, __webpack_require__) {
  var MapCache = __webpack_require__(97),
      setCacheAdd = __webpack_require__(329),
      setCacheHas = __webpack_require__(330);
  /**
   *
   * Creates an array cache object to store unique values.
   *
   * @private
   * @constructor
   * @param {Array} [values] The values to cache.
   */


  function SetCache(values) {
    var index = -1,
        length = values == null ? 0 : values.length;
    this.__data__ = new MapCache();

    while (++index < length) {
      this.add(values[index]);
    }
  } // Add methods to `SetCache`.


  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
  SetCache.prototype.has = setCacheHas;
  module.exports = SetCache;
  /***/
},
/* 329 */

/***/
function (module, exports) {
  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';
  /**
   * Adds `value` to the array cache.
   *
   * @private
   * @name add
   * @memberOf SetCache
   * @alias push
   * @param {*} value The value to cache.
   * @returns {Object} Returns the cache instance.
   */

  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);

    return this;
  }

  module.exports = setCacheAdd;
  /***/
},
/* 330 */

/***/
function (module, exports) {
  /**
   * Checks if `value` is in the array cache.
   *
   * @private
   * @name has
   * @memberOf SetCache
   * @param {*} value The value to search for.
   * @returns {number} Returns `true` if `value` is found, else `false`.
   */
  function setCacheHas(value) {
    return this.__data__.has(value);
  }

  module.exports = setCacheHas;
  /***/
},
/* 331 */

/***/
function (module, exports) {
  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }

    return false;
  }

  module.exports = arraySome;
  /***/
},
/* 332 */

/***/
function (module, exports) {
  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  module.exports = cacheHas;
  /***/
},
/* 333 */

/***/
function (module, exports, __webpack_require__) {
  var _Symbol11 = __webpack_require__(58),
      Uint8Array = __webpack_require__(334),
      eq = __webpack_require__(153),
      equalArrays = __webpack_require__(155),
      mapToArray = __webpack_require__(335),
      setToArray = __webpack_require__(336);
  /** Used to compose bitmasks for value comparisons. */


  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;
  /** `Object#toString` result references. */

  var boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]';
  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]';
  /** Used to convert symbols to primitives and strings. */

  var symbolProto = _Symbol11 ? _Symbol11.prototype : undefined,
      symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
  /**
   * A specialized version of `baseIsEqualDeep` for comparing objects of
   * the same `toStringTag`.
   *
   * **Note:** This function only supports comparing values with tags of
   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {string} tag The `toStringTag` of the objects to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */

  function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }

        object = object.buffer;
        other = other.buffer;

      case arrayBufferTag:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
          return false;
        }

        return true;

      case boolTag:
      case dateTag:
      case numberTag:
        // Coerce booleans to `1` or `0` and dates to milliseconds.
        // Invalid dates are coerced to `NaN`.
        return eq(+object, +other);

      case errorTag:
        return object.name == other.name && object.message == other.message;

      case regexpTag:
      case stringTag:
        // Coerce regexes to strings and treat strings, primitives and objects,
        // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
        // for more details.
        return object == other + '';

      case mapTag:
        var convert = mapToArray;

      case setTag:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
        convert || (convert = setToArray);

        if (object.size != other.size && !isPartial) {
          return false;
        } // Assume cyclic values are equal.


        var stacked = stack.get(object);

        if (stacked) {
          return stacked == other;
        }

        bitmask |= COMPARE_UNORDERED_FLAG; // Recursively compare objects (susceptible to call stack limits).

        stack.set(object, other);
        var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        stack['delete'](object);
        return result;

      case symbolTag:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }

    }

    return false;
  }

  module.exports = equalByTag;
  /***/
},
/* 334 */

/***/
function (module, exports, __webpack_require__) {
  var root = __webpack_require__(19);
  /** Built-in value references. */


  var Uint8Array = root.Uint8Array;
  module.exports = Uint8Array;
  /***/
},
/* 335 */

/***/
function (module, exports) {
  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);
    map.forEach(function (value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  module.exports = mapToArray;
  /***/
},
/* 336 */

/***/
function (module, exports) {
  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);
    set.forEach(function (value) {
      result[++index] = value;
    });
    return result;
  }

  module.exports = setToArray;
  /***/
},
/* 337 */

/***/
function (module, exports, __webpack_require__) {
  var getAllKeys = __webpack_require__(338);
  /** Used to compose bitmasks for value comparisons. */


  var COMPARE_PARTIAL_FLAG = 1;
  /** Used for built-in method references. */

  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * A specialized version of `baseIsEqualDeep` for objects with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */

  function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        objProps = getAllKeys(object),
        objLength = objProps.length,
        othProps = getAllKeys(other),
        othLength = othProps.length;

    if (objLength != othLength && !isPartial) {
      return false;
    }

    var index = objLength;

    while (index--) {
      var key = objProps[index];

      if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
        return false;
      }
    } // Assume cyclic values are equal.


    var stacked = stack.get(object);

    if (stacked && stack.get(other)) {
      return stacked == other;
    }

    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;

    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key],
          othValue = other[key];

      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      } // Recursively compare objects (susceptible to call stack limits).


      if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result = false;
        break;
      }

      skipCtor || (skipCtor = key == 'constructor');
    }

    if (result && !skipCtor) {
      var objCtor = object.constructor,
          othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

      if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
        result = false;
      }
    }

    stack['delete'](object);
    stack['delete'](other);
    return result;
  }

  module.exports = equalObjects;
  /***/
},
/* 338 */

/***/
function (module, exports, __webpack_require__) {
  var baseGetAllKeys = __webpack_require__(339),
      getSymbols = __webpack_require__(341),
      keys = __webpack_require__(94);
  /**
   * Creates an array of own enumerable property names and symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names and symbols.
   */


  function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
  }

  module.exports = getAllKeys;
  /***/
},
/* 339 */

/***/
function (module, exports, __webpack_require__) {
  var arrayPush = __webpack_require__(340),
      isArray = __webpack_require__(25);
  /**
   * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
   * `keysFunc` and `symbolsFunc` to get the enumerable property names and
   * symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @param {Function} symbolsFunc The function to get the symbols of `object`.
   * @returns {Array} Returns the array of property names and symbols.
   */


  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
  }

  module.exports = baseGetAllKeys;
  /***/
},
/* 340 */

/***/
function (module, exports) {
  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }

    return array;
  }

  module.exports = arrayPush;
  /***/
},
/* 341 */

/***/
function (module, exports, __webpack_require__) {
  var arrayFilter = __webpack_require__(342),
      stubArray = __webpack_require__(343);
  /** Used for built-in method references. */


  var objectProto = Object.prototype;
  /** Built-in value references. */

  var propertyIsEnumerable = objectProto.propertyIsEnumerable;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeGetSymbols = Object.getOwnPropertySymbols;
  /**
   * Creates an array of the own enumerable symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */

  var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
    if (object == null) {
      return [];
    }

    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function (symbol) {
      return propertyIsEnumerable.call(object, symbol);
    });
  };
  module.exports = getSymbols;
  /***/
},
/* 342 */

/***/
function (module, exports) {
  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];

      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }

    return result;
  }

  module.exports = arrayFilter;
  /***/
},
/* 343 */

/***/
function (module, exports) {
  /**
   * This method returns a new empty array.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {Array} Returns the new empty array.
   * @example
   *
   * var arrays = _.times(2, _.stubArray);
   *
   * console.log(arrays);
   * // => [[], []]
   *
   * console.log(arrays[0] === arrays[1]);
   * // => false
   */
  function stubArray() {
    return [];
  }

  module.exports = stubArray;
  /***/
},
/* 344 */

/***/
function (module, exports, __webpack_require__) {
  var DataView = __webpack_require__(345),
      Map = __webpack_require__(96),
      Promise = __webpack_require__(346),
      Set = __webpack_require__(347),
      WeakMap = __webpack_require__(348),
      baseGetTag = __webpack_require__(43),
      toSource = __webpack_require__(147);
  /** `Object#toString` result references. */


  var mapTag = '[object Map]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      setTag = '[object Set]',
      weakMapTag = '[object WeakMap]';
  var dataViewTag = '[object DataView]';
  /** Used to detect maps, sets, and weakmaps. */

  var dataViewCtorString = toSource(DataView),
      mapCtorString = toSource(Map),
      promiseCtorString = toSource(Promise),
      setCtorString = toSource(Set),
      weakMapCtorString = toSource(WeakMap);
  /**
   * Gets the `toStringTag` of `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */

  var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function getTag(value) {
      var result = baseGetTag(value),
          Ctor = result == objectTag ? value.constructor : undefined,
          ctorString = Ctor ? toSource(Ctor) : '';

      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;

          case mapCtorString:
            return mapTag;

          case promiseCtorString:
            return promiseTag;

          case setCtorString:
            return setTag;

          case weakMapCtorString:
            return weakMapTag;
        }
      }

      return result;
    };
  }

  module.exports = getTag;
  /***/
},
/* 345 */

/***/
function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(28),
      root = __webpack_require__(19);
  /* Built-in method references that are verified to be native. */


  var DataView = getNative(root, 'DataView');
  module.exports = DataView;
  /***/
},
/* 346 */

/***/
function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(28),
      root = __webpack_require__(19);
  /* Built-in method references that are verified to be native. */


  var Promise = getNative(root, 'Promise');
  module.exports = Promise;
  /***/
},
/* 347 */

/***/
function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(28),
      root = __webpack_require__(19);
  /* Built-in method references that are verified to be native. */


  var Set = getNative(root, 'Set');
  module.exports = Set;
  /***/
},
/* 348 */

/***/
function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(28),
      root = __webpack_require__(19);
  /* Built-in method references that are verified to be native. */


  var WeakMap = getNative(root, 'WeakMap');
  module.exports = WeakMap;
  /***/
},
/* 349 */

/***/
function (module, exports, __webpack_require__) {
  var isStrictComparable = __webpack_require__(156),
      keys = __webpack_require__(94);
  /**
   * Gets the property names, values, and compare flags of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the match data of `object`.
   */


  function getMatchData(object) {
    var result = keys(object),
        length = result.length;

    while (length--) {
      var key = result[length],
          value = object[key];
      result[length] = [key, value, isStrictComparable(value)];
    }

    return result;
  }

  module.exports = getMatchData;
  /***/
},
/* 350 */

/***/
function (module, exports, __webpack_require__) {
  var baseIsEqual = __webpack_require__(154),
      get = __webpack_require__(351),
      hasIn = __webpack_require__(355),
      isKey = __webpack_require__(98),
      isStrictComparable = __webpack_require__(156),
      matchesStrictComparable = __webpack_require__(157),
      toKey = __webpack_require__(63);
  /** Used to compose bitmasks for value comparisons. */


  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;
  /**
   * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
   *
   * @private
   * @param {string} path The path of the property to get.
   * @param {*} srcValue The value to match.
   * @returns {Function} Returns the new spec function.
   */

  function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) {
      return matchesStrictComparable(toKey(path), srcValue);
    }

    return function (object) {
      var objValue = get(object, path);
      return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
  }

  module.exports = baseMatchesProperty;
  /***/
},
/* 351 */

/***/
function (module, exports, __webpack_require__) {
  var baseGet = __webpack_require__(158);
  /**
   * Gets the value at `path` of `object`. If the resolved value is
   * `undefined`, the `defaultValue` is returned in its place.
   *
   * @static
   * @memberOf _
   * @since 3.7.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @param {*} [defaultValue] The value returned for `undefined` resolved values.
   * @returns {*} Returns the resolved value.
   * @example
   *
   * var object = { 'a': [{ 'b': { 'c': 3 } }] };
   *
   * _.get(object, 'a[0].b.c');
   * // => 3
   *
   * _.get(object, ['a', '0', 'b', 'c']);
   * // => 3
   *
   * _.get(object, 'a.b.c', 'default');
   * // => 'default'
   */


  function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
  }

  module.exports = get;
  /***/
},
/* 352 */

/***/
function (module, exports, __webpack_require__) {
  var memoizeCapped = __webpack_require__(353);
  /** Used to match property names within property paths. */


  var reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
  /** Used to match backslashes in property paths. */

  var reEscapeChar = /\\(\\)?/g;
  /**
   * Converts `string` to a property path array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the property path array.
   */

  var stringToPath = memoizeCapped(function (string) {
    var result = [];

    if (reLeadingDot.test(string)) {
      result.push('');
    }

    string.replace(rePropName, function (match, number, quote, string) {
      result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
  });
  module.exports = stringToPath;
  /***/
},
/* 353 */

/***/
function (module, exports, __webpack_require__) {
  var memoize = __webpack_require__(354);
  /** Used as the maximum memoize cache size. */


  var MAX_MEMOIZE_SIZE = 500;
  /**
   * A specialized version of `_.memoize` which clears the memoized function's
   * cache when it exceeds `MAX_MEMOIZE_SIZE`.
   *
   * @private
   * @param {Function} func The function to have its output memoized.
   * @returns {Function} Returns the new memoized function.
   */

  function memoizeCapped(func) {
    var result = memoize(func, function (key) {
      if (cache.size === MAX_MEMOIZE_SIZE) {
        cache.clear();
      }

      return key;
    });
    var cache = result.cache;
    return result;
  }

  module.exports = memoizeCapped;
  /***/
},
/* 354 */

/***/
function (module, exports, __webpack_require__) {
  var MapCache = __webpack_require__(97);
  /** Error message constants. */


  var FUNC_ERROR_TEXT = 'Expected a function';
  /**
   * Creates a function that memoizes the result of `func`. If `resolver` is
   * provided, it determines the cache key for storing the result based on the
   * arguments provided to the memoized function. By default, the first argument
   * provided to the memoized function is used as the map cache key. The `func`
   * is invoked with the `this` binding of the memoized function.
   *
   * **Note:** The cache is exposed as the `cache` property on the memoized
   * function. Its creation may be customized by replacing the `_.memoize.Cache`
   * constructor with one whose instances implement the
   * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
   * method interface of `clear`, `delete`, `get`, `has`, and `set`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to have its output memoized.
   * @param {Function} [resolver] The function to resolve the cache key.
   * @returns {Function} Returns the new memoized function.
   * @example
   *
   * var object = { 'a': 1, 'b': 2 };
   * var other = { 'c': 3, 'd': 4 };
   *
   * var values = _.memoize(_.values);
   * values(object);
   * // => [1, 2]
   *
   * values(other);
   * // => [3, 4]
   *
   * object.a = 2;
   * values(object);
   * // => [1, 2]
   *
   * // Modify the result cache.
   * values.cache.set(object, ['a', 'b']);
   * values(object);
   * // => ['a', 'b']
   *
   * // Replace `_.memoize.Cache`.
   * _.memoize.Cache = WeakMap;
   */

  function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }

    var memoized = function memoized() {
      var args = arguments,
          key = resolver ? resolver.apply(this, args) : args[0],
          cache = memoized.cache;

      if (cache.has(key)) {
        return cache.get(key);
      }

      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result) || cache;
      return result;
    };

    memoized.cache = new (memoize.Cache || MapCache)();
    return memoized;
  } // Expose `MapCache`.


  memoize.Cache = MapCache;
  module.exports = memoize;
  /***/
},
/* 355 */

/***/
function (module, exports, __webpack_require__) {
  var baseHasIn = __webpack_require__(356),
      hasPath = __webpack_require__(357);
  /**
   * Checks if `path` is a direct or inherited property of `object`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   * @example
   *
   * var object = _.create({ 'a': _.create({ 'b': 2 }) });
   *
   * _.hasIn(object, 'a');
   * // => true
   *
   * _.hasIn(object, 'a.b');
   * // => true
   *
   * _.hasIn(object, ['a', 'b']);
   * // => true
   *
   * _.hasIn(object, 'b');
   * // => false
   */


  function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
  }

  module.exports = hasIn;
  /***/
},
/* 356 */

/***/
function (module, exports) {
  /**
   * The base implementation of `_.hasIn` without support for deep paths.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {Array|string} key The key to check.
   * @returns {boolean} Returns `true` if `key` exists, else `false`.
   */
  function baseHasIn(object, key) {
    return object != null && key in Object(object);
  }

  module.exports = baseHasIn;
  /***/
},
/* 357 */

/***/
function (module, exports, __webpack_require__) {
  var castPath = __webpack_require__(159),
      isArguments = __webpack_require__(148),
      isArray = __webpack_require__(25),
      isIndex = __webpack_require__(150),
      isLength = __webpack_require__(95),
      toKey = __webpack_require__(63);
  /**
   * Checks if `path` exists on `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @param {Function} hasFunc The function to check properties.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   */


  function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1,
        length = path.length,
        result = false;

    while (++index < length) {
      var key = toKey(path[index]);

      if (!(result = object != null && hasFunc(object, key))) {
        break;
      }

      object = object[key];
    }

    if (result || ++index != length) {
      return result;
    }

    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
  }

  module.exports = hasPath;
  /***/
},
/* 358 */

/***/
function (module, exports) {
  /**
   * This method returns the first argument it receives.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'a': 1 };
   *
   * console.log(_.identity(object) === object);
   * // => true
   */
  function identity(value) {
    return value;
  }

  module.exports = identity;
  /***/
},
/* 359 */

/***/
function (module, exports, __webpack_require__) {
  var baseProperty = __webpack_require__(360),
      basePropertyDeep = __webpack_require__(361),
      isKey = __webpack_require__(98),
      toKey = __webpack_require__(63);
  /**
   * Creates a function that returns the value at `path` of a given object.
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Util
   * @param {Array|string} path The path of the property to get.
   * @returns {Function} Returns the new accessor function.
   * @example
   *
   * var objects = [
   *   { 'a': { 'b': 2 } },
   *   { 'a': { 'b': 1 } }
   * ];
   *
   * _.map(objects, _.property('a.b'));
   * // => [2, 1]
   *
   * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
   * // => [1, 2]
   */


  function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
  }

  module.exports = property;
  /***/
},
/* 360 */

/***/
function (module, exports) {
  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function (object) {
      return object == null ? undefined : object[key];
    };
  }

  module.exports = baseProperty;
  /***/
},
/* 361 */

/***/
function (module, exports, __webpack_require__) {
  var baseGet = __webpack_require__(158);
  /**
   * A specialized version of `baseProperty` which supports deep paths.
   *
   * @private
   * @param {Array|string} path The path of the property to get.
   * @returns {Function} Returns the new accessor function.
   */


  function basePropertyDeep(path) {
    return function (object) {
      return baseGet(object, path);
    };
  }

  module.exports = basePropertyDeep;
  /***/
},
/* 362 */

/***/
function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
  /*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
  */

  /* global define */


  (function () {
    'use strict';

    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;

        var argType = _typeof4(arg);

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg) && arg.length) {
          var inner = classNames.apply(null, arg);

          if (inner) {
            classes.push(inner);
          }
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (typeof module !== 'undefined' && module.exports) {
      classNames["default"] = classNames;
      module.exports = classNames;
    } else if (true) {
      // register as 'classnames', consistent with npm package name
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
        return classNames;
      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
      window.classNames = classNames;
    }
  })();
  /***/

},
/* 363 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(364);
  /***/
},
/* 364 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  // This method of obtaining a reference to the global object needs to be
  // kept identical to the way it is obtained in runtime.js
  var g = function () {
    return this;
  }() || Function("return this")(); // Use `getOwnPropertyNames` because not all browsers support calling
  // `hasOwnProperty` on the global `self` object in a worker. See #183.


  var hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0; // Save the old regeneratorRuntime in case it needs to be restored later.

  var oldRuntime = hadRuntime && g.regeneratorRuntime; // Force reevalutation of runtime.js.

  g.regeneratorRuntime = undefined;
  module.exports = __webpack_require__(365);

  if (hadRuntime) {
    // Restore the original runtime.
    g.regeneratorRuntime = oldRuntime;
  } else {
    // Remove the global property added by runtime.js.
    try {
      delete g.regeneratorRuntime;
    } catch (e) {
      g.regeneratorRuntime = undefined;
    }
  }
  /***/

},
/* 365 */

/***/
function (module, exports) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  !function (global) {
    "use strict";

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    var inModule = _typeof4(module) === "object";
    var runtime = global.regeneratorRuntime;

    if (runtime) {
      if (inModule) {
        // If regeneratorRuntime is defined globally and we're in a module,
        // make the exports object identical to regeneratorRuntime.
        module.exports = runtime;
      } // Don't bother evaluating the rest of this file if the runtime was
      // already defined globally.


      return;
    } // Define the runtime globally (as expected by generated code) as either
    // module.exports (if we're in a module) or a new, empty object.


    runtime = global.regeneratorRuntime = inModule ? module.exports : {};

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    runtime.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};

    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        prototype[method] = function (arg) {
          return this._invoke(method, arg);
        };
      });
    }

    runtime.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    runtime.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;

        if (!(toStringTagSymbol in genFun)) {
          genFun[toStringTagSymbol] = "GeneratorFunction";
        }
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    runtime.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && _typeof4(value) === "object" && hasOwn.call(value, "__await")) {
            return Promise.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return Promise.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration. If the Promise is rejected, however, the
            // result for this iteration will be rejected with the same
            // reason. Note that rejections of yielded Promises are not
            // thrown back into the generator function, as is the case
            // when an awaited Promise is rejected. This difference in
            // behavior between yield and await is important, because it
            // allows the consumer to decide what to do with the yielded
            // rejection (swallow it and continue, manually .throw it back
            // into the generator, abandon iteration, whatever). With
            // await, by contrast, there is no opportunity to examine the
            // rejection reason outside the generator function, so the
            // only option is to throw it from the await expression, and
            // let the generator function handle the exception.
            result.value = unwrapped;
            resolve(result);
          }, reject);
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new Promise(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);

    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };

    runtime.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    runtime.async = function (innerFn, outerFn, self, tryLocsList) {
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
      return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    Gp[iteratorSymbol] = function () {
      return this;
    };

    Gp.toString = function () {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    runtime.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    runtime.values = values;

    function doneResult() {
      return {
        value: undefined,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined;
        }

        return ContinueSentinel;
      }
    };
  }( // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  function () {
    return this;
  }() || Function("return this")());
  /***/
},
/* 366 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  var _promise = __webpack_require__(162);

  var _promise2 = _interopRequireDefault(_promise);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  exports["default"] = function (fn) {
    return function () {
      var gen = fn.apply(this, arguments);
      return new _promise2["default"](function (resolve, reject) {
        function step(key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }

          if (info.done) {
            resolve(value);
          } else {
            return _promise2["default"].resolve(value).then(function (value) {
              step("next", value);
            }, function (err) {
              step("throw", err);
            });
          }
        }

        return step("next");
      });
    };
  };
  /***/

},
/* 367 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(128);

  __webpack_require__(74);

  __webpack_require__(125);

  __webpack_require__(368);

  __webpack_require__(376);

  __webpack_require__(377);

  module.exports = __webpack_require__(7).Promise;
  /***/
},
/* 368 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var LIBRARY = __webpack_require__(36);

  var global = __webpack_require__(9);

  var ctx = __webpack_require__(30);

  var classof = __webpack_require__(120);

  var $export = __webpack_require__(11);

  var isObject = __webpack_require__(22);

  var aFunction = __webpack_require__(54);

  var anInstance = __webpack_require__(369);

  var forOf = __webpack_require__(370);

  var speciesConstructor = __webpack_require__(163);

  var task = __webpack_require__(164).set;

  var microtask = __webpack_require__(372)();

  var newPromiseCapabilityModule = __webpack_require__(100);

  var perform = __webpack_require__(165);

  var userAgent = __webpack_require__(373);

  var promiseResolve = __webpack_require__(166);

  var PROMISE = 'Promise';
  var TypeError = global.TypeError;
  var process = global.process;
  var versions = process && process.versions;
  var v8 = versions && versions.v8 || '';
  var $Promise = global[PROMISE];
  var isNode = classof(process) == 'process';

  var empty = function empty() {
    /* empty */
  };

  var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
  var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
  var USE_NATIVE = !!function () {
    try {
      // correct subclassing with @@species support
      var promise = $Promise.resolve(1);

      var FakePromise = (promise.constructor = {})[__webpack_require__(10)('species')] = function (exec) {
        exec(empty, empty);
      }; // unhandled rejections tracking support, NodeJS Promise without it fails @@species test


      return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0 && userAgent.indexOf('Chrome/66') === -1;
    } catch (e) {
      /* empty */
    }
  }(); // helpers

  var isThenable = function isThenable(it) {
    var then;
    return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
  };

  var notify = function notify(promise, isReject) {
    if (promise._n) return;
    promise._n = true;
    var chain = promise._c;
    microtask(function () {
      var value = promise._v;
      var ok = promise._s == 1;
      var i = 0;

      var run = function run(reaction) {
        var handler = ok ? reaction.ok : reaction.fail;
        var resolve = reaction.resolve;
        var reject = reaction.reject;
        var domain = reaction.domain;
        var result, then, exited;

        try {
          if (handler) {
            if (!ok) {
              if (promise._h == 2) onHandleUnhandled(promise);
              promise._h = 1;
            }

            if (handler === true) result = value;else {
              if (domain) domain.enter();
              result = handler(value); // may throw

              if (domain) {
                domain.exit();
                exited = true;
              }
            }

            if (result === reaction.promise) {
              reject(TypeError('Promise-chain cycle'));
            } else if (then = isThenable(result)) {
              then.call(result, resolve, reject);
            } else resolve(result);
          } else reject(value);
        } catch (e) {
          if (domain && !exited) domain.exit();
          reject(e);
        }
      };

      while (chain.length > i) {
        run(chain[i++]);
      } // variable length - can't use forEach


      promise._c = [];
      promise._n = false;
      if (isReject && !promise._h) onUnhandled(promise);
    });
  };

  var onUnhandled = function onUnhandled(promise) {
    task.call(global, function () {
      var value = promise._v;
      var unhandled = isUnhandled(promise);
      var result, handler, console;

      if (unhandled) {
        result = perform(function () {
          if (isNode) {
            process.emit('unhandledRejection', value, promise);
          } else if (handler = global.onunhandledrejection) {
            handler({
              promise: promise,
              reason: value
            });
          } else if ((console = global.console) && console.error) {
            console.error('Unhandled promise rejection', value);
          }
        }); // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should

        promise._h = isNode || isUnhandled(promise) ? 2 : 1;
      }

      promise._a = undefined;
      if (unhandled && result.e) throw result.v;
    });
  };

  var isUnhandled = function isUnhandled(promise) {
    return promise._h !== 1 && (promise._a || promise._c).length === 0;
  };

  var onHandleUnhandled = function onHandleUnhandled(promise) {
    task.call(global, function () {
      var handler;

      if (isNode) {
        process.emit('rejectionHandled', promise);
      } else if (handler = global.onrejectionhandled) {
        handler({
          promise: promise,
          reason: promise._v
        });
      }
    });
  };

  var $reject = function $reject(value) {
    var promise = this;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap

    promise._v = value;
    promise._s = 2;
    if (!promise._a) promise._a = promise._c.slice();
    notify(promise, true);
  };

  var $resolve = function $resolve(value) {
    var promise = this;
    var then;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap

    try {
      if (promise === value) throw TypeError("Promise can't be resolved itself");

      if (then = isThenable(value)) {
        microtask(function () {
          var wrapper = {
            _w: promise,
            _d: false
          }; // wrap

          try {
            then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
          } catch (e) {
            $reject.call(wrapper, e);
          }
        });
      } else {
        promise._v = value;
        promise._s = 1;
        notify(promise, false);
      }
    } catch (e) {
      $reject.call({
        _w: promise,
        _d: false
      }, e); // wrap
    }
  }; // constructor polyfill


  if (!USE_NATIVE) {
    // 25.4.3.1 Promise(executor)
    $Promise = function Promise(executor) {
      anInstance(this, $Promise, PROMISE, '_h');
      aFunction(executor);
      Internal.call(this);

      try {
        executor(ctx($resolve, this, 1), ctx($reject, this, 1));
      } catch (err) {
        $reject.call(this, err);
      }
    }; // eslint-disable-next-line no-unused-vars


    Internal = function Promise(executor) {
      this._c = []; // <- awaiting reactions

      this._a = undefined; // <- checked in isUnhandled reactions

      this._s = 0; // <- state

      this._d = false; // <- done

      this._v = undefined; // <- value

      this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled

      this._n = false; // <- notify
    };

    Internal.prototype = __webpack_require__(374)($Promise.prototype, {
      // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
      then: function then(onFulfilled, onRejected) {
        var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
        reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
        reaction.fail = typeof onRejected == 'function' && onRejected;
        reaction.domain = isNode ? process.domain : undefined;

        this._c.push(reaction);

        if (this._a) this._a.push(reaction);
        if (this._s) notify(this, false);
        return reaction.promise;
      },
      // 25.4.5.1 Promise.prototype.catch(onRejected)
      'catch': function _catch(onRejected) {
        return this.then(undefined, onRejected);
      }
    });

    OwnPromiseCapability = function OwnPromiseCapability() {
      var promise = new Internal();
      this.promise = promise;
      this.resolve = ctx($resolve, promise, 1);
      this.reject = ctx($reject, promise, 1);
    };

    newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
      return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
    };
  }

  $export($export.G + $export.W + $export.F * !USE_NATIVE, {
    Promise: $Promise
  });

  __webpack_require__(56)($Promise, PROMISE);

  __webpack_require__(375)(PROMISE);

  Wrapper = __webpack_require__(7)[PROMISE]; // statics

  $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
    // 25.4.4.5 Promise.reject(r)
    reject: function reject(r) {
      var capability = newPromiseCapability(this);
      var $$reject = capability.reject;
      $$reject(r);
      return capability.promise;
    }
  });
  $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
    // 25.4.4.6 Promise.resolve(x)
    resolve: function resolve(x) {
      return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
    }
  });
  $export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(121)(function (iter) {
    $Promise.all(iter)['catch'](empty);
  })), PROMISE, {
    // 25.4.4.1 Promise.all(iterable)
    all: function all(iterable) {
      var C = this;
      var capability = newPromiseCapability(C);
      var resolve = capability.resolve;
      var reject = capability.reject;
      var result = perform(function () {
        var values = [];
        var index = 0;
        var remaining = 1;
        forOf(iterable, false, function (promise) {
          var $index = index++;
          var alreadyCalled = false;
          values.push(undefined);
          remaining++;
          C.resolve(promise).then(function (value) {
            if (alreadyCalled) return;
            alreadyCalled = true;
            values[$index] = value;
            --remaining || resolve(values);
          }, reject);
        });
        --remaining || resolve(values);
      });
      if (result.e) reject(result.v);
      return capability.promise;
    },
    // 25.4.4.4 Promise.race(iterable)
    race: function race(iterable) {
      var C = this;
      var capability = newPromiseCapability(C);
      var reject = capability.reject;
      var result = perform(function () {
        forOf(iterable, false, function (promise) {
          C.resolve(promise).then(capability.resolve, reject);
        });
      });
      if (result.e) reject(result.v);
      return capability.promise;
    }
  });
  /***/
},
/* 369 */

/***/
function (module, exports) {
  module.exports = function (it, Constructor, name, forbiddenField) {
    if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
      throw TypeError(name + ': incorrect invocation!');
    }

    return it;
  };
  /***/

},
/* 370 */

/***/
function (module, exports, __webpack_require__) {
  var ctx = __webpack_require__(30);

  var call = __webpack_require__(117);

  var isArrayIter = __webpack_require__(118);

  var anObject = __webpack_require__(16);

  var toLength = __webpack_require__(80);

  var getIterFn = __webpack_require__(119);

  var BREAK = {};
  var RETURN = {};

  var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
    var iterFn = ITERATOR ? function () {
      return iterable;
    } : getIterFn(iterable);
    var f = ctx(fn, that, entries ? 2 : 1);
    var index = 0;
    var length, step, iterator, result;
    if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!'); // fast case for arrays with default iterator

    if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
      result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
      if (result === BREAK || result === RETURN) return result;
    } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
      result = call(iterator, f, step.value, entries);
      if (result === BREAK || result === RETURN) return result;
    }
  };

  exports.BREAK = BREAK;
  exports.RETURN = RETURN;
  /***/
},
/* 371 */

/***/
function (module, exports) {
  // fast apply, http://jsperf.lnkit.com/fast-apply/5
  module.exports = function (fn, args, that) {
    var un = that === undefined;

    switch (args.length) {
      case 0:
        return un ? fn() : fn.call(that);

      case 1:
        return un ? fn(args[0]) : fn.call(that, args[0]);

      case 2:
        return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);

      case 3:
        return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);

      case 4:
        return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
    }

    return fn.apply(that, args);
  };
  /***/

},
/* 372 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(9);

  var macrotask = __webpack_require__(164).set;

  var Observer = global.MutationObserver || global.WebKitMutationObserver;
  var process = global.process;
  var Promise = global.Promise;
  var isNode = __webpack_require__(40)(process) == 'process';

  module.exports = function () {
    var head, last, notify;

    var flush = function flush() {
      var parent, fn;
      if (isNode && (parent = process.domain)) parent.exit();

      while (head) {
        fn = head.fn;
        head = head.next;

        try {
          fn();
        } catch (e) {
          if (head) notify();else last = undefined;
          throw e;
        }
      }

      last = undefined;
      if (parent) parent.enter();
    }; // Node.js


    if (isNode) {
      notify = function notify() {
        process.nextTick(flush);
      }; // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339

    } else if (Observer && !(global.navigator && global.navigator.standalone)) {
      var toggle = true;
      var node = document.createTextNode('');
      new Observer(flush).observe(node, {
        characterData: true
      }); // eslint-disable-line no-new

      notify = function notify() {
        node.data = toggle = !toggle;
      }; // environments with maybe non-completely correct, but existent Promise

    } else if (Promise && Promise.resolve) {
      // Promise.resolve without an argument throws an error in LG WebOS 2
      var promise = Promise.resolve(undefined);

      notify = function notify() {
        promise.then(flush);
      }; // for other environments - macrotask based on:
      // - setImmediate
      // - MessageChannel
      // - window.postMessag
      // - onreadystatechange
      // - setTimeout

    } else {
      notify = function notify() {
        // strange IE + webpack dev server bug - use .call(global)
        macrotask.call(global, flush);
      };
    }

    return function (fn) {
      var task = {
        fn: fn,
        next: undefined
      };
      if (last) last.next = task;

      if (!head) {
        head = task;
        notify();
      }

      last = task;
    };
  };
  /***/

},
/* 373 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(9);

  var navigator = global.navigator;
  module.exports = navigator && navigator.userAgent || '';
  /***/
},
/* 374 */

/***/
function (module, exports, __webpack_require__) {
  var hide = __webpack_require__(26);

  module.exports = function (target, src, safe) {
    for (var key in src) {
      if (safe && target[key]) target[key] = src[key];else hide(target, key, src[key]);
    }

    return target;
  };
  /***/

},
/* 375 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(9);

  var core = __webpack_require__(7);

  var dP = __webpack_require__(15);

  var DESCRIPTORS = __webpack_require__(23);

  var SPECIES = __webpack_require__(10)('species');

  module.exports = function (KEY) {
    var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
    if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
      configurable: true,
      get: function get() {
        return this;
      }
    });
  };
  /***/

},
/* 376 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://github.com/tc39/proposal-promise-finally

  var $export = __webpack_require__(11);

  var core = __webpack_require__(7);

  var global = __webpack_require__(9);

  var speciesConstructor = __webpack_require__(163);

  var promiseResolve = __webpack_require__(166);

  $export($export.P + $export.R, 'Promise', {
    'finally': function _finally(onFinally) {
      var C = speciesConstructor(this, core.Promise || global.Promise);
      var isFunction = typeof onFinally == 'function';
      return this.then(isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () {
          return x;
        });
      } : onFinally, isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () {
          throw e;
        });
      } : onFinally);
    }
  });
  /***/
},
/* 377 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // https://github.com/tc39/proposal-promise-try

  var $export = __webpack_require__(11);

  var newPromiseCapability = __webpack_require__(100);

  var perform = __webpack_require__(165);

  $export($export.S, 'Promise', {
    'try': function _try(callbackfn) {
      var promiseCapability = newPromiseCapability.f(this);
      var result = perform(callbackfn);
      (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
      return promiseCapability.promise;
    }
  });
  /***/
},
/* 378 */

/***/
function (module, exports) {
  module.exports = require("redux-thunk");
  /***/
},
/* 379 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: true
  });
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(380);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(169);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(382);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "Provider", function () {
    return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "createProvider", function () {
    return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "connectAdvanced", function () {
    return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "connect", function () {
    return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"];
  });
  /***/

},
/* 380 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /* harmony export (immutable) */
    __webpack_exports__["a"] = createProvider;
    /* harmony import */

    var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(168);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(101);

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var didWarnAboutReceivingStore = false;

    function warnAboutReceivingStore() {
      if (didWarnAboutReceivingStore) {
        return;
      }

      didWarnAboutReceivingStore = true;
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a"
      /* default */
      ])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
    }

    function createProvider() {
      var _Provider$childContex;

      var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
      var subKey = arguments[1];
      var subscriptionKey = subKey || storeKey + 'Subscription';

      var Provider = function (_Component) {
        _inherits(Provider, _Component);

        Provider.prototype.getChildContext = function getChildContext() {
          var _ref;

          return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
        };

        function Provider(props, context) {
          _classCallCheck(this, Provider);

          var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

          _this[storeKey] = props.store;
          return _this;
        }

        Provider.prototype.render = function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
        };

        return Provider;
      }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

      if (process.env.NODE_ENV !== 'production') {
        Provider.prototype.componentWillReceiveProps = function (nextProps) {
          if (this[storeKey] !== nextProps.store) {
            warnAboutReceivingStore();
          }
        };
      }

      Provider.propTypes = {
        store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a"
        /* storeShape */
        ].isRequired,
        children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
      };
      Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a"
      /* storeShape */
      ].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b"
      /* subscriptionShape */
      ], _Provider$childContex);
      return Provider;
    }
    /* harmony default export */


    __webpack_exports__["b"] = createProvider();
    /* WEBPACK VAR INJECTION */
  }).call(__webpack_exports__, __webpack_require__(8));
  /***/
},
/* 381 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Subscription;
  });

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  } // encapsulates the subscription logic for connecting a component to the redux store, as
  // well as nesting subscriptions of descendant components, so that we can ensure the
  // ancestor components re-render before descendants


  var CLEARED = null;
  var nullListeners = {
    notify: function notify() {}
  };

  function createListenerCollection() {
    // the current/next pattern is copied from redux's createStore code.
    // TODO: refactor+expose that code to be reusable here?
    var current = [];
    var next = [];
    return {
      clear: function clear() {
        next = CLEARED;
        current = CLEARED;
      },
      notify: function notify() {
        var listeners = current = next;

        for (var i = 0; i < listeners.length; i++) {
          listeners[i]();
        }
      },
      get: function get() {
        return next;
      },
      subscribe: function subscribe(listener) {
        var isSubscribed = true;
        if (next === current) next = current.slice();
        next.push(listener);
        return function unsubscribe() {
          if (!isSubscribed || current === CLEARED) return;
          isSubscribed = false;
          if (next === current) next = current.slice();
          next.splice(next.indexOf(listener), 1);
        };
      }
    };
  }

  var Subscription = function () {
    function Subscription(store, parentSub, onStateChange) {
      _classCallCheck(this, Subscription);

      this.store = store;
      this.parentSub = parentSub;
      this.onStateChange = onStateChange;
      this.unsubscribe = null;
      this.listeners = nullListeners;
    }

    Subscription.prototype.addNestedSub = function addNestedSub(listener) {
      this.trySubscribe();
      return this.listeners.subscribe(listener);
    };

    Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
      this.listeners.notify();
    };

    Subscription.prototype.isSubscribed = function isSubscribed() {
      return Boolean(this.unsubscribe);
    };

    Subscription.prototype.trySubscribe = function trySubscribe() {
      if (!this.unsubscribe) {
        this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
        this.listeners = createListenerCollection();
      }
    };

    Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
      if (this.unsubscribe) {
        this.unsubscribe();
        this.unsubscribe = null;
        this.listeners.clear();
        this.listeners = nullListeners;
      }
    };

    return Subscription;
  }();
  /***/

},
/* 382 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* unused harmony export createConnect */

  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(169);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(383);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(384);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(394);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(395);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(396);

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }
  /*
    connect is a facade over connectAdvanced. It turns its args into a compatible
    selectorFactory, which has the signature:
  
      (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
    
    connect passes its args to connectAdvanced as options, which will in turn pass them to
    selectorFactory each time a Connect component instance is instantiated or hot reloaded.
  
    selectorFactory returns a final props selector from its mapStateToProps,
    mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
    mergePropsFactories, and pure args.
  
    The resulting final props selector is called by the Connect component instance whenever
    it receives new props or store state.
   */


  function match(arg, factories, name) {
    for (var i = factories.length - 1; i >= 0; i--) {
      var result = factories[i](arg);
      if (result) return result;
    }

    return function (dispatch, options) {
      throw new Error('Invalid value of type ' + _typeof4(arg) + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
    };
  }

  function strictEqual(a, b) {
    return a === b;
  } // createConnect with default args builds the 'official' connect behavior. Calling it with
  // different options opens up some testing and extensibility scenarios


  function createConnect() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$connectHOC = _ref.connectHOC,
        connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a"
    /* default */
    ] : _ref$connectHOC,
        _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
        mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a"
    /* default */
    ] : _ref$mapStateToPropsF,
        _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
        mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a"
    /* default */
    ] : _ref$mapDispatchToPro,
        _ref$mergePropsFactor = _ref.mergePropsFactories,
        mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a"
    /* default */
    ] : _ref$mergePropsFactor,
        _ref$selectorFactory = _ref.selectorFactory,
        selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a"
    /* default */
    ] : _ref$selectorFactory;

    return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
      var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
          _ref2$pure = _ref2.pure,
          pure = _ref2$pure === undefined ? true : _ref2$pure,
          _ref2$areStatesEqual = _ref2.areStatesEqual,
          areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
          _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
          areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a"
      /* default */
      ] : _ref2$areOwnPropsEqua,
          _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
          areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a"
      /* default */
      ] : _ref2$areStatePropsEq,
          _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
          areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a"
      /* default */
      ] : _ref2$areMergedPropsE,
          extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

      var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
      var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
      var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
      return connectHOC(selectorFactory, _extends({
        // used in error messages
        methodName: 'connect',
        // used to compute Connect's displayName from the wrapped component's displayName.
        getDisplayName: function getDisplayName(name) {
          return 'Connect(' + name + ')';
        },
        // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
        shouldHandleStateChanges: Boolean(mapStateToProps),
        // passed through to selectorFactory
        initMapStateToProps: initMapStateToProps,
        initMapDispatchToProps: initMapDispatchToProps,
        initMergeProps: initMergeProps,
        pure: pure,
        areStatesEqual: areStatesEqual,
        areOwnPropsEqual: areOwnPropsEqual,
        areStatePropsEqual: areStatePropsEqual,
        areMergedPropsEqual: areMergedPropsEqual
      }, extraOptions));
    };
  }
  /* harmony default export */


  __webpack_exports__["a"] = createConnect();
  /***/
},
/* 383 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (immutable) */

  __webpack_exports__["a"] = shallowEqual;
  var hasOwn = Object.prototype.hasOwnProperty;

  function is(x, y) {
    if (x === y) {
      return x !== 0 || y !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }

  function shallowEqual(objA, objB) {
    if (is(objA, objB)) return true;

    if (_typeof4(objA) !== 'object' || objA === null || _typeof4(objB) !== 'object' || objB === null) {
      return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;

    for (var i = 0; i < keysA.length; i++) {
      if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
        return false;
      }
    }

    return true;
  }
  /***/

},
/* 384 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* unused harmony export whenMapDispatchToPropsIsFunction */

  /* unused harmony export whenMapDispatchToPropsIsMissing */

  /* unused harmony export whenMapDispatchToPropsIsObject */

  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(167);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(170);

  function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b"
    /* wrapMapToPropsFunc */
    ])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
  }

  function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
    return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a"
    /* wrapMapToPropsConstant */
    ])(function (dispatch) {
      return {
        dispatch: dispatch
      };
    }) : undefined;
  }

  function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
    return mapDispatchToProps && _typeof4(mapDispatchToProps) === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a"
    /* wrapMapToPropsConstant */
    ])(function (dispatch) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
    }) : undefined;
  }
  /* harmony default export */


  __webpack_exports__["a"] = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
  /***/
},
/* 385 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(386);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(391);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(393);
  /** `Object#toString` result references. */


  var objectTag = '[object Object]';
  /** Used for built-in method references. */

  var funcProto = Function.prototype,
      objectProto = Object.prototype;
  /** Used to resolve the decompiled source of functions. */

  var funcToString = funcProto.toString;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /** Used to infer the `Object` constructor. */

  var objectCtorString = funcToString.call(Object);
  /**
   * Checks if `value` is a plain object, that is, an object created by the
   * `Object` constructor or one with a `[[Prototype]]` of `null`.
   *
   * @static
   * @memberOf _
   * @since 0.8.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   * }
   *
   * _.isPlainObject(new Foo);
   * // => false
   *
   * _.isPlainObject([1, 2, 3]);
   * // => false
   *
   * _.isPlainObject({ 'x': 0, 'y': 0 });
   * // => true
   *
   * _.isPlainObject(Object.create(null));
   * // => true
   */

  function isPlainObject(value) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a"
    /* default */
    ])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a"
    /* default */
    ])(value) != objectTag) {
      return false;
    }

    var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a"
    /* default */
    ])(value);

    if (proto === null) {
      return true;
    }

    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
  }
  /* harmony default export */


  __webpack_exports__["a"] = isPlainObject;
  /***/
},
/* 386 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(172);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(389);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(390);
  /** `Object#toString` result references. */


  var nullTag = '[object Null]',
      undefinedTag = '[object Undefined]';
  /** Built-in value references. */

  var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a"
  /* default */
  ] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a"
  /* default */
  ].toStringTag : undefined;
  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */

  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }

    return symToStringTag && symToStringTag in Object(value) ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a"
    /* default */
    ])(value) : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a"
    /* default */
    ])(value);
  }
  /* harmony default export */


  __webpack_exports__["a"] = baseGetTag;
  /***/
},
/* 387 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(388);
  /** Detect free variable `self`. */


  var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof4(self)) == 'object' && self && self.Object === Object && self;
  /** Used as a reference to the global object. */

  var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a"
  /* default */
  ] || freeSelf || Function('return this')();
  /* harmony default export */

  __webpack_exports__["a"] = root;
  /***/
},
/* 388 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (global) {
    /** Detect free variable `global` from Node.js. */
    var freeGlobal = _typeof4(global) == 'object' && global && global.Object === Object && global;
    /* harmony default export */

    __webpack_exports__["a"] = freeGlobal;
    /* WEBPACK VAR INJECTION */
  }).call(__webpack_exports__, __webpack_require__(33));
  /***/
},
/* 389 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(172);
  /** Used for built-in method references. */


  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */

  var nativeObjectToString = objectProto.toString;
  /** Built-in value references. */

  var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a"
  /* default */
  ] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a"
  /* default */
  ].toStringTag : undefined;
  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */

  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

    try {
      value[symToStringTag] = undefined;
      var unmasked = true;
    } catch (e) {}

    var result = nativeObjectToString.call(value);

    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }

    return result;
  }
  /* harmony default export */


  __webpack_exports__["a"] = getRawTag;
  /***/
},
/* 390 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /** Used for built-in method references. */

  var objectProto = Object.prototype;
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */

  var nativeObjectToString = objectProto.toString;
  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */

  function objectToString(value) {
    return nativeObjectToString.call(value);
  }
  /* harmony default export */


  __webpack_exports__["a"] = objectToString;
  /***/
},
/* 391 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(392);
  /** Built-in value references. */


  var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a"
  /* default */
  ])(Object.getPrototypeOf, Object);
  /* harmony default export */

  __webpack_exports__["a"] = getPrototype;
  /***/
},
/* 392 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */

  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }
  /* harmony default export */


  __webpack_exports__["a"] = overArg;
  /***/
},
/* 393 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */

  function isObjectLike(value) {
    return value != null && _typeof4(value) == 'object';
  }
  /* harmony default export */


  __webpack_exports__["a"] = isObjectLike;
  /***/
},
/* 394 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* unused harmony export whenMapStateToPropsIsFunction */

  /* unused harmony export whenMapStateToPropsIsMissing */

  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(170);

  function whenMapStateToPropsIsFunction(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b"
    /* wrapMapToPropsFunc */
    ])(mapStateToProps, 'mapStateToProps') : undefined;
  }

  function whenMapStateToPropsIsMissing(mapStateToProps) {
    return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a"
    /* wrapMapToPropsConstant */
    ])(function () {
      return {};
    }) : undefined;
  }
  /* harmony default export */


  __webpack_exports__["a"] = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
  /***/
},
/* 395 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /* unused harmony export defaultMergeProps */

    /* unused harmony export wrapMergePropsFunc */

    /* unused harmony export whenMergePropsIsFunction */

    /* unused harmony export whenMergePropsIsOmitted */

    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(171);

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    function defaultMergeProps(stateProps, dispatchProps, ownProps) {
      return _extends({}, ownProps, stateProps, dispatchProps);
    }

    function wrapMergePropsFunc(mergeProps) {
      return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName,
            pure = _ref.pure,
            areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps = void 0;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
          var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

          if (hasRunOnce) {
            if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
          } else {
            hasRunOnce = true;
            mergedProps = nextMergedProps;
            if (process.env.NODE_ENV !== 'production') Object(__WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__["a"
            /* default */
            ])(mergedProps, displayName, 'mergeProps');
          }

          return mergedProps;
        };
      };
    }

    function whenMergePropsIsFunction(mergeProps) {
      return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
    }

    function whenMergePropsIsOmitted(mergeProps) {
      return !mergeProps ? function () {
        return defaultMergeProps;
      } : undefined;
    }
    /* harmony default export */


    __webpack_exports__["a"] = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
    /* WEBPACK VAR INJECTION */
  }).call(__webpack_exports__, __webpack_require__(8));
  /***/
},
/* 396 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /* unused harmony export impureFinalPropsSelectorFactory */

    /* unused harmony export pureFinalPropsSelectorFactory */

    /* harmony export (immutable) */
    __webpack_exports__["a"] = finalPropsSelectorFactory;
    /* harmony import */

    var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(397);

    function _objectWithoutProperties(obj, keys) {
      var target = {};

      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }

      return target;
    }

    function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
      return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
      };
    }

    function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
      var areStatesEqual = _ref.areStatesEqual,
          areOwnPropsEqual = _ref.areOwnPropsEqual,
          areStatePropsEqual = _ref.areStatePropsEqual;
      var hasRunAtLeastOnce = false;
      var state = void 0;
      var ownProps = void 0;
      var stateProps = void 0;
      var dispatchProps = void 0;
      var mergedProps = void 0;

      function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
      }

      function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
      }

      function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
      }

      function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
      }

      function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
      }

      return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
      };
    } // TODO: Add more comments
    // If pure is true, the selector returned by selectorFactory will memoize its results,
    // allowing connectAdvanced's shouldComponentUpdate to return false if final
    // props have not changed. If false, the selector will always return a new
    // object and shouldComponentUpdate will always return true.


    function finalPropsSelectorFactory(dispatch, _ref2) {
      var initMapStateToProps = _ref2.initMapStateToProps,
          initMapDispatchToProps = _ref2.initMapDispatchToProps,
          initMergeProps = _ref2.initMergeProps,
          options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

      var mapStateToProps = initMapStateToProps(dispatch, options);
      var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
      var mergeProps = initMergeProps(dispatch, options);

      if (process.env.NODE_ENV !== 'production') {
        Object(__WEBPACK_IMPORTED_MODULE_0__verifySubselectors__["a"
        /* default */
        ])(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
      }

      var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
      return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
    }
    /* WEBPACK VAR INJECTION */

  }).call(__webpack_exports__, __webpack_require__(8));
  /***/
},
/* 397 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (immutable) */

  __webpack_exports__["a"] = verifySubselectors;
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(101);

  function verify(selector, methodName, displayName) {
    if (!selector) {
      throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
    } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
      if (!selector.hasOwnProperty('dependsOnOwnProps')) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a"
        /* default */
        ])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
      }
    }
  }

  function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    verify(mapStateToProps, 'mapStateToProps', displayName);
    verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    verify(mergeProps, 'mergeProps', displayName);
  }
  /***/

},
/* 398 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global) {
    !function (e, t) {
      true ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t(e.reduxLogger = e.reduxLogger || {});
    }(this, function (e) {
      "use strict";

      function t(e, t) {
        e.super_ = t, e.prototype = Object.create(t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        });
      }

      function r(e, t) {
        Object.defineProperty(this, "kind", {
          value: e,
          enumerable: !0
        }), t && t.length && Object.defineProperty(this, "path", {
          value: t,
          enumerable: !0
        });
      }

      function n(e, t, r) {
        n.super_.call(this, "E", e), Object.defineProperty(this, "lhs", {
          value: t,
          enumerable: !0
        }), Object.defineProperty(this, "rhs", {
          value: r,
          enumerable: !0
        });
      }

      function o(e, t) {
        o.super_.call(this, "N", e), Object.defineProperty(this, "rhs", {
          value: t,
          enumerable: !0
        });
      }

      function i(e, t) {
        i.super_.call(this, "D", e), Object.defineProperty(this, "lhs", {
          value: t,
          enumerable: !0
        });
      }

      function a(e, t, r) {
        a.super_.call(this, "A", e), Object.defineProperty(this, "index", {
          value: t,
          enumerable: !0
        }), Object.defineProperty(this, "item", {
          value: r,
          enumerable: !0
        });
      }

      function f(e, t, r) {
        var n = e.slice((r || t) + 1 || e.length);
        return e.length = t < 0 ? e.length + t : t, e.push.apply(e, n), e;
      }

      function u(e) {
        var t = "undefined" == typeof e ? "undefined" : N(e);
        return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
      }

      function l(e, t, r, c, s, d, p) {
        s = s || [], p = p || [];
        var g = s.slice(0);

        if ("undefined" != typeof d) {
          if (c) {
            if ("function" == typeof c && c(g, d)) return;

            if ("object" === ("undefined" == typeof c ? "undefined" : N(c))) {
              if (c.prefilter && c.prefilter(g, d)) return;

              if (c.normalize) {
                var h = c.normalize(g, d, e, t);
                h && (e = h[0], t = h[1]);
              }
            }
          }

          g.push(d);
        }

        "regexp" === u(e) && "regexp" === u(t) && (e = e.toString(), t = t.toString());
        var y = "undefined" == typeof e ? "undefined" : N(e),
            v = "undefined" == typeof t ? "undefined" : N(t),
            b = "undefined" !== y || p && p[p.length - 1].lhs && p[p.length - 1].lhs.hasOwnProperty(d),
            m = "undefined" !== v || p && p[p.length - 1].rhs && p[p.length - 1].rhs.hasOwnProperty(d);
        if (!b && m) r(new o(g, t));else if (!m && b) r(new i(g, e));else if (u(e) !== u(t)) r(new n(g, e, t));else if ("date" === u(e) && e - t !== 0) r(new n(g, e, t));else if ("object" === y && null !== e && null !== t) {
          if (p.filter(function (t) {
            return t.lhs === e;
          }).length) e !== t && r(new n(g, e, t));else {
            if (p.push({
              lhs: e,
              rhs: t
            }), Array.isArray(e)) {
              var w;
              e.length;

              for (w = 0; w < e.length; w++) {
                w >= t.length ? r(new a(g, w, new i(void 0, e[w]))) : l(e[w], t[w], r, c, g, w, p);
              }

              for (; w < t.length;) {
                r(new a(g, w, new o(void 0, t[w++])));
              }
            } else {
              var x = Object.keys(e),
                  S = Object.keys(t);
              x.forEach(function (n, o) {
                var i = S.indexOf(n);
                i >= 0 ? (l(e[n], t[n], r, c, g, n, p), S = f(S, i)) : l(e[n], void 0, r, c, g, n, p);
              }), S.forEach(function (e) {
                l(void 0, t[e], r, c, g, e, p);
              });
            }

            p.length = p.length - 1;
          }
        } else e !== t && ("number" === y && isNaN(e) && isNaN(t) || r(new n(g, e, t)));
      }

      function c(e, t, r, n) {
        return n = n || [], l(e, t, function (e) {
          e && n.push(e);
        }, r), n.length ? n : void 0;
      }

      function s(e, t, r) {
        if (r.path && r.path.length) {
          var n,
              o = e[t],
              i = r.path.length - 1;

          for (n = 0; n < i; n++) {
            o = o[r.path[n]];
          }

          switch (r.kind) {
            case "A":
              s(o[r.path[n]], r.index, r.item);
              break;

            case "D":
              delete o[r.path[n]];
              break;

            case "E":
            case "N":
              o[r.path[n]] = r.rhs;
          }
        } else switch (r.kind) {
          case "A":
            s(e[t], r.index, r.item);
            break;

          case "D":
            e = f(e, t);
            break;

          case "E":
          case "N":
            e[t] = r.rhs;
        }

        return e;
      }

      function d(e, t, r) {
        if (e && t && r && r.kind) {
          for (var n = e, o = -1, i = r.path ? r.path.length - 1 : 0; ++o < i;) {
            "undefined" == typeof n[r.path[o]] && (n[r.path[o]] = "number" == typeof r.path[o] ? [] : {}), n = n[r.path[o]];
          }

          switch (r.kind) {
            case "A":
              s(r.path ? n[r.path[o]] : n, r.index, r.item);
              break;

            case "D":
              delete n[r.path[o]];
              break;

            case "E":
            case "N":
              n[r.path[o]] = r.rhs;
          }
        }
      }

      function p(e, t, r) {
        if (r.path && r.path.length) {
          var n,
              o = e[t],
              i = r.path.length - 1;

          for (n = 0; n < i; n++) {
            o = o[r.path[n]];
          }

          switch (r.kind) {
            case "A":
              p(o[r.path[n]], r.index, r.item);
              break;

            case "D":
              o[r.path[n]] = r.lhs;
              break;

            case "E":
              o[r.path[n]] = r.lhs;
              break;

            case "N":
              delete o[r.path[n]];
          }
        } else switch (r.kind) {
          case "A":
            p(e[t], r.index, r.item);
            break;

          case "D":
            e[t] = r.lhs;
            break;

          case "E":
            e[t] = r.lhs;
            break;

          case "N":
            e = f(e, t);
        }

        return e;
      }

      function g(e, t, r) {
        if (e && t && r && r.kind) {
          var n,
              o,
              i = e;

          for (o = r.path.length - 1, n = 0; n < o; n++) {
            "undefined" == typeof i[r.path[n]] && (i[r.path[n]] = {}), i = i[r.path[n]];
          }

          switch (r.kind) {
            case "A":
              p(i[r.path[n]], r.index, r.item);
              break;

            case "D":
              i[r.path[n]] = r.lhs;
              break;

            case "E":
              i[r.path[n]] = r.lhs;
              break;

            case "N":
              delete i[r.path[n]];
          }
        }
      }

      function h(e, t, r) {
        if (e && t) {
          var n = function n(_n2) {
            r && !r(e, t, _n2) || d(e, t, _n2);
          };

          l(e, t, n);
        }
      }

      function y(e) {
        return "color: " + F[e].color + "; font-weight: bold";
      }

      function v(e) {
        var t = e.kind,
            r = e.path,
            n = e.lhs,
            o = e.rhs,
            i = e.index,
            a = e.item;

        switch (t) {
          case "E":
            return [r.join("."), n, "→", o];

          case "N":
            return [r.join("."), o];

          case "D":
            return [r.join(".")];

          case "A":
            return [r.join(".") + "[" + i + "]", a];

          default:
            return [];
        }
      }

      function b(e, t, r, n) {
        var o = c(e, t);

        try {
          n ? r.groupCollapsed("diff") : r.group("diff");
        } catch (e) {
          r.log("diff");
        }

        o ? o.forEach(function (e) {
          var t = e.kind,
              n = v(e);
          r.log.apply(r, ["%c " + F[t].text, y(t)].concat(P(n)));
        }) : r.log("—— no diff ——");

        try {
          r.groupEnd();
        } catch (e) {
          r.log("—— diff end —— ");
        }
      }

      function m(e, t, r, n) {
        switch ("undefined" == typeof e ? "undefined" : N(e)) {
          case "object":
            return "function" == typeof e[n] ? e[n].apply(e, P(r)) : e[n];

          case "function":
            return e(t);

          default:
            return e;
        }
      }

      function w(e) {
        var t = e.timestamp,
            r = e.duration;
        return function (e, n, o) {
          var i = ["action"];
          return i.push("%c" + String(e.type)), t && i.push("%c@ " + n), r && i.push("%c(in " + o.toFixed(2) + " ms)"), i.join(" ");
        };
      }

      function x(e, t) {
        var r = t.logger,
            n = t.actionTransformer,
            o = t.titleFormatter,
            i = void 0 === o ? w(t) : o,
            a = t.collapsed,
            f = t.colors,
            u = t.level,
            l = t.diff,
            c = "undefined" == typeof t.titleFormatter;
        e.forEach(function (o, s) {
          var d = o.started,
              p = o.startedTime,
              g = o.action,
              h = o.prevState,
              y = o.error,
              v = o.took,
              w = o.nextState,
              x = e[s + 1];
          x && (w = x.prevState, v = x.started - d);
          var S = n(g),
              k = "function" == typeof a ? a(function () {
            return w;
          }, g, o) : a,
              j = D(p),
              E = f.title ? "color: " + f.title(S) + ";" : "",
              A = ["color: gray; font-weight: lighter;"];
          A.push(E), t.timestamp && A.push("color: gray; font-weight: lighter;"), t.duration && A.push("color: gray; font-weight: lighter;");
          var O = i(S, j, v);

          try {
            k ? f.title && c ? r.groupCollapsed.apply(r, ["%c " + O].concat(A)) : r.groupCollapsed(O) : f.title && c ? r.group.apply(r, ["%c " + O].concat(A)) : r.group(O);
          } catch (e) {
            r.log(O);
          }

          var N = m(u, S, [h], "prevState"),
              P = m(u, S, [S], "action"),
              C = m(u, S, [y, h], "error"),
              F = m(u, S, [w], "nextState");
          if (N) if (f.prevState) {
            var L = "color: " + f.prevState(h) + "; font-weight: bold";
            r[N]("%c prev state", L, h);
          } else r[N]("prev state", h);
          if (P) if (f.action) {
            var T = "color: " + f.action(S) + "; font-weight: bold";
            r[P]("%c action    ", T, S);
          } else r[P]("action    ", S);
          if (y && C) if (f.error) {
            var M = "color: " + f.error(y, h) + "; font-weight: bold;";
            r[C]("%c error     ", M, y);
          } else r[C]("error     ", y);
          if (F) if (f.nextState) {
            var _ = "color: " + f.nextState(w) + "; font-weight: bold";

            r[F]("%c next state", _, w);
          } else r[F]("next state", w);
          l && b(h, w, r, k);

          try {
            r.groupEnd();
          } catch (e) {
            r.log("—— log end ——");
          }
        });
      }

      function S() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = Object.assign({}, L, e),
            r = t.logger,
            n = t.stateTransformer,
            o = t.errorTransformer,
            i = t.predicate,
            a = t.logErrors,
            f = t.diffPredicate;
        if ("undefined" == typeof r) return function () {
          return function (e) {
            return function (t) {
              return e(t);
            };
          };
        };
        if (e.getState && e.dispatch) return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"), function () {
          return function (e) {
            return function (t) {
              return e(t);
            };
          };
        };
        var u = [];
        return function (e) {
          var r = e.getState;
          return function (e) {
            return function (l) {
              if ("function" == typeof i && !i(r, l)) return e(l);
              var c = {};
              u.push(c), c.started = O.now(), c.startedTime = new Date(), c.prevState = n(r()), c.action = l;
              var s = void 0;
              if (a) try {
                s = e(l);
              } catch (e) {
                c.error = o(e);
              } else s = e(l);
              c.took = O.now() - c.started, c.nextState = n(r());
              var d = t.diff && "function" == typeof f ? f(r, l) : t.diff;
              if (x(u, Object.assign({}, t, {
                diff: d
              })), u.length = 0, c.error) throw c.error;
              return s;
            };
          };
        };
      }

      var k,
          j,
          E = function E(e, t) {
        return new Array(t + 1).join(e);
      },
          A = function A(e, t) {
        return E("0", t - e.toString().length) + e;
      },
          D = function D(e) {
        return A(e.getHours(), 2) + ":" + A(e.getMinutes(), 2) + ":" + A(e.getSeconds(), 2) + "." + A(e.getMilliseconds(), 3);
      },
          O = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance : Date,
          N = "function" == typeof Symbol && "symbol" == _typeof4(Symbol.iterator) ? function (e) {
        return _typeof4(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof4(e);
      },
          P = function P(e) {
        if (Array.isArray(e)) {
          for (var t = 0, r = Array(e.length); t < e.length; t++) {
            r[t] = e[t];
          }

          return r;
        }

        return Array.from(e);
      },
          C = [];

      k = "object" === ("undefined" == typeof global ? "undefined" : N(global)) && global ? global : "undefined" != typeof window ? window : {}, j = k.DeepDiff, j && C.push(function () {
        "undefined" != typeof j && k.DeepDiff === c && (k.DeepDiff = j, j = void 0);
      }), t(n, r), t(o, r), t(i, r), t(a, r), Object.defineProperties(c, {
        diff: {
          value: c,
          enumerable: !0
        },
        observableDiff: {
          value: l,
          enumerable: !0
        },
        applyDiff: {
          value: h,
          enumerable: !0
        },
        applyChange: {
          value: d,
          enumerable: !0
        },
        revertChange: {
          value: g,
          enumerable: !0
        },
        isConflict: {
          value: function value() {
            return "undefined" != typeof j;
          },
          enumerable: !0
        },
        noConflict: {
          value: function value() {
            return C && (C.forEach(function (e) {
              e();
            }), C = null), c;
          },
          enumerable: !0
        }
      });

      var F = {
        E: {
          color: "#2196F3",
          text: "CHANGED:"
        },
        N: {
          color: "#4CAF50",
          text: "ADDED:"
        },
        D: {
          color: "#F44336",
          text: "DELETED:"
        },
        A: {
          color: "#2196F3",
          text: "ARRAY:"
        }
      },
          L = {
        level: "log",
        logger: console,
        logErrors: !0,
        collapsed: void 0,
        predicate: void 0,
        duration: !1,
        timestamp: !0,
        stateTransformer: function stateTransformer(e) {
          return e;
        },
        actionTransformer: function actionTransformer(e) {
          return e;
        },
        errorTransformer: function errorTransformer(e) {
          return e;
        },
        colors: {
          title: function title() {
            return "inherit";
          },
          prevState: function prevState() {
            return "#9E9E9E";
          },
          action: function action() {
            return "#03A9F4";
          },
          nextState: function nextState() {
            return "#4CAF50";
          },
          error: function error() {
            return "#F20404";
          }
        },
        diff: !1,
        diffPredicate: void 0,
        transformer: void 0
      },
          T = function T() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.dispatch,
            r = e.getState;
        return "function" == typeof t || "function" == typeof r ? S()({
          dispatch: t,
          getState: r
        }) : void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n");
      };

      e.defaults = L, e.createLogger = S, e.logger = T, e["default"] = T, Object.defineProperty(e, "__esModule", {
        value: !0
      });
    });
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(33));
  /***/
},
/* 399 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__File_File__ = __webpack_require__(400);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__File_File__["a"];
  });
  /***/

},
/* 400 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(161);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_recompose__ = __webpack_require__(18);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10_react_form__ = __webpack_require__(46);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10_react_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_form__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11_react_dropzone__ = __webpack_require__(401);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_12__UI_Spinner_Spinner__ = __webpack_require__(405);

  var _class,
      _temp2,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/Form/File/File.js'; // Import React
  // Recompose
  // Field
  // Components


  var File = (_temp2 = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(File, _React$Component);

    function File() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, File);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = File.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(File)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        accepted: [],
        rejected: [],
        dropzoneActive: false,
        loading: false
      }, _this.onDragEnter = function () {
        _this.setState({
          dropzoneActive: true
        });
      }, _this.onDragLeave = function () {
        _this.setState({
          dropzoneActive: false
        });
      }, _this.onDrop = function (accepted, rejected) {
        var _this$props = _this.props,
            fieldApi = _this$props.fieldApi,
            onChange = _this$props.onChange;

        _this.setState({
          accepted: accepted,
          rejected: rejected,
          dropzoneActive: false
        }, function () {
          if (_this.state.accepted.length) {
            if (_this.props.onUploadImage) {
              _this.setState({
                loading: true
              });

              _this.props.onUploadImage(_this.state.accepted).then(function (value) {
                _this.setState({
                  loading: false
                });

                fieldApi.setValue(value);

                if (onChange) {
                  onChange(value);
                }
              })["catch"](function (e) {
                console.error(e);

                _this.setState({
                  accepted: [],
                  rejected: [{
                    error: e.toString()
                  }],
                  loading: false
                });
              });
            }
          }
        });
      }, _this.triggerBrowseOrCancel = function () {
        var _this$props2 = _this.props,
            fieldApi = _this$props2.fieldApi,
            onChange = _this$props2.onChange;
        var accepted = _this.state.accepted;

        if (accepted.length) {
          fieldApi.setValue('');

          if (onChange) {
            onChange('');
          }

          _this.setState({
            accepted: [],
            rejected: [],
            loading: false
          });
        } else {
          _this.dropzone.open();
        }
      }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }
    /**
     * DROPZONE EVENTS
     * - onDragEnter
     * - onDragLeave
     * - onDrop
    */


    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(File, [{
      key: 'getRejectedErrors',

      /**
       * HELPERS
       * - getRejectedErrors
      */
      value: function getRejectedErrors() {
        var rejected = this.state.rejected;
        var options = this.props.options;
        return rejected.map(function (r) {
          if (r.error) {
            return r.error;
          }

          if (r.size > options.maxSize) {
            return 'Image is over ' + options.maxSize / 1000000 + ' MB';
          }

          if (!options.accept.includes(r.type)) {
            return 'Image is not ' + options.accept.join(', ');
          }

          return 'Unexpected error';
        });
      }
      /**
       * UI EVENTS
       * - triggerBrowseOrCancel
      */

    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _state = this.state,
            accepted = _state.accepted,
            loading = _state.loading,
            dropzoneActive = _state.dropzoneActive;

        var _props = this.props,
            fieldApi = _props.fieldApi,
            _onChange = _props.onChange,
            _onBlur = _props.onBlur,
            onUploadImage = _props.onUploadImage,
            rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['fieldApi', 'onChange', 'onBlur', 'onUploadImage']);

        var errors = this.getRejectedErrors();
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
          className: 'cw-file',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 154
          }
        }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_dropzone__["a"
        /* default */
        ], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          ref: function ref(node) {
            _this2.dropzone = node;
          },
          className: 'file-dropzone'
        }, this.props.options, {
          disabled: !onUploadImage,
          onDrop: this.onDrop,
          onDragEnter: this.onDragEnter,
          onDragLeave: this.onDragLeave,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 155
          }
        }), dropzoneActive && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
          className: 'dropzone-active',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 165
          }
        }, 'Drop files...'), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
          value: fieldApi.getValue() || '',
          onChange: function onChange(e) {
            fieldApi.setValue(e.target.value);

            if (_onChange) {
              _onChange(e.target.value, e);
            }
          },
          onBlur: function onBlur(e) {
            fieldApi.setTouched();

            if (_onBlur) {
              _onBlur(e);
            }
          },
          readOnly: !!accepted.length,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 170
          }
        })), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__UI_Spinner_Spinner__["a"
        /* default */
        ], {
          className: '-light -small',
          isLoading: loading,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 188
          }
        }), this.props.onUploadImage && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('button', {
          type: 'button',
          className: 'cw-button -primary -compressed',
          onClick: this.triggerBrowseOrCancel,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 191
          }
        }, accepted.length ? 'Cancel' : 'Browse file'), !!errors.length && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
          className: 'error',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 201
          }
        }, errors.map(function (e) {
          return e;
        }))));
      }
    }]);

    return File;
  }(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _class.propTypes = {
    fieldApi: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    options: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onBlur: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onUploadImage: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
  }, _temp2);
  File.displayName = 'File';
  /* harmony default export */

  __webpack_exports__["a"] = Object(__WEBPACK_IMPORTED_MODULE_9_recompose__["a"
  /* getContext */
  ])({
    onUploadImage: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
  })(Object(__WEBPACK_IMPORTED_MODULE_10_react_form__["FormField"])(File));
  /***/
},
/* 401 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(402);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_3__utils_styles__ = __webpack_require__(404);

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    function _objectWithoutProperties(obj, keys) {
      var target = {};

      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }

      return target;
    }

    function _toConsumableArray(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }

        return arr2;
      } else {
        return Array.from(arr);
      }
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    /* eslint prefer-template: 0 */


    var Dropzone = function (_React$Component) {
      _inherits(Dropzone, _React$Component);

      function Dropzone(props, context) {
        _classCallCheck(this, Dropzone);

        var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));

        _this.renderChildren = function (children, isDragActive, isDragAccept, isDragReject) {
          if (typeof children === 'function') {
            return children(_extends({}, _this.state, {
              isDragActive: isDragActive,
              isDragAccept: isDragAccept,
              isDragReject: isDragReject
            }));
          }

          return children;
        };

        _this.composeHandlers = _this.composeHandlers.bind(_this);
        _this.onClick = _this.onClick.bind(_this);
        _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
        _this.onDragEnter = _this.onDragEnter.bind(_this);
        _this.onDragLeave = _this.onDragLeave.bind(_this);
        _this.onDragOver = _this.onDragOver.bind(_this);
        _this.onDragStart = _this.onDragStart.bind(_this);
        _this.onDrop = _this.onDrop.bind(_this);
        _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
        _this.onInputElementClick = _this.onInputElementClick.bind(_this);
        _this.setRef = _this.setRef.bind(_this);
        _this.setRefs = _this.setRefs.bind(_this);
        _this.isFileDialogActive = false;
        _this.state = {
          draggedFiles: [],
          acceptedFiles: [],
          rejectedFiles: []
        };
        return _this;
      }

      _createClass(Dropzone, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var preventDropOnDocument = this.props.preventDropOnDocument;
          this.dragTargets = [];

          if (preventDropOnDocument) {
            document.addEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f"
            /* onDocumentDragOver */
            ], false);
            document.addEventListener('drop', this.onDocumentDrop, false);
          }

          this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
          window.addEventListener('focus', this.onFileDialogCancel, false);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          var preventDropOnDocument = this.props.preventDropOnDocument;

          if (preventDropOnDocument) {
            document.removeEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f"
            /* onDocumentDragOver */
            ]);
            document.removeEventListener('drop', this.onDocumentDrop);
          }

          if (this.fileInputEl != null) {
            this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
          }

          window.removeEventListener('focus', this.onFileDialogCancel, false);
        }
      }, {
        key: 'composeHandlers',
        value: function composeHandlers(handler) {
          if (this.props.disabled) {
            return null;
          }

          return handler;
        }
      }, {
        key: 'onDocumentDrop',
        value: function onDocumentDrop(evt) {
          if (this.node && this.node.contains(evt.target)) {
            // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
            return;
          }

          evt.preventDefault();
          this.dragTargets = [];
        }
      }, {
        key: 'onDragStart',
        value: function onDragStart(evt) {
          if (this.props.onDragStart) {
            this.props.onDragStart.call(this, evt);
          }
        }
      }, {
        key: 'onDragEnter',
        value: function onDragEnter(evt) {
          evt.preventDefault(); // Count the dropzone and any children that are entered.

          if (this.dragTargets.indexOf(evt.target) === -1) {
            this.dragTargets.push(evt.target);
          }

          this.setState({
            isDragActive: true,
            // Do not rely on files for the drag state. It doesn't work in Safari.
            draggedFiles: Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d"
            /* getDataTransferItems */
            ])(evt)
          });

          if (this.props.onDragEnter) {
            this.props.onDragEnter.call(this, evt);
          }
        }
      }, {
        key: 'onDragOver',
        value: function onDragOver(evt) {
          // eslint-disable-line class-methods-use-this
          evt.preventDefault();
          evt.stopPropagation();

          try {
            // The file dialog on Chrome allows users to drag files from the dialog onto
            // the dropzone, causing the browser the crash when the file dialog is closed.
            // A drop effect of 'none' prevents the file from being dropped
            evt.dataTransfer.dropEffect = this.isFileDialogActive ? 'none' : 'copy'; // eslint-disable-line no-param-reassign
          } catch (err) {// continue regardless of error
          }

          if (this.props.onDragOver) {
            this.props.onDragOver.call(this, evt);
          }

          return false;
        }
      }, {
        key: 'onDragLeave',
        value: function onDragLeave(evt) {
          var _this2 = this;

          evt.preventDefault(); // Only deactivate once the dropzone and all children have been left.

          this.dragTargets = this.dragTargets.filter(function (el) {
            return el !== evt.target && _this2.node.contains(el);
          });

          if (this.dragTargets.length > 0) {
            return;
          } // Clear dragging files state


          this.setState({
            isDragActive: false,
            draggedFiles: []
          });

          if (this.props.onDragLeave) {
            this.props.onDragLeave.call(this, evt);
          }
        }
      }, {
        key: 'onDrop',
        value: function onDrop(evt) {
          var _this3 = this;

          var _props = this.props,
              onDrop = _props.onDrop,
              onDropAccepted = _props.onDropAccepted,
              onDropRejected = _props.onDropRejected,
              multiple = _props.multiple,
              disablePreview = _props.disablePreview,
              accept = _props.accept;
          var fileList = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d"
          /* getDataTransferItems */
          ])(evt);
          var acceptedFiles = [];
          var rejectedFiles = []; // Stop default browser behavior

          evt.preventDefault(); // Reset the counter along with the drag on a drop.

          this.dragTargets = [];
          this.isFileDialogActive = false;
          fileList.forEach(function (file) {
            if (!disablePreview) {
              try {
                file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
              } catch (err) {
                if (process.env.NODE_ENV !== 'production') {
                  console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
                }
              }
            }

            if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b"
            /* fileAccepted */
            ])(file, accept) && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c"
            /* fileMatchSize */
            ])(file, _this3.props.maxSize, _this3.props.minSize)) {
              acceptedFiles.push(file);
            } else {
              rejectedFiles.push(file);
            }
          });

          if (!multiple) {
            // if not in multi mode add any extra accepted files to rejected.
            // This will allow end users to easily ignore a multi file drop in "single" mode.
            rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
          }

          if (onDrop) {
            onDrop.call(this, acceptedFiles, rejectedFiles, evt);
          }

          if (rejectedFiles.length > 0 && onDropRejected) {
            onDropRejected.call(this, rejectedFiles, evt);
          }

          if (acceptedFiles.length > 0 && onDropAccepted) {
            onDropAccepted.call(this, acceptedFiles, evt);
          } // Clear files value


          this.draggedFiles = null; // Reset drag state

          this.setState({
            isDragActive: false,
            draggedFiles: [],
            acceptedFiles: acceptedFiles,
            rejectedFiles: rejectedFiles
          });
        }
      }, {
        key: 'onClick',
        value: function onClick(evt) {
          var _props2 = this.props,
              onClick = _props2.onClick,
              disableClick = _props2.disableClick;

          if (!disableClick) {
            evt.stopPropagation();

            if (onClick) {
              onClick.call(this, evt);
            } // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
            // this is so react can handle state changes in the onClick prop above above
            // see: https://github.com/react-dropzone/react-dropzone/issues/450


            if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e"
            /* isIeOrEdge */
            ])()) {
              setTimeout(this.open.bind(this), 0);
            } else {
              this.open();
            }
          }
        }
      }, {
        key: 'onInputElementClick',
        value: function onInputElementClick(evt) {
          evt.stopPropagation();

          if (this.props.inputProps && this.props.inputProps.onClick) {
            this.props.inputProps.onClick();
          }
        }
      }, {
        key: 'onFileDialogCancel',
        value: function onFileDialogCancel() {
          var _this4 = this; // timeout will not recognize context of this method


          var onFileDialogCancel = this.props.onFileDialogCancel; // execute the timeout only if the FileDialog is opened in the browser

          if (this.isFileDialogActive) {
            setTimeout(function () {
              if (_this4.fileInputEl != null) {
                // Returns an object as FileList
                var files = _this4.fileInputEl.files;

                if (!files.length) {
                  _this4.isFileDialogActive = false;
                }
              }

              if (typeof onFileDialogCancel === 'function') {
                onFileDialogCancel();
              }
            }, 300);
          }
        }
      }, {
        key: 'setRef',
        value: function setRef(ref) {
          this.node = ref;
        }
      }, {
        key: 'setRefs',
        value: function setRefs(ref) {
          this.fileInputEl = ref;
        }
        /**
         * Open system file upload dialog.
         *
         * @public
         */

      }, {
        key: 'open',
        value: function open() {
          this.isFileDialogActive = true;
          this.fileInputEl.value = null;
          this.fileInputEl.click();
        }
      }, {
        key: 'render',
        value: function render() {
          var _props3 = this.props,
              accept = _props3.accept,
              acceptClassName = _props3.acceptClassName,
              activeClassName = _props3.activeClassName,
              children = _props3.children,
              disabled = _props3.disabled,
              disabledClassName = _props3.disabledClassName,
              inputProps = _props3.inputProps,
              multiple = _props3.multiple,
              name = _props3.name,
              rejectClassName = _props3.rejectClassName,
              rest = _objectWithoutProperties(_props3, ['accept', 'acceptClassName', 'activeClassName', 'children', 'disabled', 'disabledClassName', 'inputProps', 'multiple', 'name', 'rejectClassName']);

          var acceptStyle = rest.acceptStyle,
              activeStyle = rest.activeStyle,
              _rest$className = rest.className,
              className = _rest$className === undefined ? '' : _rest$className,
              disabledStyle = rest.disabledStyle,
              rejectStyle = rest.rejectStyle,
              style = rest.style,
              props = _objectWithoutProperties(rest, ['acceptStyle', 'activeStyle', 'className', 'disabledStyle', 'rejectStyle', 'style']);

          var _state = this.state,
              isDragActive = _state.isDragActive,
              draggedFiles = _state.draggedFiles;
          var filesCount = draggedFiles.length;
          var isMultipleAllowed = multiple || filesCount <= 1;
          var isDragAccept = filesCount > 0 && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a"
          /* allFilesAccepted */
          ])(draggedFiles, this.props.accept);
          var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
          var noStyles = !className && !style && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;

          if (isDragActive && activeClassName) {
            className += ' ' + activeClassName;
          }

          if (isDragAccept && acceptClassName) {
            className += ' ' + acceptClassName;
          }

          if (isDragReject && rejectClassName) {
            className += ' ' + rejectClassName;
          }

          if (disabled && disabledClassName) {
            className += ' ' + disabledClassName;
          }

          if (noStyles) {
            style = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a"
            /* default */
            ]["default"];
            activeStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a"
            /* default */
            ].active;
            acceptStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a"
            /* default */
            ].active;
            rejectStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a"
            /* default */
            ].rejected;
            disabledStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a"
            /* default */
            ].disabled;
          }

          var appliedStyle = _extends({
            position: 'relative'
          }, style);

          if (activeStyle && isDragActive) {
            appliedStyle = _extends({}, appliedStyle, activeStyle);
          }

          if (acceptStyle && isDragAccept) {
            appliedStyle = _extends({}, appliedStyle, acceptStyle);
          }

          if (rejectStyle && isDragReject) {
            appliedStyle = _extends({}, appliedStyle, rejectStyle);
          }

          if (disabledStyle && disabled) {
            appliedStyle = _extends({}, appliedStyle, disabledStyle);
          }

          var inputAttributes = {
            accept: accept,
            disabled: disabled,
            type: 'file',
            style: _extends({
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              opacity: 0.00001,
              pointerEvents: 'none'
            }, inputProps.style),
            multiple: __WEBPACK_IMPORTED_MODULE_2__utils__["g"
            /* supportMultiple */
            ] && multiple,
            ref: this.setRefs,
            onChange: this.onDrop,
            autoComplete: 'off'
          };

          if (name && name.length) {
            inputAttributes.name = name;
          } // Destructure custom props away from props used for the div element


          var acceptedFiles = props.acceptedFiles,
              preventDropOnDocument = props.preventDropOnDocument,
              disablePreview = props.disablePreview,
              disableClick = props.disableClick,
              onDropAccepted = props.onDropAccepted,
              onDropRejected = props.onDropRejected,
              onFileDialogCancel = props.onFileDialogCancel,
              maxSize = props.maxSize,
              minSize = props.minSize,
              divProps = _objectWithoutProperties(props, ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize']);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({
            className: className,
            style: appliedStyle
          }, divProps
          /* expand user provided props first so event handlers are never overridden */
          , {
            onClick: this.composeHandlers(this.onClick),
            onDragStart: this.composeHandlers(this.onDragStart),
            onDragEnter: this.composeHandlers(this.onDragEnter),
            onDragOver: this.composeHandlers(this.onDragOver),
            onDragLeave: this.composeHandlers(this.onDragLeave),
            onDrop: this.composeHandlers(this.onDrop),
            ref: this.setRef,
            'aria-disabled': disabled
          }), this.renderChildren(children, isDragActive, isDragAccept, isDragReject), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, inputProps
          /* expand user provided inputProps first so inputAttributes override them */
          , inputAttributes)));
        }
      }]);

      return Dropzone;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
    /* harmony default export */


    __webpack_exports__["a"] = Dropzone;
    Dropzone.propTypes = {
      /**
       * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
       * Keep in mind that mime type determination is not reliable across platforms. CSV files,
       * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
       * Windows. In some cases there might not be a mime type set at all.
       * See: https://github.com/react-dropzone/react-dropzone/issues/276
       */
      accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),

      /**
       * Contents of the dropzone
       */
      children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),

      /**
       * Disallow clicking on the dropzone container to open file dialog
       */
      disableClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

      /**
       * Enable/disable the dropzone entirely
       */
      disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

      /**
       * Enable/disable preview generation
       */
      disablePreview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

      /**
       * If false, allow dropped items to take over the current browser window
       */
      preventDropOnDocument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

      /**
       * Pass additional attributes to the `<input type="file"/>` tag
       */
      inputProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

      /**
       * Allow dropping multiple files
       */
      multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

      /**
       * `name` attribute for the input tag
       */
      name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

      /**
       * Maximum file size (in bytes)
       */
      maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

      /**
       * Minimum file size (in bytes)
       */
      minSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

      /**
       * className
       */
      className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

      /**
       * className to apply when drag is active
       */
      activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

      /**
       * className to apply when drop will be accepted
       */
      acceptClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

      /**
       * className to apply when drop will be rejected
       */
      rejectClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

      /**
       * className to apply when dropzone is disabled
       */
      disabledClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

      /**
       * CSS styles to apply
       */
      style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

      /**
       * CSS styles to apply when drag is active
       */
      activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

      /**
       * CSS styles to apply when drop will be accepted
       */
      acceptStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

      /**
       * CSS styles to apply when drop will be rejected
       */
      rejectStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

      /**
       * CSS styles to apply when dropzone is disabled
       */
      disabledStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

      /**
       * onClick callback
       * @param {Event} event
       */
      onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

      /**
       * onDrop callback
       */
      onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

      /**
       * onDropAccepted callback
       */
      onDropAccepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

      /**
       * onDropRejected callback
       */
      onDropRejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

      /**
       * onDragStart callback
       */
      onDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

      /**
       * onDragEnter callback
       */
      onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

      /**
       * onDragOver callback
       */
      onDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

      /**
       * onDragLeave callback
       */
      onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

      /**
       * Provide a callback on clicking the cancel button of the file dialog
       */
      onFileDialogCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
    };
    Dropzone.defaultProps = {
      preventDropOnDocument: true,
      disabled: false,
      disablePreview: false,
      disableClick: false,
      inputProps: {},
      multiple: true,
      maxSize: Infinity,
      minSize: 0
    };
    /* WEBPACK VAR INJECTION */
  }).call(__webpack_exports__, __webpack_require__(8));
  /***/
},
/* 402 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "g", function () {
    return supportMultiple;
  });
  /* harmony export (immutable) */


  __webpack_exports__["d"] = getDataTransferItems;
  /* harmony export (immutable) */

  __webpack_exports__["b"] = fileAccepted;
  /* harmony export (immutable) */

  __webpack_exports__["c"] = fileMatchSize;
  /* harmony export (immutable) */

  __webpack_exports__["a"] = allFilesAccepted;
  /* harmony export (immutable) */

  __webpack_exports__["f"] = onDocumentDragOver;
  /* harmony export (immutable) */

  __webpack_exports__["e"] = isIeOrEdge;
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_attr_accept__ = __webpack_require__(403);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_attr_accept__);

  var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;

  function getDataTransferItems(event) {
    var dataTransferItemsList = [];

    if (event.dataTransfer) {
      var dt = event.dataTransfer;

      if (dt.files && dt.files.length) {
        dataTransferItemsList = dt.files;
      } else if (dt.items && dt.items.length) {
        // During the drag even the dataTransfer.files is null
        // but Chrome implements some drag store, which is accesible via dataTransfer.items
        dataTransferItemsList = dt.items;
      }
    } else if (event.target && event.target.files) {
      dataTransferItemsList = event.target.files;
    } // Convert from DataTransferItemsList to the native Array


    return Array.prototype.slice.call(dataTransferItemsList);
  } // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
  // that MIME type will always be accepted


  function fileAccepted(file, accept) {
    return file.type === 'application/x-moz-file' || __WEBPACK_IMPORTED_MODULE_0_attr_accept___default()(file, accept);
  }

  function fileMatchSize(file, maxSize, minSize) {
    return file.size <= maxSize && file.size >= minSize;
  }

  function allFilesAccepted(files, accept) {
    return files.every(function (file) {
      return fileAccepted(file, accept);
    });
  } // allow the entire document to be a drag target


  function onDocumentDragOver(evt) {
    evt.preventDefault();
  }

  function isIe(userAgent) {
    return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
  }

  function isEdge(userAgent) {
    return userAgent.indexOf('Edge/') !== -1;
  }

  function isIeOrEdge() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return isIe(userAgent) || isEdge(userAgent);
  }
  /***/

},
/* 403 */

/***/
function (module, exports) {
  module.exports = function (t) {
    function n(e) {
      if (r[e]) return r[e].exports;
      var o = r[e] = {
        i: e,
        l: !1,
        exports: {}
      };
      return t[e].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    var r = {};
    return n.m = t, n.c = r, n.d = function (t, r, e) {
      n.o(t, r) || Object.defineProperty(t, r, {
        configurable: !1,
        enumerable: !0,
        get: e
      });
    }, n.n = function (t) {
      var r = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return n.d(r, "a", r), r;
    }, n.o = function (t, n) {
      return Object.prototype.hasOwnProperty.call(t, n);
    }, n.p = "", n(n.s = 13);
  }([function (t, n) {
    var r = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = r);
  }, function (t, n) {
    t.exports = function (t) {
      return "object" == _typeof4(t) ? null !== t : "function" == typeof t;
    };
  }, function (t, n) {
    var r = t.exports = {
      version: "2.5.0"
    };
    "number" == typeof __e && (__e = r);
  }, function (t, n, r) {
    t.exports = !r(4)(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, n) {
    t.exports = function (t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    };
  }, function (t, n) {
    var r = {}.toString;

    t.exports = function (t) {
      return r.call(t).slice(8, -1);
    };
  }, function (t, n, r) {
    var e = r(32)("wks"),
        o = r(9),
        i = r(0).Symbol,
        u = "function" == typeof i;
    (t.exports = function (t) {
      return e[t] || (e[t] = u && i[t] || (u ? i : o)("Symbol." + t));
    }).store = e;
  }, function (t, n, r) {
    var e = r(0),
        o = r(2),
        i = r(8),
        u = r(22),
        c = r(10),
        f = function f(t, n, r) {
      var a,
          s,
          p,
          l,
          v = t & f.F,
          y = t & f.G,
          h = t & f.S,
          d = t & f.P,
          x = t & f.B,
          g = y ? e : h ? e[n] || (e[n] = {}) : (e[n] || {}).prototype,
          m = y ? o : o[n] || (o[n] = {}),
          b = m.prototype || (m.prototype = {});
      y && (r = n);

      for (a in r) {
        s = !v && g && void 0 !== g[a], p = (s ? g : r)[a], l = x && s ? c(p, e) : d && "function" == typeof p ? c(Function.call, p) : p, g && u(g, a, p, t & f.U), m[a] != p && i(m, a, l), d && b[a] != p && (b[a] = p);
      }
    };

    e.core = o, f.F = 1, f.G = 2, f.S = 4, f.P = 8, f.B = 16, f.W = 32, f.U = 64, f.R = 128, t.exports = f;
  }, function (t, n, r) {
    var e = r(16),
        o = r(21);
    t.exports = r(3) ? function (t, n, r) {
      return e.f(t, n, o(1, r));
    } : function (t, n, r) {
      return t[n] = r, t;
    };
  }, function (t, n) {
    var r = 0,
        e = Math.random();

    t.exports = function (t) {
      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++r + e).toString(36));
    };
  }, function (t, n, r) {
    var e = r(24);

    t.exports = function (t, n, r) {
      if (e(t), void 0 === n) return t;

      switch (r) {
        case 1:
          return function (r) {
            return t.call(n, r);
          };

        case 2:
          return function (r, e) {
            return t.call(n, r, e);
          };

        case 3:
          return function (r, e, o) {
            return t.call(n, r, e, o);
          };
      }

      return function () {
        return t.apply(n, arguments);
      };
    };
  }, function (t, n) {
    t.exports = function (t) {
      if (void 0 == t) throw TypeError("Can't call method on  " + t);
      return t;
    };
  }, function (t, n, r) {
    var e = r(28),
        o = Math.min;

    t.exports = function (t) {
      return t > 0 ? o(e(t), 9007199254740991) : 0;
    };
  }, function (t, n, r) {
    "use strict";

    n.__esModule = !0, n["default"] = function (t, n) {
      if (t && n) {
        var r = Array.isArray(n) ? n : n.split(","),
            e = t.name || "",
            o = t.type || "",
            i = o.replace(/\/.*$/, "");
        return r.some(function (t) {
          var n = t.trim();
          return "." === n.charAt(0) ? e.toLowerCase().endsWith(n.toLowerCase()) : n.endsWith("/*") ? i === n.replace(/\/.*$/, "") : o === n;
        });
      }

      return !0;
    }, r(14), r(34);
  }, function (t, n, r) {
    r(15), t.exports = r(2).Array.some;
  }, function (t, n, r) {
    "use strict";

    var e = r(7),
        o = r(25)(3);
    e(e.P + e.F * !r(33)([].some, !0), "Array", {
      some: function some(t) {
        return o(this, t, arguments[1]);
      }
    });
  }, function (t, n, r) {
    var e = r(17),
        o = r(18),
        i = r(20),
        u = Object.defineProperty;
    n.f = r(3) ? Object.defineProperty : function (t, n, r) {
      if (e(t), n = i(n, !0), e(r), o) try {
        return u(t, n, r);
      } catch (t) {}
      if ("get" in r || "set" in r) throw TypeError("Accessors not supported!");
      return "value" in r && (t[n] = r.value), t;
    };
  }, function (t, n, r) {
    var e = r(1);

    t.exports = function (t) {
      if (!e(t)) throw TypeError(t + " is not an object!");
      return t;
    };
  }, function (t, n, r) {
    t.exports = !r(3) && !r(4)(function () {
      return 7 != Object.defineProperty(r(19)("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, n, r) {
    var e = r(1),
        o = r(0).document,
        i = e(o) && e(o.createElement);

    t.exports = function (t) {
      return i ? o.createElement(t) : {};
    };
  }, function (t, n, r) {
    var e = r(1);

    t.exports = function (t, n) {
      if (!e(t)) return t;
      var r, o;
      if (n && "function" == typeof (r = t.toString) && !e(o = r.call(t))) return o;
      if ("function" == typeof (r = t.valueOf) && !e(o = r.call(t))) return o;
      if (!n && "function" == typeof (r = t.toString) && !e(o = r.call(t))) return o;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (t, n) {
    t.exports = function (t, n) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: n
      };
    };
  }, function (t, n, r) {
    var e = r(0),
        o = r(8),
        i = r(23),
        u = r(9)("src"),
        c = Function.toString,
        f = ("" + c).split("toString");
    r(2).inspectSource = function (t) {
      return c.call(t);
    }, (t.exports = function (t, n, r, c) {
      var a = "function" == typeof r;
      a && (i(r, "name") || o(r, "name", n)), t[n] !== r && (a && (i(r, u) || o(r, u, t[n] ? "" + t[n] : f.join(String(n)))), t === e ? t[n] = r : c ? t[n] ? t[n] = r : o(t, n, r) : (delete t[n], o(t, n, r)));
    })(Function.prototype, "toString", function () {
      return "function" == typeof this && this[u] || c.call(this);
    });
  }, function (t, n) {
    var r = {}.hasOwnProperty;

    t.exports = function (t, n) {
      return r.call(t, n);
    };
  }, function (t, n) {
    t.exports = function (t) {
      if ("function" != typeof t) throw TypeError(t + " is not a function!");
      return t;
    };
  }, function (t, n, r) {
    var e = r(10),
        o = r(26),
        i = r(27),
        u = r(12),
        c = r(29);

    t.exports = function (t, n) {
      var r = 1 == t,
          f = 2 == t,
          a = 3 == t,
          s = 4 == t,
          p = 6 == t,
          l = 5 == t || p,
          v = n || c;
      return function (n, c, y) {
        for (var h, d, x = i(n), g = o(x), m = e(c, y, 3), b = u(g.length), _ = 0, w = r ? v(n, b) : f ? v(n, 0) : void 0; b > _; _++) {
          if ((l || _ in g) && (h = g[_], d = m(h, _, x), t)) if (r) w[_] = d;else if (d) switch (t) {
            case 3:
              return !0;

            case 5:
              return h;

            case 6:
              return _;

            case 2:
              w.push(h);
          } else if (s) return !1;
        }

        return p ? -1 : a || s ? s : w;
      };
    };
  }, function (t, n, r) {
    var e = r(5);
    t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
      return "String" == e(t) ? t.split("") : Object(t);
    };
  }, function (t, n, r) {
    var e = r(11);

    t.exports = function (t) {
      return Object(e(t));
    };
  }, function (t, n) {
    var r = Math.ceil,
        e = Math.floor;

    t.exports = function (t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? e : r)(t);
    };
  }, function (t, n, r) {
    var e = r(30);

    t.exports = function (t, n) {
      return new (e(t))(n);
    };
  }, function (t, n, r) {
    var e = r(1),
        o = r(31),
        i = r(6)("species");

    t.exports = function (t) {
      var n;
      return o(t) && (n = t.constructor, "function" != typeof n || n !== Array && !o(n.prototype) || (n = void 0), e(n) && null === (n = n[i]) && (n = void 0)), void 0 === n ? Array : n;
    };
  }, function (t, n, r) {
    var e = r(5);

    t.exports = Array.isArray || function (t) {
      return "Array" == e(t);
    };
  }, function (t, n, r) {
    var e = r(0),
        o = e["__core-js_shared__"] || (e["__core-js_shared__"] = {});

    t.exports = function (t) {
      return o[t] || (o[t] = {});
    };
  }, function (t, n, r) {
    "use strict";

    var e = r(4);

    t.exports = function (t, n) {
      return !!t && e(function () {
        n ? t.call(null, function () {}, 1) : t.call(null);
      });
    };
  }, function (t, n, r) {
    r(35), t.exports = r(2).String.endsWith;
  }, function (t, n, r) {
    "use strict";

    var e = r(7),
        o = r(12),
        i = r(36),
        u = "".endsWith;
    e(e.P + e.F * r(38)("endsWith"), "String", {
      endsWith: function endsWith(t) {
        var n = i(this, t, "endsWith"),
            r = arguments.length > 1 ? arguments[1] : void 0,
            e = o(n.length),
            c = void 0 === r ? e : Math.min(o(r), e),
            f = String(t);
        return u ? u.call(n, f, c) : n.slice(c - f.length, c) === f;
      }
    });
  }, function (t, n, r) {
    var e = r(37),
        o = r(11);

    t.exports = function (t, n, r) {
      if (e(n)) throw TypeError("String#" + r + " doesn't accept regex!");
      return String(o(t));
    };
  }, function (t, n, r) {
    var e = r(1),
        o = r(5),
        i = r(6)("match");

    t.exports = function (t) {
      var n;
      return e(t) && (void 0 !== (n = t[i]) ? !!n : "RegExp" == o(t));
    };
  }, function (t, n, r) {
    var e = r(6)("match");

    t.exports = function (t) {
      var n = /./;

      try {
        "/./"[t](n);
      } catch (r) {
        try {
          return n[e] = !1, !"/./"[t](n);
        } catch (t) {}
      }

      return !0;
    };
  }]);
  /***/

},
/* 404 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony default export */

  __webpack_exports__["a"] = {
    rejected: {
      borderStyle: 'solid',
      borderColor: '#c66',
      backgroundColor: '#eee'
    },
    disabled: {
      opacity: 0.5
    },
    active: {
      borderStyle: 'solid',
      borderColor: '#6c6',
      backgroundColor: '#eee'
    },
    "default": {
      width: 200,
      height: 200,
      borderWidth: 2,
      borderColor: '#666',
      borderStyle: 'dashed',
      borderRadius: 5
    }
  };
  /***/
},
/* 405 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(13);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);

  var _class,
      _temp,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/UI/Spinner/Spinner.js';

  var Spinner = (_temp = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Spinner, _React$Component);

    function Spinner() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Spinner);

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Spinner.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Spinner)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Spinner, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            isLoading = _props.isLoading,
            className = _props.className;

        var classNames = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
          '-loading': isLoading
        }, className, !!className));

        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', {
          className: 'cw-spinner ' + classNames,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 24
          }
        }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', {
          className: 'spinner-box',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 25
          }
        }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', {
          className: 'icon',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 26
          }
        })), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', {
          className: 'spinner-box',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 28
          }
        }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', {
          className: 'icon-2',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 29
          }
        })));
      }
    }]);

    return Spinner;
  }(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component), _class.propTypes = {
    isLoading: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
  }, _class.defaultProps = {
    isLoading: false,
    className: ''
  }, _temp);
  Spinner.displayName = 'Spinner';
  /* harmony default export */

  __webpack_exports__["a"] = Spinner;
  /***/
},
/* 406 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_recompose__ = __webpack_require__(18);

  var _class,
      _temp,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/WysiwygProvider.js';

  var WysiwygProvider = (_temp = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(WysiwygProvider, _React$Component);

    function WysiwygProvider() {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WysiwygProvider);

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WysiwygProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(WysiwygProvider)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(WysiwygProvider, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', {
          className: 'cw-wysiwyg-provider',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 13
          }
        }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.map(this.props.children, function (child) {
          return child;
        }));
      }
    }]);

    return WysiwygProvider;
  }(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component), _class.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
  }, _temp);
  WysiwygProvider.displayName = 'WysiwygProvider';
  /* harmony default export */

  __webpack_exports__["a"] = Object(__WEBPACK_IMPORTED_MODULE_7_recompose__["b"
  /* withContext */
  ])({
    blocks: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    items: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
    readOnly: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    cursor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
    editionMode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    setToolbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    setCursor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    setEditionMode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    setItems: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    addItem: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    updateItem: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    removeItem: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onUploadImage: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  }, function (props) {
    return {
      blocks: props.blocks,
      items: props.items,
      readOnly: props.readOnly,
      cursor: props.cursor,
      editionMode: props.editionMode,
      setToolbar: props.setToolbar,
      setCursor: props.setCursor,
      setEditionMode: props.setEditionMode,
      setItems: props.setItems,
      addItem: props.addItem,
      updateItem: props.updateItem,
      removeItem: props.removeItem,
      onUploadImage: props.onUploadImage
    };
  })(WysiwygProvider);
  /***/
},
/* 407 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(53);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_recompose__ = __webpack_require__(18);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_react_sortable_hoc__ = __webpack_require__(65);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_react_sortable_hoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_sortable_hoc__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10__List_List__ = __webpack_require__(516);

  var _class,
      _temp2,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/Content/Content.js'; // Recompose
  // Drag and drop


  var Content = (_temp2 = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Content, _React$Component);

    function Content() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Content);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Content.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Content)).call.apply(_ref, [this].concat(args))), _this), _this.onSortEnd = function (_ref2) {
        var oldIndex = _ref2.oldIndex,
            newIndex = _ref2.newIndex; // Reorder items

        var items = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.props.items));

        _this.props.setItems(Object(__WEBPACK_IMPORTED_MODULE_9_react_sortable_hoc__["arrayMove"])(items, oldIndex, newIndex));

        _this.props.setCursor(newIndex);
      }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }
    /**
     * UI EVENTS
     * - onSortStart
     * - onSortEnd
     * @param  {Object} drag
     * @return void
    */


    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Content, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__List_List__["a"
        /* default */
        ], {
          useDragHandle: true,
          helperClass: '-isDragging',
          onSortEnd: this.onSortEnd,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 42
          }
        });
      }
    }]);

    return Content;
  }(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component), _class.propTypes = {
    items: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array,
    setItems: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    setCursor: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  }, _class.defaultProps = {
    items: [],
    setItems: null,
    setCursor: null
  }, _temp2);
  Content.displayName = 'Content';
  /* harmony default export */

  __webpack_exports__["a"] = Object(__WEBPACK_IMPORTED_MODULE_8_recompose__["a"
  /* getContext */
  ])({
    items: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array,
    setItems: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    setCursor: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  })(Content);
  /***/
},
/* 408 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  exports["default"] = sortableContainer;

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactDom = __webpack_require__(35);

  var _invariant = __webpack_require__(64);

  var _invariant2 = _interopRequireDefault(_invariant);

  var _Manager = __webpack_require__(409);

  var _Manager2 = _interopRequireDefault(_Manager);

  var _utils = __webpack_require__(66);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return Array.from(arr);
    }
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  } // Export Higher Order Sortable Container Component


  function sortableContainer(WrappedComponent) {
    var _class, _temp;

    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      withRef: false
    };
    return _temp = _class = function (_Component) {
      _inherits(_class, _Component);

      function _class(props) {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

        _this.handleStart = function (e) {
          var _this$props = _this.props,
              distance = _this$props.distance,
              shouldCancelStart = _this$props.shouldCancelStart;

          if (e.button === 2 || shouldCancelStart(e)) {
            return false;
          }

          _this._touched = true;
          _this._pos = {
            x: e.pageX,
            y: e.pageY
          };
          var node = (0, _utils.closest)(e.target, function (el) {
            return el.sortableInfo != null;
          });

          if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
            var useDragHandle = _this.props.useDragHandle;
            var _node$sortableInfo = node.sortableInfo,
                index = _node$sortableInfo.index,
                collection = _node$sortableInfo.collection;
            if (useDragHandle && !(0, _utils.closest)(e.target, function (el) {
              return el.sortableHandle != null;
            })) return;
            _this.manager.active = {
              index: index,
              collection: collection
            };
            /*
            * Fixes a bug in Firefox where the :active state of anchor tags
            * prevent subsequent 'mousemove' events from being fired
            * (see https://github.com/clauderic/react-sortable-hoc/issues/118)
            */

            if (e.target.tagName.toLowerCase() === 'a') {
              e.preventDefault();
            }

            if (!distance) {
              if (_this.props.pressDelay === 0) {
                _this.handlePress(e);
              } else {
                _this.pressTimer = setTimeout(function () {
                  return _this.handlePress(e);
                }, _this.props.pressDelay);
              }
            }
          }
        };

        _this.nodeIsChild = function (node) {
          return node.sortableInfo.manager === _this.manager;
        };

        _this.handleMove = function (e) {
          var _this$props2 = _this.props,
              distance = _this$props2.distance,
              pressThreshold = _this$props2.pressThreshold;

          if (!_this.state.sorting && _this._touched) {
            _this._delta = {
              x: _this._pos.x - e.pageX,
              y: _this._pos.y - e.pageY
            };
            var delta = Math.abs(_this._delta.x) + Math.abs(_this._delta.y);

            if (!distance && (!pressThreshold || pressThreshold && delta >= pressThreshold)) {
              clearTimeout(_this.cancelTimer);
              _this.cancelTimer = setTimeout(_this.cancel, 0);
            } else if (distance && delta >= distance && _this.manager.isActive()) {
              _this.handlePress(e);
            }
          }
        };

        _this.handleEnd = function () {
          var distance = _this.props.distance;
          _this._touched = false;

          if (!distance) {
            _this.cancel();
          }
        };

        _this.cancel = function () {
          if (!_this.state.sorting) {
            clearTimeout(_this.pressTimer);
            _this.manager.active = null;
          }
        };

        _this.handlePress = function (e) {
          var active = _this.manager.getActive();

          if (active) {
            var _this$props3 = _this.props,
                axis = _this$props3.axis,
                getHelperDimensions = _this$props3.getHelperDimensions,
                helperClass = _this$props3.helperClass,
                hideSortableGhost = _this$props3.hideSortableGhost,
                onSortStart = _this$props3.onSortStart,
                useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
            var node = active.node,
                collection = active.collection;
            var index = node.sortableInfo.index;
            var margin = (0, _utils.getElementMargin)(node);

            var containerBoundingRect = _this.container.getBoundingClientRect();

            var dimensions = getHelperDimensions({
              index: index,
              node: node,
              collection: collection
            });
            _this.node = node;
            _this.margin = margin;
            _this.width = dimensions.width;
            _this.height = dimensions.height;
            _this.marginOffset = {
              x: _this.margin.left + _this.margin.right,
              y: Math.max(_this.margin.top, _this.margin.bottom)
            };
            _this.boundingClientRect = node.getBoundingClientRect();
            _this.containerBoundingRect = containerBoundingRect;
            _this.index = index;
            _this.newIndex = index;
            _this.axis = {
              x: axis.indexOf('x') >= 0,
              y: axis.indexOf('y') >= 0
            };
            _this.offsetEdge = _this.getEdgeOffset(node);
            _this.initialOffset = _this.getOffset(e);
            _this.initialScroll = {
              top: _this.scrollContainer.scrollTop,
              left: _this.scrollContainer.scrollLeft
            };
            _this.initialWindowScroll = {
              top: window.pageYOffset,
              left: window.pageXOffset
            };
            var fields = node.querySelectorAll('input, textarea, select');
            var clonedNode = node.cloneNode(true);
            var clonedFields = [].concat(_toConsumableArray(clonedNode.querySelectorAll('input, textarea, select'))); // Convert NodeList to Array

            clonedFields.forEach(function (field, index) {
              if (field.type !== 'file' && fields[index]) {
                field.value = fields[index].value;
              }
            });
            _this.helper = _this.document.body.appendChild(clonedNode);
            _this.helper.style.position = 'fixed';
            _this.helper.style.top = _this.boundingClientRect.top - margin.top + 'px';
            _this.helper.style.left = _this.boundingClientRect.left - margin.left + 'px';
            _this.helper.style.width = _this.width + 'px';
            _this.helper.style.height = _this.height + 'px';
            _this.helper.style.boxSizing = 'border-box';
            _this.helper.style.pointerEvents = 'none';

            if (hideSortableGhost) {
              _this.sortableGhost = node;
              node.style.visibility = 'hidden';
              node.style.opacity = 0;
            }

            _this.minTranslate = {};
            _this.maxTranslate = {};

            if (_this.axis.x) {
              _this.minTranslate.x = (useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
              _this.maxTranslate.x = (useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
            }

            if (_this.axis.y) {
              _this.minTranslate.y = (useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
              _this.maxTranslate.y = (useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
            }

            if (helperClass) {
              var _this$helper$classLis;

              (_this$helper$classLis = _this.helper.classList).add.apply(_this$helper$classLis, _toConsumableArray(helperClass.split(' ')));
            }

            _this.listenerNode = e.touches ? node : _this.contentWindow;

            _utils.events.move.forEach(function (eventName) {
              return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
            });

            _utils.events.end.forEach(function (eventName) {
              return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
            });

            _this.setState({
              sorting: true,
              sortingIndex: index
            });

            if (onSortStart) onSortStart({
              node: node,
              index: index,
              collection: collection
            }, e);
          }
        };

        _this.handleSortMove = function (e) {
          var onSortMove = _this.props.onSortMove;
          e.preventDefault(); // Prevent scrolling on mobile

          _this.updatePosition(e);

          _this.animateNodes();

          _this.autoscroll();

          if (onSortMove) onSortMove(e);
        };

        _this.handleSortEnd = function (e) {
          var _this$props4 = _this.props,
              hideSortableGhost = _this$props4.hideSortableGhost,
              onSortEnd = _this$props4.onSortEnd;
          var collection = _this.manager.active.collection; // Remove the event listeners if the node is still in the DOM

          if (_this.listenerNode) {
            _utils.events.move.forEach(function (eventName) {
              return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
            });

            _utils.events.end.forEach(function (eventName) {
              return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
            });
          } // Remove the helper from the DOM


          _this.helper.parentNode.removeChild(_this.helper);

          if (hideSortableGhost && _this.sortableGhost) {
            _this.sortableGhost.style.visibility = '';
            _this.sortableGhost.style.opacity = '';
          }

          var nodes = _this.manager.refs[collection];

          for (var i = 0, len = nodes.length; i < len; i++) {
            var node = nodes[i];
            var el = node.node; // Clear the cached offsetTop / offsetLeft value

            node.edgeOffset = null; // Remove the transforms / transitions

            el.style[_utils.vendorPrefix + 'Transform'] = '';
            el.style[_utils.vendorPrefix + 'TransitionDuration'] = '';
          } // Stop autoscroll


          clearInterval(_this.autoscrollInterval);
          _this.autoscrollInterval = null; // Update state

          _this.manager.active = null;

          _this.setState({
            sorting: false,
            sortingIndex: null
          });

          if (typeof onSortEnd === 'function') {
            onSortEnd({
              oldIndex: _this.index,
              newIndex: _this.newIndex,
              collection: collection
            }, e);
          }

          _this._touched = false;
        };

        _this.autoscroll = function () {
          var translate = _this.translate;
          var direction = {
            x: 0,
            y: 0
          };
          var speed = {
            x: 1,
            y: 1
          };
          var acceleration = {
            x: 10,
            y: 10
          };

          if (translate.y >= _this.maxTranslate.y - _this.height / 2) {
            direction.y = 1; // Scroll Down

            speed.y = acceleration.y * Math.abs((_this.maxTranslate.y - _this.height / 2 - translate.y) / _this.height);
          } else if (translate.x >= _this.maxTranslate.x - _this.width / 2) {
            direction.x = 1; // Scroll Right

            speed.x = acceleration.x * Math.abs((_this.maxTranslate.x - _this.width / 2 - translate.x) / _this.width);
          } else if (translate.y <= _this.minTranslate.y + _this.height / 2) {
            direction.y = -1; // Scroll Up

            speed.y = acceleration.y * Math.abs((translate.y - _this.height / 2 - _this.minTranslate.y) / _this.height);
          } else if (translate.x <= _this.minTranslate.x + _this.width / 2) {
            direction.x = -1; // Scroll Left

            speed.x = acceleration.x * Math.abs((translate.x - _this.width / 2 - _this.minTranslate.x) / _this.width);
          }

          if (_this.autoscrollInterval) {
            clearInterval(_this.autoscrollInterval);
            _this.autoscrollInterval = null;
            _this.isAutoScrolling = false;
          }

          if (direction.x !== 0 || direction.y !== 0) {
            _this.autoscrollInterval = setInterval(function () {
              _this.isAutoScrolling = true;
              var offset = {
                left: 1 * speed.x * direction.x,
                top: 1 * speed.y * direction.y
              };
              _this.scrollContainer.scrollTop += offset.top;
              _this.scrollContainer.scrollLeft += offset.left;
              _this.translate.x += offset.left;
              _this.translate.y += offset.top;

              _this.animateNodes();
            }, 5);
          }
        };

        _this.manager = new _Manager2["default"]();
        _this.events = {
          start: _this.handleStart,
          move: _this.handleMove,
          end: _this.handleEnd
        };
        (0, _invariant2["default"])(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');
        _this.state = {};
        return _this;
      }

      _createClass(_class, [{
        key: 'getChildContext',
        value: function getChildContext() {
          return {
            manager: this.manager
          };
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          var _props = this.props,
              getContainer = _props.getContainer,
              useWindowAsScrollContainer = _props.useWindowAsScrollContainer;
          /*
           *  Set our own default rather than using defaultProps because Jest
           *  snapshots will serialize window, causing a RangeError
           *  https://github.com/clauderic/react-sortable-hoc/issues/249
           */

          var contentWindow = this.props.contentWindow || window;
          this.container = typeof getContainer === 'function' ? getContainer(this.getWrappedInstance()) : (0, _reactDom.findDOMNode)(this);
          this.document = this.container.ownerDocument || document;
          this.scrollContainer = useWindowAsScrollContainer ? this.document.body : this.container;
          this.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;

          var _loop = function _loop(key) {
            if (_this2.events.hasOwnProperty(key)) {
              _utils.events[key].forEach(function (eventName) {
                return _this2.container.addEventListener(eventName, _this2.events[key], false);
              });
            }
          };

          for (var key in this.events) {
            _loop(key);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          var _this3 = this;

          var _loop2 = function _loop2(key) {
            if (_this3.events.hasOwnProperty(key)) {
              _utils.events[key].forEach(function (eventName) {
                return _this3.container.removeEventListener(eventName, _this3.events[key]);
              });
            }
          };

          for (var key in this.events) {
            _loop2(key);
          }
        }
      }, {
        key: 'getEdgeOffset',
        value: function getEdgeOffset(node) {
          var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            top: 0,
            left: 0
          }; // Get the actual offsetTop / offsetLeft value, no matter how deep the node is nested

          if (node) {
            var nodeOffset = {
              top: offset.top + node.offsetTop,
              left: offset.left + node.offsetLeft
            };

            if (node.parentNode !== this.container) {
              return this.getEdgeOffset(node.parentNode, nodeOffset);
            } else {
              return nodeOffset;
            }
          }
        }
      }, {
        key: 'getOffset',
        value: function getOffset(e) {
          return {
            x: e.touches ? e.touches[0].pageX : e.pageX,
            y: e.touches ? e.touches[0].pageY : e.pageY
          };
        }
      }, {
        key: 'getLockPixelOffsets',
        value: function getLockPixelOffsets() {
          var lockOffset = this.props.lockOffset;

          if (!Array.isArray(lockOffset)) {
            lockOffset = [lockOffset, lockOffset];
          }

          (0, _invariant2["default"])(lockOffset.length === 2, 'lockOffset prop of SortableContainer should be a single ' + 'value or an array of exactly two values. Given %s', lockOffset);

          var _lockOffset = lockOffset,
              _lockOffset2 = _slicedToArray(_lockOffset, 2),
              minLockOffset = _lockOffset2[0],
              maxLockOffset = _lockOffset2[1];

          return [this.getLockPixelOffset(minLockOffset), this.getLockPixelOffset(maxLockOffset)];
        }
      }, {
        key: 'getLockPixelOffset',
        value: function getLockPixelOffset(lockOffset) {
          var offsetX = lockOffset;
          var offsetY = lockOffset;
          var unit = 'px';

          if (typeof lockOffset === 'string') {
            var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);
            (0, _invariant2["default"])(match !== null, 'lockOffset value should be a number or a string of a ' + 'number followed by "px" or "%". Given %s', lockOffset);
            offsetX = offsetY = parseFloat(lockOffset);
            unit = match[1];
          }

          (0, _invariant2["default"])(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);

          if (unit === '%') {
            offsetX = offsetX * this.width / 100;
            offsetY = offsetY * this.height / 100;
          }

          return {
            x: offsetX,
            y: offsetY
          };
        }
      }, {
        key: 'updatePosition',
        value: function updatePosition(e) {
          var _props2 = this.props,
              lockAxis = _props2.lockAxis,
              lockToContainerEdges = _props2.lockToContainerEdges;
          var offset = this.getOffset(e);
          var translate = {
            x: offset.x - this.initialOffset.x,
            y: offset.y - this.initialOffset.y
          }; // Adjust for window scroll

          translate.y -= window.pageYOffset - this.initialWindowScroll.top;
          translate.x -= window.pageXOffset - this.initialWindowScroll.left;
          this.translate = translate;

          if (lockToContainerEdges) {
            var _getLockPixelOffsets = this.getLockPixelOffsets(),
                _getLockPixelOffsets2 = _slicedToArray(_getLockPixelOffsets, 2),
                minLockOffset = _getLockPixelOffsets2[0],
                maxLockOffset = _getLockPixelOffsets2[1];

            var minOffset = {
              x: this.width / 2 - minLockOffset.x,
              y: this.height / 2 - minLockOffset.y
            };
            var maxOffset = {
              x: this.width / 2 - maxLockOffset.x,
              y: this.height / 2 - maxLockOffset.y
            };
            translate.x = (0, _utils.limit)(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
            translate.y = (0, _utils.limit)(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
          }

          if (lockAxis === 'x') {
            translate.y = 0;
          } else if (lockAxis === 'y') {
            translate.x = 0;
          }

          this.helper.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px, 0)';
        }
      }, {
        key: 'animateNodes',
        value: function animateNodes() {
          var _props3 = this.props,
              transitionDuration = _props3.transitionDuration,
              hideSortableGhost = _props3.hideSortableGhost;
          var nodes = this.manager.getOrderedRefs();
          var deltaScroll = {
            left: this.scrollContainer.scrollLeft - this.initialScroll.left,
            top: this.scrollContainer.scrollTop - this.initialScroll.top
          };
          var sortingOffset = {
            left: this.offsetEdge.left + this.translate.x + deltaScroll.left,
            top: this.offsetEdge.top + this.translate.y + deltaScroll.top
          };
          var scrollDifference = {
            top: window.pageYOffset - this.initialWindowScroll.top,
            left: window.pageXOffset - this.initialWindowScroll.left
          };
          this.newIndex = null;

          for (var i = 0, len = nodes.length; i < len; i++) {
            var node = nodes[i].node;
            var index = node.sortableInfo.index;
            var width = node.offsetWidth;
            var height = node.offsetHeight;
            var offset = {
              width: this.width > width ? width / 2 : this.width / 2,
              height: this.height > height ? height / 2 : this.height / 2
            };
            var translate = {
              x: 0,
              y: 0
            };
            var edgeOffset = nodes[i].edgeOffset; // If we haven't cached the node's offsetTop / offsetLeft value

            if (!edgeOffset) {
              nodes[i].edgeOffset = edgeOffset = this.getEdgeOffset(node);
            } // Get a reference to the next and previous node


            var nextNode = i < nodes.length - 1 && nodes[i + 1];
            var prevNode = i > 0 && nodes[i - 1]; // Also cache the next node's edge offset if needed.
            // We need this for calculating the animation in a grid setup

            if (nextNode && !nextNode.edgeOffset) {
              nextNode.edgeOffset = this.getEdgeOffset(nextNode.node);
            } // If the node is the one we're currently animating, skip it


            if (index === this.index) {
              if (hideSortableGhost) {
                /*
                * With windowing libraries such as `react-virtualized`, the sortableGhost
                * node may change while scrolling down and then back up (or vice-versa),
                * so we need to update the reference to the new node just to be safe.
                */
                this.sortableGhost = node;
                node.style.visibility = 'hidden';
                node.style.opacity = 0;
              }

              continue;
            }

            if (transitionDuration) {
              node.style[_utils.vendorPrefix + 'TransitionDuration'] = transitionDuration + 'ms';
            }

            if (this.axis.x) {
              if (this.axis.y) {
                // Calculations for a grid setup
                if (index < this.index && (sortingOffset.left + scrollDifference.left - offset.width <= edgeOffset.left && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height || sortingOffset.top + scrollDifference.top + offset.height <= edgeOffset.top)) {
                  // If the current node is to the left on the same row, or above the node that's being dragged
                  // then move it to the right
                  translate.x = this.width + this.marginOffset.x;

                  if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                    // If it moves passed the right bounds, then animate it to the first position of the next row.
                    // We just use the offset of the next node to calculate where to move, because that node's original position
                    // is exactly where we want to go
                    translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                    translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                  }

                  if (this.newIndex === null) {
                    this.newIndex = index;
                  }
                } else if (index > this.index && (sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top || sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top + height)) {
                  // If the current node is to the right on the same row, or below the node that's being dragged
                  // then move it to the left
                  translate.x = -(this.width + this.marginOffset.x);

                  if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                    // If it moves passed the left bounds, then animate it to the last position of the previous row.
                    // We just use the offset of the previous node to calculate where to move, because that node's original position
                    // is exactly where we want to go
                    translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                    translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                  }

                  this.newIndex = index;
                }
              } else {
                if (index > this.index && sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left) {
                  translate.x = -(this.width + this.marginOffset.x);
                  this.newIndex = index;
                } else if (index < this.index && sortingOffset.left + scrollDifference.left <= edgeOffset.left + offset.width) {
                  translate.x = this.width + this.marginOffset.x;

                  if (this.newIndex == null) {
                    this.newIndex = index;
                  }
                }
              }
            } else if (this.axis.y) {
              if (index > this.index && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top) {
                translate.y = -(this.height + this.marginOffset.y);
                this.newIndex = index;
              } else if (index < this.index && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height) {
                translate.y = this.height + this.marginOffset.y;

                if (this.newIndex == null) {
                  this.newIndex = index;
                }
              }
            }

            node.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px,0)';
          }

          if (this.newIndex == null) {
            this.newIndex = this.index;
          }
        }
      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          (0, _invariant2["default"])(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
          return this.refs.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var ref = config.withRef ? 'wrappedInstance' : null;
          return _react2["default"].createElement(WrappedComponent, _extends({
            ref: ref
          }, (0, _utils.omit)(this.props, 'contentWindow', 'useWindowAsScrollContainer', 'distance', 'helperClass', 'hideSortableGhost', 'transitionDuration', 'useDragHandle', 'pressDelay', 'pressThreshold', 'shouldCancelStart', 'onSortStart', 'onSortMove', 'onSortEnd', 'axis', 'lockAxis', 'lockOffset', 'lockToContainerEdges', 'getContainer', 'getHelperDimensions')));
        }
      }]);

      return _class;
    }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableList', WrappedComponent), _class.defaultProps = {
      axis: 'y',
      transitionDuration: 300,
      pressDelay: 0,
      pressThreshold: 5,
      distance: 0,
      useWindowAsScrollContainer: false,
      hideSortableGhost: true,
      shouldCancelStart: function shouldCancelStart(e) {
        // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
        var disabledElements = ['input', 'textarea', 'select', 'option', 'button'];

        if (disabledElements.indexOf(e.target.tagName.toLowerCase()) !== -1) {
          return true; // Return true to cancel sorting
        }
      },
      lockToContainerEdges: false,
      lockOffset: '50%',
      getHelperDimensions: function getHelperDimensions(_ref) {
        var node = _ref.node;
        return {
          width: node.offsetWidth,
          height: node.offsetHeight
        };
      }
    }, _class.propTypes = {
      axis: _propTypes2["default"].oneOf(['x', 'y', 'xy']),
      distance: _propTypes2["default"].number,
      lockAxis: _propTypes2["default"].string,
      helperClass: _propTypes2["default"].string,
      transitionDuration: _propTypes2["default"].number,
      contentWindow: _propTypes2["default"].any,
      onSortStart: _propTypes2["default"].func,
      onSortMove: _propTypes2["default"].func,
      onSortEnd: _propTypes2["default"].func,
      shouldCancelStart: _propTypes2["default"].func,
      pressDelay: _propTypes2["default"].number,
      useDragHandle: _propTypes2["default"].bool,
      useWindowAsScrollContainer: _propTypes2["default"].bool,
      hideSortableGhost: _propTypes2["default"].bool,
      lockToContainerEdges: _propTypes2["default"].bool,
      lockOffset: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string, _propTypes2["default"].arrayOf(_propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]))]),
      getContainer: _propTypes2["default"].func,
      getHelperDimensions: _propTypes2["default"].func
    }, _class.childContextTypes = {
      manager: _propTypes2["default"].object.isRequired
    }, _temp;
  }
  /***/

},
/* 409 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _find = __webpack_require__(410);

  var _find2 = _interopRequireDefault(_find);

  var _sortBy = __webpack_require__(492);

  var _sortBy2 = _interopRequireDefault(_sortBy);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var Manager = function () {
    function Manager() {
      _classCallCheck(this, Manager);

      this.refs = {};
    }

    _createClass(Manager, [{
      key: 'add',
      value: function add(collection, ref) {
        if (!this.refs[collection]) {
          this.refs[collection] = [];
        }

        this.refs[collection].push(ref);
      }
    }, {
      key: 'remove',
      value: function remove(collection, ref) {
        var index = this.getIndex(collection, ref);

        if (index !== -1) {
          this.refs[collection].splice(index, 1);
        }
      }
    }, {
      key: 'isActive',
      value: function isActive() {
        return this.active;
      }
    }, {
      key: 'getActive',
      value: function getActive() {
        var _this = this;

        return (0, _find2["default"])(this.refs[this.active.collection], // eslint-disable-next-line eqeqeq
        function (_ref) {
          var node = _ref.node;
          return node.sortableInfo.index == _this.active.index;
        });
      }
    }, {
      key: 'getIndex',
      value: function getIndex(collection, ref) {
        return this.refs[collection].indexOf(ref);
      }
    }, {
      key: 'getOrderedRefs',
      value: function getOrderedRefs() {
        var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;
        return (0, _sortBy2["default"])(this.refs[collection], function (_ref2) {
          var node = _ref2.node;
          return node.sortableInfo.index;
        });
      }
    }]);

    return Manager;
  }();

  exports["default"] = Manager;
  /***/
},
/* 410 */

/***/
function (module, exports, __webpack_require__) {
  var createFind = __webpack_require__(411),
      findIndex = __webpack_require__(487);
  /**
   * Iterates over elements of `collection`, returning the first element
   * `predicate` returns truthy for. The predicate is invoked with three
   * arguments: (value, index|key, collection).
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} [predicate=_.identity] The function invoked per iteration.
   * @param {number} [fromIndex=0] The index to search from.
   * @returns {*} Returns the matched element, else `undefined`.
   * @example
   *
   * var users = [
   *   { 'user': 'barney',  'age': 36, 'active': true },
   *   { 'user': 'fred',    'age': 40, 'active': false },
   *   { 'user': 'pebbles', 'age': 1,  'active': true }
   * ];
   *
   * _.find(users, function(o) { return o.age < 40; });
   * // => object for 'barney'
   *
   * // The `_.matches` iteratee shorthand.
   * _.find(users, { 'age': 1, 'active': true });
   * // => object for 'pebbles'
   *
   * // The `_.matchesProperty` iteratee shorthand.
   * _.find(users, ['active', false]);
   * // => object for 'fred'
   *
   * // The `_.property` iteratee shorthand.
   * _.find(users, 'active');
   * // => object for 'barney'
   */


  var find = createFind(findIndex);
  module.exports = find;
  /***/
},
/* 411 */

/***/
function (module, exports, __webpack_require__) {
  var baseIteratee = __webpack_require__(102),
      isArrayLike = __webpack_require__(51),
      keys = __webpack_require__(71);
  /**
   * Creates a `_.find` or `_.findLast` function.
   *
   * @private
   * @param {Function} findIndexFunc The function to find the collection index.
   * @returns {Function} Returns the new find function.
   */


  function createFind(findIndexFunc) {
    return function (collection, predicate, fromIndex) {
      var iterable = Object(collection);

      if (!isArrayLike(collection)) {
        var iteratee = baseIteratee(predicate, 3);
        collection = keys(collection);

        predicate = function predicate(key) {
          return iteratee(iterable[key], key, iterable);
        };
      }

      var index = findIndexFunc(collection, predicate, fromIndex);
      return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
  }

  module.exports = createFind;
  /***/
},
/* 412 */

/***/
function (module, exports, __webpack_require__) {
  var baseIsMatch = __webpack_require__(413),
      getMatchData = __webpack_require__(473),
      matchesStrictComparable = __webpack_require__(187);
  /**
   * The base implementation of `_.matches` which doesn't clone `source`.
   *
   * @private
   * @param {Object} source The object of property values to match.
   * @returns {Function} Returns the new spec function.
   */


  function baseMatches(source) {
    var matchData = getMatchData(source);

    if (matchData.length == 1 && matchData[0][2]) {
      return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    }

    return function (object) {
      return object === source || baseIsMatch(object, source, matchData);
    };
  }

  module.exports = baseMatches;
  /***/
},
/* 413 */

/***/
function (module, exports, __webpack_require__) {
  var Stack = __webpack_require__(176),
      baseIsEqual = __webpack_require__(180);
  /** Used to compose bitmasks for value comparisons. */


  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;
  /**
   * The base implementation of `_.isMatch` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to inspect.
   * @param {Object} source The object of property values to match.
   * @param {Array} matchData The property names, values, and compare flags to match.
   * @param {Function} [customizer] The function to customize comparisons.
   * @returns {boolean} Returns `true` if `object` is a match, else `false`.
   */

  function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length,
        length = index,
        noCustomizer = !customizer;

    if (object == null) {
      return !length;
    }

    object = Object(object);

    while (index--) {
      var data = matchData[index];

      if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
        return false;
      }
    }

    while (++index < length) {
      data = matchData[index];
      var key = data[0],
          objValue = object[key],
          srcValue = data[1];

      if (noCustomizer && data[2]) {
        if (objValue === undefined && !(key in object)) {
          return false;
        }
      } else {
        var stack = new Stack();

        if (customizer) {
          var result = customizer(objValue, srcValue, key, object, source, stack);
        }

        if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
          return false;
        }
      }
    }

    return true;
  }

  module.exports = baseIsMatch;
  /***/
},
/* 414 */

/***/
function (module, exports) {
  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */
  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }

  module.exports = listCacheClear;
  /***/
},
/* 415 */

/***/
function (module, exports, __webpack_require__) {
  var assocIndexOf = __webpack_require__(68);
  /** Used for built-in method references. */


  var arrayProto = Array.prototype;
  /** Built-in value references. */

  var splice = arrayProto.splice;
  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */

  function listCacheDelete(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }

    var lastIndex = data.length - 1;

    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }

    --this.size;
    return true;
  }

  module.exports = listCacheDelete;
  /***/
},
/* 416 */

/***/
function (module, exports, __webpack_require__) {
  var assocIndexOf = __webpack_require__(68);
  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function listCacheGet(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
  }

  module.exports = listCacheGet;
  /***/
},
/* 417 */

/***/
function (module, exports, __webpack_require__) {
  var assocIndexOf = __webpack_require__(68);
  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }

  module.exports = listCacheHas;
  /***/
},
/* 418 */

/***/
function (module, exports, __webpack_require__) {
  var assocIndexOf = __webpack_require__(68);
  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */


  function listCacheSet(key, value) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }

    return this;
  }

  module.exports = listCacheSet;
  /***/
},
/* 419 */

/***/
function (module, exports, __webpack_require__) {
  var ListCache = __webpack_require__(67);
  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */


  function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
  }

  module.exports = stackClear;
  /***/
},
/* 420 */

/***/
function (module, exports) {
  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function stackDelete(key) {
    var data = this.__data__,
        result = data['delete'](key);
    this.size = data.size;
    return result;
  }

  module.exports = stackDelete;
  /***/
},
/* 421 */

/***/
function (module, exports) {
  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function stackGet(key) {
    return this.__data__.get(key);
  }

  module.exports = stackGet;
  /***/
},
/* 422 */

/***/
function (module, exports) {
  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function stackHas(key) {
    return this.__data__.has(key);
  }

  module.exports = stackHas;
  /***/
},
/* 423 */

/***/
function (module, exports, __webpack_require__) {
  var ListCache = __webpack_require__(67),
      Map = __webpack_require__(104),
      MapCache = __webpack_require__(105);
  /** Used as the size to enable large array optimizations. */


  var LARGE_ARRAY_SIZE = 200;
  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */

  function stackSet(key, value) {
    var data = this.__data__;

    if (data instanceof ListCache) {
      var pairs = data.__data__;

      if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }

      data = this.__data__ = new MapCache(pairs);
    }

    data.set(key, value);
    this.size = data.size;
    return this;
  }

  module.exports = stackSet;
  /***/
},
/* 424 */

/***/
function (module, exports, __webpack_require__) {
  var isFunction = __webpack_require__(177),
      isMasked = __webpack_require__(427),
      isObject = __webpack_require__(49),
      toSource = __webpack_require__(179);
  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */


  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  /** Used to detect host constructors (Safari). */

  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  /** Used for built-in method references. */

  var funcProto = Function.prototype,
      objectProto = Object.prototype;
  /** Used to resolve the decompiled source of functions. */

  var funcToString = funcProto.toString;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /** Used to detect if a method is native. */

  var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */

  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }

    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }

  module.exports = baseIsNative;
  /***/
},
/* 425 */

/***/
function (module, exports, __webpack_require__) {
  var _Symbol12 = __webpack_require__(48);
  /** Used for built-in method references. */


  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */

  var nativeObjectToString = objectProto.toString;
  /** Built-in value references. */

  var symToStringTag = _Symbol12 ? _Symbol12.toStringTag : undefined;
  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */

  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

    try {
      value[symToStringTag] = undefined;
      var unmasked = true;
    } catch (e) {}

    var result = nativeObjectToString.call(value);

    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }

    return result;
  }

  module.exports = getRawTag;
  /***/
},
/* 426 */

/***/
function (module, exports) {
  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */

  var nativeObjectToString = objectProto.toString;
  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */

  function objectToString(value) {
    return nativeObjectToString.call(value);
  }

  module.exports = objectToString;
  /***/
},
/* 427 */

/***/
function (module, exports, __webpack_require__) {
  var coreJsData = __webpack_require__(428);
  /** Used to detect methods masquerading as native. */


  var maskSrcKey = function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
  }();
  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */


  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }

  module.exports = isMasked;
  /***/
},
/* 428 */

/***/
function (module, exports, __webpack_require__) {
  var root = __webpack_require__(20);
  /** Used to detect overreaching core-js shims. */


  var coreJsData = root['__core-js_shared__'];
  module.exports = coreJsData;
  /***/
},
/* 429 */

/***/
function (module, exports) {
  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  module.exports = getValue;
  /***/
},
/* 430 */

/***/
function (module, exports, __webpack_require__) {
  var Hash = __webpack_require__(431),
      ListCache = __webpack_require__(67),
      Map = __webpack_require__(104);
  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */


  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      'hash': new Hash(),
      'map': new (Map || ListCache)(),
      'string': new Hash()
    };
  }

  module.exports = mapCacheClear;
  /***/
},
/* 431 */

/***/
function (module, exports, __webpack_require__) {
  var hashClear = __webpack_require__(432),
      hashDelete = __webpack_require__(433),
      hashGet = __webpack_require__(434),
      hashHas = __webpack_require__(435),
      hashSet = __webpack_require__(436);
  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */


  function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  } // Add methods to `Hash`.


  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;
  module.exports = Hash;
  /***/
},
/* 432 */

/***/
function (module, exports, __webpack_require__) {
  var nativeCreate = __webpack_require__(69);
  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */


  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
  }

  module.exports = hashClear;
  /***/
},
/* 433 */

/***/
function (module, exports) {
  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }

  module.exports = hashDelete;
  /***/
},
/* 434 */

/***/
function (module, exports, __webpack_require__) {
  var nativeCreate = __webpack_require__(69);
  /** Used to stand-in for `undefined` hash values. */


  var HASH_UNDEFINED = '__lodash_hash_undefined__';
  /** Used for built-in method references. */

  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */

  function hashGet(key) {
    var data = this.__data__;

    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }

    return hasOwnProperty.call(data, key) ? data[key] : undefined;
  }

  module.exports = hashGet;
  /***/
},
/* 435 */

/***/
function (module, exports, __webpack_require__) {
  var nativeCreate = __webpack_require__(69);
  /** Used for built-in method references. */


  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */

  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
  }

  module.exports = hashHas;
  /***/
},
/* 436 */

/***/
function (module, exports, __webpack_require__) {
  var nativeCreate = __webpack_require__(69);
  /** Used to stand-in for `undefined` hash values. */


  var HASH_UNDEFINED = '__lodash_hash_undefined__';
  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */

  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
  }

  module.exports = hashSet;
  /***/
},
/* 437 */

/***/
function (module, exports, __webpack_require__) {
  var getMapData = __webpack_require__(70);
  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
  }

  module.exports = mapCacheDelete;
  /***/
},
/* 438 */

/***/
function (module, exports) {
  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */
  function isKeyable(value) {
    var type = _typeof4(value);

    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
  }

  module.exports = isKeyable;
  /***/
},
/* 439 */

/***/
function (module, exports, __webpack_require__) {
  var getMapData = __webpack_require__(70);
  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }

  module.exports = mapCacheGet;
  /***/
},
/* 440 */

/***/
function (module, exports, __webpack_require__) {
  var getMapData = __webpack_require__(70);
  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }

  module.exports = mapCacheHas;
  /***/
},
/* 441 */

/***/
function (module, exports, __webpack_require__) {
  var getMapData = __webpack_require__(70);
  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */


  function mapCacheSet(key, value) {
    var data = getMapData(this, key),
        size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  }

  module.exports = mapCacheSet;
  /***/
},
/* 442 */

/***/
function (module, exports, __webpack_require__) {
  var Stack = __webpack_require__(176),
      equalArrays = __webpack_require__(181),
      equalByTag = __webpack_require__(448),
      equalObjects = __webpack_require__(452),
      getTag = __webpack_require__(468),
      isArray = __webpack_require__(21),
      isBuffer = __webpack_require__(183),
      isTypedArray = __webpack_require__(184);
  /** Used to compose bitmasks for value comparisons. */


  var COMPARE_PARTIAL_FLAG = 1;
  /** `Object#toString` result references. */

  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      objectTag = '[object Object]';
  /** Used for built-in method references. */

  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * A specialized version of `baseIsEqual` for arrays and objects which performs
   * deep comparisons and tracks traversed objects enabling objects with circular
   * references to be compared.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} [stack] Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */

  function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object),
        othIsArr = isArray(other),
        objTag = objIsArr ? arrayTag : getTag(object),
        othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag,
        othIsObj = othTag == objectTag,
        isSameTag = objTag == othTag;

    if (isSameTag && isBuffer(object)) {
      if (!isBuffer(other)) {
        return false;
      }

      objIsArr = true;
      objIsObj = false;
    }

    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack());
      return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }

    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
      var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
          othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object,
            othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }

    if (!isSameTag) {
      return false;
    }

    stack || (stack = new Stack());
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
  }

  module.exports = baseIsEqualDeep;
  /***/
},
/* 443 */

/***/
function (module, exports, __webpack_require__) {
  var MapCache = __webpack_require__(105),
      setCacheAdd = __webpack_require__(444),
      setCacheHas = __webpack_require__(445);
  /**
   *
   * Creates an array cache object to store unique values.
   *
   * @private
   * @constructor
   * @param {Array} [values] The values to cache.
   */


  function SetCache(values) {
    var index = -1,
        length = values == null ? 0 : values.length;
    this.__data__ = new MapCache();

    while (++index < length) {
      this.add(values[index]);
    }
  } // Add methods to `SetCache`.


  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
  SetCache.prototype.has = setCacheHas;
  module.exports = SetCache;
  /***/
},
/* 444 */

/***/
function (module, exports) {
  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';
  /**
   * Adds `value` to the array cache.
   *
   * @private
   * @name add
   * @memberOf SetCache
   * @alias push
   * @param {*} value The value to cache.
   * @returns {Object} Returns the cache instance.
   */

  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);

    return this;
  }

  module.exports = setCacheAdd;
  /***/
},
/* 445 */

/***/
function (module, exports) {
  /**
   * Checks if `value` is in the array cache.
   *
   * @private
   * @name has
   * @memberOf SetCache
   * @param {*} value The value to search for.
   * @returns {number} Returns `true` if `value` is found, else `false`.
   */
  function setCacheHas(value) {
    return this.__data__.has(value);
  }

  module.exports = setCacheHas;
  /***/
},
/* 446 */

/***/
function (module, exports) {
  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }

    return false;
  }

  module.exports = arraySome;
  /***/
},
/* 447 */

/***/
function (module, exports) {
  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  module.exports = cacheHas;
  /***/
},
/* 448 */

/***/
function (module, exports, __webpack_require__) {
  var _Symbol13 = __webpack_require__(48),
      Uint8Array = __webpack_require__(449),
      eq = __webpack_require__(103),
      equalArrays = __webpack_require__(181),
      mapToArray = __webpack_require__(450),
      setToArray = __webpack_require__(451);
  /** Used to compose bitmasks for value comparisons. */


  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;
  /** `Object#toString` result references. */

  var boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]';
  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]';
  /** Used to convert symbols to primitives and strings. */

  var symbolProto = _Symbol13 ? _Symbol13.prototype : undefined,
      symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
  /**
   * A specialized version of `baseIsEqualDeep` for comparing objects of
   * the same `toStringTag`.
   *
   * **Note:** This function only supports comparing values with tags of
   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {string} tag The `toStringTag` of the objects to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */

  function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }

        object = object.buffer;
        other = other.buffer;

      case arrayBufferTag:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
          return false;
        }

        return true;

      case boolTag:
      case dateTag:
      case numberTag:
        // Coerce booleans to `1` or `0` and dates to milliseconds.
        // Invalid dates are coerced to `NaN`.
        return eq(+object, +other);

      case errorTag:
        return object.name == other.name && object.message == other.message;

      case regexpTag:
      case stringTag:
        // Coerce regexes to strings and treat strings, primitives and objects,
        // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
        // for more details.
        return object == other + '';

      case mapTag:
        var convert = mapToArray;

      case setTag:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
        convert || (convert = setToArray);

        if (object.size != other.size && !isPartial) {
          return false;
        } // Assume cyclic values are equal.


        var stacked = stack.get(object);

        if (stacked) {
          return stacked == other;
        }

        bitmask |= COMPARE_UNORDERED_FLAG; // Recursively compare objects (susceptible to call stack limits).

        stack.set(object, other);
        var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        stack['delete'](object);
        return result;

      case symbolTag:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }

    }

    return false;
  }

  module.exports = equalByTag;
  /***/
},
/* 449 */

/***/
function (module, exports, __webpack_require__) {
  var root = __webpack_require__(20);
  /** Built-in value references. */


  var Uint8Array = root.Uint8Array;
  module.exports = Uint8Array;
  /***/
},
/* 450 */

/***/
function (module, exports) {
  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);
    map.forEach(function (value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  module.exports = mapToArray;
  /***/
},
/* 451 */

/***/
function (module, exports) {
  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);
    set.forEach(function (value) {
      result[++index] = value;
    });
    return result;
  }

  module.exports = setToArray;
  /***/
},
/* 452 */

/***/
function (module, exports, __webpack_require__) {
  var getAllKeys = __webpack_require__(453);
  /** Used to compose bitmasks for value comparisons. */


  var COMPARE_PARTIAL_FLAG = 1;
  /** Used for built-in method references. */

  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * A specialized version of `baseIsEqualDeep` for objects with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */

  function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        objProps = getAllKeys(object),
        objLength = objProps.length,
        othProps = getAllKeys(other),
        othLength = othProps.length;

    if (objLength != othLength && !isPartial) {
      return false;
    }

    var index = objLength;

    while (index--) {
      var key = objProps[index];

      if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
        return false;
      }
    } // Assume cyclic values are equal.


    var stacked = stack.get(object);

    if (stacked && stack.get(other)) {
      return stacked == other;
    }

    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;

    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key],
          othValue = other[key];

      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      } // Recursively compare objects (susceptible to call stack limits).


      if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result = false;
        break;
      }

      skipCtor || (skipCtor = key == 'constructor');
    }

    if (result && !skipCtor) {
      var objCtor = object.constructor,
          othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

      if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
        result = false;
      }
    }

    stack['delete'](object);
    stack['delete'](other);
    return result;
  }

  module.exports = equalObjects;
  /***/
},
/* 453 */

/***/
function (module, exports, __webpack_require__) {
  var baseGetAllKeys = __webpack_require__(454),
      getSymbols = __webpack_require__(455),
      keys = __webpack_require__(71);
  /**
   * Creates an array of own enumerable property names and symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names and symbols.
   */


  function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
  }

  module.exports = getAllKeys;
  /***/
},
/* 454 */

/***/
function (module, exports, __webpack_require__) {
  var arrayPush = __webpack_require__(182),
      isArray = __webpack_require__(21);
  /**
   * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
   * `keysFunc` and `symbolsFunc` to get the enumerable property names and
   * symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @param {Function} symbolsFunc The function to get the symbols of `object`.
   * @returns {Array} Returns the array of property names and symbols.
   */


  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
  }

  module.exports = baseGetAllKeys;
  /***/
},
/* 455 */

/***/
function (module, exports, __webpack_require__) {
  var arrayFilter = __webpack_require__(456),
      stubArray = __webpack_require__(457);
  /** Used for built-in method references. */


  var objectProto = Object.prototype;
  /** Built-in value references. */

  var propertyIsEnumerable = objectProto.propertyIsEnumerable;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeGetSymbols = Object.getOwnPropertySymbols;
  /**
   * Creates an array of the own enumerable symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */

  var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
    if (object == null) {
      return [];
    }

    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function (symbol) {
      return propertyIsEnumerable.call(object, symbol);
    });
  };
  module.exports = getSymbols;
  /***/
},
/* 456 */

/***/
function (module, exports) {
  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];

      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }

    return result;
  }

  module.exports = arrayFilter;
  /***/
},
/* 457 */

/***/
function (module, exports) {
  /**
   * This method returns a new empty array.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {Array} Returns the new empty array.
   * @example
   *
   * var arrays = _.times(2, _.stubArray);
   *
   * console.log(arrays);
   * // => [[], []]
   *
   * console.log(arrays[0] === arrays[1]);
   * // => false
   */
  function stubArray() {
    return [];
  }

  module.exports = stubArray;
  /***/
},
/* 458 */

/***/
function (module, exports, __webpack_require__) {
  var baseTimes = __webpack_require__(459),
      isArguments = __webpack_require__(106),
      isArray = __webpack_require__(21),
      isBuffer = __webpack_require__(183),
      isIndex = __webpack_require__(107),
      isTypedArray = __webpack_require__(184);
  /** Used for built-in method references. */


  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */

  function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value),
        isArg = !isArr && isArguments(value),
        isBuff = !isArr && !isArg && isBuffer(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;

    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
      key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
      isIndex(key, length)))) {
        result.push(key);
      }
    }

    return result;
  }

  module.exports = arrayLikeKeys;
  /***/
},
/* 459 */

/***/
function (module, exports) {
  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }

    return result;
  }

  module.exports = baseTimes;
  /***/
},
/* 460 */

/***/
function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(47),
      isObjectLike = __webpack_require__(50);
  /** `Object#toString` result references. */


  var argsTag = '[object Arguments]';
  /**
   * The base implementation of `_.isArguments`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   */

  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
  }

  module.exports = baseIsArguments;
  /***/
},
/* 461 */

/***/
function (module, exports) {
  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */
  function stubFalse() {
    return false;
  }

  module.exports = stubFalse;
  /***/
},
/* 462 */

/***/
function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(47),
      isLength = __webpack_require__(108),
      isObjectLike = __webpack_require__(50);
  /** `Object#toString` result references. */


  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';
  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';
  /** Used to identify `toStringTag` values of typed arrays. */

  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */

  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }

  module.exports = baseIsTypedArray;
  /***/
},
/* 463 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (module) {
    var freeGlobal = __webpack_require__(178);
    /** Detect free variable `exports`. */


    var freeExports = _typeof4(exports) == 'object' && exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */

    var freeModule = freeExports && _typeof4(module) == 'object' && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */

    var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */

    var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */

    var nodeUtil = function () {
      try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;

        if (types) {
          return types;
        } // Legacy `process.binding('util')` for Node.js < 10.


        return freeProcess && freeProcess.binding && freeProcess.binding('util');
      } catch (e) {}
    }();

    module.exports = nodeUtil;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(45)(module));
  /***/
},
/* 464 */

/***/
function (module, exports, __webpack_require__) {
  var isPrototype = __webpack_require__(465),
      nativeKeys = __webpack_require__(466);
  /** Used for built-in method references. */


  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */

  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }

    var result = [];

    for (var key in Object(object)) {
      if (hasOwnProperty.call(object, key) && key != 'constructor') {
        result.push(key);
      }
    }

    return result;
  }

  module.exports = baseKeys;
  /***/
},
/* 465 */

/***/
function (module, exports) {
  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */

  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
  }

  module.exports = isPrototype;
  /***/
},
/* 466 */

/***/
function (module, exports, __webpack_require__) {
  var overArg = __webpack_require__(467);
  /* Built-in method references for those with the same name as other `lodash` methods. */


  var nativeKeys = overArg(Object.keys, Object);
  module.exports = nativeKeys;
  /***/
},
/* 467 */

/***/
function (module, exports) {
  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }

  module.exports = overArg;
  /***/
},
/* 468 */

/***/
function (module, exports, __webpack_require__) {
  var DataView = __webpack_require__(469),
      Map = __webpack_require__(104),
      Promise = __webpack_require__(470),
      Set = __webpack_require__(471),
      WeakMap = __webpack_require__(472),
      baseGetTag = __webpack_require__(47),
      toSource = __webpack_require__(179);
  /** `Object#toString` result references. */


  var mapTag = '[object Map]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      setTag = '[object Set]',
      weakMapTag = '[object WeakMap]';
  var dataViewTag = '[object DataView]';
  /** Used to detect maps, sets, and weakmaps. */

  var dataViewCtorString = toSource(DataView),
      mapCtorString = toSource(Map),
      promiseCtorString = toSource(Promise),
      setCtorString = toSource(Set),
      weakMapCtorString = toSource(WeakMap);
  /**
   * Gets the `toStringTag` of `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */

  var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function getTag(value) {
      var result = baseGetTag(value),
          Ctor = result == objectTag ? value.constructor : undefined,
          ctorString = Ctor ? toSource(Ctor) : '';

      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;

          case mapCtorString:
            return mapTag;

          case promiseCtorString:
            return promiseTag;

          case setCtorString:
            return setTag;

          case weakMapCtorString:
            return weakMapTag;
        }
      }

      return result;
    };
  }

  module.exports = getTag;
  /***/
},
/* 469 */

/***/
function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(29),
      root = __webpack_require__(20);
  /* Built-in method references that are verified to be native. */


  var DataView = getNative(root, 'DataView');
  module.exports = DataView;
  /***/
},
/* 470 */

/***/
function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(29),
      root = __webpack_require__(20);
  /* Built-in method references that are verified to be native. */


  var Promise = getNative(root, 'Promise');
  module.exports = Promise;
  /***/
},
/* 471 */

/***/
function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(29),
      root = __webpack_require__(20);
  /* Built-in method references that are verified to be native. */


  var Set = getNative(root, 'Set');
  module.exports = Set;
  /***/
},
/* 472 */

/***/
function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(29),
      root = __webpack_require__(20);
  /* Built-in method references that are verified to be native. */


  var WeakMap = getNative(root, 'WeakMap');
  module.exports = WeakMap;
  /***/
},
/* 473 */

/***/
function (module, exports, __webpack_require__) {
  var isStrictComparable = __webpack_require__(186),
      keys = __webpack_require__(71);
  /**
   * Gets the property names, values, and compare flags of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the match data of `object`.
   */


  function getMatchData(object) {
    var result = keys(object),
        length = result.length;

    while (length--) {
      var key = result[length],
          value = object[key];
      result[length] = [key, value, isStrictComparable(value)];
    }

    return result;
  }

  module.exports = getMatchData;
  /***/
},
/* 474 */

/***/
function (module, exports, __webpack_require__) {
  var baseIsEqual = __webpack_require__(180),
      get = __webpack_require__(475),
      hasIn = __webpack_require__(481),
      isKey = __webpack_require__(109),
      isStrictComparable = __webpack_require__(186),
      matchesStrictComparable = __webpack_require__(187),
      toKey = __webpack_require__(72);
  /** Used to compose bitmasks for value comparisons. */


  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;
  /**
   * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
   *
   * @private
   * @param {string} path The path of the property to get.
   * @param {*} srcValue The value to match.
   * @returns {Function} Returns the new spec function.
   */

  function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) {
      return matchesStrictComparable(toKey(path), srcValue);
    }

    return function (object) {
      var objValue = get(object, path);
      return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
  }

  module.exports = baseMatchesProperty;
  /***/
},
/* 475 */

/***/
function (module, exports, __webpack_require__) {
  var baseGet = __webpack_require__(188);
  /**
   * Gets the value at `path` of `object`. If the resolved value is
   * `undefined`, the `defaultValue` is returned in its place.
   *
   * @static
   * @memberOf _
   * @since 3.7.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @param {*} [defaultValue] The value returned for `undefined` resolved values.
   * @returns {*} Returns the resolved value.
   * @example
   *
   * var object = { 'a': [{ 'b': { 'c': 3 } }] };
   *
   * _.get(object, 'a[0].b.c');
   * // => 3
   *
   * _.get(object, ['a', '0', 'b', 'c']);
   * // => 3
   *
   * _.get(object, 'a.b.c', 'default');
   * // => 'default'
   */


  function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
  }

  module.exports = get;
  /***/
},
/* 476 */

/***/
function (module, exports, __webpack_require__) {
  var memoizeCapped = __webpack_require__(477);
  /** Used to match property names within property paths. */


  var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
  /** Used to match backslashes in property paths. */

  var reEscapeChar = /\\(\\)?/g;
  /**
   * Converts `string` to a property path array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the property path array.
   */

  var stringToPath = memoizeCapped(function (string) {
    var result = [];

    if (string.charCodeAt(0) === 46
    /* . */
    ) {
        result.push('');
      }

    string.replace(rePropName, function (match, number, quote, subString) {
      result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
  });
  module.exports = stringToPath;
  /***/
},
/* 477 */

/***/
function (module, exports, __webpack_require__) {
  var memoize = __webpack_require__(478);
  /** Used as the maximum memoize cache size. */


  var MAX_MEMOIZE_SIZE = 500;
  /**
   * A specialized version of `_.memoize` which clears the memoized function's
   * cache when it exceeds `MAX_MEMOIZE_SIZE`.
   *
   * @private
   * @param {Function} func The function to have its output memoized.
   * @returns {Function} Returns the new memoized function.
   */

  function memoizeCapped(func) {
    var result = memoize(func, function (key) {
      if (cache.size === MAX_MEMOIZE_SIZE) {
        cache.clear();
      }

      return key;
    });
    var cache = result.cache;
    return result;
  }

  module.exports = memoizeCapped;
  /***/
},
/* 478 */

/***/
function (module, exports, __webpack_require__) {
  var MapCache = __webpack_require__(105);
  /** Error message constants. */


  var FUNC_ERROR_TEXT = 'Expected a function';
  /**
   * Creates a function that memoizes the result of `func`. If `resolver` is
   * provided, it determines the cache key for storing the result based on the
   * arguments provided to the memoized function. By default, the first argument
   * provided to the memoized function is used as the map cache key. The `func`
   * is invoked with the `this` binding of the memoized function.
   *
   * **Note:** The cache is exposed as the `cache` property on the memoized
   * function. Its creation may be customized by replacing the `_.memoize.Cache`
   * constructor with one whose instances implement the
   * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
   * method interface of `clear`, `delete`, `get`, `has`, and `set`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to have its output memoized.
   * @param {Function} [resolver] The function to resolve the cache key.
   * @returns {Function} Returns the new memoized function.
   * @example
   *
   * var object = { 'a': 1, 'b': 2 };
   * var other = { 'c': 3, 'd': 4 };
   *
   * var values = _.memoize(_.values);
   * values(object);
   * // => [1, 2]
   *
   * values(other);
   * // => [3, 4]
   *
   * object.a = 2;
   * values(object);
   * // => [1, 2]
   *
   * // Modify the result cache.
   * values.cache.set(object, ['a', 'b']);
   * values(object);
   * // => ['a', 'b']
   *
   * // Replace `_.memoize.Cache`.
   * _.memoize.Cache = WeakMap;
   */

  function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }

    var memoized = function memoized() {
      var args = arguments,
          key = resolver ? resolver.apply(this, args) : args[0],
          cache = memoized.cache;

      if (cache.has(key)) {
        return cache.get(key);
      }

      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result) || cache;
      return result;
    };

    memoized.cache = new (memoize.Cache || MapCache)();
    return memoized;
  } // Expose `MapCache`.


  memoize.Cache = MapCache;
  module.exports = memoize;
  /***/
},
/* 479 */

/***/
function (module, exports, __webpack_require__) {
  var baseToString = __webpack_require__(480);
  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */


  function toString(value) {
    return value == null ? '' : baseToString(value);
  }

  module.exports = toString;
  /***/
},
/* 480 */

/***/
function (module, exports, __webpack_require__) {
  var _Symbol14 = __webpack_require__(48),
      arrayMap = __webpack_require__(190),
      isArray = __webpack_require__(21),
      isSymbol = __webpack_require__(52);
  /** Used as references for various `Number` constants. */


  var INFINITY = 1 / 0;
  /** Used to convert symbols to primitives and strings. */

  var symbolProto = _Symbol14 ? _Symbol14.prototype : undefined,
      symbolToString = symbolProto ? symbolProto.toString : undefined;
  /**
   * The base implementation of `_.toString` which doesn't convert nullish
   * values to empty strings.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */

  function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
      return value;
    }

    if (isArray(value)) {
      // Recursively convert values (susceptible to call stack limits).
      return arrayMap(value, baseToString) + '';
    }

    if (isSymbol(value)) {
      return symbolToString ? symbolToString.call(value) : '';
    }

    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
  }

  module.exports = baseToString;
  /***/
},
/* 481 */

/***/
function (module, exports, __webpack_require__) {
  var baseHasIn = __webpack_require__(482),
      hasPath = __webpack_require__(483);
  /**
   * Checks if `path` is a direct or inherited property of `object`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   * @example
   *
   * var object = _.create({ 'a': _.create({ 'b': 2 }) });
   *
   * _.hasIn(object, 'a');
   * // => true
   *
   * _.hasIn(object, 'a.b');
   * // => true
   *
   * _.hasIn(object, ['a', 'b']);
   * // => true
   *
   * _.hasIn(object, 'b');
   * // => false
   */


  function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
  }

  module.exports = hasIn;
  /***/
},
/* 482 */

/***/
function (module, exports) {
  /**
   * The base implementation of `_.hasIn` without support for deep paths.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {Array|string} key The key to check.
   * @returns {boolean} Returns `true` if `key` exists, else `false`.
   */
  function baseHasIn(object, key) {
    return object != null && key in Object(object);
  }

  module.exports = baseHasIn;
  /***/
},
/* 483 */

/***/
function (module, exports, __webpack_require__) {
  var castPath = __webpack_require__(189),
      isArguments = __webpack_require__(106),
      isArray = __webpack_require__(21),
      isIndex = __webpack_require__(107),
      isLength = __webpack_require__(108),
      toKey = __webpack_require__(72);
  /**
   * Checks if `path` exists on `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @param {Function} hasFunc The function to check properties.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   */


  function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1,
        length = path.length,
        result = false;

    while (++index < length) {
      var key = toKey(path[index]);

      if (!(result = object != null && hasFunc(object, key))) {
        break;
      }

      object = object[key];
    }

    if (result || ++index != length) {
      return result;
    }

    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
  }

  module.exports = hasPath;
  /***/
},
/* 484 */

/***/
function (module, exports, __webpack_require__) {
  var baseProperty = __webpack_require__(485),
      basePropertyDeep = __webpack_require__(486),
      isKey = __webpack_require__(109),
      toKey = __webpack_require__(72);
  /**
   * Creates a function that returns the value at `path` of a given object.
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Util
   * @param {Array|string} path The path of the property to get.
   * @returns {Function} Returns the new accessor function.
   * @example
   *
   * var objects = [
   *   { 'a': { 'b': 2 } },
   *   { 'a': { 'b': 1 } }
   * ];
   *
   * _.map(objects, _.property('a.b'));
   * // => [2, 1]
   *
   * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
   * // => [1, 2]
   */


  function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
  }

  module.exports = property;
  /***/
},
/* 485 */

/***/
function (module, exports) {
  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function (object) {
      return object == null ? undefined : object[key];
    };
  }

  module.exports = baseProperty;
  /***/
},
/* 486 */

/***/
function (module, exports, __webpack_require__) {
  var baseGet = __webpack_require__(188);
  /**
   * A specialized version of `baseProperty` which supports deep paths.
   *
   * @private
   * @param {Array|string} path The path of the property to get.
   * @returns {Function} Returns the new accessor function.
   */


  function basePropertyDeep(path) {
    return function (object) {
      return baseGet(object, path);
    };
  }

  module.exports = basePropertyDeep;
  /***/
},
/* 487 */

/***/
function (module, exports, __webpack_require__) {
  var baseFindIndex = __webpack_require__(488),
      baseIteratee = __webpack_require__(102),
      toInteger = __webpack_require__(489);
  /* Built-in method references for those with the same name as other `lodash` methods. */


  var nativeMax = Math.max;
  /**
   * This method is like `_.find` except that it returns the index of the first
   * element `predicate` returns truthy for instead of the element itself.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Array
   * @param {Array} array The array to inspect.
   * @param {Function} [predicate=_.identity] The function invoked per iteration.
   * @param {number} [fromIndex=0] The index to search from.
   * @returns {number} Returns the index of the found element, else `-1`.
   * @example
   *
   * var users = [
   *   { 'user': 'barney',  'active': false },
   *   { 'user': 'fred',    'active': false },
   *   { 'user': 'pebbles', 'active': true }
   * ];
   *
   * _.findIndex(users, function(o) { return o.user == 'barney'; });
   * // => 0
   *
   * // The `_.matches` iteratee shorthand.
   * _.findIndex(users, { 'user': 'fred', 'active': false });
   * // => 1
   *
   * // The `_.matchesProperty` iteratee shorthand.
   * _.findIndex(users, ['active', false]);
   * // => 0
   *
   * // The `_.property` iteratee shorthand.
   * _.findIndex(users, 'active');
   * // => 2
   */

  function findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;

    if (!length) {
      return -1;
    }

    var index = fromIndex == null ? 0 : toInteger(fromIndex);

    if (index < 0) {
      index = nativeMax(length + index, 0);
    }

    return baseFindIndex(array, baseIteratee(predicate, 3), index);
  }

  module.exports = findIndex;
  /***/
},
/* 488 */

/***/
function (module, exports) {
  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while (fromRight ? index-- : ++index < length) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }

    return -1;
  }

  module.exports = baseFindIndex;
  /***/
},
/* 489 */

/***/
function (module, exports, __webpack_require__) {
  var toFinite = __webpack_require__(490);
  /**
   * Converts `value` to an integer.
   *
   * **Note:** This method is loosely based on
   * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {number} Returns the converted integer.
   * @example
   *
   * _.toInteger(3.2);
   * // => 3
   *
   * _.toInteger(Number.MIN_VALUE);
   * // => 0
   *
   * _.toInteger(Infinity);
   * // => 1.7976931348623157e+308
   *
   * _.toInteger('3.2');
   * // => 3
   */


  function toInteger(value) {
    var result = toFinite(value),
        remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
  }

  module.exports = toInteger;
  /***/
},
/* 490 */

/***/
function (module, exports, __webpack_require__) {
  var toNumber = __webpack_require__(491);
  /** Used as references for various `Number` constants. */


  var INFINITY = 1 / 0,
      MAX_INTEGER = 1.7976931348623157e+308;
  /**
   * Converts `value` to a finite number.
   *
   * @static
   * @memberOf _
   * @since 4.12.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {number} Returns the converted number.
   * @example
   *
   * _.toFinite(3.2);
   * // => 3.2
   *
   * _.toFinite(Number.MIN_VALUE);
   * // => 5e-324
   *
   * _.toFinite(Infinity);
   * // => 1.7976931348623157e+308
   *
   * _.toFinite('3.2');
   * // => 3.2
   */

  function toFinite(value) {
    if (!value) {
      return value === 0 ? value : 0;
    }

    value = toNumber(value);

    if (value === INFINITY || value === -INFINITY) {
      var sign = value < 0 ? -1 : 1;
      return sign * MAX_INTEGER;
    }

    return value === value ? value : 0;
  }

  module.exports = toFinite;
  /***/
},
/* 491 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(49),
      isSymbol = __webpack_require__(52);
  /** Used as references for various `Number` constants. */


  var NAN = 0 / 0;
  /** Used to match leading and trailing whitespace. */

  var reTrim = /^\s+|\s+$/g;
  /** Used to detect bad signed hexadecimal string values. */

  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
  /** Used to detect binary string values. */

  var reIsBinary = /^0b[01]+$/i;
  /** Used to detect octal string values. */

  var reIsOctal = /^0o[0-7]+$/i;
  /** Built-in method references without a dependency on `root`. */

  var freeParseInt = parseInt;
  /**
   * Converts `value` to a number.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to process.
   * @returns {number} Returns the number.
   * @example
   *
   * _.toNumber(3.2);
   * // => 3.2
   *
   * _.toNumber(Number.MIN_VALUE);
   * // => 5e-324
   *
   * _.toNumber(Infinity);
   * // => Infinity
   *
   * _.toNumber('3.2');
   * // => 3.2
   */

  function toNumber(value) {
    if (typeof value == 'number') {
      return value;
    }

    if (isSymbol(value)) {
      return NAN;
    }

    if (isObject(value)) {
      var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
      value = isObject(other) ? other + '' : other;
    }

    if (typeof value != 'string') {
      return value === 0 ? value : +value;
    }

    value = value.replace(reTrim, '');
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
  }

  module.exports = toNumber;
  /***/
},
/* 492 */

/***/
function (module, exports, __webpack_require__) {
  var baseFlatten = __webpack_require__(493),
      baseOrderBy = __webpack_require__(495),
      baseRest = __webpack_require__(505),
      isIterateeCall = __webpack_require__(513);
  /**
   * Creates an array of elements, sorted in ascending order by the results of
   * running each element in a collection thru each iteratee. This method
   * performs a stable sort, that is, it preserves the original sort order of
   * equal elements. The iteratees are invoked with one argument: (value).
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {...(Function|Function[])} [iteratees=[_.identity]]
   *  The iteratees to sort by.
   * @returns {Array} Returns the new sorted array.
   * @example
   *
   * var users = [
   *   { 'user': 'fred',   'age': 48 },
   *   { 'user': 'barney', 'age': 36 },
   *   { 'user': 'fred',   'age': 40 },
   *   { 'user': 'barney', 'age': 34 }
   * ];
   *
   * _.sortBy(users, [function(o) { return o.user; }]);
   * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
   *
   * _.sortBy(users, ['user', 'age']);
   * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
   */


  var sortBy = baseRest(function (collection, iteratees) {
    if (collection == null) {
      return [];
    }

    var length = iteratees.length;

    if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
      iteratees = [];
    } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
      iteratees = [iteratees[0]];
    }

    return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
  });
  module.exports = sortBy;
  /***/
},
/* 493 */

/***/
function (module, exports, __webpack_require__) {
  var arrayPush = __webpack_require__(182),
      isFlattenable = __webpack_require__(494);
  /**
   * The base implementation of `_.flatten` with support for restricting flattening.
   *
   * @private
   * @param {Array} array The array to flatten.
   * @param {number} depth The maximum recursion depth.
   * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
   * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
   * @param {Array} [result=[]] The initial result value.
   * @returns {Array} Returns the new flattened array.
   */


  function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1,
        length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);

    while (++index < length) {
      var value = array[index];

      if (depth > 0 && predicate(value)) {
        if (depth > 1) {
          // Recursively flatten arrays (susceptible to call stack limits).
          baseFlatten(value, depth - 1, predicate, isStrict, result);
        } else {
          arrayPush(result, value);
        }
      } else if (!isStrict) {
        result[result.length] = value;
      }
    }

    return result;
  }

  module.exports = baseFlatten;
  /***/
},
/* 494 */

/***/
function (module, exports, __webpack_require__) {
  var _Symbol15 = __webpack_require__(48),
      isArguments = __webpack_require__(106),
      isArray = __webpack_require__(21);
  /** Built-in value references. */


  var spreadableSymbol = _Symbol15 ? _Symbol15.isConcatSpreadable : undefined;
  /**
   * Checks if `value` is a flattenable `arguments` object or array.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
   */

  function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
  }

  module.exports = isFlattenable;
  /***/
},
/* 495 */

/***/
function (module, exports, __webpack_require__) {
  var arrayMap = __webpack_require__(190),
      baseIteratee = __webpack_require__(102),
      baseMap = __webpack_require__(496),
      baseSortBy = __webpack_require__(502),
      baseUnary = __webpack_require__(185),
      compareMultiple = __webpack_require__(503),
      identity = __webpack_require__(73);
  /**
   * The base implementation of `_.orderBy` without param guards.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
   * @param {string[]} orders The sort orders of `iteratees`.
   * @returns {Array} Returns the new sorted array.
   */


  function baseOrderBy(collection, iteratees, orders) {
    var index = -1;
    iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
    var result = baseMap(collection, function (value, key, collection) {
      var criteria = arrayMap(iteratees, function (iteratee) {
        return iteratee(value);
      });
      return {
        'criteria': criteria,
        'index': ++index,
        'value': value
      };
    });
    return baseSortBy(result, function (object, other) {
      return compareMultiple(object, other, orders);
    });
  }

  module.exports = baseOrderBy;
  /***/
},
/* 496 */

/***/
function (module, exports, __webpack_require__) {
  var baseEach = __webpack_require__(497),
      isArrayLike = __webpack_require__(51);
  /**
   * The base implementation of `_.map` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */


  function baseMap(collection, iteratee) {
    var index = -1,
        result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function (value, key, collection) {
      result[++index] = iteratee(value, key, collection);
    });
    return result;
  }

  module.exports = baseMap;
  /***/
},
/* 497 */

/***/
function (module, exports, __webpack_require__) {
  var baseForOwn = __webpack_require__(498),
      createBaseEach = __webpack_require__(501);
  /**
   * The base implementation of `_.forEach` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array|Object} Returns `collection`.
   */


  var baseEach = createBaseEach(baseForOwn);
  module.exports = baseEach;
  /***/
},
/* 498 */

/***/
function (module, exports, __webpack_require__) {
  var baseFor = __webpack_require__(499),
      keys = __webpack_require__(71);
  /**
   * The base implementation of `_.forOwn` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Object} Returns `object`.
   */


  function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
  }

  module.exports = baseForOwn;
  /***/
},
/* 499 */

/***/
function (module, exports, __webpack_require__) {
  var createBaseFor = __webpack_require__(500);
  /**
   * The base implementation of `baseForOwn` which iterates over `object`
   * properties returned by `keysFunc` and invokes `iteratee` for each property.
   * Iteratee functions may exit iteration early by explicitly returning `false`.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @returns {Object} Returns `object`.
   */


  var baseFor = createBaseFor();
  module.exports = baseFor;
  /***/
},
/* 500 */

/***/
function (module, exports) {
  /**
   * Creates a base function for methods like `_.forIn` and `_.forOwn`.
   *
   * @private
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */
  function createBaseFor(fromRight) {
    return function (object, iteratee, keysFunc) {
      var index = -1,
          iterable = Object(object),
          props = keysFunc(object),
          length = props.length;

      while (length--) {
        var key = props[fromRight ? length : ++index];

        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }

      return object;
    };
  }

  module.exports = createBaseFor;
  /***/
},
/* 501 */

/***/
function (module, exports, __webpack_require__) {
  var isArrayLike = __webpack_require__(51);
  /**
   * Creates a `baseEach` or `baseEachRight` function.
   *
   * @private
   * @param {Function} eachFunc The function to iterate over a collection.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */


  function createBaseEach(eachFunc, fromRight) {
    return function (collection, iteratee) {
      if (collection == null) {
        return collection;
      }

      if (!isArrayLike(collection)) {
        return eachFunc(collection, iteratee);
      }

      var length = collection.length,
          index = fromRight ? length : -1,
          iterable = Object(collection);

      while (fromRight ? index-- : ++index < length) {
        if (iteratee(iterable[index], index, iterable) === false) {
          break;
        }
      }

      return collection;
    };
  }

  module.exports = createBaseEach;
  /***/
},
/* 502 */

/***/
function (module, exports) {
  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);

    while (length--) {
      array[length] = array[length].value;
    }

    return array;
  }

  module.exports = baseSortBy;
  /***/
},
/* 503 */

/***/
function (module, exports, __webpack_require__) {
  var compareAscending = __webpack_require__(504);
  /**
   * Used by `_.orderBy` to compare multiple properties of a value to another
   * and stable sort them.
   *
   * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
   * specify an order of "desc" for descending or "asc" for ascending sort order
   * of corresponding values.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {boolean[]|string[]} orders The order to sort by for each property.
   * @returns {number} Returns the sort order indicator for `object`.
   */


  function compareMultiple(object, other, orders) {
    var index = -1,
        objCriteria = object.criteria,
        othCriteria = other.criteria,
        length = objCriteria.length,
        ordersLength = orders.length;

    while (++index < length) {
      var result = compareAscending(objCriteria[index], othCriteria[index]);

      if (result) {
        if (index >= ordersLength) {
          return result;
        }

        var order = orders[index];
        return result * (order == 'desc' ? -1 : 1);
      }
    } // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.


    return object.index - other.index;
  }

  module.exports = compareMultiple;
  /***/
},
/* 504 */

/***/
function (module, exports, __webpack_require__) {
  var isSymbol = __webpack_require__(52);
  /**
   * Compares values to sort them in ascending order.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */


  function compareAscending(value, other) {
    if (value !== other) {
      var valIsDefined = value !== undefined,
          valIsNull = value === null,
          valIsReflexive = value === value,
          valIsSymbol = isSymbol(value);
      var othIsDefined = other !== undefined,
          othIsNull = other === null,
          othIsReflexive = other === other,
          othIsSymbol = isSymbol(other);

      if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
        return 1;
      }

      if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
        return -1;
      }
    }

    return 0;
  }

  module.exports = compareAscending;
  /***/
},
/* 505 */

/***/
function (module, exports, __webpack_require__) {
  var identity = __webpack_require__(73),
      overRest = __webpack_require__(506),
      setToString = __webpack_require__(508);
  /**
   * The base implementation of `_.rest` which doesn't validate or coerce arguments.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @returns {Function} Returns the new function.
   */


  function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
  }

  module.exports = baseRest;
  /***/
},
/* 506 */

/***/
function (module, exports, __webpack_require__) {
  var apply = __webpack_require__(507);
  /* Built-in method references for those with the same name as other `lodash` methods. */


  var nativeMax = Math.max;
  /**
   * A specialized version of `baseRest` which transforms the rest array.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @param {Function} transform The rest array transform.
   * @returns {Function} Returns the new function.
   */

  function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function () {
      var args = arguments,
          index = -1,
          length = nativeMax(args.length - start, 0),
          array = Array(length);

      while (++index < length) {
        array[index] = args[start + index];
      }

      index = -1;
      var otherArgs = Array(start + 1);

      while (++index < start) {
        otherArgs[index] = args[index];
      }

      otherArgs[start] = transform(array);
      return apply(func, this, otherArgs);
    };
  }

  module.exports = overRest;
  /***/
},
/* 507 */

/***/
function (module, exports) {
  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);

      case 1:
        return func.call(thisArg, args[0]);

      case 2:
        return func.call(thisArg, args[0], args[1]);

      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }

    return func.apply(thisArg, args);
  }

  module.exports = apply;
  /***/
},
/* 508 */

/***/
function (module, exports, __webpack_require__) {
  var baseSetToString = __webpack_require__(509),
      shortOut = __webpack_require__(512);
  /**
   * Sets the `toString` method of `func` to return `string`.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */


  var setToString = shortOut(baseSetToString);
  module.exports = setToString;
  /***/
},
/* 509 */

/***/
function (module, exports, __webpack_require__) {
  var constant = __webpack_require__(510),
      defineProperty = __webpack_require__(511),
      identity = __webpack_require__(73);
  /**
   * The base implementation of `setToString` without support for hot loop shorting.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */


  var baseSetToString = !defineProperty ? identity : function (func, string) {
    return defineProperty(func, 'toString', {
      'configurable': true,
      'enumerable': false,
      'value': constant(string),
      'writable': true
    });
  };
  module.exports = baseSetToString;
  /***/
},
/* 510 */

/***/
function (module, exports) {
  /**
   * Creates a function that returns `value`.
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Util
   * @param {*} value The value to return from the new function.
   * @returns {Function} Returns the new constant function.
   * @example
   *
   * var objects = _.times(2, _.constant({ 'a': 1 }));
   *
   * console.log(objects);
   * // => [{ 'a': 1 }, { 'a': 1 }]
   *
   * console.log(objects[0] === objects[1]);
   * // => true
   */
  function constant(value) {
    return function () {
      return value;
    };
  }

  module.exports = constant;
  /***/
},
/* 511 */

/***/
function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(29);

  var defineProperty = function () {
    try {
      var func = getNative(Object, 'defineProperty');
      func({}, '', {});
      return func;
    } catch (e) {}
  }();

  module.exports = defineProperty;
  /***/
},
/* 512 */

/***/
function (module, exports) {
  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeNow = Date.now;
  /**
   * Creates a function that'll short out and invoke `identity` instead
   * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
   * milliseconds.
   *
   * @private
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new shortable function.
   */

  function shortOut(func) {
    var count = 0,
        lastCalled = 0;
    return function () {
      var stamp = nativeNow(),
          remaining = HOT_SPAN - (stamp - lastCalled);
      lastCalled = stamp;

      if (remaining > 0) {
        if (++count >= HOT_COUNT) {
          return arguments[0];
        }
      } else {
        count = 0;
      }

      return func.apply(undefined, arguments);
    };
  }

  module.exports = shortOut;
  /***/
},
/* 513 */

/***/
function (module, exports, __webpack_require__) {
  var eq = __webpack_require__(103),
      isArrayLike = __webpack_require__(51),
      isIndex = __webpack_require__(107),
      isObject = __webpack_require__(49);
  /**
   * Checks if the given arguments are from an iteratee call.
   *
   * @private
   * @param {*} value The potential iteratee value argument.
   * @param {*} index The potential iteratee index or key argument.
   * @param {*} object The potential iteratee object argument.
   * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
   *  else `false`.
   */


  function isIterateeCall(value, index, object) {
    if (!isObject(object)) {
      return false;
    }

    var type = _typeof4(index);

    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
      return eq(object[index], value);
    }

    return false;
  }

  module.exports = isIterateeCall;
  /***/
},
/* 514 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  exports["default"] = sortableElement;

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactDom = __webpack_require__(35);

  var _invariant = __webpack_require__(64);

  var _invariant2 = _interopRequireDefault(_invariant);

  var _utils = __webpack_require__(66);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  } // Export Higher Order Sortable Element Component


  function sortableElement(WrappedComponent) {
    var _class, _temp;

    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      withRef: false
    };
    return _temp = _class = function (_Component) {
      _inherits(_class, _Component);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
      }

      _createClass(_class, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _props = this.props,
              collection = _props.collection,
              disabled = _props.disabled,
              index = _props.index;

          if (!disabled) {
            this.setDraggable(collection, index);
          }
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          if (this.props.index !== nextProps.index && this.node) {
            this.node.sortableInfo.index = nextProps.index;
          }

          if (this.props.disabled !== nextProps.disabled) {
            var collection = nextProps.collection,
                disabled = nextProps.disabled,
                index = nextProps.index;

            if (disabled) {
              this.removeDraggable(collection);
            } else {
              this.setDraggable(collection, index);
            }
          } else if (this.props.collection !== nextProps.collection) {
            this.removeDraggable(this.props.collection);
            this.setDraggable(nextProps.collection, nextProps.index);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          var _props2 = this.props,
              collection = _props2.collection,
              disabled = _props2.disabled;
          if (!disabled) this.removeDraggable(collection);
        }
      }, {
        key: 'setDraggable',
        value: function setDraggable(collection, index) {
          var node = this.node = (0, _reactDom.findDOMNode)(this);
          node.sortableInfo = {
            index: index,
            collection: collection,
            manager: this.context.manager
          };
          this.ref = {
            node: node
          };
          this.context.manager.add(collection, this.ref);
        }
      }, {
        key: 'removeDraggable',
        value: function removeDraggable(collection) {
          this.context.manager.remove(collection, this.ref);
        }
      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          (0, _invariant2["default"])(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
          return this.refs.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var ref = config.withRef ? 'wrappedInstance' : null;
          return _react2["default"].createElement(WrappedComponent, _extends({
            ref: ref
          }, (0, _utils.omit)(this.props, 'collection', 'disabled', 'index')));
        }
      }]);

      return _class;
    }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableElement', WrappedComponent), _class.contextTypes = {
      manager: _propTypes2["default"].object.isRequired
    }, _class.propTypes = {
      index: _propTypes2["default"].number.isRequired,
      collection: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
      disabled: _propTypes2["default"].bool
    }, _class.defaultProps = {
      collection: 0
    }, _temp;
  }
  /***/

},
/* 515 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  exports["default"] = sortableHandle;

  var _react = __webpack_require__(0);

  var _react2 = _interopRequireDefault(_react);

  var _reactDom = __webpack_require__(35);

  var _invariant = __webpack_require__(64);

  var _invariant2 = _interopRequireDefault(_invariant);

  var _utils = __webpack_require__(66);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  } // Export Higher Order Sortable Element Component


  function sortableHandle(WrappedComponent) {
    var _class, _temp;

    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      withRef: false
    };
    return _temp = _class = function (_Component) {
      _inherits(_class, _Component);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
      }

      _createClass(_class, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var node = (0, _reactDom.findDOMNode)(this);
          node.sortableHandle = true;
        }
      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          (0, _invariant2["default"])(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
          return this.refs.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var ref = config.withRef ? 'wrappedInstance' : null;
          return _react2["default"].createElement(WrappedComponent, _extends({
            ref: ref
          }, this.props));
        }
      }]);

      return _class;
    }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableHandle', WrappedComponent), _temp;
  }
  /***/

},
/* 516 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_recompose__ = __webpack_require__(18);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_react_sortable_hoc__ = __webpack_require__(65);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_react_sortable_hoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_sortable_hoc__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__Toolbar_Toolbar__ = __webpack_require__(90);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10__ListItem_ListItem__ = __webpack_require__(517);

  var _class,
      _temp2,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/List/List.js'; // Recompose
  // Drag and drop


  var List = (_temp2 = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(List, _React$Component);

    function List() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, List);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = List.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(List)).call.apply(_ref, [this].concat(args))), _this), _this.onAddItem = function (payload) {
        var items = _this.props.items;

        _this.props.addItem(payload, items.length);
      }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }
    /**
     * UI EVENTS
     * - onAddItem
    */


    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(List, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            items = _props.items,
            readOnly = _props.readOnly;
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('ul', {
          className: 'cw-wysiwyg-list',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 38
          }
        }, items.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ListItem_ListItem__["a"
          /* default */
          ], {
            key: 'item-' + item.id,
            index: index,
            position: index,
            item: item,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 40
            }
          });
        }), !readOnly && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Toolbar_Toolbar__["a"
        /* default */
        ], {
          onAdd: this.onAddItem,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 49
          }
        }));
      }
    }]);

    return List;
  }(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component), _class.propTypes = {
    items: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
    readOnly: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    addItem: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  }, _class.defaultProps = {
    items: [],
    readOnly: false
  }, _temp2);
  List.displayName = 'List';
  /* harmony default export */

  __webpack_exports__["a"] = Object(__WEBPACK_IMPORTED_MODULE_8_react_sortable_hoc__["SortableContainer"])(Object(__WEBPACK_IMPORTED_MODULE_7_recompose__["a"
  /* getContext */
  ])({
    items: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
    readOnly: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    addItem: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  })(List));
  /***/
},
/* 517 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(13);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_recompose__ = __webpack_require__(18);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10_react_transition_group__ = __webpack_require__(140);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_transition_group__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11_react_sortable_hoc__ = __webpack_require__(65);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11_react_sortable_hoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_sortable_hoc__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_12__Toolbar_Toolbar__ = __webpack_require__(90);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_13__ListItemDrag__ = __webpack_require__(518);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_14__ListItemActions__ = __webpack_require__(519);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_15__ListItemContent__ = __webpack_require__(520);

  var _class,
      _temp2,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/ListItem/ListItem.js'; // Recompose
  // Motion
  // Drag and drop
  // Components


  var ListItem = (_temp2 = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ListItem, _React$Component);

    function ListItem() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ListItem);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ListItem.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ListItem)).call.apply(_ref, [this].concat(args))), _this), _this.onAddItem = function (payload) {
        _this.props.addItem(payload);
      }, _this.getClasses = function () {
        var _this$props = _this.props,
            item = _this$props.item,
            cursor = _this$props.cursor,
            position = _this$props.position,
            readOnly = _this$props.readOnly;
        var isCurrent = position === cursor && !readOnly;
        return __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
          '-isDragging': false,
          '-isHover': isCurrent,
          '-isReadOnly': readOnly
        }, '-' + item.type, !!item.type));
      }, _this.getContentClasses = function () {
        var _this$props2 = _this.props,
            item = _this$props2.item,
            cursor = _this$props2.cursor,
            position = _this$props2.position,
            readOnly = _this$props2.readOnly;
        var isCurrent = position === cursor && !readOnly;
        return __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
          '-isDragging': false,
          '-isHover': isCurrent,
          '-isReadOnly': readOnly
        }, '-' + item.type, !!item.type));
      }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }
    /**
     * UI EVENTS
     * - onAddItem
    */

    /**
     * HELPERS
     * - getClasses
     * - getContentClasses
    */


    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ListItem, [{
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            item = _props.item,
            cursor = _props.cursor,
            position = _props.position,
            readOnly = _props.readOnly;
        var isCurrent = position === cursor && !readOnly;
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', {
          className: 'cw-wysiwyg-list-item ' + this.getClasses(),
          onMouseOver: function onMouseOver() {
            _this2.props.setCursor(position);
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 82
          }
        }, isCurrent && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Toolbar_Toolbar__["a"
        /* default */
        ], {
          onAdd: this.onAddItem,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 90
          }
        }), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', {
          className: 'list-item-container',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 93
          }
        }, !readOnly && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_transition_group__["Transition"], {
          'in': isCurrent,
          timeout: 150,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 98
          }
        }, function (status) {
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ListItemDrag__["a"
          /* default */
          ], {
            item: item,
            className: '-' + status,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 100
            }
          });
        }), !readOnly && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_transition_group__["Transition"], {
          'in': isCurrent,
          timeout: 150,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 110
          }
        }, function (status) {
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ListItemActions__["a"
          /* default */
          ], {
            item: item,
            className: '-' + status,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 112
            }
          });
        }), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ListItemContent__["a"
        /* default */
        ], {
          item: item,
          className: this.getContentClasses(),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 121
          }
        })));
      }
    }]);

    return ListItem;
  }(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component), _class.propTypes = {
    item: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
    cursor: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
    position: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
    readOnly: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    addItem: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    setCursor: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  }, _class.defaultProps = {
    item: {},
    cursor: 0,
    position: 0,
    readOnly: false,
    addItem: null,
    setCursor: null
  }, _temp2);
  ListItem.displayName = 'ListItem';
  /* harmony default export */

  __webpack_exports__["a"] = Object(__WEBPACK_IMPORTED_MODULE_11_react_sortable_hoc__["SortableElement"])(Object(__WEBPACK_IMPORTED_MODULE_9_recompose__["a"
  /* getContext */
  ])({
    cursor: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
    readOnly: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    addItem: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    setCursor: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  })(ListItem));
  /***/
},
/* 518 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(13);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_react_sortable_hoc__ = __webpack_require__(65);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_react_sortable_hoc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_sortable_hoc__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10__UI_Icon_Icon__ = __webpack_require__(34);

  var _class,
      _temp,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/ListItem/ListItemDrag.js'; // Drag and drop
  // Components


  var ListItemDrag = (_temp = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ListItemDrag, _React$Component);

    function ListItemDrag() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ListItemDrag);

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ListItemDrag.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ListItemDrag)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ListItemDrag, [{
      key: 'render',
      value: function render() {
        var className = this.props.className;

        var classNames = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, className, !!className));

        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', {
          className: 'cw-wysiwyg-item-drag ' + classNames,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 28
          }
        }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ul', {
          className: 'item-drag',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 29
          }
        }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 30
          }
        }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('button', {
          type: 'button',
          className: 'cw-button -primary -round -small',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 31
          }
        }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__UI_Icon_Icon__["a"
        /* default */
        ], {
          name: 'icon-drag_handle',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 35
          }
        })))));
      }
    }]);

    return ListItemDrag;
  }(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component), _class.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
  }, _class.defaultProps = {
    className: ''
  }, _temp);
  ListItemDrag.displayName = 'ListItemDrag';
  /* harmony default export */

  __webpack_exports__["a"] = Object(__WEBPACK_IMPORTED_MODULE_9_react_sortable_hoc__["SortableHandle"])(ListItemDrag);
  /***/
},
/* 519 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(13);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_recompose__ = __webpack_require__(18);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10__UI_Icon_Icon__ = __webpack_require__(34);

  var _class,
      _temp,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/ListItem/ListItemActions.js'; // Recompose
  // Components


  var ListItemActions = (_temp = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ListItemActions, _React$Component);

    function ListItemActions() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ListItemActions);

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ListItemActions.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ListItemActions)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ListItemActions, [{
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            item = _props.item,
            className = _props.className;

        var classNames = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, className, !!className));

        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', {
          className: 'cw-wysiwyg-item-actions ' + classNames,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 32
          }
        }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ul', {
          className: 'item-actions',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 33
          }
        }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 34
          }
        }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('button', {
          type: 'button',
          className: 'cw-button -close -round -small',
          onClick: function onClick() {
            _this2.props.removeItem(item);
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 35
          }
        }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__UI_Icon_Icon__["a"
        /* default */
        ], {
          name: 'icon-delete',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 40
          }
        })))));
      }
    }]);

    return ListItemActions;
  }(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component), _class.propTypes = {
    item: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
    className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    removeItem: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  }, _class.defaultProps = {
    item: {},
    prov: {},
    className: '',
    removeItem: null
  }, _temp);
  ListItemActions.displayName = 'ListItemActions';
  /* harmony default export */

  __webpack_exports__["a"] = Object(__WEBPACK_IMPORTED_MODULE_9_recompose__["a"
  /* getContext */
  ])({
    removeItem: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  })(ListItemActions);
  /***/
},
/* 520 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(24);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(13);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10_recompose__ = __webpack_require__(18);

  var _class,
      _temp2,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/ListItem/ListItemContent.js'; // Recompose


  var ListItemContent = (_temp2 = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ListItemContent, _React$Component);

    function ListItemContent() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ListItemContent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ListItemContent.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ListItemContent)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (payload) {
        var item = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.props.item, payload);

        _this.props.updateItem(item);
      }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ListItemContent, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            blocks = _props.blocks,
            item = _props.item,
            readOnly = _props.readOnly,
            className = _props.className;

        var classNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, className, !!className));

        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', {
          className: 'cw-wysiwyg-item-content ' + classNames,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 38
          }
        }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(blocks[item.type].Component, {
          item: item,
          readOnly: readOnly,
          block: blocks[item.type],
          onChange: this.onChange
        }));
      }
    }]);

    return ListItemContent;
  }(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _class.propTypes = {
    item: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    blocks: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    readOnly: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    updateItem: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
  }, _class.defaultProps = {
    item: {},
    blocks: {},
    readOnly: false,
    className: ''
  }, _temp2);
  ListItemContent.displayName = 'ListItemContent';
  /* harmony default export */

  __webpack_exports__["a"] = Object(__WEBPACK_IMPORTED_MODULE_10_recompose__["a"
  /* getContext */
  ])({
    blocks: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    readOnly: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    updateItem: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
  })(ListItemContent);
  /***/
},
/* 521 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (immutable) */

  __webpack_exports__["a"] = Icons;
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

  var _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/UI/Icons/Icons.js';

  function Icons() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg', {
      style: {
        position: 'absolute',
        width: 0,
        height: 0,
        overflow: 'hidden'
      },
      version: '1.1',
      xmlns: 'http://www.w3.org/2000/svg',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 5
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs', {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 6
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('symbol', {
      id: 'icon-grid',
      viewBox: '0 0 32 32',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 7
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title', {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 8
      }
    }, 'grid'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
      d: 'M24.547 11.752v-4.298h-4.298v4.298h4.298zM24.547 18.149v-4.298h-4.298v4.298h4.298zM24.547 24.547v-4.298h-4.298v4.298h4.298zM18.149 11.752v-4.298h-4.298v4.298h4.298zM18.149 18.149v-4.298h-4.298v4.298h4.298zM18.149 24.547v-4.298h-4.298v4.298h4.298zM11.752 11.752v-4.298h-4.298v4.298h4.298zM11.752 18.149v-4.298h-4.298v4.298h4.298zM11.752 24.547v-4.298h-4.298v4.298h4.298zM24.547 5.354c1.15 0 2.099 0.95 2.099 2.099v17.093c0 1.15-0.95 2.099-2.099 2.099h-17.093c-1.15 0-2.099-0.95-2.099-2.099v-17.093c0-1.15 0.95-2.099 2.099-2.099h17.093z',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('symbol', {
      id: 'icon-text',
      viewBox: '0 0 32 32',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 11
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title', {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 12
      }
    }, 'text'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
      d: 'M24 5.333h-16c-1.1 0-2 0.9-2 2v17.333c0 1.1 0.9 2 2 2h16c1.1 0 2-0.9 2-2v-17.333c0-1.1-0.9-2-2-2zM23.333 24h-14.667v-16h14.667v16zM11.333 14.667h9.333v1.333h-9.333zM11.333 17.333h9.333v1.333h-9.333zM11.333 20h9.333v1.333h-9.333zM11.333 12h9.333v1.333h-9.333z',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 13
      }
    })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('symbol', {
      id: 'icon-add',
      viewBox: '0 0 32 32',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 15
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title', {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 16
      }
    }, 'add'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
      d: 'M26.646 17.5h-9.145v9.145h-3.001v-9.145h-9.145v-3.001h9.145v-9.145h3.001v9.145h9.145v3.001z',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 17
      }
    })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('symbol', {
      id: 'icon-close',
      viewBox: '0 0 32 32',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 19
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title', {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 20
      }
    }, 'close'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
      d: 'M26.646 7.498l-8.502 8.502 8.502 8.502-2.143 2.143-8.502-8.502-8.502 8.502-2.143-2.143 8.502-8.502-8.502-8.502 2.143-2.143 8.502 8.502 8.502-8.502z',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 21
      }
    })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('symbol', {
      id: 'icon-edit',
      viewBox: '0 0 32 32',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 23
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title', {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 24
      }
    }, 'edit'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
      d: 'M26.34 10.107l-2.168 2.168-4.447-4.447 2.168-2.168c0.445-0.445 1.223-0.445 1.668 0l2.78 2.78c0.445 0.445 0.445 1.223 0 1.668zM5.326 22.226l13.12-13.12 4.447 4.447-13.12 13.12h-4.447v-4.447z',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 25
      }
    })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('symbol', {
      id: 'icon-delete',
      viewBox: '0 0 32 32',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title', {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 28
      }
    }, 'delete'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
      d: 'M24.278 6.5v2.389h-16.556v-2.389h4.111l1.222-1.167h5.889l1.222 1.167h4.111zM8.889 24.278v-14.222h14.222v14.222c0 1.278-1.111 2.389-2.389 2.389h-9.444c-1.278 0-2.389-1.111-2.389-2.389z',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 29
      }
    })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('symbol', {
      id: 'icon-drag_handle',
      viewBox: '0 0 32 32',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 31
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title', {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 32
      }
    }, 'drag_handle'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
      d: 'M5.313 20v-2.688h21.375v2.688h-21.375zM26.688 12v2.688h-21.375v-2.688h21.375z',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 33
      }
    })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('symbol', {
      id: 'icon-keyboard_arrow_down',
      viewBox: '0 0 32 32',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title', {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 36
      }
    }, 'keyboard_arrow_down'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
      d: 'M9.875 10.438l6.125 6.125 6.125-6.125 1.875 1.875-8 8-8-8z',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37
      }
    })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('symbol', {
      id: 'icon-keyboard_arrow_left',
      viewBox: '0 0 32 32',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 39
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title', {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 40
      }
    }, 'keyboard_arrow_left'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
      d: 'M20.563 21.438l-1.875 1.875-8-8 8-8 1.875 1.875-6.125 6.125z',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 41
      }
    })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('symbol', {
      id: 'icon-keyboard_arrow_right',
      viewBox: '0 0 32 32',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 43
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title', {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 44
      }
    }, 'keyboard_arrow_right'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
      d: 'M11.438 21.813l6.125-6.125-6.125-6.125 1.875-1.875 8 8-8 8z',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 45
      }
    })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('symbol', {
      id: 'icon-keyboard_arrow_up',
      viewBox: '0 0 32 32',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 47
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title', {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 48
      }
    }, 'keyboard_arrow_up'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
      d: 'M9.875 20.563l-1.875-1.875 8-8 8 8-1.875 1.875-6.125-6.125z',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 49
      }
    })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('symbol', {
      id: 'icon-remove',
      viewBox: '0 0 32 32',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 51
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title', {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 52
      }
    }, 'remove'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
      d: 'M25.313 17.313h-18.625v-2.625h18.625v2.625z',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 53
      }
    })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('symbol', {
      id: 'icon-search',
      viewBox: '0 0 32 32',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 55
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title', {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 56
      }
    }, 'search'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
      d: 'M13.066 18.38c2.934 0 5.314-2.38 5.314-5.314s-2.38-5.314-5.314-5.314-5.314 2.38-5.314 5.314 2.38 5.314 5.314 5.314zM20.151 18.38l5.867 5.867-1.771 1.771-5.867-5.867v-0.941l-0.332-0.332c-1.328 1.162-3.1 1.827-4.982 1.827-4.262 0-7.694-3.376-7.694-7.638s3.432-7.694 7.694-7.694 7.638 3.432 7.638 7.694c0 1.882-0.664 3.653-1.827 4.982l0.332 0.332h0.941z',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 57
      }
    })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('symbol', {
      id: 'icon-embed',
      viewBox: '0 0 32 32',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 59
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title', {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 60
      }
    }, 'embed'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
      d: 'M19.438 22.125l6.188-6.125-6.188-6.125 1.875-1.875 8 8-8 8zM12.563 22.125l-1.875 1.875-8-8 8-8 1.875 1.875-6.188 6.125z',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 61
      }
    })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('symbol', {
      id: 'icon-image',
      viewBox: '0 0 32 32',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 63
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title', {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 64
      }
    }, 'image'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
      d: 'M11.833 17.778l-4.111 5.333h16.556l-5.333-7.111-4.111 5.333zM26.667 24.278c0 1.278-1.111 2.389-2.389 2.389h-16.556c-1.278 0-2.389-1.111-2.389-2.389v-16.556c0-1.278 1.111-2.389 2.389-2.389h16.556c1.278 0 2.389 1.111 2.389 2.389v16.556z',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65
      }
    })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('symbol', {
      id: 'icon-video',
      viewBox: '0 0 32 32',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 67
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title', {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 68
      }
    }, 'video'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
      d: 'M20.722 14.833l-8.278 4.722v-9.5zM26.667 21.944v-14.222h-21.333v14.222h21.333zM26.667 5.333c1.278 0 2.389 1.056 2.389 2.389l-0.056 14.222c0 1.278-1.056 2.333-2.333 2.333h-5.944v2.389h-9.444v-2.389h-5.944c-1.333 0-2.389-1.056-2.389-2.333v-14.222c0-1.333 1.056-2.389 2.389-2.389h21.333z',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69
      }
    })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('symbol', {
      id: 'icon-widget',
      viewBox: '0 0 32 32',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 71
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title', {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 72
      }
    }, 'widget'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
      d: 'M3.282 23.282h25.436v3.18h-25.436zM6.462 16.923h3.179v4.769h-3.179zM11.231 10.564h3.18v11.128h-3.18zM16 15.333h3.18v6.359h-3.18zM20.769 5.795h3.18v15.897h-3.18z',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 73
      }
    }))));
  }

  Icons.displayName = 'Icons';
  Icons.displayName = 'Icons';
  /***/
},
/* 522 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);

  var _class,
      _temp,
      _jsxFileName = '/Users/miguelbarrenechea/Projects/vizz-wysiwyg/components/Wysiwyg/UI/Backdrop/Backdrop.js';

  var Backdrop = (_temp = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Backdrop, _React$Component);

    function Backdrop() {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Backdrop);

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Backdrop.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Backdrop)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Backdrop, [{
      key: 'render',
      value: function render() {
        var isActive = this.props.isActive;

        if (!isActive) {
          return null;
        }

        return (
          /* eslint-disable */
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', {
            className: 'cw-wysiwyg-backdrop',
            onClick: this.props.onClick,
            role: 'button',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 22
            }
          })
          /* eslint-enable */

        );
      }
    }]);

    return Backdrop;
  }(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component), _class.propTypes = {
    isActive: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  }, _class.defaultProps = {
    isActive: false,
    onClick: null
  }, _temp);
  Backdrop.displayName = 'Backdrop';
  /* harmony default export */

  __webpack_exports__["a"] = Backdrop;
  /***/
}]);